import {compose, createFeatureSelector, createSelector} from '@ngrx/store';
import { environment } from '../../../environments/environment';
import {CryptoService} from '../../services/crypto.service';
import {
  deviceType,
  eventMapping,
  eventStatusMapping,
  imageUrl,
  statusMapping,
  batStaMapping,
  batHeaMapping,
  groupStr,
  deviceStr,
  byKeyStr,
  groupDesc,
  moduleValueType,
  PackageList,
  timeZoneOption,
  childDeviceStr,
  licenseMap,
  powSourMapping,
  outStaMapping,
  powerConditionMapping,
  InStaMapping,
  unitMapping,
  purchaseOrderMap,
  oldErrorCode, platformTypeMap, planStatusMap, PackageLevel, authorityMap,
  NotificationMsgType,
  deviceTypeCode,
  deviceTypeCodeRMC,
  shareDeviceStatus,
  shareDeviceStatusType,
  shareObjectType,
  monthMap,
  reportDataMonthlyType,
  reportDataMonthlySubType,
  appDownloadType,
  reportDataField,
  DeviceResetOptionType,
  reportDataPeriod,
  authorityLevelMap,
  hideBHIModelList,
  mspPaymentDocumentStatus,
  DefaultMinimumQuantity,
  DeviceSubType,
  DeviceSubTypeMapping,
  DisplaySourceType,
  FirmwareType,
  ePDUSourceMapping,
  ActionType,
  PaymentType,
  PaymentTypeIndex,
  ActionTypeNagetiveMapping,
  ActionTypeIndex_Sell,
  PROStatusIndex,
  PROStatusLockAuthTypeIndex,
  PROLockStatusIndex,
  reportDataMonthlyTertiaryType,
  reportDataMonthlySWType,
  reportDataMonthlyGatewayCategoryType,
  reportDataMonthlyReportCustomType,
  reportDataMonthlyRenewalRateRangeType,
  reportDataMonthlyChargeType
} from '../../shareModel';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
// Reducer:
import * as fromReducer from '../reducers';
import * as fromUser from '../reducers/user.reducers';
import * as fromEvents from '../reducers/events.reducers';
import * as fromDevicesStatus from '../reducers/devices-status.reducers';
import * as fromDevicesInfo from '../reducers/devices-info.reducers';
import * as fromModule from '../../my-features/module/reducers/module.reducer';
import * as fromFilters from '../reducers/filter.reducer';
import * as fromNode from '../../my-features/node/reducers/node.reducer';
import * as fromGroup from '../reducers/group.reducer';
import * as fromGroupDetail from '../reducers/group-detail.reducer';
import * as fromUpdateInfo from '../../my-features/updateInfo/reducers/update-info.reducer';
import * as fromRegion from '../../my-features/region/reducers/region.reducer';
import * as fromUserModule from '../reducers/user-module.reducer';
import * as fromStatusLog from '../../my-features/status/reducers/status-log.reducer';
import * as fromStatusAggregation from '../../my-features/status/reducers/status-aggregation.reducer';
import * as fromDeviceStatus from '../reducers/devices-status.reducers';
import * as fromFloorMap from '../../my-features/floor-map/reducers/floor-map.reducer';
import * as fromMapFilter from '../../my-features/floor-map/reducers/map-filter.reducer';
import * as fromChangeInfo from '../../my-features/change-info/reducers/change-info.reducer';
import * as fromPurchase from '../../my-features/purchase/reducers/purchase.reducer';
import * as fromEventMaps from '../../my-features/event-map/reducers/event-map.reducer';
import * as fromLicenseMgt from '../../my-features/license-mgt/reducers/license-mgt.reducer';
import * as fromLicenseMgtList from '../../my-features/license-mgt/reducers/license-mgt-list.reducer';
import * as fromLicenseSettingList from '../../my-features/license-mgt/reducers/license-setting-list.reducer';
import * as fromLicenseMgtListFilter from '../../my-features/license-mgt/reducers/license-mgt-list-filter.reducer';
import * as fromDeviceMgtList from '../../my-features/device-mgt/reducers/device-mgt-list.reducer';
import * as fromDeviceSettingList from '../../my-features/device-mgt/reducers/device-setting-list.reducer';
import * as fromDeviceMgtListFilter from '../../my-features/device-mgt/reducers/device-mgt-list-filter.reducer';
import * as fromDevice from '../../my-features/device/reducers/device.reducer';
import * as fromAccount from '../../my-features/account/reducers/account.reducer';
import * as fromCheckLicense from '../../my-features/check-license/reducers/check-license.reducer';
import * as fromLicenseDetails from '../../my-features/license-mgt/reducers/license-detail.reducer';
import * as fromDeviceLicenseDetails from '../../my-features/device-mgt/reducers/device-detail.reducer';
import * as fromFirmWareInfo from '../../my-features/firm-ware/reducers/firm-ware-info.reducer';
import * as fromFirmWareLog from '../../my-features/firm-ware/reducers/firm-ware-log.reducer';
import * as fromFirmWareUpdatingData from '../../my-features/firm-ware/reducers/firm-ware-updating-data.reducer';
import * as fromAuthority from '../../my-features/account/reducers/authority.reducer';
import * as fromAccountMgtListFilter from '../../my-features/account/reducers/account-mgt-list-filter.reducer';
import * as fromDeviceMonitoring from '../../my-features/device-monitoring/reducers/device-monitoring.reducer';
import * as fromDeviceMonitoringFilter from '../../my-features/device-monitoring/reducers/device-monitoring-filter.reducer';
import * as fromEventMonitoring from '../../my-features/event-monitoring/reducers/event-monitoring.reducer';
import * as fromPrivacyAndTerms from '../../my-features/privacy-and-terms/reducers/privacy-and-terms.reducer';
import * as fromModulesFilter from '../../my-features/module/reducers/module-filter.reducer';
import * as fromNodesFilter from '../../my-features/node/reducers/node-filter.reducer';
import * as fromPurchaseFilter from '../../my-features/purchase/reducers/purchase-filter.reducer';
import * as fromUserPackage from '../../my-features/purchase/reducers/package.reducer';
import * as fromBatteryTestStatus from '../../my-features/battery-test/reducers/battery-test-status.reducer';
import * as fromHardwareFaultLevelMaps from '../../my-features/hardware/reducers/hardware-fault-level.reducer';
import * as fromHardwareFaultCodeMaps from '../../my-features/hardware/reducers/hardware-fault-code.reducer';
import * as fromBatteryReplacement from '../../my-features/battery-replacement/reducers/battery-replacement.reducer';
import * as fromEventMonitoringFilter from '../../my-features/event-monitoring/reducers/event-filters.reducer';
import * as fromTrialLicense from '../../my-features/license-mgt/reducers/trial-license.reducer';
import * as fromCountry from '../../my-features/region/reducers/country.reducer';
import * as fromBindDevice from '../../my-features/bind-device/reducers/bind-device.reducer';
import * as fromBindMiniCard from '../../my-features/bind-device/reducers/bind-mini-card.reducer';
import * as fromBindWifiCard from '../../my-features/bind-device/reducers/bind-wifi-card.reducer';
import * as fromWorldMap from '../../my-features/world-map/reducers/world-map.reducer';
import * as fromPlanMgt from '../../my-features/plan/reducers/plan-mgt.reducer';
import * as fromPlanSetting from '../../my-features/plan/reducers/plan-setting.reducer';
import * as fromPlanUserInfo from '../../my-features/plan/reducers/plan-user-info.reducer';
import * as fromPlanList from '../../my-features/plan/reducers/plan-list.reducer';
import * as fromPlanListFilter from '../../my-features/plan/reducers/plan-list-filer.reducer';
import * as fromNotification from '../../my-features/notification/reducers/notification.reducer';
import * as fromAzureBlobStorage from '../../my-features/azure-blob-storage/reducers/azure-blob-storage.reducer';
import * as fromLicenseSw from '../../my-features/license-mgt/reducers/license-sw.reducer';
import * as fromDeviceSharing from '../../my-features/object-sharing/reducers/device-sharing.reducer';
import * as fromGroupSharing from '../../my-features/object-sharing/reducers/group-sharing.reducer';
import * as fromUserActivityLog from '../../my-features/user-activity-log/reducers/user-activity-log.reducer';
import * as fromAppDownload from '../../my-features/app-download/reducers/app-download.reducer';
import * as fromPrice from '../../my-features/price/reducers/price.reducer';
import * as fromSummary from '../../my-features/summary/reducers/summary.reducer';
import * as fromOauth from '../../my-features/account/reducers/oauth.reducer';
import * as fromAuthOtp from '../../my-features/account/reducers/auth-otp.reducer';
import * as fromDeviceReset from '../../my-features/device-reset/reducers/device-reset.reducer';
import * as fromSystemlog from '../../my-features/systemlog/reducers/systemlog.reducer';
import * as fromCompanion from '../../my-features/companion/reducers/companion.reducer';
import * as fromCompanionRule from '../../my-features/companion/reducers/companion-rule.reducer';
import * as fromRegionMember from '../../my-features/region/reducers/region-member.reducer';
import * as fromMspRegion from '../../my-features/region/reducers/region-msp.reducer';
import * as fromMspAuthority from '../../my-features/region/reducers/region-msp-authority.reducer';
import * as fromMspMemberAuthority from '../../my-features/region/reducers/region-msp-member-authority.reducer';
import * as fromApiKey from '../../my-features/api-key/reducers/api-key.reducer';
import * as fromMspRegionPayment from '../../my-features/region/reducers/region-msp-payment.reducer';
import * as fromGateWay from '../../my-features/gateway/reducers/gateway.reducer';
import * as fromGateWayMib from '../../my-features/gateway/reducers/gateway-mib.reducer';
import * as fromGateWayTrap from '../../my-features/gateway/reducers/gateway-trap.reducer';
import * as fromGateWayAttribute from '../../my-features/gateway/reducers/gateway-attribute.reducer';
import * as fromGateWayProfile from '../../my-features/gateway/reducers/gateway-profile.reducer';
import * as fromGateWayDiscovery from '../../my-features/gateway/reducers/gateway-discovery.reducer';
import * as fromGateWayDevice from '../../my-features/gateway/reducers/gateway-device.reducer';
import * as fromSoftware from '../../my-features/software/reducers/software.reducer';
import * as fromPro from '../../my-features/pro/reducers/pro.reducer';
import * as fromSmartPowerReport from '../../my-features/smart-power-report/reducers/smart-power-report.reducer';
import * as fromMailModules from '../../my-features/mail/reducers/mail-module.reducer';
import * as fromMailGroup from '../../my-features/mail/reducers/mail-group.reducer';
import * as fromBatteryTestScheduler from '../../my-features/battery-test/reducers/battery-test-scheduler.reducer';
import * as fromDeviceUpsControl from '../../my-features/device-ups-control/reducers/device-ups-control.reducer';
// Model:
import {ViewDeviceOrderGroup, ViewDeviceOrderDetail} from '../../my-features/purchase/purchase.model';
import {Group, ViewGroupInfo} from '../../models/group';
import {Module} from '../../my-features/module/module.model';
import {FilterParams} from '../../models/events';
import {FloorMap} from '../../my-features/floor-map/floor-map.model';
import {ViewDeviceInfo} from '../../models/devices';
import {FirmWareInfo} from '../../my-features/firm-ware/firm-ware.model';
import {BatteryReplacement} from '../../my-features/battery-replacement/battery-replacement.model';
import {PlanList} from '../../my-features/plan/plan-list.model';
import { ObjectShareToOther, ObjectSharing } from '../../my-features/object-sharing/object-sharing.model';
import { LicenseSw } from 'src/app/my-features/license-mgt/license-mgt.model';
import { UserActivityLogDataList } from 'src/app/my-features/user-activity-log/user-activity-log.model';
import { Summary, EventsParams, Events } from 'src/app/my-features/summary/summary.model';
import { AuthOtp } from 'src/app/my-features/account/auth-otp.model';
import { DeviceReset } from 'src/app/my-features/device-reset/device-reset.model';
import {Companion} from '../../my-features/companion/companion.model';
import {CompanionRule} from '../../my-features/companion/companion-rule.model';
import * as moment from 'moment';
import { GetPlanMgts, GetRegions, StatusAggregationActionTypes } from 'src/app/my-features';
import { ShareModule } from 'src/app/modules/share/share.module';
import { filter, last } from 'rxjs/operators';


// State:
export const getUserState = (state: fromReducer.State) => state.user;
export const getEventsState = createFeatureSelector<fromEvents.EventsState>('events');
export const getEventFilterParamsState = createFeatureSelector<FilterParams>('eventsFilterParams');
export const getDevicesStatusState = createFeatureSelector<fromDeviceStatus.DevicesStatusState>('devicesStatus');
export const getDevicesInfoState = (state: fromReducer.State) => state.devicesInfo;
export const getDeviceDetailsState = (state: fromReducer.State) => state.deviceDetails;
export const getSelectedDashboardStatusState = (state: fromReducer.State) => state.selectedDashboardStatus;
export const getModulesState = createFeatureSelector<fromModule.ModuleState>('module');
export const getFiltersState = createFeatureSelector<fromFilters.FiltersState>('filters');
export const getNodeState = createFeatureSelector<fromNode.NodeState>('node');
export const getGroupState = createFeatureSelector<fromGroup.GroupdsState>('group');
export const getUpdateInfoState = createFeatureSelector<fromUpdateInfo.UpdateInfoState>('updateInfo');
export const getRegionState = createFeatureSelector<fromRegion.RegionState>('region');
export const getSingleGroupState = createFeatureSelector<fromGroupDetail.State>('groupDetail');
export const getUserModuleState = createFeatureSelector<fromUserModule.UserModuleState>('userModule');
export const getStatusLogState = createFeatureSelector<fromStatusLog.StatusLogState>('statusLog');
export const getStatusPeakState = createFeatureSelector<fromStatusAggregation.StatusAggregationState>('statusAggregation');
export const getFloorMapState = createFeatureSelector<fromFloorMap.State>('floorMap');
export const getFloorMapFilterState = createFeatureSelector<fromMapFilter.State>('mapFilter');
export const getChangeInfoState = createFeatureSelector<fromChangeInfo.ChangeInfoState>('changeInfo');
export const getPurchaseState = createFeatureSelector<fromPurchase.PurchaseState>('purchase');
export const getPurchaseOtpState = createFeatureSelector<fromPurchase.PurchaseOtpState>('packageOtp');
export const getPurchaseFilterState = createFeatureSelector<fromPurchaseFilter.State>('purchaseFilter');
export const getEventsMapsState = createFeatureSelector<fromEventMaps.State>('eventMaps');
export const getLicenseMgtListState = createFeatureSelector<fromLicenseMgtList.State>('licenseMgtList');
export const getLicenseMgtListFilterState = createFeatureSelector<fromLicenseMgtListFilter.State>('licenseMgtListFilter');
export const getLicenseState = createFeatureSelector<fromLicenseMgt.State>('licenseMgt');
export const getDeviceMgtListState = createFeatureSelector<fromDeviceMgtList.DeviceMgtListState>('deviceMgtList');
export const getDeviceState = createFeatureSelector<fromDevice.State>('device');
export const getAccountState = createFeatureSelector<fromAccount.State>('account');
export const getCheckLicenseState = createFeatureSelector<fromCheckLicense.State>('checkLicense');
export const getDeviceMgtListFilterState = createFeatureSelector<fromDeviceMgtListFilter.State>('deviceMgtListFilter');
export const getLicenseSettingState = createFeatureSelector<fromLicenseSettingList.State>('licenseSettingList');
export const getLicenseSettingListFilterState = createFeatureSelector<fromLicenseMgtListFilter.State>('licenseSettingListFilter');
export const getLicenseDetailsState = createFeatureSelector<fromLicenseDetails.State>('licenseDetail');
export const getDeviceSettingState = createFeatureSelector<fromDeviceSettingList.State>('deviceSettingList');
export const getDeviceLicenseDetailsState = createFeatureSelector<fromDeviceLicenseDetails.State>('deviceDetail');
export const getFirmWareInfoState = createFeatureSelector<fromFirmWareInfo.State>('firmWareInfo');
export const getFirmWareLogState = createFeatureSelector<fromFirmWareLog.State>('firmWareLog');
export const getFirmWareUpdatingDataState = createFeatureSelector<fromFirmWareUpdatingData.State>('firmWareUpdatingData');
export const getAuthorityState = createFeatureSelector<fromAuthority.State>('authority');
export const getAccountMgtListFilterState = createFeatureSelector<fromAccountMgtListFilter.State>('accountMgtListFilter');
export const getDeviceMonitoringState = createFeatureSelector<fromDeviceMonitoring.State>('deviceMonitoring');
export const getDeviceMonitoringFilterState = createFeatureSelector<fromDeviceMonitoringFilter.State>('deviceMonitoringFilter');
export const getEventMonitoringState = createFeatureSelector<fromEventMonitoring.State>('eventMonitoring');
export const getPrivacyAndTermsState = createFeatureSelector<fromPrivacyAndTerms.State>('privacyAndTerms');
export const getModuleFilterState = createFeatureSelector<fromModulesFilter.State>('moduleFilter');
export const getNodesFilterState = createFeatureSelector<fromNodesFilter.State>('nodeFilter');
export const getUserPackageState = createFeatureSelector<fromUserPackage.State>('package');
export const getBatteryTestState = createFeatureSelector<fromBatteryTestStatus.State>('batteryTestStatus');
export const getHardwareFaultLevelMapsState = createFeatureSelector<fromHardwareFaultLevelMaps.State>('hardwareFaultLevel');
export const getHardwareFaultCodeMapsState = createFeatureSelector<fromHardwareFaultCodeMaps.State>('hardwareFaultCode');
export const getBatteryReplacementState = createFeatureSelector<fromBatteryReplacement.State>('batteryReplacement');
export const getEventMonitoringFilterState = createFeatureSelector<fromEventMonitoringFilter.State>('eventFilters');
export const getTrialLicenseState = createFeatureSelector<fromTrialLicense.State>('trialLicense');
export const getCountryState = createFeatureSelector<fromCountry.State>('country');
export const getBindMiniCardState = createFeatureSelector<fromBindMiniCard.State>('bindMiniCard');
export const getWifiCardState = createFeatureSelector<fromBindWifiCard.State>('bindWifiCard');
export const getWorldMapState = createFeatureSelector<fromWorldMap.State>('worldMap');
export const getPlanMgtState = createFeatureSelector<fromPlanMgt.State>('planMgt');
export const getPlanSettingState = createFeatureSelector<fromPlanSetting.State>('planSetting');
export const getPlanUserInfoState = createFeatureSelector<fromPlanUserInfo.State>('planUserInfo');
export const getPlanListState = createFeatureSelector<fromPlanList.State>('planList');
export const getPlanListFilterState = createFeatureSelector<fromPlanListFilter.State>('planListFiler');
export const getNotificationState = createFeatureSelector<fromNotification.State>('notification');
export const getAzureBlobStorageSASTokenState = createFeatureSelector<fromAzureBlobStorage.SASTokenState>('sasToken');
export const getAzureBlobStoragesDownloadState = createFeatureSelector<fromAzureBlobStorage.State>('azureBlobStorage');
export const getLicenseSwState = createFeatureSelector<fromLicenseSw.State>('licenseSw');
export const getLicenseSwTypeState = createFeatureSelector<fromLicenseSw.LicenseSwTypeState>('licenseSwType');
export const getDeviceSharingState = createFeatureSelector<fromDeviceSharing.State>('DeviceSharing');
export const getGroupSharingState = createFeatureSelector<fromGroupSharing.State>('GroupSharing');
export const getUserActivityLogState = createFeatureSelector<fromUserActivityLog.State>('UserActivityLog');
export const getAppDownloadState = createFeatureSelector<fromAppDownload.State>('AppDownload');
export const getPriceState = createFeatureSelector<fromPrice.State>('price');
export const getSummaryState = createFeatureSelector<fromSummary.State>('Summary');
export const getPreferencesState = createFeatureSelector<fromSummary.PreferencesState>('Preferences');
export const getSummaryDetailState = createFeatureSelector<fromSummary.SummaryDetailState>('SummaryDetail');
export const getOauthState = createFeatureSelector<fromOauth.State>('Oauth');
export const getOauthLoginState = createFeatureSelector<fromOauth.OauthLoginState>('OauthLogin');
export const getAccountOauthSWParamState = createFeatureSelector<fromOauth.AccountOauthSWParamState>('AccountOauthSWParam');
export const getAuthOtpState = createFeatureSelector<fromAuthOtp.State>('authOtp');
export const getCheckAuthOtpState = createFeatureSelector<fromAuthOtp.CheckAuthOTPState>('checkAuthOtp');
export const getEnableAuthOtpState = createFeatureSelector<fromAuthOtp.EnableAuthOTPState>('enableAuthOtp');
export const getDeviceResetState = createFeatureSelector<fromDeviceReset.State>('deviceReset');
export const getDeviceResetLogState = createFeatureSelector<fromDeviceReset.DeviceResetLogState>('deviceResetlog');
export const getSystemlogState = createFeatureSelector<fromSystemlog.SystemlogTypeState>('systemlog');
export const getSystemlogTypeState = createFeatureSelector<fromSystemlog.SystemlogTypeState>('systemlogtype');
export const getCompanionState = createFeatureSelector<fromCompanion.State>('companion');
export const getCompanionOverViewState = createFeatureSelector<fromCompanion.CompanionOverViewState>('companionOverView');
export const getCompanionRuleListState = createFeatureSelector<fromCompanionRule.State>('companionRuleList');
export const getCompanionProtectionProcessDeviceState =
createFeatureSelector<fromCompanion.CompanionProtectionProcessDeviceState>('companionProtectionProcessDevice');
export const getResendDataOfCompanionProtectionProcessState =
createFeatureSelector<fromCompanion.ResendDataOfCompanionProtectionProcessState>('resendDataOfCompanionProtectionProcess');

export const getRegionMemberState = createFeatureSelector<fromRegionMember.State>('regionMember');
export const getMspRegionState = createFeatureSelector<fromMspRegion.State>('mspRegion');
export const getMspAuthorityState = createFeatureSelector<fromMspAuthority.State>('mspAuthority');
export const getMspMemberAuthorityState = createFeatureSelector<fromMspMemberAuthority.State>('mspMemberAuthority');
export const getMspRegionFilterState = createFeatureSelector<fromMspRegion.MspRegionFilterState>('mspRegionFilter');
export const getAccountListFilterState = createFeatureSelector<fromAccount.AccountFilterState>('accountListFilter');
export const getApiKeyState = createFeatureSelector<fromApiKey.ApiKeyTypeState>('apiKey');
export const getApiKeyUsageState = createFeatureSelector<fromApiKey.ApiKeyUsageState>('apiKeyUsage');
export const getMspRegionPaymentState = createFeatureSelector<fromMspRegionPayment.State>('mspRegionPayment');
export const getMspDistributorRegionPaymentState = createFeatureSelector<fromMspRegionPayment.PaymentDistributorState>('mspDistributorRegionPayment');
export const getMspPaymentDocumentListState = createFeatureSelector<fromMspRegionPayment.PaymentDocumentListState>('mspPaymentDocumentList');
export const getMspPaymentDocumentState = createFeatureSelector<fromMspRegionPayment.PaymentDocumentState>('mspPaymentDocument');
export const getMspDeviceUsageListState = createFeatureSelector<fromMspRegionPayment.DeviceUsageListState>('mspDeviceUsageList');
export const getMspDeviceUsageState = createFeatureSelector<fromMspRegionPayment.DeviceUsageState>('mspDeviceUsage');
export const getGateWayListState = createFeatureSelector<fromGateWay.GateWayState>('gatewayList');
export const getGateWayDeviceListState = createFeatureSelector<fromGateWayDevice.State>('gatewayDeviceList');
export const getGateWayAddToCloudState = createFeatureSelector<fromGateWayDevice.GateWayResultAddToCloudState>('gatewayResultAddToCloud');
export const getGateWayMgtMibTrapListState = createFeatureSelector<fromGateWayMib.GateWayMgtMibTrapListState>('gatewayMgtMibTrapList');
export const getGateWayMgtMibDetailState = createFeatureSelector<fromGateWayMib.GateWayMgtMibDetailState>('gatewayMgtMibDetail');
export const getGateWayMibTrapListState = createFeatureSelector<fromGateWayMib.GateWayMibTrapListState>('gatewayMibTrapList');
export const getGateWayMibDetailState = createFeatureSelector<fromGateWayMib.GateWayMibDetailState>('gatewayMibDetail');
export const getGateWayMgtTrapDetailState = createFeatureSelector<fromGateWayTrap.GateWayMgtTrapDetailState>('gatewayMgtTrapDetail');
export const getGateWayTrapDetailState = createFeatureSelector<fromGateWayTrap.GateWayTrapDetailState>('gatewayTrapDetail');
export const getGateWayMgtAttributeState = createFeatureSelector<fromGateWayAttribute.GateWayMgtAttributeState>('gatewayMgtAttribute');
export const getGateWayCategoryListState = createFeatureSelector<fromGateWayMib.GateWayCategoryListState>('gatewayCategoryList');
export const getGateWayProfileListState = createFeatureSelector<fromGateWayProfile.GateWayProfileListState>('gatewayProfileList');
export const getGateWayProfileInfoState = createFeatureSelector<fromGateWayProfile.GateWayProfileInfoState>('gatewayProfileInfo');
export const getGateWayDiscoveryInfoListState = createFeatureSelector<fromGateWayDiscovery.GateWayDiscoveryInfoListState>('gatewayDiscoveryInfoList');
export const getGateWayDiscoveryInfoState = createFeatureSelector<fromGateWayDiscovery.GateWayDiscoveryInfoState>('gatewayDiscoveryInfo');
export const getGateWayExecuteDiscoveryState = createFeatureSelector<fromGateWayDiscovery.GateWayExecuteDiscoveryState>('gatewayExecuteDiscovery');
export const getGateWayExecuteDiscoveryListState = createFeatureSelector<fromGateWayDiscovery.GateWayExecuteDiscoveryListState>('gatewayExecuteDiscoveryList');
export const getGateWayDiscoveryResultListState = createFeatureSelector<fromGateWayDiscovery.GateWayDiscoveryResultListState>('gatewayDiscoveryResultList');
export const getGateWayDiscoveryExecutingResultForOneTimeState = createFeatureSelector<fromGateWayDiscovery.GateWayDiscoveryExecutingResultForOneTimeState>('gatewayDiscoveryExecutingResultForOneTime');
export const getProIncomeListState = createFeatureSelector<fromUserActivityLog.ProIncomeListState>('ProIncomeList');
export const getReportDiscountListState = createFeatureSelector<fromUserActivityLog.ReportDiscountListState>('ReportDiscountList');
export const getSoftwareVersionState = createFeatureSelector<fromSoftware.State>('SoftwareVersion');

export const getPayPalAgreementApprovalUrlState = createFeatureSelector<fromPurchase.PayPalAgreementApprovalUrlState>('agreementApprovalUrl');
export const GetProNodesBankState = createFeatureSelector<fromPro.ProNodesBankState>('proNodesBank');
export const GetCalculateProNodesState = createFeatureSelector<fromPro.CalculateProNodesState>('calculateProNodes');
export const getSmartPowerReportListState = createFeatureSelector<fromSmartPowerReport.State>('smartPowerReportList');
export const getSmartPowerReportState = createFeatureSelector<fromSmartPowerReport.SmartPowerReportState>('smartPowerReport');
export const getSmartPowerReportDataState = createFeatureSelector<fromSmartPowerReport.SmartPowerReportDataState>('smartPowerReportData');
export const getMailModuleState = createFeatureSelector<fromMailGroup.State>('mailModuleList');
export const getMailGroupState = createFeatureSelector<fromMailModules.State>('mailGroupList');
export const getBatteryTestSchedulerState = createFeatureSelector<fromBatteryTestScheduler.State>('batteryTestScheduler');
export const getBatteryTestSchedulerDetailState = createFeatureSelector<fromBatteryTestScheduler.BatteryTestSchedulerDetailState>('batteryTestSchedulerDetail');
export const getBatteryTestSchedulerResultState = createFeatureSelector<fromBatteryTestScheduler.BatteryTestSchedulerResultState>('batteryTestSchedulerReducer');
export const getDeviceUpsControlState = createFeatureSelector<fromDeviceUpsControl.State>('deviceUPSControl');
// Region Start -- DataLogic--------------------------------------------------------------------------------------------

// Login & USER
export const getIsLogin = createSelector(getUserState, fromUser.getIsLogin);
export const getCurrentUser = createSelector(getUserState, fromUser.getCurrentUser);
export const getCurrentAcode = createSelector(getUserState, fromUser.getCurrentAcode);

export const getIsUserModuleData = createSelector(getUserModuleState,
  (res) => {
    return {isLoaded: res.Loaded ,
            isLoading: res.Loading};
});

// Battery Replacement
export const getBatteryReplacement = createSelector(getBatteryReplacementState, (data) => {
  if (data.isLoaded && !data.isLoading) {
    // 創建新對象副本以避免修改只讀的 store 數據 (NgRx 9 immutability)
    const newEntities = {};
    for (const [key, value] of Object.entries(data.entities)) {
      const info: BatteryReplacement = value;
      const BR_Date_Format = (info.BR_Date) ? new Date(info.BR_Date * 1000) : null;
      let BR_Rc_Date = null;
      let expires = false;
      if (value.BR_Date) {
        const dt = new Date(info.BR_Date * 1000);
        dt.setMonth(dt.getMonth() + info.BR_Months);
        BR_Rc_Date = dt.getTime();
        expires = BR_Rc_Date < new Date().getTime();
      }
      // 創建新對象副本，包含新計算的屬性
      newEntities[key] = { ...value, BR_Date_Format, BR_Rc_Date, expires };
    }
    return newEntities;
  }
});

export const DevicesFilteredLoaded = createSelector(getDevicesStatusState, getDevicesInfoState,
  getEventsMapsState, getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState, getBatteryReplacementState,
  (status, info, maps, faultLevelMaps, faultCodeMaps, btyReplacement) => {
    const result = (maps.Loaded && status.isLoaded && !status.isLoading && info.isLoaded && !info.isLoading &&
      !faultLevelMaps.Loading && faultLevelMaps.Loaded && !faultCodeMaps.Loading && faultCodeMaps.Loaded &&
      !btyReplacement.isLoading && btyReplacement.isLoaded);
    return result;
  });

// Groups
export const DevicesFiltered = createSelector(getDevicesStatusState, getDevicesInfoState,
  getEventsMapsState, getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState, getBatteryReplacement,
  (status, info, maps, faultLevelMaps, faultCodeMaps, btyReplacement) => {
    const listLen = (list: any): number => {
      if (list == null) { return 0; }
      if (Array.isArray(list)) { return list.length; }
      if (typeof list === 'object') { return Object.keys(list).length; }
      return 0;
    };
    const deviceList = status?.entities?.DeviceList;
    const shareDeviceList = status?.entities?.ShareDeviceList;
    const shareGroupDeviceList = status?.entities?.ShareGroupDeviceList;
    const infoEntities = Array.isArray(info?.entities) ? info.entities : [];

    if (maps.Loaded && status.isLoaded && !status.isLoading && info.isLoaded && !info.isLoading &&
      status.entities !== null && (listLen(deviceList) !== 0 ||
      listLen(shareDeviceList) !== 0 || listLen(shareGroupDeviceList) !== 0)) {
        const cryptoService = new CryptoService;
        const result = [] as ViewDeviceInfo[];
        // DeviceList
        if (listLen(deviceList) !== 0) {
          infoEntities.forEach(i => {
            const device = Array.isArray(deviceList)
              ? deviceList.find(l => l.device_sn === i.DeviceSN)
              : null;
            if (device) {
              const deviceStatus = ( typeof device.device_status === 'undefined' ) ? 3 : device.device_status;
              const model = i.Model;
              const event = (typeof device.event !== 'undefined' && device.event !== null && device.event !== '') ?
                device.event.toString().split(',').map(eventCode => {
                  return (maps.entities.hasOwnProperty(eventCode)) ? maps.entities[eventCode].desc : 'None.';
                  // return (typeof eventMapping !== 'undefined') ? eventMapping[eventCode].desc : 'None.';
                }).join(' / ') : '';
              const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ?
                   i.DeviceSubType !== 2 ? DeviceSubType[i.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
              const subtypeName = (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].name : '';
              const item = {
                name: i.DeviceName,
                type: (typeof deviceType !== 'undefined') ? deviceType[i.DeviceType] : '',
                DeviceSubType: i.DeviceSubType,
                subtype: subtypeName,
                displaysubtype: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayName : '',
                displayTag: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayTag : '',
                SourceType: device.SourceType,
                DisplaySourceType: i.DisplaySourceType,
                image: imageUrl + model,
                status: statusMapping[deviceStatus].status,
                icon: statusMapping[deviceStatus].icon,
                desc: (deviceStatus === 0) ? statusMapping[deviceStatus].desc.replace('{DeviceType}', new_desc_deviceType) : event,
                // 2025-03-03 修正原本batStaMapping key值為deviceStatus
                batteryStatus: (typeof batStaMapping !== 'undefined') ? batStaMapping[device.BatSta] : '',
                batteryCapacity: (device.BatCap === undefined || device.BatCap === null) ? 0 : device.BatCap,
                batteryRun: (device.BatRun === undefined || device.BatRun === null) ? 0 : device.BatRun,
                // #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                BHI: ((device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                  device.BHI === undefined || device.BHI === null) ? 0 : device.BHI,
                BHIStatus: (device && !(device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase()))) ?
                  ((device.BHI === -1 || device.BHI === undefined || !device.BHI_Enable) ? null :
                    ((device.BHI >= 70) ? batHeaMapping[0] :
                      ((device.BHI >= 50) ? batHeaMapping[1] :
                        ((device.BHI >= 35) ? batHeaMapping[2] :
                          ((device.BHI >= 25) ? batHeaMapping[3] :
                            ((device.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
                // 2025-03-06 kyrie #1286 Gateway加的UPS除了Cyberpower以外的第三方廠牌不顯示BHI
                // 2025-02-17 kyrie #1203 Gateway加的3-PH UPS不顯示BHI
                // 2024-01-22 kyrie #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                hideBHI: (device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                         ((device.SourceType !== undefined) && (device.DeviceSubType && DeviceSubType[device.DeviceSubType]) ?
                           !DeviceSubType[device.DeviceSubType].BHIdisplay : false) ||
                         ((device.SourceType !== undefined) && (subtypeName !== undefined) &&
                          (subtypeName === 'UPS' && device.SourceType === 1 && device.Brand !== 'CyberPower')),
                Load: (device.Load === undefined || device.Load === null) ? 0 : device.Load,
                LoadPctA: (device.LoadPctA === undefined || device.LoadPctA === null) ? 0 : device.LoadPctA,
                LoadPctB: (device.LoadPctB === undefined || device.LoadPctB === null) ? 0 : device.LoadPctB,
                LoadPctC: (device.LoadPctC === undefined || device.LoadPctC === null) ? 0 : device.LoadPctC,
                DeviceSN: i.DeviceSN,
                Model: i.Model,
                DeviceStatus: statusMapping[deviceStatus].type,
                deviceStatusCode: deviceStatus,
                // SelectedType: selectedType,
                region: i.Region,
                deviceDescription: device.desc,
                gId: device.gId,
                dcode: device.dcode,
                expireDate: device.expiredDate,
                level: device.level,
                co2Emitted: device.co2Emitted,
                energyCost: device.energyCost,
                countrySelection: device.countrySelection,
                unit: device.unit,
                connectedDate: device.connectedDate,
                timeZone: device.timeZone,
                levelChangedCnt: device.levelChangedCnt,
                routeLink: '/detail/' + cryptoService.aesEncrypt(i.DeviceSN),
                isExpired: device.isExpired,
                hardwarefault: hardwareFaultDetailLogic(device, faultLevelMaps, faultCodeMaps),
                btyReplacement: (btyReplacement && btyReplacement.hasOwnProperty(device.dcode)) ? btyReplacement[device.dcode] : null,
                canTrial: device.canTrial,
                trialRemainDay: device.trial_remainday,
                planActivate: (device.plan_activate === undefined || device.plan_activate === null) ? false : device.plan_activate,
                is_shared: false,
                protecting: device.Protecting,
                mspPlanActivate: (device.msp_plan_activate === undefined || device.msp_plan_activate === null) ?
                  false : device.msp_plan_activate,
                regionId: device.RegionId !== undefined ? device.RegionId : 0,
                Cur: device.Cur,
                Volt: device.Volt,
                VoltA: device.VoltA,
                VoltB: device.VoltB,
                VoltC: device.VoltC,
                InVoltA: device.InVoltA,
                InVoltB: device.InVoltB,
                InVoltC: device.InVoltC,
                OutVolt: device.OutVolt,
                Energy: device.Energy,
                EnergyT: device.EnergyT,
                Power: device.Power,
                PowerT: device.PowerT,
                Brand: device.Brand,
                DeviceIP: i.DeviceIP
              } as ViewDeviceInfo;
              result.push(item);
            }
          });
        }
        // ShareDeviceList
        if (listLen(shareDeviceList) !== 0) {
          infoEntities.forEach(i => {
            const device = Array.isArray(shareDeviceList)
              ? shareDeviceList.find(l => l.device_sn === i.DeviceSN)
              : null;
            if (device && device.share_status !== shareDeviceStatus['Rejected']) {
              const deviceStatus = ( typeof device.device_status === 'undefined' ) ? 3 : device.device_status;
              const model = i.Model;
              const event = (typeof device.event !== 'undefined' && device.event !== null && device.event !== '') ?
                device.event.toString().split(',').map(eventCode => {
                  return (maps.entities.hasOwnProperty(eventCode)) ? maps.entities[eventCode].desc : 'None.';
                  // return (typeof eventMapping !== 'undefined') ? eventMapping[eventCode].desc : 'None.';
                }).join(' / ') : '';
              const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ?
                 i.DeviceSubType !== 2 ? DeviceSubType[i.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
              const subtypeName = (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].name : '';
              const item = {
                name: i.DeviceName,
                type: (typeof deviceType !== 'undefined') ? deviceType[i.DeviceType] : '',
                DeviceSubType: i.DeviceSubType,
                subtype: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].name : '',
                displaysubtype: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayName : '',
                displayTag: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayTag : '',
                SourceType: device.SourceType,
                DisplaySourceType: i.DisplaySourceType,
                image: imageUrl + model,
                status: statusMapping[deviceStatus].status,
                icon: statusMapping[deviceStatus].icon,
                desc: (deviceStatus === 0) ? statusMapping[deviceStatus].desc.replace('{DeviceType}', new_desc_deviceType) : event,
                // 2025-03-03 修正原本batStaMapping key值為deviceStatus
                batteryStatus: (typeof batStaMapping !== 'undefined') ? batStaMapping[device.BatSta] : '',
                batteryCapacity: (device.BatCap === undefined || device.BatCap === null) ? 0 : device.BatCap,
                batteryRun: (device.BatRun === undefined || device.BatRun === null) ? 0 : device.BatRun,
                // #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                BHI: ((device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                  device.BHI === undefined || device.BHI === null) ? 0 : device.BHI,
                BHIStatus: (device && !(device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase()))) ?
                  ((device.BHI === -1 || device.BHI === undefined || !device.BHI_Enable) ? null :
                    ((device.BHI >= 70) ? batHeaMapping[0] :
                      ((device.BHI >= 50) ? batHeaMapping[1] :
                        ((device.BHI >= 35) ? batHeaMapping[2] :
                          ((device.BHI >= 25) ? batHeaMapping[3] :
                            ((device.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
                // 2025-03-06 kyrie #1286 Gateway加的UPS除了Cyberpower以外的第三方廠牌不顯示BHI
                // 2025-02-17 kyrie #1203 Gateway加的3-PH UPS不顯示BHI
                // 2024-01-22 kyrie #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                hideBHI: (device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                          ((device.SourceType !== undefined) && (device.DeviceSubType && DeviceSubType[device.DeviceSubType]) ?
                            !DeviceSubType[device.DeviceSubType].BHIdisplay : false) ||
                          ((device.SourceType !== undefined) && (subtypeName !== undefined) &&
                           (subtypeName === 'UPS' && device.SourceType === 1 && device.Brand !== 'CyberPower')),
                Load: (device.Load === undefined || device.Load === null) ? 0 : device.Load,
                LoadPctA: (device.LoadPctA === undefined || device.LoadPctA === null) ? 0 : device.LoadPctA,
                LoadPctB: (device.LoadPctB === undefined || device.LoadPctB === null) ? 0 : device.LoadPctB,
                LoadPctC: (device.LoadPctC === undefined || device.LoadPctC === null) ? 0 : device.LoadPctC,
                DeviceSN: i.DeviceSN,
                Model: i.Model,
                DeviceStatus: statusMapping[deviceStatus].type,
                deviceStatusCode: deviceStatus,
                // SelectedType: selectedType,
                region: i.Region,
                deviceDescription: device.desc,
                gId: device.gId,
                dcode: device.dcode,
                expireDate: device.expiredDate,
                level: device.level,
                co2Emitted: device.co2Emitted,
                energyCost: device.energyCost,
                countrySelection: device.countrySelection,
                unit: device.unit,
                connectedDate: device.connectedDate,
                timeZone: device.timeZone,
                levelChangedCnt: device.levelChangedCnt,
                routeLink: '/detail/' + cryptoService.aesEncrypt(i.DeviceSN),
                isExpired: device.isExpired,
                hardwarefault: hardwareFaultDetailLogic(device, faultLevelMaps, faultCodeMaps),
                btyReplacement: (btyReplacement && btyReplacement.hasOwnProperty(device.dcode)) ? btyReplacement[device.dcode] : null,
                canTrial: device.canTrial,
                trialRemainDay: device.trial_remainday,
                planActivate: (device.plan_activate === undefined || device.plan_activate === null) ? false : device.plan_activate,
                owner_acode: device.owner_acode,
                share_status: device.share_status,
                share_id: device.share_id,
                share_group_id: device.share_group_id,
                share_type: shareObjectType.ShareDevice,
                is_shared: true,
                protecting: device.Protecting,
                mspPlanActivate: (device.msp_plan_activate === undefined || device.msp_plan_activate === null) ?
                  false : device.msp_plan_activate,
                regionId: device.RegionId !== undefined ? device.RegionId : 0,
                Cur: device.Cur,
                Volt: device.Volt,
                VoltA: device.VoltA,
                VoltB: device.VoltB,
                VoltC: device.VoltC,
                InVoltA: device.InVoltA,
                InVoltB: device.InVoltB,
                InVoltC: device.InVoltC,
                OutVolt: device.OutVolt,
                Energy: device.Energy,
                EnergyT: device.EnergyT,
                Power: device.Power,
                PowerT: device.PowerT,
                Brand: device.Brand,
                DeviceIP: i.DeviceIP
              } as ViewDeviceInfo;

              result.push(item);
            }
          });
        }
        // ShareGroupDeviceList
        if (listLen(shareGroupDeviceList) !== 0) {
          infoEntities.forEach(i => {
            const device = Array.isArray(shareGroupDeviceList)
              ? shareGroupDeviceList.find(l => l.device_sn === i.DeviceSN)
              : null;
            if (device && device.share_status !== shareDeviceStatus['Rejected']) {
              const deviceStatus = ( typeof device.device_status === 'undefined' ) ? 3 : device.device_status;
              const model = i.Model;
              const event = (typeof device.event !== 'undefined' && device.event !== null && device.event !== '') ?
                device.event.toString().split(',').map(eventCode => {
                  return (maps.entities.hasOwnProperty(eventCode)) ? maps.entities[eventCode].desc : 'None.';
                  // return (typeof eventMapping !== 'undefined') ? eventMapping[eventCode].desc : 'None.';
                }).join(' / ') : '';
              const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ?
                 i.DeviceSubType !== 2 ? DeviceSubType[i.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
              const subtypeName = (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].name : '';
              const item = {
                name: i.DeviceName,
                type: (typeof deviceType !== 'undefined') ? deviceType[i.DeviceType] : '',
                DeviceSubType: i.DeviceSubType,
                subtype: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].name : '',
                displaysubtype: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayName : '',
                displayTag: (typeof DeviceSubType !== 'undefined') ? DeviceSubType[i.DeviceSubType].displayTag : '',
                SourceType: device.SourceType,
                DisplaySourceType: i.DisplaySourceType,
                image: imageUrl + model,
                status: statusMapping[deviceStatus].status,
                icon: statusMapping[deviceStatus].icon,
                desc: (deviceStatus === 0) ? statusMapping[deviceStatus].desc.replace('{DeviceType}', new_desc_deviceType) : event,
                // 2025-03-03 修正原本batStaMapping key值為deviceStatus
                batteryStatus: (typeof batStaMapping !== 'undefined') ? batStaMapping[device.BatSta] : '',
                batteryCapacity: (device.BatCap === undefined || device.BatCap === null) ? 0 : device.BatCap,
                batteryRun: (device.BatRun === undefined || device.BatRun === null) ? 0 : device.BatRun,
                // #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                BHI: ((device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                  device.BHI === undefined || device.BHI === null) ? 0 : device.BHI,
                BHIStatus: (device && !(device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase()))) ?
                  ((device.BHI === -1 || device.BHI === undefined || !device.BHI_Enable) ? null :
                    ((device.BHI >= 70) ? batHeaMapping[0] :
                      ((device.BHI >= 50) ? batHeaMapping[1] :
                        ((device.BHI >= 35) ? batHeaMapping[2] :
                          ((device.BHI >= 25) ? batHeaMapping[3] :
                            ((device.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
                // 2025-03-06 kyrie #1286 Gateway加的UPS除了Cyberpower以外的第三方廠牌不顯示BHI
                // 2025-02-17 kyrie #1203 Gateway加的3-PH UPS不顯示BHI
                // 2024-01-22 kyrie #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
                hideBHI: (device && device.Model && hideBHIModelList.includes(device.Model.toLocaleUpperCase())) ||
                          ((device.SourceType !== undefined) && (device.DeviceSubType && DeviceSubType[device.DeviceSubType]) ?
                            !DeviceSubType[device.DeviceSubType].BHIdisplay : false) ||
                          ((device.SourceType !== undefined) && (subtypeName !== undefined) &&
                           (subtypeName === 'UPS' && device.SourceType === 1 && device.Brand !== 'CyberPower')),
                Load: (device.Load === undefined || device.Load === null) ? 0 : device.Load,
                LoadPctA: (device.LoadPctA === undefined || device.LoadPctA === null) ? 0 : device.LoadPctA,
                LoadPctB: (device.LoadPctB === undefined || device.LoadPctB === null) ? 0 : device.LoadPctB,
                LoadPctC: (device.LoadPctC === undefined || device.LoadPctC === null) ? 0 : device.LoadPctC,
                DeviceSN: i.DeviceSN,
                Model: i.Model,
                DeviceStatus: statusMapping[deviceStatus].type,
                deviceStatusCode: deviceStatus,
                // SelectedType: selectedType,
                region: i.Region,
                deviceDescription: device.desc,
                gId: device.gId,
                dcode: device.dcode,
                expireDate: device.expiredDate,
                level: device.level,
                co2Emitted: device.co2Emitted,
                energyCost: device.energyCost,
                countrySelection: device.countrySelection,
                unit: device.unit,
                connectedDate: device.connectedDate,
                timeZone: device.timeZone,
                levelChangedCnt: device.levelChangedCnt,
                routeLink: '/detail/' + cryptoService.aesEncrypt(i.DeviceSN),
                isExpired: device.isExpired,
                hardwarefault: hardwareFaultDetailLogic(device, faultLevelMaps, faultCodeMaps),
                btyReplacement: (btyReplacement && btyReplacement.hasOwnProperty(device.dcode)) ? btyReplacement[device.dcode] : null,
                canTrial: device.canTrial,
                trialRemainDay: device.trial_remainday,
                planActivate: (device.plan_activate === undefined || device.plan_activate === null) ? false : device.plan_activate,
                owner_acode: device.owner_acode,
                share_status: device.share_status,
                share_id: device.share_id,
                share_group_id: device.share_group_id,
                share_type: shareObjectType.ShareGroupDevice,
                is_shared: true,
                protecting: device.Protecting,
                mspPlanActivate: (device.msp_plan_activate === undefined || device.msp_plan_activate === null) ?
                  false : device.msp_plan_activate,
                regionId: device.RegionId !== undefined ? device.RegionId : 0,
                Cur: device.Cur,
                Volt: device.Volt,
                VoltA: device.VoltA,
                VoltB: device.VoltB,
                VoltC: device.VoltC,
                InVoltA: device.InVoltA,
                InVoltB: device.InVoltB,
                InVoltC: device.InVoltC,
                OutVolt: device.OutVolt,
                Energy: device.Energy,
                EnergyT: device.EnergyT,
                Power: device.Power,
                PowerT: device.PowerT,
                Brand: device.Brand,
                DeviceIP: i.DeviceIP
              } as ViewDeviceInfo;

              result.push(item);
            }
          });
        }
      return result.filter(k => {
        if (typeof k === 'undefined') {
          return false;
        }
        return true;
        // if (k.SelectedType === -1) {
        //   return true;
        // }
        // return k.deviceStatusCode === Number(k.SelectedType);
      });
    } else {
      return [];
    }
  });
export const getDeviceGroupInfo = createSelector(getGroupState, DevicesFiltered, getDeviceSharingState, getGroupSharingState,
   getMspMemberAuthorityState, (group, device, share, groupshare, auth) => {
  const result = [] as ViewGroupInfo[],
        deviceObj = {},
        groupObj = {};
  deviceObj['no_group'] = [];
  const cryptoService = new CryptoService;
  if (device.length > 0) {
    device.forEach(item => {
      // NgRx 9 不可變性: 創建新對象副本以添加屬性
      let enrichedItem = item;
      if (item.share_type === shareObjectType.ShareDevice) {
        const shareDetail = Array.isArray(share?.entities)
          ? share.entities.find(s => item.share_id === s.Id)
          : null;
        if (shareDetail) {
          enrichedItem = {
            ...item,
            FirstName: shareDetail.FirstName,
            LastName: shareDetail.LastName
          };
        }
      }
      if ((item.share_type !== shareObjectType.ShareDevice) && (typeof item.gId === 'number')) {
        if (!deviceObj.hasOwnProperty(item.gId)) {
          deviceObj[item.gId] = [];
        }
        deviceObj[item.gId].push({data: enrichedItem});
      } else {
        deviceObj['no_group'].push({data: enrichedItem});
      }
    });
  }
  if (Array.isArray(groupshare?.entities) && groupshare.entities.length > 0) {
    groupshare.entities.forEach(item => {
      if (!groupObj.hasOwnProperty(item.GroupId)) {
        groupObj[item.GroupId] = item;
      }
    });
  }
  if (!group.Loading && group.Loaded && Array.isArray(group?.entities) && group.entities.length > 0) {
    const authList = auth.entities;
    group.entities.forEach(g => {
      const groups = {data: {}, children: [{data: {}}]} as ViewGroupInfo;
        groups.data['gId'] = g.Id;
        groups.data['name'] = g.gName;
        groups.data['type'] = groupStr;
        groups.data.timeZone = g.TimeZone;
        groups.data.deviceStatusCode = 3;
        groups.data.status = statusMapping[3].status;
        groups.data.icon = statusMapping[3].icon;
        groups.data.routeLink = '/group_detail/' + cryptoService.aesEncrypt(g.Id);
        // groups.data.desc = statusMapping[3].desc;
        let groupStatus = 0;
        if (deviceObj.hasOwnProperty(g.Id)) {
          groups.children = deviceObj[g.Id];
          for (const key in deviceObj[g.Id]) {
            if (groupStatus < deviceObj[g.Id][key].data.deviceStatusCode) {
              groupStatus = deviceObj[g.Id][key].data.deviceStatusCode;
            }
          }
          groups.data.deviceStatusCode = groupStatus;
          groups.data.status = statusMapping[groupStatus].status;
          groups.data.icon = statusMapping[groupStatus].icon;
          if (groupStatus === 0) {
            groups.data.desc = groupDesc;
          }
        }
        groups.data.is_shared = g.is_shared;
        groups.data.regionId = g.RegionId;
        if (g.is_shared) {
          groups.data.share_id = groupObj[g.Id] ? groupObj[g.Id].Id : 0;
          groups.data.owner_acode = groupObj[g.Id] ? groupObj[g.Id].acode : 0;
          groups.data.FirstName = groupObj[g.Id] ? groupObj[g.Id].FirstName : '';
          groups.data.LastName = groupObj[g.Id] ? groupObj[g.Id].LastName : '';
          groups.data.share_status = groupObj[g.Id] ? groupObj[g.Id].status : 0;
        }
        if (g.RegionId && authList && authList.length > 0) {
          const authItem = authList.find(item => item.RegionId === g.RegionId);
          if (authItem) {
            groups.data.EditDevice = authItem.EditDevice;
          }
        }
        result.push(groups);
      });
    }
    deviceObj['no_group'].map(item => {
      result.push(item);
    });
  return result;
});
export const getNoGroupDevices = createSelector(getDeviceGroupInfo, (group) => {
  return group.map(item => item.data)
    .filter(item => {
      return item.type !==  groupStr;
    });
});
export const getGroupDevices = createSelector(getDeviceGroupInfo, (group) => {
  return group.filter(item => {
    return item.data.type === groupStr;
  });
});


// Event
export const getEventsPageData = createSelector(getEventsState, DevicesFiltered, (event, info) => {
  if (event.isLoaded && !event.isLoading && event.entities.length > 0 ) {
    return event.entities.map((i) => {
      const device = info.find(l => l.DeviceSN === i.sn);
      if (device) {
        return {
          sn: i.sn,
          timeZone: device.timeZone,
          timezoneLabel: (device.timeZone !== null) ?
            'UTC' + ((Number(device.timeZone) >= 0) ? '+' + device.timeZone : device.timeZone)  + ':00' : '',
          gId: Number(device.gId),
          dcode: Number(device.dcode),
          name: device.name,
          type: device.type,
          event: i.event,
          routeLink: device.routeLink,
          share_group_id: device.share_group_id
        };
      }
      return;
    }).filter(item => !!item);
  }
});

// Summary Detail
export const getSummaryEvents = createSelector(getSummaryDetailState, getEventsMapsState, (data, maps) => {
  return data;
});

// Summary
export const getSummary = createSelector(getSummaryState, (data) => {
  return data;
});

// Preferences
export const getPreferences = createSelector(getPreferencesState, (preferences) => {
  return preferences;
});


// FloorMap
export const getFloorMapArrangeData = createSelector(getFloorMapState, getGroupDevices, DevicesFiltered, (data, group, device) => {
  // 將Map Details 與現有Device & Group進行比對
  if (data.Loaded && !data.Loading) {
    const groupFlat = group.map(item => item.data);
    const groupObj: {} = Object.assign({}, ...groupFlat.map(item => ({[item.gId]: item})));
    const deviceObj: {} = Object.assign({}, ...device.map(item => ({[item.dcode]: item})));
    const maps = Object.values(data.entities).map((item: FloorMap) => {
      const details = Array.isArray(item.details) ? item.details
        .filter((detail) => {
          if (detail.type === groupStr) {
            return groupObj.hasOwnProperty(detail.ownerId);
          }
          if (detail.type === deviceStr) {
            return deviceObj.hasOwnProperty(detail.ownerId);
          }
          return true;
        })
        .map((detail: any) => {
          if (detail.type === groupStr && groupObj.hasOwnProperty(detail.ownerId)) {
            return {
              ...detail,
              name: groupObj[detail.ownerId].name,
              status: groupObj[detail.ownerId].status,
              statusCode: groupObj[detail.ownerId].deviceStatusCode,
              isGroup: true, // 屬性為Group
              gId: detail.ownerId
            };
          }
          if (detail.type === deviceStr && deviceObj.hasOwnProperty(detail.ownerId)) {
            return {
              ...detail,
              name: deviceObj[detail.ownerId].name,
              status: deviceObj[detail.ownerId].status,
              statusCode: deviceObj[detail.ownerId].deviceStatusCode,
              isGroup: false,
              gId: (deviceObj[detail.ownerId].gId !== null) ? deviceObj[detail.ownerId].gId : null,
              deviceSN: deviceObj[detail.ownerId].DeviceSN,
              isExpired: deviceObj[detail.ownerId].isExpired
            };
          }
          return { ...detail };
        })
        : [];
      return {...item, details: details} as FloorMap;
    });
    return {...data, entities: Object.assign({}, ...maps.map(item => ({[item.id]: item})))};
  }
  return data;
});

// Floor Map Data for Global Map
export const getFloorMapInfoForGlobalMap = createSelector(getFloorMapArrangeData, (data) => {
  if (data.Loaded && !data.Loading && data.ids.length > 0) {
    return Object.values(data.entities);
  }
  return [];
});

// Device Ids (From NodeJS)
export const getDeviceIds = createSelector(getDeviceState, data => {
  return data.ids;
});

// Device Info (From NodeJS)
export const getDeviceInfo = createSelector(getDeviceState, data => {
  return data.entities;
});

// Account Ids (From NodeJS)
export const getAccountIds = createSelector(getAccountState, data => {
  return data.ids;
});

// Account Info (From NodeJS)
export const getAccountInfo = createSelector(getAccountState, data => {
  return data.entities;
});

export const getAccountbyFilter = createSelector(getAccountState, getAccountListFilterState, (data, filter) => {
  const result = {Loading: data.Loading, Loaded: data.Loaded, entities: Object.values(data.entities)};
  if (filter && filter.Loaded && filter.Filter.Authority && filter.Filter.Authority === 1) {
    result.entities = result.entities.filter(item => filter.Filter.AuthorityRegion.includes(item.CompanyId));
  }
  if (filter && filter.Loaded && filter.Filter.Acodes) {
    result.entities = result.entities.filter(item => filter.Filter.Acodes.includes(item.Acode));
  }
  return result;
});

// Single Account Info (From NodeJS)
export const getSingleAccountInfo = (acode) => createSelector(getAccountState, data => {
  if (data.Loaded && !data.Loading && data.entities.hasOwnProperty(acode)) {
    return data.entities[acode];
  }
});

export const getOauth = createSelector(getOauthState, res => {
  return res;
});

export const getOauthLogin = createSelector(getOauthLoginState, data => {
  return data;
});

export const getAccountOauthSWParam = createSelector(getAccountOauthSWParamState, data => {
  return data;
});

// AddAuthOtp
export const getAuthotp = createSelector(getAuthOtpState, data => {
  return data;
});

// CheckAuthOtp
export const getCheckAuthOtp = createSelector(getCheckAuthOtpState, data => {
  return data;
});

// EnableAuthOtp
export const getEnableAuthotp = createSelector(getEnableAuthOtpState, data => {
  return data;
});

// System Log
export const getSystemLog = createSelector(getSystemlogState, data => {
  return data;
});

// System Log Type
export const getSystemLogType = createSelector(getSystemlogTypeState, data => {
  return data;
});

// get Api Key
export const getApiKey = createSelector(getApiKeyState, getRegionState, getAccountState, (data, region, account) => {
  if (data.Loaded && !data.Loading && region.Loaded && !region.Loading && account.Loaded && !account.Loading) {
    const result = [];
    if (data.entities !== null && region.entities !== null) {
      const cryptoService = new CryptoService;
      const apiKeys = Object.values(data.entities);
      const regions = Object.values(region.entities);
      apiKeys.forEach((i) => {
        const acode = i['acode'];
        const regionItem = regions.find(r => r.Id === i['RegionId']);
        const accountInfo = account.entities.hasOwnProperty(i['CreateId']) ? account.entities[i['CreateId']].Account : '';
        const item = {
          RegionName: regionItem !== undefined ? regionItem.RegionName : '',
          RegionId: i['RegionId'],
          acode: acode,
          Account: accountInfo !== undefined ? accountInfo : '',
          name: i['Name'],
          apiKey: i['Key'],
          apiKeyId: i['ItemId'],
          ExpiredTime: i['ExpiredTime'],
          CreateTime: i['CreateTime'],
          status: i['IsEnable'] === 1 ? true : false,
          expired: i['Status'] === 3 ? true : false,
          HashApiKeyId: cryptoService.aesEncrypt(i['ItemId']),
          HashAcode: cryptoService.aesEncrypt(i['acode']),
        };
        result.push(item);
      });
    }
    return result;
  }
});

// Api Key Usage
export const getApiKeyUsage = createSelector(getApiKeyUsageState, (data) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

// Companion list
export const getCompanionlist = createSelector(getCompanionState, (data) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

// Companion OverView
export const getCompanionOverView = createSelector(getCompanionOverViewState, (data) => {
  if (data.Loaded && !data.Loading) {
    if (data.entities !== null && data.entities !== undefined) {
      const companionlist = Object.values(data.entities);
      if (companionlist.length > 0) {
        const groupby = [];
        // groupby companion
        companionlist.forEach((i) => {
          if (groupby.length > 0) {
            const companionitem = groupby.find(g => g.dcode === i['dcode']);
            if (companionitem !== undefined && companionitem !== null) {
              groupby.find(q => q.dcode === i['dcode']).Companion.push({
                  Status: i['Status'],
                  CompId: i['CmpnId'],
                  UpTime: i['UpTime'],
                  Action: i['Action'],
                  IsConfirm: i['IsConfirm'],
                  IsPass: i['IsPass'],
              });
            } else {
              groupby.push({
                dcode : i['dcode'],
                Companion: [{
                  Status: i['Status'],
                  CompId: i['CmpnId'],
                  UpTime: i['UpTime'],
                  Action: i['Action'],
                  IsConfirm: i['IsConfirm'],
                  IsPass: i['IsPass'],
                }]
              });
            }
          } else {
            groupby.push({
              dcode : i['dcode'],
              Companion: [{
                Status: i['Status'],
                CompId: i['CmpnId'],
                UpTime: i['UpTime'],
                Action: i['Action'],
                IsConfirm: i['IsConfirm'],
                IsPass: i['IsPass'],
              }]
            });
          }
        });
        return groupby;
      }
    }
  }
});

// Companion Protection Process Device
export const getCompanionProtectionProcessDevice = createSelector(getCompanionProtectionProcessDeviceState, (data) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

// Resend Data Of Companion Protection Process
export const getResendDataOfCompanionProtectionProcess = createSelector(getResendDataOfCompanionProtectionProcessState, (data) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

// Companion Rule List
export const getCompanionRuleList = createSelector(getCompanionRuleListState, (ruleList) => {
  const ruleitem = [];
  if (ruleList.Loaded && !ruleList.Loading) {
    const rules = Object.values(ruleList.entities);
    if ( rules.length > 0) {
      rules.map((r: any) => {
        const item = {
          dcode : r.dcode,
          name : '',
          rules : [],
        };
        if (r.Rules !== undefined && r.Rules.length > 0) {
          r.Rules.map((i) => {
            item.rules.push({
              action : i.Action,
              delay : i.Delay,
              event : i.Event,
              name : i.CmpnId,
              ruleId : i.RuleId,
            });
          });
        }
        ruleitem.push(item);
      });
    }
  }
  return ruleitem;
});

// Authority Info (From NodeJS)
export const getAuthorityInfo = createSelector(getAuthorityState, data => {
  return data.entities;
});

export const getAccountMgtList = createSelector(getAccountbyFilter, getAuthorityState, getRegionState, getAccountMgtListFilterState,
  getCurrentUser, (info, authstate, regionstate, filter, user) => {
    const auth = authstate.entities;
    const result = { accountList: [], Loading: (info.Loading || authstate.Loading), Loaded: (info.Loaded && authstate.Loaded)};
    const cryptoService = new CryptoService;
    const region = regionstate.entities;
    const isSuperAdmin = (user.authority && user.authority === 2) ? true : false;
    result.accountList = Object.values(info.entities).map((item) => {
      const authority = auth.hasOwnProperty(item.Acode) ? auth[item.Acode].Type : 0;
      const hashAcode = cryptoService.aesEncrypt(item.Acode);
      const Company = region.hasOwnProperty(item.CompanyId) ? region[item.CompanyId].RegionName : '';
      return {...item, Authority: authorityLevelMap[authority], Company: Company, AuthorityCode: authority, HashAcode: hashAcode};
    });
    if (filter.AuthorityIdOption !== -1) {
      result.accountList = result.accountList.filter(i => i.AuthorityCode === filter.AuthorityIdOption);
    }
    if (filter.RegionIdOption !== -1) {
      result.accountList = result.accountList.filter(i => i.CompanyId === filter.RegionIdOption);
    }
    if (!isSuperAdmin) {
      result.accountList = result.accountList.filter(i => i.AuthorityCode !== 2);
    }
    result.accountList = result.accountList.filter((i) => {
      const pattern = /^region_\S+@.+$/;
      const lowerCaseItem = i.Account.toLowerCase();
      return !pattern.test(lowerCaseItem);
    });
    return result;
});

// Check License State
export const getCheckLicense = createSelector(getCheckLicenseState, getDeviceInfo, (data, device) => {
  return {...data, deviceInfo: device};
});

// License
export const getLicenseFilterLoad = createSelector(getLicenseMgtListFilterState, (filter) => {
  return filter;
});
export const getLicenseMgtListExpiredDate = createSelector(getLicenseMgtListState, (license) => {
  if (license.Loaded && !license.Loading) {
    const item = Object.values(license.entities);
    return expiredDateCalculated(item);
  }
  return {};
});
export const getLicenseSettingListExpiredDate = createSelector(getLicenseSettingState, (license) => {
  if (license.Loaded && !license.Loading) {
    const item = Object.values(license.entities);
    return expiredDateCalculated(item);
  }
  return {};
});

// FirmWare
export const getFirmWareUpdatingData = createSelector(getFirmWareUpdatingDataState, (data) => {
  return data;
});
export const getFirmWareLog = createSelector(getFirmWareLogState, (data) => {
  return data;
});

// Privacy And Terms
export const getPrivacyAndTerms = createSelector(getPrivacyAndTermsState, (data) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

// Purchase Packages
export const getUserPackages = createSelector(getUserPackageState, (data) => {
  if (data.isLoaded && !data.isLoading) {
    return data.entities;
  }
});

// Battery Test
export const getBatteryTestStatus = createSelector(getBatteryTestState, (data) => {
  return data;
});

// Battery Test Scheduler
export const getBatteryTestScheduler = createSelector(getBatteryTestSchedulerState, (data) => {
  return data;
});

// Battery Test Scheduler Detail
export const getBatteryTestSchedulerDetail = createSelector(getBatteryTestSchedulerDetailState, (data) => {
  return data;
});

// Battery Test Scheduler Result
export const getBatteryTestSchedulerResult = createSelector(getBatteryTestSchedulerResultState, (data) => {
  return data;
});

// Device UPS Control
export const getDeviceUpsControl = createSelector(getDeviceUpsControlState, (data) => {
  return data;
});

// Trial License
export const getTrialLicense = createSelector(getTrialLicenseState, (data) => {
  // 創建新對象副本以避免 PrimeNG Table 排序時修改只讀數組 (NgRx 9 immutability)
  return { ...data, entity: data.entity ? [...data.entity] : [] };
});

// Country List
export const getCountryList = createSelector(getCountryState, (data) => {
  return data;
});

// Wifi Card Binding Step
export const getWifiCardBindingStep = createSelector(getWifiCardState, (data) => {
  return data.wifiCardStep;
});

// Event Monitoring Filters
export const getEventMonitoringFilters = createSelector(getEventMonitoringFilterState, (data) => {
  return data.device_status;
});

// Plan Setting Devices
export const getPlanSettingDevices = createSelector(getDevicesInfoState, getLicenseSettingListExpiredDate, (device, licenseInfo) => {
  let result: any = [];
  if (device.isLoaded && device.entities !== null) {
    result = device.entities.filter(item => !item.is_shared).map((item) => {
      let isTrial = false;
      let trialMinRemainDay = 0,
        expirationDate = new Date();
      if (licenseInfo.hasOwnProperty(item.Id)) {
        for (const i of licenseInfo[item.Id]) {
          if (i.LicenseType === 3 && i.RemainDay > 0 && i.UsingStatus !== 6) {
            if (isTrial) {
              if (trialMinRemainDay > i.RemainDay) { // Get minimum expirationDate
                trialMinRemainDay = i.RemainDay;
              }
            } else {
              isTrial = true;
              trialMinRemainDay = i.RemainDay;
              // break;
            }
            expirationDate = addDays(new Date(), trialMinRemainDay);
          }
        }
      }
      return {
        dcode: item.Id,
        name: item.DeviceName,
        image: (item.Model) ? imageUrl + item.Model : null,
        isTrial: isTrial,
        expirationDate: (isTrial) ? expirationDate : null,
        deviceType: item.DeviceType,
        deviceSubType: item.DeviceSubType,
        DisplaySourceType: item.DisplaySourceType
      };
    });
  }
  return {...device, entities: result};
});

// Plan Key List Entities
export const getPlanKeyEntities = createSelector(getPlanListState, fromPlanList.selectEntities);


// Region End -- DataLogic----------------------------------------------------------------------------------------------


// Region Start --Frontend Viewed---------------------------------------------------------------------------------------

// Page - Dashboard
export const getDevicesTypeCount = createSelector(getDevicesStatusState, getMspMemberAuthorityState, (state, memberState) => {
  let all = 0, normal = 0, warning = 0, critical = 0, offline = 0;
  if (state.entities.DeviceList && state.entities.DeviceList.length > 0) {
    if (!memberState.Loading) {
      
      const hasMemberEntities = memberState.entities && memberState.entities.length > 0;
      const isNormalAccount = !hasMemberEntities; 
      const hasViewPermission = hasMemberEntities && memberState.entities.some(e => e.ViewDevice === 1);
      
      if (isNormalAccount || hasViewPermission) {
        state.entities.DeviceList.forEach(device => {
          const isNotTrial = device.canTrial === undefined || !device.canTrial;
          const shouldCount = isNormalAccount || (hasViewPermission && isNotTrial);

          if (shouldCount) {
            all++;
            const status = device.device_status;
            if (status === 0) normal++;
            else if (status === 1) warning++;
            else if (status === 2) critical++;
            else if (status === 3 || status === undefined) offline++;
          }
        });
      }
    }
  }

  // ==========================================
  // ShareDeviceList
  // ==========================================
  if (state.entities.ShareDeviceList && state.entities.ShareDeviceList.length > 0) {
    state.entities.ShareDeviceList.forEach(device => {
      if (device.share_status !== 2) {
        all++;
        if (device.share_status === shareDeviceStatus['Accepted']) {
          const status = device.device_status;
          if (status === 0) normal++;
          else if (status === 1) warning++;
          else if (status === 2) critical++;
          else if (status === 3 || status === undefined) offline++;
        }
      }
    });
  }

  // ==========================================
  // ShareGroupDeviceList
  // ==========================================
  if (state.entities.ShareGroupDeviceList && state.entities.ShareGroupDeviceList.length > 0) {
    state.entities.ShareGroupDeviceList.forEach(device => {
      if (device.share_status !== 2) {
        all++;
        if (device.share_status === shareDeviceStatus['Accepted']) {
          const status = device.device_status;
          if (status === 0) normal++;
          else if (status === 1) warning++;
          else if (status === 2) critical++;
          else if (status === 3 || status === undefined) offline++;
        }
      }
    });
  }
  
  return {
    isLoading: state.isLoading,
    isLoaded: state.isLoaded,
    data: [
      { label: TRANSLATE('All'), value: -1, title: all },
      { label: TRANSLATE('Normal'), value: 0, title: normal },
      { label: TRANSLATE('Warning'), value: 1, title: warning },
      { label: TRANSLATE('Critical'), value: 2, title: critical },
      { label: TRANSLATE('Offline'), value: 3, title: offline }
    ]
  };
});

export const getNoGroupDevicesPageView = createSelector(getDeviceGroupInfo, getSelectedDashboardStatusState, (group, selectedStatus) => {
  return group.map(item => item.data)
    .filter(item => {
      if (Number(selectedStatus) === -1) {
        return item.type !==  groupStr && !item.is_shared;
      }
      return item.type !==  groupStr && item.deviceStatusCode === Number(selectedStatus) && !item.is_shared;
    });
});
export const getNoGroupShareDevicesPageView = createSelector(getDeviceGroupInfo, getSelectedDashboardStatusState,
  (group, selectedStatus) => {
  return group.map(item => item.data)
    .filter(item => {
      if (Number(selectedStatus) === -1) {
        return item.type !==  groupStr && item.is_shared && item.share_status !== shareDeviceStatus['Rejected'];
      }
      return item.type !==  groupStr && item.deviceStatusCode === Number(selectedStatus) &&
      item.is_shared && item.share_status !== shareDeviceStatus['Rejected'];
    });
});
export const getGroupDevicesPageGridView = createSelector(getDeviceGroupInfo, getSelectedDashboardStatusState, (group, selectedStatus) => {
  let result = [] as ViewGroupInfo[];
  group = group.filter(item => item.data.type === groupStr);
  // 如Group下有Device且不是Offline狀態，而selectedStatus為3(offline)時，移除該空Group項目。 如Group底下無Device，則該空Group顯示於Offline.
  const emptyGroup = group.map(copyGroup).filter(item => item.children.length === 0);
  if (Number(selectedStatus) === -1) {
    return group.map(copyGroup);
  } else {
    group.forEach((item, index) => {
      result.push({
        data: { ...item.data },
        children: item.children.map(copyChild) as { data: ViewDeviceInfo }[]
      });
      result[index].data.status = statusMapping[Number(selectedStatus)].status;
      result[index].data.icon = statusMapping[Number(selectedStatus)].icon;
      for (let i = result[index].children.length - 1; i >= 0; i -= 1) {
        if (result[index].children[i].data.deviceStatusCode !== Number(selectedStatus)) {
          result[index].children.splice(i, 1);
        }
      }
    });
  }
  result = result.filter(item => item.children.length > 0);
  if (Number(selectedStatus) === 3) {
    return result.concat(emptyGroup);
  } else {
    return result;
  }
  function copyChild(o) {
    return { ...o, data: { ...o.data } };
  }
  function copyGroup(o) {
    return {
      data: { ...o.data },
      children: (o.children || []).map(copyChild) as { data: ViewDeviceInfo }[]
    };
  }
});
export const getGroupShareDevicesPageGridView =
  createSelector(getDeviceGroupInfo, getSelectedDashboardStatusState, (group, selectedStatus) => {
  let result = [] as ViewGroupInfo[];
  group = group.filter(item => item.data.type === groupStr);
  // 如Group下有Device且不是Offline狀態，而selectedStatus為3(offline)時，移除該空Group項目。 如Group底下無Device，則該空Group顯示於Offline.
  const emptyGroup = group.map(copyGroup).filter(item => item.children.length === 0);
  if (Number(selectedStatus) === -1) {
    group.forEach((item, index) => {
      result.push({
        data: { ...item.data },
        children: item.children.filter(i => i.data.is_shared && i.data.share_status !== shareDeviceStatus['Rejected'])
                               .map(copyChild) as { data: ViewDeviceInfo }[]
      });
    });
    return result;
  } else {
    group.forEach((item, index) => {
      result.push({
        data: { ...item.data },
        children: item.children.filter(i => i.data.is_shared && i.data.share_status !== shareDeviceStatus['Rejected'])
                               .map(copyChild) as { data: ViewDeviceInfo }[]
      });
      result[index].data.status = statusMapping[Number(selectedStatus)].status;
      result[index].data.icon = statusMapping[Number(selectedStatus)].icon;
      for (let i = result[index].children.length - 1; i >= 0; i -= 1) {
        if (result[index].children[i].data.deviceStatusCode !== Number(selectedStatus)) {
          result[index].children.splice(i, 1);
        }
      }
    });
  }
  result = result.filter(item => item.children.length > 0);
  if (Number(selectedStatus) === 3) {
    return result.concat(emptyGroup);
  } else {
    return result;
  }
  function copyChild(o) {
    return { ...o, data: { ...o.data } };
  }
  function copyGroup(o) {
    return {
      data: { ...o.data },
      children: (o.children || []).map(copyChild) as { data: ViewDeviceInfo }[]
    };
  }
});
export const getGroupDevicesPageListView =
createSelector(getNoGroupDevicesPageView, getNoGroupShareDevicesPageView, getGroupDevicesPageGridView, (device, sharedevice, group) => {
  return group.concat(device.map(item => {
    return {
      data: item
    } as ViewGroupInfo;
  }), sharedevice.map(item => {
    return {
      data: item
    } as ViewGroupInfo;
  }));
});
export const getWithoutGroupFeatureView = createSelector(DevicesFiltered, getSelectedDashboardStatusState, (device, selectedStatus) => {
  if (Number(selectedStatus) === -1) {
    return device.filter(item => !item.is_shared);
  }
  return device.filter(item => item.deviceStatusCode === Number(selectedStatus) && !item.is_shared);
});
export const getWithoutGroupFeatureListView = createSelector(DevicesFiltered, getSelectedDashboardStatusState, (device, selectedStatus) => {
  if (Number(selectedStatus) === -1) {
    return device;
  }
  return device.filter(item => item.deviceStatusCode === Number(selectedStatus));
});
export const getWithoutGroupShareFeatureView =
  createSelector(DevicesFiltered, getSelectedDashboardStatusState, (device, selectedStatus) => {
  if (Number(selectedStatus) === -1) {
    return device.filter(item => item.is_shared && item.share_status !== shareDeviceStatus['Rejected']);
  }
  return device.filter(item =>
    item.deviceStatusCode === Number(selectedStatus) && item.is_shared && item.share_status !== shareDeviceStatus['Rejected']);
});

export const getAddDevicesListToGroup = createSelector(getNoGroupDevices, (device) => {
  return device.filter(item => !item.is_shared).map(item => {
    return {
      label: item.name, value: Number(item.dcode), timeZone: item.timeZone, regionId: item.regionId
    };
  });
});

export const getIsMsp = createSelector(getCurrentUser, (user) => {
  return (user && !user.isLoading && user.isLoaded && user.isLogin) ? (user.isMsp ? user.isMsp : false) : undefined;
});

export const getEditDevicesListToGroup = createSelector(getDeviceGroupInfo , getIsMsp, (groupInfo, isMsp, props) => {
  let noGroupDevice = new Array(),
    result = new Array();
  let groupRegionId = 0;
    groupInfo.filter((i) => {
      if (i.data.gId === props.gId) {
        groupRegionId = i.data.regionId;
      }
    });
  noGroupDevice = groupInfo
    .filter(item => {
      return (item.data.type !== groupStr) ||
        (item.data.gId === props.gId);
      // no group device or in the same group.
    }).map(item => {
      if (item.data.type !== groupStr) {
        if (!item.data.is_shared) {
          if (isMsp) {
            if (item.data.regionId === groupRegionId) {
              return {
                label: item.data.name, value: Number(item.data.dcode), is_shared: item.data.is_shared
              };
            } else {
              return {};
            }
          } else {
            return {
              label: item.data.name, value: Number(item.data.dcode), is_shared: item.data.is_shared
            };
          }
        }
        // return {
        //   label: item.data.name, value: Number(item.data.dcode), is_shared: item.data.is_shared
        // };
      } else {
        if (item.children) {
          return filterEmptyChildren(item.children).map(i => {
            return {
              label: i.data.name, value: Number(i.data.dcode), is_shared: i.data.is_shared
            };
          });
        }
      }
      return null;
    }).filter(Boolean);
  result = [].concat(...noGroupDevice).filter(item => Object.keys(item).length !== 0);

  return result;
});
export const getDeviceGroupByGroupId  = createSelector(getGroupDevices, (group, props) => {
  return group.find(k => {
    return Number(k.data.gId === props);
  });
});
export const getGroupCount = createSelector(getGroupState, (data) => {
  return IsEmptyObject(data.entities) ? 0 : data.entities.length;
});


// Page - Regions
export const getRegionsOptions = createSelector(getRegionState, getCurrentUser, (regionState, user) => {
  let allRegions = Object.values(regionState.entities);
  if (user.authority !== 2) {
    allRegions = allRegions.filter((i) => user.AuthorityRegion.includes(Number(i.Id)));
  }
  return allRegions.map(res => {
    return { label: res.RegionName, value: res.Id };
  });
  /*  if (item.Loaded && item.Loaded && item.entities.length > 0) {
      return item.entities.map((region) => {
        return { label: region.Region, value: region.Id };
      });
    }
    return [
      { label: 'Default', value: 1 },
      { label: 'USA', value: 2 },
      { label: 'Germany', value: 3 },
      { label: 'Taiwan', value: 4 },
    ];*/
});
export const getAllRegionsOptions = createSelector(getRegionsOptions, (data) => {
  const result = [...data];
  result.unshift({label: 'All', value: -1});
  return result;
});
export const getRegions = createSelector(getRegionState, getAccountInfo, (regionState, accountInfo) => {
  const allRegions = Object.values(regionState.entities).map(item => {
    let accountItem = '';
    if (item.MainAdmin !== undefined) {
      accountItem = (item.Admins !== undefined) ?
       item.Admins.filter(accountId => accountInfo.hasOwnProperty(accountId) && accountId !== item.MainAdmin).map(accountId => {
        return  accountInfo[accountId].Account;
      }).join('/\r') : '';
    } else {
      accountItem = (item.Admins !== undefined) ? item.Admins.filter(accountId => accountInfo.hasOwnProperty(accountId)).map(accountId => {
        return  accountInfo[accountId].Account;
      }).join('/\r') : '';
    }
    return {...item,
      account: accountItem
    };
  });
  return allRegions || [];
});

export const getRegionHierarchy = createSelector(getRegionState, (regionState) => {
  if (regionState.Loaded && !regionState.Loading) {
    const regionsHierarchyArr = Object.values(regionState.entities).filter(i => !i.IsMsp ||
       (i.ParentRegionId > 0 && !(i.MspMainRegionId !== i.Id && i.IsMsp)));  // !(i.MspMainRegionId != i.Id && i.IsMsp) 作用為濾掉子公司
    const result = [];
    const nodes = [];
    const lookupList = {};
    regionsHierarchyArr.forEach((item) => {
      const n = {
        Id: item.Id,
        label: item.RegionName,
        ParentRegionId: item.ParentRegionId,
        children: [],
        expanded: true,
      };
      lookupList[n.Id] = n;
      nodes.push(n);
      if (lookupList[1] == null || lookupList[1] === undefined) {
        result.push(n);
      } else if (n.Id === n.ParentRegionId) {
        result.push(n);
      }
    });
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      if (n.ParentRegionId !== n.Id) {
        if (lookupList[n.ParentRegionId] != null && lookupList[n.ParentRegionId] !== undefined) {
          lookupList[n.ParentRegionId].children = [...lookupList[n.ParentRegionId].children, n];
        }
      }
    }
    result.forEach((item) => {
      const iterationNodes = (node) => {
        if (node.children.length === 0) {
          node.expanded = false;
        } else {
          node.children.forEach((child) => {
            iterationNodes(child);
          });
        }
      };
      iterationNodes(item);
    });
    return result;
  }
});

// RegionMember
export const getRegionMember = createSelector(getRegionMemberState, data => {
    return data;
});

// ReadMspAuthority
export const getMspAuthority = createSelector(getMspAuthorityState, data => {
  if (!data.Loading && data.Loaded) {
    return data.entities || [];
  }
});

// ReadMspMemberAuthority
export const getMspMemberAuthority = createSelector(getMspMemberAuthorityState, data => {
  if (!data.Loading && data.Loaded) {
    return data.entities || [];
  }
});

// MspRegion State
export const getMspRegion = createSelector(getMspRegionState, (data) => {
  if (!data.Loading && data.Loaded) {
    return fromMspRegion.selectAll(data);
  }
});

// getMsp RegionAuth By Account
export const getMspRegionAuth = createSelector(getMspRegionState, getAccountInfo, getMspAuthority, (data, accountInfo, mspAuthority) => {
  if (!data.Loading && data.Loaded && Object.values(data.entities).length > 0) {
    const msp_auth_dic = [];
    if (mspAuthority !== undefined && mspAuthority.length > 0) {
      mspAuthority.map(m => {
        if (msp_auth_dic[m.RegionId] == undefined) {
          msp_auth_dic[m.RegionId] = [];
        }
        msp_auth_dic[m.RegionId].push(m);
      });
    }
    let admins = [];
    const getData = fromMspRegion.selectAll(data).map(item => {
      let accountItem = '';
      let device_managers = '';
      let viewers = '';
      let device_manager_arr = [];
      let viewer_arr = [];
      if (item.Admins !== undefined) {
        accountItem =
        item.Admins.filter(accountId => accountInfo.hasOwnProperty(accountId) && accountId !== item.MainAdmin).map(accountId => {
          if (!admins.includes(accountId)) {
            admins.push(accountId);
          }
          return  accountInfo[accountId] !== undefined ? accountInfo[accountId].Account : '';
        }).join('/\r');
      }
      const auth_list = msp_auth_dic[item.Id];
      if (auth_list !== undefined) {
        auth_list.forEach((a) => {
          if (accountInfo.hasOwnProperty(a.acode) && a.acode !== item.MainAdmin) {
            if (!admins.includes(a.acode)) {
              if (a.ViewDevice === 1 && a.EditDevice === 1) {
                device_manager_arr.push(accountInfo[a.acode].Account);
              } else if (a.ViewDevice === 1 && a.EditDevice === 0) {
                viewer_arr.push(accountInfo[a.acode].Account);
              }
            }
          }
        })
      }
      // if (item.Members !== undefined) {
      //   // For adminMembers
      //   item.Members.filter(acode => accountInfo.hasOwnProperty(acode) && acode !== item.MainAdmin &&
      //   (
      //     (msp_auth_dic[acode] !== undefined && msp_auth_dic[acode].ViewDevice === 1 && msp_auth_dic[acode].EditDevice === 1))).map(acode => {
      //       if (accountInfo[acode] !== undefined) {
      //         if (item.Admins !== undefined) {
      //           if (!item.Admins.includes(acode)) {
      //             adminMembers_arr.push(accountInfo[acode].Account)
      //           }
      //         } else {
      //           adminMembers_arr.push(accountInfo[acode].Account)
      //         }
      //       }
      //   });
      //   members = item.Members.filter(acode => accountInfo.hasOwnProperty(acode) && acode !== item.MainAdmin &&
      //   (msp_auth_dic[acode] !== undefined && msp_auth_dic[acode].ViewDevice === 1 && msp_auth_dic[acode].EditDevice !== 1) &&
      //   (item.Admins === undefined || !item.Admins.includes(acode))).map(acode => {
      //     return  accountInfo[acode] !== undefined ? accountInfo[acode].Account : '';
      //   }).join('/\r');
      // }
      if (item.Account !== undefined && item.Id !== item.MspMainRegionId) {
        if (accountItem !== '') {
          if (!accountItem.includes(item.Account.account)) {
            accountItem = item.Account.account + '/\r' + accountItem;
          }
        } else {
          accountItem += item.Account.account;
        }
      }
      device_managers = device_manager_arr.join('/\r');
      viewers = viewer_arr.join('/\r');
      return {...item,
        account: accountItem,
        device_managers: device_managers,
        viewers: viewers
      };
    });
    return getData || [];
  }
});

export const getPROStatusLock = createSelector(getCurrentUser, getRegionState, getMspRegionPaymentState, (user, regionState, paymentState) => {
  const PROStatusLock = {
    isLoaded: false,
    Lock: false,
    AuthType: -1
  };
  
  if (user.isMsp) {
    if (!regionState.Loading && regionState.Loaded && !paymentState.Loading && paymentState.Loaded) {
      const regionList = Object.values(regionState.entities);
      const userRegion = regionList.find(f => f.Id === user.RegionId);
      if (userRegion && paymentState.entities && paymentState.entities.length > 0) {
        const payment = paymentState.entities.find(f => f.MspRegionId === userRegion.MspMainRegionId);
        if (payment) {
          PROStatusLock.Lock = (payment.LockStatus == PROLockStatusIndex.Locked);
          if (PROStatusLock.Lock) {
            if (user.authority !== authorityMap.EndUser) {
              if (userRegion.MspMainRegionId === userRegion.Id) {
                if (typeof payment.ChargeType === "undefined" || payment.ChargeType === null) {
                  PROStatusLock.AuthType = PROStatusLockAuthTypeIndex.AccountManager;
                  PROStatusLock.isLoaded = true;
                } else {
                  PROStatusLock.AuthType = PROStatusLockAuthTypeIndex.EndUserAccountManager;
                  PROStatusLock.isLoaded = true;
                }
              } else {
                PROStatusLock.AuthType = PROStatusLockAuthTypeIndex.NotMspMainRegionAccountManager;
                PROStatusLock.isLoaded = true;
              }
            } else {
              PROStatusLock.AuthType = PROStatusLockAuthTypeIndex.NotMspMainRegionAccountManager;
              PROStatusLock.isLoaded = true;
            }
          } else {
            PROStatusLock.isLoaded = true;
          }
        }
      }
    }
  } else {
    PROStatusLock.isLoaded = true;
  }
  return PROStatusLock;
});

export const getMspRegionHierarchy = createSelector(getMspRegionState, getAccountInfo, (regionState, accountInfo) => {
  if (regionState.Loaded && !regionState.Loading && Object.values(regionState.entities).length > 0) {
    // ------------------------------------------------------------------
    // Id     Region	      		  ParentRegionId		MspMainRegionId
    // 278		ABC Company		      302			          302
    // 302		SHICompanyyyyyyyy	  2		            	302
    // 383		asdfasdfasdfasdf	  -1	          		302
    // ------------------------------------------------------------------
    // 參考以上 3 筆資料:
    //    1. SHICompanyyyyyyyy 公司, 跟欄位 Id 跟 MspMainRegionId 同樣是 302, 這家就是母公司
    //    2. ABC Company 公司, 欄位 ParentRegionId 是 302, 確認為 SHICompanyyyyyyyy 的子公司
    //    3. asdfasdfasdfasdf 公司, 欄位 ParentRegionId 是 -1, 但 MspMainRegionId 是 302, 表示只是以 SHICompanyyyyyyyy 名義 "建立" 出來, 準備成為子公司的公司
    //    4. 簡單說 MspMainRegionId 為 302 是由 Customer Management 這個 Table Add 的公司, 在 Hierarchy 區域拉好關聯 (Add) 才會存入 ParentRegionId 這個欄位


    // 理論上讀進來的 regionState.entities 只包含某一個 "母公司" 以及其底下其餘子公司 (資料是從 API "/region/msp/read" 拉出來的, 會吃母公司的 Id)
    const regionsHierarchyArr = fromMspRegion.selectAll(regionState).filter(i => i.MspMainRegionId > 0); // 代表應該是 Msp 的才要列入判斷
    // debugger;
    const result = [];
    const nodes = [];
    const lookupList = {};
    regionsHierarchyArr.forEach((item) => {
      let adminsItem = [];
      // 大於本身權限的Account,例如建立母公司的systemadmin母公司的systemadmin
      if (item.Account !== undefined && item.Id !== item.MspMainRegionId) {
        adminsItem.push(item.Account.account);
      }
      if (item.Admins !== undefined) {
        item.Admins.filter(accountId => accountInfo.hasOwnProperty(accountId) && accountId !== item.MainAdmin).map(accountId => {
          if (accountInfo[accountId] !== undefined) {
            adminsItem.push(accountInfo[accountId].Account);
          }
        });
      }
      const n = {
        Id: item.Id,
        label: item.RegionName,
        ParentRegionId: item.ParentRegionId,
        MspMainRegionId: item.MspMainRegionId,
        children: [],
        expanded: true,
        admins: item.Admins ? [...item.Admins] : [],
        adminsItem: adminsItem
      };
      lookupList[n.Id] = n;
      nodes.push(n);

      // 參考 Admin Management 頁面的 Hierarchy 產生方法, 但這邊要注意的是多加一組判斷確認是否為 "母公司"
      if (n.Id === n.ParentRegionId || n.Id === n.MspMainRegionId) {  // "n.Id === n.MspMainRegionId" 用於判斷是母公司
        result.push(n);
      }
    });
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      // 此處應該就是在判斷要成為 children, 也就是子公司的地方
      if (n.ParentRegionId !== n.Id && n.MspMainRegionId !== n.Id) {  // 分為
        try {
          lookupList[n.ParentRegionId].children = [...lookupList[n.ParentRegionId].children, n];
        } catch (e) {
        }
      }
    }
    result.forEach((item) => {
      const iterationNodes = (node) => {
        if (node.children.length === 0) {
          node.expanded = false;
        } else {
          node.children.forEach((child) => {
            iterationNodes(child);
          });
        }
      };
      iterationNodes(item);
    });
    // debugger;
    return result;
  }
});

// getMspRegionPayment
export const getMspRegionPayment = createSelector(getMspRegionPaymentState, getRegionState, (data, region) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    const result = {
      payment_list : [],
      payment_dic : [],
      region_dic : []
    };
    const payment_data_dic = []
    const region_dic = [];
    const payment_dic = [];
    const customer_id_arr = [];
    const customer_dic = [];
    const allRegions = Object.values(region.entities);
    const payment_list = data.entities;
    allRegions.map((r) => {
      region_dic[r.Id] = r;
    });
    result.region_dic = region_dic;
    if (payment_list !== undefined && !IsEmptyObject(payment_list)) {
      payment_list.map((p) => {
        payment_dic[p.MspRegionId] = p;
        if (p.Customers !== undefined && p.Customers.length > 0) {
          p.Customers.map((i) => {
            customer_id_arr.push(i.Id);
            customer_dic[i.Id] = p.MspRegionId;
          });
        }
        if (p.MspRegionId !== undefined) {
          if ((payment_data_dic[p.MspRegionId] == null || payment_data_dic[p.MspRegionId] == undefined)) {
            payment_data_dic[p.MspRegionId] = []
          }
          payment_data_dic[p.MspRegionId].push(p)
        }
      });
      result.payment_dic = payment_data_dic
      const cryptoService = new CryptoService;
      payment_list.filter(f => !customer_id_arr.includes(f.MspRegionId)).map((p) => {
        if (region_dic[p.MspRegionId] !== undefined) {
          const customer_name_arr = [];
          const item = {
            Company: region_dic[p.MspRegionId].RegionName,
            CompanyName: p.Company,
            Address: p.Address,
            RegionId: p.RegionId,
            MspRegionId: p.MspRegionId,
            MspMainRegionId: region_dic[p.MspRegionId].MspMainRegionId,
            Region: region_dic[p.MspRegionId].RegionName,
            UnitPrice: p.UnitPrice,
            DocDay: p.DocDay !== 0 ? p.DocDay : 1,
            DocumentCreateTime: p.DocumentCreateTime !== undefined ? moment.utc(Number(p.DocumentCreateTime) * 1000).format('YYYY/MM/DD HH:mm:ss') : '',
            EmailInfo: p.EmailInfo,
            HashMspRegionId: cryptoService.aesEncrypt(p.MspRegionId),
            // DocType: p.DocType,
            IsDistributor: p.IsDistributor,
            MinCharge: p.MinCharge,
            CompanyEmail: p.CompanyEmail,
            PaymentName: region_dic[p.MspRegionId] !== undefined ? region_dic[p.MspRegionId].PaymentName : '',
            PaymentAddress: region_dic[p.MspRegionId] !== undefined ? region_dic[p.MspRegionId].PaymentAddress : '',
            Customers: (p.Customers !== undefined && p.Customers.length > 0) ? p.Customers.reduce((acc, i) => {
              if (region_dic[i.Id] !== undefined && payment_dic[i.Id] !== undefined) {
                customer_name_arr.push(region_dic[i.Id].RegionName);
                acc.push({
                  label: region_dic[i.Id].RegionName,
                  value: i,
                  Company: region_dic[i.Id].RegionName,
                  Region: region_dic[p.MspRegionId].RegionName,
                  CompanyName: payment_dic[i.Id].Company,
                  Address: payment_dic[i.Id].Address,
                  RegionId: payment_dic[i.Id].RegionId,
                  MspRegionId: i.Id,
                  DistributorId: customer_dic[i.Id],
                  EmailInfo: payment_dic[i.Id].EmailInfo,
                  HashMspRegionId: cryptoService.aesEncrypt(i.Id),
                  CompanyEmail: payment_dic[i.Id].CompanyEmail,
                  UnitPrice: payment_dic[i.Id].UnitPrice,
                  DocDay: payment_dic[i.Id].DocDay !== 0 ? payment_dic[i.Id].DocDay : null,
                  Nodes: payment_dic[i.Id].Nodes,
                  // DeviceUsage: customer_UsedDevice,
                  MinCharge: payment_dic[i.Id].MinCharge,
                  DocumentCreateTime: payment_dic[i.Id].DocumentCreateTime !== undefined
                    ? moment.utc(Number(payment_dic[i.Id].DocumentCreateTime) * 1000).format('YYYY/MM/DD HH:mm:ss')
                    : '',
                  PaymentRegionId: payment_dic[i.Id].PaymentRegionId,
                  IsDistributor: payment_dic[i.Id].IsDistributor,
                  IsCustomer: true,
                  IsReminder: payment_dic[i.Id].IsReminder,
                  IsAllowLock: payment_dic[i.Id].IsAllowLock
                });
              }
              return acc;
            }, []) : [],
            Customers_Str: (p.Customers !== undefined && p.Customers.length > 0) ? customer_name_arr.join('/ ') : '',
            Nodes: p.Nodes !== null ? p.Nodes : 0,
            // DeviceUsage: UsedDevice,
            ChargeType: p.ChargeType !== undefined ? p.ChargeType : null,
            PaymentRegionId: p.PaymentRegionId,
            IsReminder: p.IsReminder,
            IsAllowLock: p.IsAllowLock,
            IsCustomer: false,
            IsEndUserPro: p.ChargeType !== null
          };
          result.payment_list.push(item);
        }
      });
    }
    return result;
  }
});

export const getMspRegionPaymentWithDeviceUsage = createSelector(getMspRegionPaymentState, getRegionState, getMspDeviceUsageListState, (data, region, usageList) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    const result = {
      payment_list : [],
      region_dic : []
    };
    const region_dic = [];
    const payment_dic = [];
    const customer_id_arr = [];
    const customer_dic = [];
    const deviceUsage_dic = [];
    const allRegions = Object.values(region.entities);
    const payment_list = data.entities;
    allRegions.map((r) => {
      region_dic[r.Id] = r;
    });
    if (!usageList.Loading && usageList.Loaded && usageList.entities && Object.keys(usageList.entities.body).length !== 0) {
      usageList.entities.body.map((m) => {
        deviceUsage_dic[m.RegionId] = m;
      });
    }
    result.region_dic = region_dic;
    if (payment_list !== undefined && !IsEmptyObject(payment_list)) {
      payment_list.map((p) => {
        payment_dic[p.MspRegionId] = p;
        if (p.Customers !== undefined && p.Customers.length > 0) {
          p.Customers.map((i) => {
            customer_id_arr.push(i.Id);
            customer_dic[i.Id] = p.MspRegionId;
          });
        }
      });
      const cryptoService = new CryptoService;
      payment_list.filter(f => !customer_id_arr.includes(f.MspRegionId)).map((p) => {
        if (region_dic[p.MspRegionId] !== undefined) {
          if (region_dic[p.RegionId] !== undefined) {
            const customer_name_arr = [];
            const UsedDevice = deviceUsage_dic[p.MspRegionId] !== undefined ? deviceUsage_dic[p.MspRegionId].DeviceUsage : 0;
            const NpmBank = p.Nodes !== null ? p.Nodes : 0;
            const item = {
              Company: region_dic[p.MspRegionId].RegionName,
              CompanyName: p.Company,
              Address: p.Address,
              RegionId: p.RegionId,
              MspRegionId: p.MspRegionId,
              MspMainRegionId: region_dic[p.MspRegionId].MspMainRegionId,
              Region: region_dic[p.RegionId].RegionName,
              UnitPrice: p.UnitPrice,
              DocDay: p.DocDay !== 0 ? p.DocDay : 1,
              DocumentCreateTime: p.DocumentCreateTime !== undefined ? moment.utc(Number(p.DocumentCreateTime) * 1000).format('YYYY/MM/DD HH:mm:ss') : '',
              EmailInfo: p.EmailInfo,
              HashMspRegionId: cryptoService.aesEncrypt(p.MspRegionId),
              // DocType: p.DocType,
              IsDistributor: p.IsDistributor,
              MinCharge: p.MinCharge,
              CompanyEmail: p.CompanyEmail,
              PaymentName: region_dic[p.MspRegionId] !== undefined ? region_dic[p.MspRegionId].PaymentName : '',
              PaymentAddress: region_dic[p.MspRegionId] !== undefined ? region_dic[p.MspRegionId].PaymentAddress : '',
              Customers: (p.Customers !== undefined && p.Customers.length > 0) ? p.Customers.reduce((acc, i) => {
                if (region_dic[i.Id] !== undefined && payment_dic[i.Id] !== undefined) {
                  customer_name_arr.push(region_dic[i.Id].RegionName);
                  // const customer_UsedDevice = deviceUsage_dic[i.Id] !== undefined ? deviceUsage_dic[i.Id].DeviceUsage : 0;
                  // const customer_NpmBank = p.Nodes !== null ? p.Nodes : 0;
                  acc.push({
                    label: region_dic[i.Id].RegionName,
                    value: i,
                    Company: region_dic[i.Id].RegionName,
                    Region: region_dic[payment_dic[i.Id].RegionId].RegionName,
                    CompanyName: payment_dic[i.Id].Company,
                    Address: payment_dic[i.Id].Address,
                    RegionId: payment_dic[i.Id].RegionId,
                    MspRegionId: i.Id,
                    DistributorId: customer_dic[i.Id],
                    EmailInfo: payment_dic[i.Id].EmailInfo,
                    HashMspRegionId: cryptoService.aesEncrypt(i.Id),
                    CompanyEmail: payment_dic[i.Id].CompanyEmail,
                    UnitPrice: payment_dic[i.Id].UnitPrice,
                    DocDay: payment_dic[i.Id].DocDay !== 0 ? payment_dic[i.Id].DocDay : null,
                    Nodes: payment_dic[i.Id].Nodes,
                    // DeviceUsage: customer_UsedDevice,
                    MinCharge: payment_dic[i.Id].MinCharge,
                    DocumentCreateTime: payment_dic[i.Id].DocumentCreateTime !== undefined
                      ? moment.utc(Number(payment_dic[i.Id].DocumentCreateTime) * 1000).format('YYYY/MM/DD HH:mm:ss')
                      : '',
                    PaymentRegionId: payment_dic[i.Id].PaymentRegionId,
                    IsDistributor: payment_dic[i.Id].IsDistributor,
                    IsCustomer: true,
                    IsReminder: payment_dic[i.Id].IsReminder,
                    IsAllowLock: payment_dic[i.Id].IsAllowLock,
                    NpmBankWarning: payment_dic[i.Id].Nodes < 3 * payment_dic[i.Id].MinCharge,
                    NpmBankWarningMonth: (payment_dic[i.Id].Nodes < (payment_dic[i.Id].MinCharge * 3) && payment_dic[i.Id].Nodes >= (payment_dic[i.Id].MinCharge * 2)) ? 3 : ((payment_dic[i.Id].Nodes < (payment_dic[i.Id].MinCharge * 2) && payment_dic[i.Id].Nodes >= payment_dic[i.Id].MinCharge) ? 2 : ((payment_dic[i.Id].Nodes < payment_dic[i.Id].MinCharge) ? 1 : 0)),
                  });
                }
                return acc;
              }, []) : [],
              Customers_Str: (p.Customers !== undefined && p.Customers.length > 0) ? customer_name_arr.join('/ ') : '',
              Nodes: p.Nodes !== null ? p.Nodes : 0,
              // DeviceUsage: UsedDevice,
              ChargeType: p.ChargeType,
              PaymentRegionId: p.PaymentRegionId,
              IsReminder: p.IsReminder,
              IsAllowLock: p.IsAllowLock,
              IsCustomer: false,
              IsEndUserPro: p.ChargeType !== null,
              NpmBankWarning: NpmBank < 3 * p.MinCharge,
              NpmBankWarningMonth: (NpmBank < (p.MinCharge * 3) && NpmBank >= (p.MinCharge * 2)) ? 3 : ((NpmBank < (p.MinCharge * 2) && NpmBank >= p.MinCharge) ? 2 : ((NpmBank < p.MinCharge) ? 1 : 0)),
            };
            result.payment_list.push(item);
          }
          
        }
      });
    }
    return result;
  }
});

// getMspDistributorRegionPaymentState
export const getMspDistributorRegionPayment = createSelector(getMspDistributorRegionPaymentState, data => {
  if (!data.Loading && data.Loaded) {
    return data.entities;
  }
});

export const getMspCustomerRegionPaymentByDistributor = createSelector(getMspRegionPaymentState, data => {
  const result = {
    Loading: data.Loading,
    Loaded: data.Loaded,
    RegionIdList: []
  };
  if (!data.Loading && data.Loaded) {
    const payment_list = data.entities;
    if (payment_list !== undefined && !IsEmptyObject(payment_list)) {
      payment_list.map(p => {
        result.RegionIdList.push(p.MspRegionId);
        if (p.Customers && p.Customers.length > 0) {
          p.Customers.map(c => {
            result.RegionIdList.push(c.Id);
          });
        }
      });
    }
  }
  return result;
});

export const getMspDistributorRegionPaymentOption = (regionId: number = null ) => createSelector(getRegionState, getMspDistributorRegionPaymentState, (region, distributorpayment) => {
  const options = [];
  if (!region.Loading && region.Loaded && regionId !== null) {
    const allRegions = Object.values(region.entities);
    const userRegion = allRegions.find((r) => {
      return r.Id === regionId;
    });
    if (userRegion) {
      options.push({ label: userRegion.RegionName, value: userRegion.Id, isCustomer: false });
    }
  }
  if (!distributorpayment.Loading && distributorpayment.Loaded && distributorpayment.entities && distributorpayment.entities.Customers && distributorpayment.entities.Customers.length > 0) {
    distributorpayment.entities.Customers.map(c => {
      options.push({ label: c.RegionName, value: c.Id, isCustomer: true });
    });
  }
  return options;
});

// getMspPaymentDocumentList
export const getMspPaymentDocumentList = createSelector(getMspPaymentDocumentListState, getRegionState, getAccountInfo, (data, region, accountInfo) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    const result = {
      doc_List: [],
      region_dic: []
    };
    const doc_List = data.entities;
    const allRegions = Object.values(region.entities);
    if (allRegions && allRegions.length > 0) {
      allRegions.map((r) => {
        result.region_dic[r.Id] = r;
      });
    }
    if (!IsEmptyObject(doc_List)) {
      // NgRx 9 不可變性: 創建數組副本再排序
      [...doc_List].sort(function (a: any, b: any) {
        return b.CreateTime - a.CreateTime;
      }).map((i) => {

        const dateObject = new Date(i.DocDate);
        const month = dateObject.getUTCMonth() + 1;
        const year = dateObject.getUTCFullYear();
        const month_str = monthMap[month];
        const year_str = year.toString().substring(2);
        const month_year = `${month_str} - ${year_str}`;
        const periodObj = GenerateProMonthlyPeriodDate(i.DocDate, i.PaymentType)
        let close_time = '';
        if (i.ClosedTime !== null) {
          close_time = moment.utc(Number(i.ClosedTime) * 1000).format('YYYY/MM/DD HH:mm:ss');
        }
        const item = {
          ParentRegionId: i.ParentRegionId,
          RegionId: i.RegionId,
          DocId: i.DocId,
          DocType: i.DocType,
          DocNo: i.DocNo,
          Company: result.region_dic[i.RegionId] !== undefined ? result.region_dic[i.RegionId].RegionName : '',
          CorrNo: i.CorrNo,
          DocDate: i.DocDate,
          Period: periodObj.Period,
          PeriodPDFFormat: periodObj.PeriodPDFFormat,
          MonthYear: month_year,
          Month: month,
          Year: year,
          PaymentUsage: i.PaymentUsage,
          PaymentPrice: parseFloat((i.UnitPrice * i.PaymentUsage).toFixed(2)),
          UsedDevice: i.DeviceUsage,
          UnitPrice: i.UnitPrice,
          MinCharge: i.MinCharge,
          TotalPrice: parseFloat((i.UnitPrice * i.DeviceUsage).toFixed(2)),
          GenerateTime: moment.utc(Number(i.CreateTime) * 1000).format('YYYY/MM/DD HH:mm:ss'),
          CloseTime: close_time,
          IsManual: i.IsManual,
          // IsDistributorAll: i.IsDistributorAll,
          DocStatus: i.DocStatus,
          Status: mspPaymentDocumentStatus[i.DocStatus],
          PaymentType: i.PaymentType,
          PaymentTypeStr: PaymentType[i.PaymentType],
          CreateId: i.CreateId,
          CreateAccount: accountInfo[i.CreateId] !== undefined ? accountInfo[i.CreateId].Account : '',
          IsFree: i.IsFree
        };
        result.doc_List.push(item);
      });
    }
    return result;
  }
});

// get Msp Device Usage List State
export const getMspDeviceUsageList = (id: number = null ) => createSelector(getMspDeviceUsageListState, getMspRegionPaymentState, getRegionState, getMspDistributorRegionPayment, (data, payment, region, distributor) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    let result = {
      deviceUsage: [],
      region_dic: [],
      deviceUsage_dic: [],
      TotalDeviceUsage: 0
    };
    let minCharge = 0;
    const region_dic = [];
    const usages_dic = [];
    const distributor_dic = [];
    const deviceUsage = data.entities;
    const allRegions = Object.values(region.entities);
    if (!IsEmptyObject(region.entities)) {
      allRegions.map((r) => {
        region_dic[r.Id] = r;
        if (id === null) {
          id = r.MspMainRegionId;
        }
      });
    }
    if (Object.keys(data.entities.body).length !== 0) {
      data.entities.body.map((m) => {
        result.deviceUsage_dic[m.RegionId] = m;
      });
    }
    result.region_dic = region_dic;
    if (deviceUsage !== undefined) {
        let unitPrice = deviceUsage.UnitPrice !== undefined && deviceUsage.UnitPrice !== 0 ? deviceUsage.UnitPrice : 1;
        let total_data = {
          name: 'Total',
          type: 0,
          quantity: 0,
          data_quantity: 0,
          last_quantity: 0,
          unitprice: unitPrice,
          amount: 0,
        };
        const summary_total_data = {
          name: 'Total',
          type: 1,
          quantity: 0,
          unitprice: unitPrice,
          amount: 0
        };
        if (payment.entities !== null && payment.entities.length > 0) {
          payment.entities.map((p) =>{
            if (p.MspRegionId === id) {
              unitPrice = p.UnitPrice !== undefined && p.UnitPrice !== 0 ? p.UnitPrice : 1;
              minCharge = p.MinCharge !== undefined ? p.MinCharge : 0;
            }
          });
        }
        if (distributor !== undefined && distributor.Customers.length > 0) {
          distributor.Customers.map((p) =>{
            if (distributor_dic[p.Id] === undefined) {
              distributor_dic[p.Id] = p;
            }
          });
          
        }
        if (deviceUsage.body.length > 0) {
          const Total = deviceUsage.body.reduce(
            (accumulator, currentItem) => accumulator + currentItem.DeviceUsage,
            0
          );
          result.TotalDeviceUsage = Total;
          
          deviceUsage.body.map((d) => {
            usages_dic[d.RegionId] = d;
            // usages_parent_dic[d.ParentRegionId].push(d)
          });
          if (usages_dic.length > 0) {
            const main_region = deviceUsage.body.find(s => s.RegionId === deviceUsage.RegionId);
            // Detail進來的最上層公司
            if (main_region !== undefined) {
              const usage = {
                data: {
                  regionid: main_region.RegionId,
                  name: region_dic[main_region.RegionId] !== undefined ? region_dic[main_region.RegionId].RegionName : '',
                  quantity: main_region.DeviceUsage,
                  data_quantity: main_region.DeviceUsage,
                  last_quantity: main_region.LastDeviceUsage !== undefined ? main_region.LastDeviceUsage : 0,
                  unitprice: unitPrice,
                  amount: parseFloat((main_region.DeviceUsage * unitPrice).toFixed(2)),
                  total_quantity: main_region.DeviceUsage,
                  total_last_quantity: main_region.LastDeviceUsage !== undefined ? main_region.LastDeviceUsage : 0,
                  total_amount: parseFloat((main_region.DeviceUsage * unitPrice).toFixed(2)),
                  isDefaultQuantity: false,
                },
                expanded: true,
                children: []
              };
              total_data.quantity = usage.data.quantity;
              total_data.data_quantity = usage.data.quantity;
              total_data.last_quantity = usage.data.last_quantity;
              total_data.unitprice = unitPrice;
              total_data.amount = usage.data.amount;
              result.deviceUsage.push(usage);
            }
            if (main_region === undefined) {
              return result;
            }
            let indexcount = 0;
            const sortedDeviceUsageBody = [...deviceUsage.body].sort(function (a: any, b: any) {
              if (a.RegionId === main_region.RegionId) {
                return -1;
              }
              if (b.RegionId === main_region.RegionId) {
                return 1;
              }
              return a.ParentRegionId - b.ParentRegionId;
            });
            sortedDeviceUsageBody.forEach((m) => {
              if (m.ParentRegionId == -1 || m.ParentRegionId == 0) {
                if (result.deviceUsage.length > 0) {
                  if (indexcount == 0) {
                    const children = convertToTreeNode(sortedDeviceUsageBody, m.RegionId, region_dic, total_data)
                    result.deviceUsage[indexcount].children = children.data_node;
                    result.deviceUsage[indexcount].data.data_quantity = total_data.quantity;
                    if (distributor_dic[m.RegionId] !== undefined) {
                      minCharge = distributor_dic[m.RegionId].MinCharge
                    }
                    // quantity
                    if (minCharge !== 0 && total_data.quantity < minCharge) {
                      result.deviceUsage[indexcount].data.isDefaultQuantity = true;
                      summary_total_data.quantity = minCharge;
                    } else {
                      summary_total_data.quantity = total_data.quantity;
                    }
                    // last_quantity
                    if (minCharge !== 0 && total_data.last_quantity < minCharge) {
                      total_data.last_quantity = minCharge
                    }
                    total_data.last_quantity
                    summary_total_data.amount = parseFloat((summary_total_data.quantity * unitPrice).toFixed(2));
                    result.deviceUsage[indexcount].data.total_quantity = summary_total_data.quantity;
                    result.deviceUsage[indexcount].data.total_last_quantity = total_data.last_quantity;
                    result.deviceUsage[indexcount].data.total_amount = summary_total_data.amount;
                    indexcount++ ;
                  } else {
                    const usage_distributor = {
                      data: {
                        regionid: m.RegionId,
                        name: region_dic[m.RegionId] !== undefined ? region_dic[m.RegionId].RegionName : '',
                        quantity: m.DeviceUsage,
                        data_quantity: m.DeviceUsage,
                        last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                        unitprice: unitPrice,
                        amount: parseFloat((m.DeviceUsage * unitPrice).toFixed(2)),
                        total_quantity: m.DeviceUsage,
                        total_last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                        total_amount: parseFloat((m.DeviceUsage * unitPrice).toFixed(2)),
                        isDefaultQuantity: false,
                      },
                      expanded: true,
                      children: []
                    };
                    let usage_distributor_total = {
                      name: 'Total',
                      quantity: m.DeviceUsage,
                      last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                      unitprice: unitPrice,
                      amount: usage_distributor.data.amount
                    };
                    const children = convertToTreeNode(sortedDeviceUsageBody, m.RegionId, region_dic, usage_distributor_total)
                    usage_distributor.data.quantity = usage_distributor_total.quantity;
                    usage_distributor.data.last_quantity = usage_distributor_total.last_quantity;
                    if (distributor_dic[m.RegionId] !== undefined) {
                      minCharge = distributor_dic[m.RegionId].MinCharge
                    }
                    if (minCharge !== 0 && usage_distributor_total.quantity < minCharge) {
                      summary_total_data.quantity += minCharge;
                      usage_distributor_total.quantity = minCharge;
                      usage_distributor.data.isDefaultQuantity = true;
                    } else {
                      summary_total_data.quantity += usage_distributor_total.quantity;
                    }
                    if (minCharge !== 0 && usage_distributor_total.last_quantity < minCharge) {
                      usage_distributor_total.last_quantity = minCharge;
                    }
                    summary_total_data.amount = parseFloat((summary_total_data.quantity * unitPrice).toFixed(2));
                    usage_distributor.data.total_quantity = usage_distributor_total.quantity;
                    usage_distributor.data.total_last_quantity = usage_distributor_total.last_quantity;
                    usage_distributor.data.total_amount = parseFloat((usage_distributor_total.quantity * unitPrice).toFixed(2));
                    // usage_distributor.children = children.data_node;
                    result.deviceUsage.push(usage_distributor);
                    indexcount++ ;

                    // total_data.quantity += usage_distributor_total.quantity;
                    // total_data.last_quantity += usage_distributor_total.last_quantity;
                    // total_data.unitprice = unitPrice;
                    // total_data.amount += usage_distributor_total.amount;
                  }
                  
                  if (minCharge !== 0 && total_data.quantity < minCharge) {
                    total_data.quantity = minCharge;
                    total_data.last_quantity = minCharge;
                    total_data.amount = parseFloat((total_data.quantity * unitPrice).toFixed(2));
                  }
                }
              }
            });
            result.deviceUsage.push(summary_total_data);
            result.deviceUsage.push(total_data);
          }
        }
    }
    return result;
  }
});

// get Msp Device Usage
export const getMspDeviceUsage = createSelector(getMspDeviceUsageState, getRegionState, getMspDistributorRegionPayment, (data, region, distributorData) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    let result = {
      deviceUsage: [],
      region_dic: []
    };
    const region_dic = [];
    const deviceUsage = data.entities;
    const allRegions = Object.values(region.entities);
    if (!IsEmptyObject(region.entities)) {
      allRegions.map((r) => {
        region_dic[r.Id] = r;
      });
    }
    const customer_dic = [];
    if (distributorData !== undefined && distributorData.Customers.length > 0) {
      distributorData.Customers.map((r) => {
        customer_dic[r.Id] = r;
      });
    }
    result.region_dic = region_dic;
    if (!IsEmptyObject(deviceUsage)) {
      // NgRx 9 不可變性: 創建數組副本再排序
      [...deviceUsage].sort(function (a: any, b: any) {
        return new Date(b.UsageDate).getTime() - new Date(a.UsageDate).getTime();
      }).map((u) => {

        const dateObject = new Date(u.UsageDate);
        const month = monthMap[dateObject.getMonth() + 1];
        const year = dateObject.getFullYear().toString().substring(2);
        const month_year = `${month} - ${year}`;

        const item = {
          Company: region_dic[u.RegionId] == undefined ? customer_dic[u.RegionId] !== undefined ? customer_dic[u.RegionId].RegionName : '' : region_dic[u.RegionId].RegionName,
          MonthYear: month_year,
          DeviceUsage: 0
        };

        if (u.Usage !== undefined && u.Usage.length > 0) {
          u.Usage.map((s) => {
            item.DeviceUsage += s.DeviceUsage;
          });
        }

        result.deviceUsage.push(item);
      });

    }
    return result;
  }
});

// getMspPaymentDocument
export const getMspPaymentDocument = createSelector(getMspPaymentDocumentState, getRegionState, getMspRegionPaymentState, getAccountInfo, (data, region, paymentSetting, accountInfo) => {
  if (!data.Loading && data.Loaded && !region.Loading && region.Loaded) {
    let result = null;
    const region_dic = [];
    const payment_dic = [];
    const doc = data.entities;
    const allRegions = Object.values(region.entities);
    allRegions.map((r) => {
      region_dic[r.Id] = r;
    });
    if (paymentSetting.entities !== null && paymentSetting.entities.length > 0) {
      paymentSetting.entities.map((p) =>{
        payment_dic[p.MspRegionId] = p;
      });
    }
    if (doc !== undefined) {
        const usages_dic = [];
        const usages = [];
        const dateObject = new Date(doc.DocDate);
        const month = dateObject.getUTCMonth() + 1;
        const year = dateObject.getUTCFullYear();
        const firstDay = new Date(year, month - 1, 1).getDate();
        const lastDay = new Date(year, month, 0).getDate();
        const month_str = monthMap[month];
        const year_str = year.toString().substring(2);
        const month_year = `${month_str} - ${year_str}`;
        const periodObj = GenerateProMonthlyPeriodDate(doc.DocDate, doc.PaymentType);
        const doc_start_day = `${month.toString().padStart(2, '0')}/${firstDay.toString().padStart(2, '0')}/${year}`;
        const doc_end_day = `${month.toString().padStart(2, '0')}/${lastDay.toString().padStart(2, '0')}/${year}`;
        
        result = {
          ParentRegionId: doc.ParentRegionId,
          RegionId: doc.RegionId,
          Company: payment_dic[doc.RegionId] !== undefined ? payment_dic[doc.RegionId].Company : '',
          CompanyEmail: payment_dic[doc.RegionId] !== undefined ? payment_dic[doc.RegionId].CompanyEmail : '',
          RegionName: region_dic[doc.RegionId].RegionName,
          MonthYear: month_year,
          DocId: doc.DocId,
          DocDate: doc.DocDate,
          DocStartDay: doc_start_day,
          DocEndDay: doc_end_day,
          Period: periodObj.Period,
          PeriodPDFFormat: periodObj.PeriodPDFFormat,
          DocType: doc.DocType,
          DocNo: doc.DocNo,
          CorrNo: doc.CorrNo,
          UnitPrice: doc.UnitPrice,
          DeviceUsage: doc.DeviceUsage,
          PaymentUsage: doc.PaymentUsage,
          MinCharge: doc.MinCharge !== undefined ? doc.MinCharge : 0,
          CreateTime: moment.utc(Number(doc.CreateTime) * 1000).format('MM/DD/YYYY'),
          CloseTime: doc.ClosedTime !== undefined ? moment.utc(Number(doc.ClosedTime) * 1000).format('YYYY/MM/DD HH:mm:ss') : '',
          Status: mspPaymentDocumentStatus[doc.DocStatus],
          IsManual: doc.IsManual,
          // IsDistributorAll: doc.IsDistributorAll,
          deviceUsage: usages,
          PaymentType: doc.PaymentType,
          CreateId: doc.CreateId,
          CreateAccount: accountInfo[doc.CreateId] !== undefined ? accountInfo[doc.CreateId].Account : '',
          IsFree: doc.IsFree
        };
        // const interval_data = []
        let total_data = {
          name: 'Total',
          type: 0,
          quantity: 0,
          paymentquantity: 0,
          last_quantity: 0,
          unitprice: doc.UnitPrice,
          amount: 0
        };
        const summary_total_data = {
          name: 'Total',
          type: 1,
          quantity: 0,
          unitprice: doc.UnitPrice,
          amount: 0
        };
        if (doc.Usage.length > 0) {
          doc.Usage.map((d) => {
            usages_dic[d.RegionId] = d;
            // usages_parent_dic[d.ParentRegionId].push(d)
          });
          if (usages_dic.length > 0) {
              const main_region = doc.Usage.find(s => s.RegionId === doc.RegionId);
              // Detail進來的最上層公司
              if (main_region !== undefined) {
                
                const usage = {
                  data: {
                    name: region_dic[main_region.RegionId] !== undefined ? region_dic[main_region.RegionId].RegionName : '',
                    quantity: main_region.DeviceUsage,
                    paymentquantity: result.PaymentUsage,
                    last_quantity: main_region.LastDeviceUsage,
                    unitprice: doc.UnitPrice,
                    amount: parseFloat((main_region.DeviceUsage * doc.UnitPrice).toFixed(2)),
                    total_quantity: main_region.DeviceUsage,
                    total_last_quantity: main_region.DeviceUsage,
                    total_amount: parseFloat((main_region.DeviceUsage * doc.UnitPrice).toFixed(2)),
                    isDefaultQuantity: false,
                  },
                  expanded: true,
                  children: []
                };
                if (doc.MinCharge !== 0 && total_data.quantity < doc.MinCharge) {
                  total_data.quantity = doc.MinCharge;
                  total_data.last_quantity = doc.MinCharge;
                  total_data.amount = parseFloat((total_data.quantity * doc.UnitPrice).toFixed(2));
                }
                total_data.quantity = usage.data.quantity;
                total_data.paymentquantity = usage.data.paymentquantity;
                total_data.last_quantity = usage.data.last_quantity;
                total_data.unitprice = doc.UnitPrice;
                total_data.amount = usage.data.amount;
                result.deviceUsage.push(usage);
              }
              let indexcount = 0;
              const sortedDocUsage = [...doc.Usage].sort(function (a: any, b: any) {
                if (a.RegionId === main_region.RegionId) {
                  return -1;
                }
                if (b.RegionId === main_region.RegionId) {
                  return 1;
                }
                return a.ParentRegionId - b.ParentRegionId;
              });
              sortedDocUsage.forEach((m) => {
                if (region_dic[m.RegionId] !== undefined && (m.ParentRegionId == -1 || m.ParentRegionId == 0)) {
                  if (result.deviceUsage.length > 0) {
                    if (indexcount == 0) {
                      const children = convertToTreeNode(sortedDocUsage, m.RegionId, region_dic, total_data);
                      result.deviceUsage[indexcount].children = children.data_node;
                      summary_total_data.quantity = total_data.quantity;
                      if (payment_dic[doc.RegionId] !== undefined && doc.PaymentType !== PaymentTypeIndex["Prepaid"]) {
                        if (result.MinCharge !== 0 && total_data.quantity < result.MinCharge) {
                          result.deviceUsage[indexcount].data.isDefaultQuantity = true;
                          summary_total_data.quantity = result.MinCharge;
                        }
                      }
                      summary_total_data.amount = parseFloat((summary_total_data.quantity * doc.UnitPrice).toFixed(2));
                      result.deviceUsage[indexcount].data.total_quantity = summary_total_data.quantity;
                      result.deviceUsage[indexcount].data.total_last_quantity = total_data.last_quantity;
                      result.deviceUsage[indexcount].data.total_amount = summary_total_data.amount;
                      indexcount++ ;
                    } else {
                      const usage_distributor = {
                        data: {
                          name: region_dic[m.RegionId] !== undefined ? region_dic[m.RegionId].RegionName : '',
                          quantity: m.DeviceUsage,
                          last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                          unitprice: doc.UnitPrice,
                          amount: parseFloat((m.DeviceUsage * doc.UnitPrice).toFixed(2)),
                          total_quantity: m.DeviceUsage,
                          total_last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                          total_amount: parseFloat((m.DeviceUsage * doc.UnitPrice).toFixed(2)),
                          isDefaultQuantity: false,
                        },
                        expanded: true,
                        children: []
                      };
                      let usage_distributor_total = {
                        name: 'Total',
                        quantity: m.DeviceUsage,
                        last_quantity: m.LastDeviceUsage !== undefined ? m.LastDeviceUsage : 0,
                        unitprice: doc.UnitPrice,
                        amount: usage_distributor.data.amount
                      };
                      const children = convertToTreeNode(sortedDocUsage, m.RegionId, region_dic, usage_distributor_total);
                      total_data.quantity += usage_distributor_total.quantity;
                      total_data.unitprice = doc.UnitPrice;
                      total_data.amount += usage_distributor_total.amount;
                      usage_distributor.data.quantity = usage_distributor_total.quantity;
                      usage_distributor.data.last_quantity = usage_distributor_total.last_quantity;
                      summary_total_data.quantity += usage_distributor_total.quantity;
                      if (payment_dic[doc.RegionId] !== undefined && doc.PaymentType !== PaymentTypeIndex["Prepaid"]) {
                        if (result.MinCharge !== 0 && total_data.quantity < result.MinCharge) {
                          summary_total_data.quantity += result.MinCharge;
                          usage_distributor_total.quantity = result.MinCharge;
                          usage_distributor.data.isDefaultQuantity = true;
                        }
                      }
                      summary_total_data.amount = parseFloat((summary_total_data.quantity * doc.UnitPrice).toFixed(2));
                      usage_distributor.data.total_quantity = usage_distributor_total.quantity;
                      usage_distributor.data.total_last_quantity = usage_distributor_total.last_quantity;
                      usage_distributor.data.total_amount = parseFloat((usage_distributor_total.quantity * doc.UnitPrice).toFixed(2));
                      // usage_distributor.children = children.data_node;
                      result.deviceUsage.push(usage_distributor);
                      indexcount++ ;
                    }
                  }
                }
              });
              result.deviceUsage.push(summary_total_data);
              result.deviceUsage.push(total_data);
            }
        } else {
          const data = {
            data: {
              // RegionId: doc[0].RegionId,
              name: region_dic[doc.RegionId].RegionName,
              // ParentRegionId: doc[0].ParentRegionId,
              quantity: doc.DeviceUsage,
              unitprice: doc.UnitPrice,
              amount: parseFloat((doc.DeviceUsage * doc.UnitPrice).toFixed(2))
            }
          };
          // interval_data.push(doc[0].RegionId)
          usages.push(data);
          total_data.quantity = data.data.quantity;
          total_data.unitprice = doc.UnitPrice;
          total_data.amount = parseFloat(data.data.amount.toFixed(2));
          result.deviceUsage.push(summary_total_data);
          result.deviceUsage.push(total_data);
        }
    }
    return result;
  }
});

export const getMspRegionFilter = createSelector(getIsMsp, getMspRegionFilterState, (isMsp, filter) => {
  let result = null;
  if (isMsp !== undefined) {
    result = {
      isMsp: isMsp,
      filterLoaded: filter.Loaded,
      selectedId: filter.RegionIds
    };
  }
  return result;
});

export const getSelectedMspRegionFilter = createSelector(getIsMsp, getMspRegionFilterState, (isMsp, filter) => {
  let result = null;
  if (isMsp !== undefined) {
    if (isMsp) {
      if (filter.Loaded) {
        result = [];
        filter.RegionIds.map(item => result.push(item));
      }
    } else {
      result = [];
    }
  }
  return result;
});

export const getMspRegionOptions = createSelector(getIsMsp, getRegions, getMspRegionFilterState, (isMsp, region, filter) => {
  let result = null;
  if (isMsp !== undefined) {
    if (isMsp) {
      if (region.length > 0 && filter.Loaded && filter.RegionIds.length > 0) {
        result = [...region.filter(item => filter.RegionIds.includes(item.Id)).map(item => {return {label: item.RegionName, value: item.Id};
        })];
      }
    } else {
      result = [];
    }
  }
  return result;
});

// Page - Modules
export const getModules = createSelector(getModulesState, getModuleFilterState, (modules, params) => {
  const regionId = typeof params.RegionId === 'number' ? params.RegionId : 1;
  const module = [...Object.values(modules.entities)]
    .filter((item) => item.RegionId === regionId && item.Package.toUpperCase() === params.Package.toUpperCase())
    .sort(fromModule.sortBySeqNo);
  return module;
});
// Page - Plan-Settings 需全部的Plan module判斷EnableAPI
export const getRegionModules = createSelector(getModulesState, (modules) => {
  const module = [...Object.values(modules.entities)].sort(fromModule.sortBySeqNo);
  return module;
});
export const getUserAllModule = createSelector(getUserModuleState, getCurrentUser, (data, user) => {
  const accountPackage = Object.values(data.entities).filter(item => item['Package'] === user.Package && item.RegionId === user.RegionId);
  if (accountPackage.length > 0) {
    return accountPackage.reduce((acc, cur, Index, array) => {
      acc[cur.Module] = cur;
      return acc;
    }, {});
  } else {
    return data.entities;
  }
});
export const getIsActiveUserModule = createSelector(getUserAllModule, (modules, props) => {
  const module: Module = modules.hasOwnProperty(props) ? modules[props] : null;
  if (module != null && module.Module === props) {
    if (module.ValueType === moduleValueType.checkbox) {
      if (Boolean(Number(module.Value))) {
        return true;
      } else {
        return false;
      }
    } else if (module.ValueType === moduleValueType.number) {
      return Number(module.Value);
    }
  }
});
export const getAllModuleForPurchase = createSelector(getUserModuleState, getCurrentUser, (data, user) => {
  const result = Object.values(data.entities).filter(item => item['Package'] === user.Package);
  return [...result.filter(i => i.IsShowItem)].sort((a, b) => { // sort the limit of number  first
    if (a.ValueType === 'checkbox' && b.ValueType === 'number') {
      return 1;
    } else if (a.ValueType === 'number' && b.ValueType === 'checkbox') {
      return -1;
    }
    return 0;
  });
});


// Page - Nodes
export const getNodes = createSelector(getNodeState, getNodesFilterState, (nodes, params) => {
  const regionId = typeof params.RegionId === 'number' ? params.RegionId : 1;
  const node = [...Object.values(nodes.entities)].filter((item) => item.RegionId === regionId).sort(fromNode.sortBySeqLevel);
  return node;
});
export const getUserNode = createSelector(getNodeState, getCurrentUser, (nodes, user) => {
  if (!nodes.Loading && nodes.Loaded) {
    const nodeArr = Object.values(nodes.entities).filter(i => i.RegionId === user.RegionId);
    return nodeArr;
  }
  return [];
});
export const getNodeSetting = createSelector(getUserNode, (userNodeArr) => {
  const nodeSetting = {
    eventLogDay: 0,
    statusLogDay: 0,
    statusLogPeakDay: 0
  };
  userNodeArr.forEach((item) => {
    if (item.EventLogLimit > nodeSetting.eventLogDay) {
      nodeSetting.eventLogDay = item.EventLogLimit;
    }
    if (item.StatusLogLimit > nodeSetting.statusLogDay) {
      nodeSetting.statusLogDay = item.StatusLogLimit;
    }
    if (item.StatusPeakLimit > nodeSetting.statusLogPeakDay) {
      nodeSetting.statusLogPeakDay = item.StatusPeakLimit;
    }
  });
  return nodeSetting;
});


// Page -  Event
export const getEventLogData = createSelector(getEventsPageData, getEventFilterParamsState,
  getEventsMapsState, getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState,
  (events, params, maps, errorLevelMaps, errorCodeMaps) => {
    if (events) {
    if (params.type === groupStr) {
      const groupId = (params && params.filterId) ? params.filterId.split('group-')[1] : -1;
      events = events.filter(i => i.gId === Number(groupId) || i.share_group_id === Number(groupId));
    } else if (params.type === 'device') {
      if (params.filterId) {
        events = events.filter(i => i.dcode === Number(params.filterId));
      }
      if (params.sn) {
        events = events.filter(i => i.sn.toLowerCase() === params.sn.toLowerCase());
      }
    }
    // Filter the empty event
      const localTimeZone = new Date().getTimezoneOffset() / 60;
      const data = events.filter(j => Object.keys(j.event).length > 0).map(item => {
        const levelMaps = errorLevelMaps.entities;
        const codeMaps = errorCodeMaps.entities;
      return item.event.map(i => {
        const time = new Date(Number(i.ts) * 1000);
        const timeformat = (time != null) ?
         (moment((Number(i.ts) * 1000) + ((localTimeZone + item.timeZone) * 60 * 60 * 1000)).format('YYYY/MM/DD HH:mm:ss')) : '';
        let event: any = {
          sn: item.sn,
          timezoneLabel: item.timezoneLabel,
          timeZone: item.timeZone,
          gId: item.gId,
          dcode: item.dcode,
          name: item.name,
          type: item.type,
          time: timeformat,
          routeLink: item.routeLink,
          timestamp: i.ts,
          isHardwareFault: false
        };
        if (typeof i.IsHardwareOccur === 'undefined') { // Common Event.
          const eventMap = (maps.entities.hasOwnProperty(i.event_number)) ? maps.entities[i.event_number] : eventMapping[i.event_number];
          const status = statusMapping[eventMap.status.toString()].status;
          // const localTime = time.setHours(time.getHours() + ((item.timeZone !== null) ? Number(item.timeZone) : 0));
          event = {...event,
            status: status,
            statusCode: eventMap.status,
            desc: eventMap.desc,
            icon: eventStatusMapping[status].icon,
          };
        } else
         if (typeof i.ErrorCode !== 'undefined' && typeof i.LevelCode !== 'undefined' && errorLevelMaps.Loaded && errorCodeMaps.Loaded) {
          // Hardware fault occur
          if (!i.IsHardwareOccur) { // Restore hardware fault
            event = {...event,
              status: statusMapping[0].status,
              statusCode: 0,
              icon: eventStatusMapping['normal'].icon,
              desc: 'Restore：' + oldErrorCodeDesc(i, codeMaps) +
                    (codeMaps.hasOwnProperty(i.ErrorCode) ? codeMaps[i.ErrorCode].Description : ''),
            };
          } else { // Hardware fault occur
            event = {...event,
              status: 'Hardware Fault',
              desc: oldErrorCodeDesc(i, codeMaps) + (codeMaps.hasOwnProperty(i.ErrorCode) ? codeMaps[i.ErrorCode].Description : ''),
              faultLevelColor: levelMaps.hasOwnProperty(i.LevelCode) ? levelMaps[i.LevelCode].ColorCode : '',
              statusCode: 4,
              isHardwareFault: true
            };
          }
        }
        return event;
      }).filter(i => !!i);
    });
    let result = [].concat(...data);
      if (params.status !== -1) {
      result = result.filter(i => i.statusCode === params.status);
    }
    return [...result].sort((a, b) =>
      Number(b.timestamp) - Number(a.timestamp)
    );
  }
});
// export const getEventDevicesOptions = createSelector(DevicesFiltered, (data) => {
//   return data;
//   // const options: any = [{label: 'All', value: 'all'}];
//   // const arrItem = Array.from(new Set(data.map(item => item.DeviceCode)));
//   // if (data.length > 0) {
//   //   const arrItem = data.filter(i => !i.isExpired).map(item => {
//   //     return {label: item.name, value: item.dcode};
//   //   });
//   //   return arrItem;
//
//     // return options.concat(arrItem);
//   // }
//   // arrItem.forEach(item => {
//   //   options.push({label: item, value: item});
//   // });
// });
export const getEventGroupOptions = createSelector(getGroupDevices, getNoGroupDevices, (groups, devices) => {
  const options: any = [{
    label: '',
    value: null,
    items: [{ label: TRANSLATE('Select Device'), value: 'all' }]
  }];
  groups.forEach(item => {
      options.push({label: item.data.name, value: item.data.gId,
        items: formatGroup([{ label: item.data.name, value: 'group-' + item.data.gId }], item.children)});
  });
  const deviceOpt: any = devices.filter(i => !i.isExpired).map(item => {
    return {label: item.name, value: item.dcode};
  });
  if (devices.length > 0) {
    options.push({label: TRANSLATE('Devices'), value: null, items: deviceOpt});
  }
  return options;
  function formatGroup(initOpt, children) {
    const opt = initOpt;
    children.forEach(child => {
      if (!IsEmptyObject(child.data) && !child.data.isExpired) {
        opt.push({ label: child.data.name, value: child.data.dcode});
      }
    });
    return opt;
  }
});


// Page - Details
export const getDeviceDetails = createSelector(getDeviceDetailsState, (data) => {
  if (data.isLoaded && !data.isLoading && data.entities) {
    const res = data.entities;
    const subDevice = [];
    if (res.DeviceSubType === DeviceSubTypeMapping['nATS'] || res.DeviceSubType === DeviceSubTypeMapping['nPDU']) {
      for (let i = 1; i <= 3; i++) {
        const device = {
          Cur: res[`Cur${i}`],
          CurA: res[`Cur${i}A`],
          CurB: res[`Cur${i}B`],
          CurC: res[`Cur${i}C`],
          PkCur: res[`PkCur${i}`],
          PkCurA: res[`PkCur${i}A`],
          PkCurB: res[`PkCur${i}B`],
          PkCurC: res[`PkCur${i}C`],
          PkTs: res[`PkTs${i}`],
          VoltA: res[`Volt${i}A`],
          VoltB: res[`Volt${i}B`],
          VoltC: res[`Volt${i}C`],
          Energy: res[`Energy${i}`],
          Model: res[`Model${i}`],
          SN: res[`SN${i}`],
          SubDevice: `Sub-device#${i}`,
          SelSrc: (res[`SelSrc${i}`]) ? ePDUSourceMapping[res[`SelSrc${i}`]] : null,
          PreSrc: (res[`PreSrc${i}`]) ? ePDUSourceMapping[res[`PreSrc${i}`]] : null,
          SrcVoltA: res[`SrcVolt${i}A`],
          SrcVoltB: res[`SrcVolt${i}B`],
          SrcFreqA: res[`SrcFreq${i}A`],
          SrcFreqB: res[`SrcFreq${i}B`],
          SrcStaA: res[`SrcSta${i}A`] ? InStaMapping[res[`SrcSta${i}A`]] : null,
          SrcStaB: res[`SrcSta${i}B`] ? InStaMapping[res[`SrcSta${i}B`]] : null
        };
        subDevice.push(device);
      }
    }
    const result = {
      PowSour: powSourMapping[res.PowSour],
      OutVolt: res.OutVolt,
      OutStaNUM: res.OutSta,
      OutSta: getStatusStr(res.DeviceSubType, res.OutSta, res.OutStaArr, outStaMapping),
      InSta: getStatusStr(res.DeviceSubType, res.InSta, res.InStaArr, InStaMapping),
      InStaA: (res.InStaA || res.InStaA === 0) ? InStaMapping[res.InStaA] : '',
      InStaB: (res.InStaB || res.InStaB === 0) ? InStaMapping[res.InStaB] : '',
      BatCap: res.BatCap,
      BatSta: getStatusStr(res.DeviceSubType, res.BatSta, res.BatStaArr, batStaMapping), // Personal Output Status.
      BatRun: res.BatRun,
      Load: res.Load,
      LoadPct: res.LoadPct,
      LoadPctA: res.LoadPctA,
      LoadPctB: res.LoadPctB,
      LoadPctC: res.LoadPctC,
      FV: res.FV,
      RatPow: res.RatPow,
      countrySelection: res.countrySelection,
      energyCost: res.energyCost,
      co2Emitted: res.co2Emitted,
      unit: (res.unit) ? unitMapping[res.unit] : '',
      Model: res.Model,
      SN: res.SN,
      dcode: res.dcode,
      subtype: (typeof DeviceSubType !== 'undefined' && res.DeviceSubType !== null) ? DeviceSubType[res.DeviceSubType].name : '',
      IsConnectedCard: (res.InSta || res.InSta === 0) ? true : false,
      SysTemp: (res.SysTemp || res.SysTemp === 0) ? res.SysTemp : null,
      TrialRemainDay: res.TrialRemainDay,
      expirationDate: (res.TrialRemainDay > 0) ? addDays(new Date(), res.TrialRemainDay) : null,
      LP: res.LP,
      BHIStatus: (res && !(res.Model && hideBHIModelList.includes(res.Model.toLocaleUpperCase()))) ?
        ((res.BHI === -1 || res.BHI === undefined || !res.BHI_Enable) ? null :
          ((res.BHI >= 70) ? batHeaMapping[0] :
            ((res.BHI >= 50) ? batHeaMapping[1] :
              ((res.BHI >= 35) ? batHeaMapping[2] :
                ((res.BHI >= 25) ? batHeaMapping[3] :
                  ((res.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
      BHI: res.BHI,
      BHI_Enable: res.BHI_Enable,
      is_critical_update: res.is_critical_update,
      device_setting: res.device_setting,
      Energy: res.Energy,
      timestamp: res.timestamp,
      Source: res.Source ? ePDUSourceMapping[res.Source] : null,
      Power: res.Power,
      BpsVoltA: res.BpsVoltA,
      BpsVoltB: res.BpsVoltB,
      BpsVoltC: res.BpsVoltC,
      InPFA: res.InPFA,
      InPFB: res.InPFB,
      InPFC: res.InPFC,
      InVoltA: res.InVoltA,
      InVoltB: res.InVoltB,
      InVoltC: res.InVoltC,
      OutPwA: res.OutPwA,
      OutPwB: res.OutPwB,
      OutPwC: res.OutPwC,
      OutPFA: res.OutPFA,
      OutPFB: res.OutPFB,
      OutPFC: res.OutPFC,
      OutVoltA: res.OutVoltA,
      OutVoltB: res.OutVoltB,
      OutVoltC: res.OutVoltC,
      BatVolt: res.BatVolt,
      BatRDate: res.BatRDate,
      GeoRegion: res.GeoRegion,
      GeoType: res.GeoType,
      ServerNum: res.ServerNum,
      Cur: res.Cur,
      CurA: res.CurA,
      CurB: res.CurB,
      CurC: res.CurC,
      PowerT: res.PowerT,
      EnergyT: res.EnergyT,
      PkCur: res.PkCur,
      PkCurA: res.PkCurA,
      PkCurB: res.PkCurB,
      PkCurC: res.PkCurC,
      PkTs: res.PkTs,
      Volt: res.Volt,
      VoltA: res.VoltA,
      VoltB: res.VoltB,
      VoltC: res.VoltC,
      SelSrc: res.SelSrc ? ePDUSourceMapping[res.SelSrc] : null,
      PreSrc: res.PreSrc ? ePDUSourceMapping[res.PreSrc] : null,
      SrcVoltA: res.SrcVoltA,
      SrcVoltB: res.SrcVoltB,
      SrcFreqA: res.SrcFreqA,
      SrcFreqB: res.SrcFreqB,
      SrcStaA: res.SrcStaA ? InStaMapping[res.SrcStaA] : null,
      SrcStaB: res.SrcStaB ? InStaMapping[res.SrcStaB] : null,
      subDevice: subDevice,
      BpsCurA: res.BpsCurA,
      BpsCurB: res.BpsCurB,
      BpsCurC: res.BpsCurC,
      BpsFreqA: res.BpsFreqA,
      BpsFreqB: res.BpsFreqB,
      BpsFreqC: res.BpsFreqC,
      BpsPFA: res.BpsPFA,
      BpsPFB: res.BpsPFB,
      BpsPFC: res.BpsPFC,
      InCurA: res.InCurA,
      InCurB: res.InCurB,
      InCurC: res.InCurC,
      InFreqA: res.InFreqA,
      InFreqB: res.InFreqB,
      InFreqC: res.InFreqC,
      OutCurA: res.OutCurA,
      OutCurB: res.OutCurB,
      OutCurC: res.OutCurC,
      OutFreqA: res.OutFreqA,
      OutFreqB: res.OutFreqB,
      OutFreqC: res.OutFreqC,
      OutAppA: res.OutAppA,
      OutAppB: res.OutAppB,
      OutAppC: res.OutAppC,
      OutRctA: res.OutRctA,
      OutRctB: res.OutRctB,
      OutRctC: res.OutRctC,
      BatVoltB: res.BatVoltB,
      BatCurA: res.BatCurA,
      BatCurB: res.BatCurB,
      BatTemp: res.BatTemp,
      BatNum: res.BatNum,
      ModNum: res.ModNum,
      CloudFlag: res.CloudFlag,
    };
    return result;
  }
});

// Page - Monitoring Details
export const getMonitoringDeviceDetails = createSelector(getDeviceDetailsState, getEventsMapsState,
  getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState, getBatteryReplacement,
  (data, maps, faultLevelMaps, faultCodeMaps, btyReplacement) => {
  if (data.isLoaded && !data.isLoading && data.entities) {
    const res = data.entities;
    const event = (res.event) ?
    res.event.toString().split(',').map(eventCode => {
          return (maps.entities.hasOwnProperty(eventCode)) ? maps.entities[eventCode].desc : 'None.';
        }).join(' / ') : '';
    const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ?
      res.DeviceSubType !== 2 ? DeviceSubType[res.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
    const subDevice = [];
    if (res.DeviceSubType === DeviceSubTypeMapping['nATS'] || res.DeviceSubType === DeviceSubTypeMapping['nPDU']) {
      for (let i = 1; i <= 3; i++) {
        const device = {
          Cur: res[`Cur${i}`],
          CurA: res[`Cur${i}A`],
          CurB: res[`Cur${i}B`],
          CurC: res[`Cur${i}C`],
          PkCur: res[`PkCur${i}`],
          PkCurA: res[`PkCur${i}A`],
          PkCurB: res[`PkCur${i}B`],
          PkCurC: res[`PkCur${i}C`],
          PkTs: res[`PkTs${i}`],
          VoltA: res[`Volt${i}A`],
          VoltB: res[`Volt${i}B`],
          VoltC: res[`Volt${i}C`],
          Energy: res[`Energy${i}`],
          Model: res[`Model${i}`],
          SN: res[`SN${i}`],
          SubDevice: `Sub-device#${i}`,
          SelSrc: (res[`SelSrc${i}`]) ? ePDUSourceMapping[res[`SelSrc${i}`]] : null,
          PreSrc: (res[`PreSrc${i}`]) ? ePDUSourceMapping[res[`PreSrc${i}`]] : null,
          SrcVoltA: res[`SrcVolt${i}A`],
          SrcVoltB: res[`SrcVolt${i}B`],
          SrcFreqA: res[`SrcFreq${i}A`],
          SrcFreqB: res[`SrcFreq${i}B`],
          SrcStaA: res[`SrcSta${i}A`] ? InStaMapping[res[`SrcSta${i}A`]] : null,
          SrcStaB: res[`SrcSta${i}B`] ? InStaMapping[res[`SrcSta${i}B`]] : null
        };
        subDevice.push(device);
      }
    }
    const result = {
      PowSour: powSourMapping[res.PowSour],
      OutVolt: res.OutVolt,
      OutSta: getStatusStr(res.DeviceSubType, res.OutSta, res.OutStaArr, outStaMapping),
      InSta: getStatusStr(res.DeviceSubType, res.InSta, res.InStaArr, InStaMapping),
      InStaA: (res.InStaA || res.InStaA === 0) ? InStaMapping[res.InStaA] : '',
      InStaB: (res.InStaB || res.InStaB === 0) ? InStaMapping[res.InStaB] : '',
      BatCap: res.BatCap,
      BatSta: getStatusStr(res.DeviceSubType, res.BatSta, res.BatStaArr, batStaMapping), // Personal Output Status.
      BatRun: res.BatRun,
      Load: res.Load,
      LoadPct: res.LoadPct,
      LoadPctA: res.LoadPctA,
      LoadPctB: res.LoadPctB,
      LoadPctC: res.LoadPctC,
      FV: res.FV,
      RatPow: res.RatPow,
      countrySelection: res.countrySelection,
      energyCost: res.energyCost,
      co2Emitted: res.co2Emitted,
      unit: (res.unit) ? unitMapping[res.unit] : '',
      Model: res.Model,
      SN: res.SN,
      subtype: (typeof DeviceSubType !== 'undefined' && res.DeviceSubType !== null) ? DeviceSubType[res.DeviceSubType].name : '',
      IsConnectedCard: (res.InSta || res.InSta === 0) ? true : false,
      SysTemp: (res.SysTemp || res.SysTemp === 0) ? res.SysTemp : null,
      TrialRemainDay: res.TrialRemainDay,
      expirationDate: (res.TrialRemainDay > 0) ? addDays(new Date(), res.TrialRemainDay) : null,
      LP: res.LP,
      BHIStatus: (res && !(res.Model && hideBHIModelList.includes(res.Model.toLocaleUpperCase()))) ?
        ((res.BHI === -1 || res.BHI === undefined || !res.BHI_Enable) ? null :
          ((res.BHI >= 70) ? batHeaMapping[0] :
            ((res.BHI >= 50) ? batHeaMapping[1] :
              ((res.BHI >= 35) ? batHeaMapping[2] :
                ((res.BHI >= 25) ? batHeaMapping[3] :
                  ((res.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
      BHI: res.BHI,
      BHI_Enable: res.BHI_Enable,
      is_critical_update: res.is_critical_update,
      acode: res.acode,
      dcode: res.dcode,
      name: res.DeviceName,
      status: statusMapping[res.device_status].status,
      type: deviceType[res.device_type],
      device_setting: res.device_setting,
      Energy: res.Energy,
      timestamp: res.timestamp,
      SourceType: res.SourceType,
      desc: (res.device_status === 0) ? statusMapping[res.device_status].desc.replace('{DeviceType}', new_desc_deviceType) : event,
      icon: statusMapping[res.device_status].icon,
      image: (res) ? imageUrl + res.Model : null,
      hardwarefault: hardwareFaultDetailLogic(res, faultLevelMaps, faultCodeMaps),
      btyReplacement: (btyReplacement && btyReplacement.hasOwnProperty(res.dcode)) ? btyReplacement[res.dcode] : null,
      time: (btyReplacement && btyReplacement.hasOwnProperty(res.dcode)) ? btyReplacement[res.dcode].BR_Rc_Date : null,
      timeZone: res.timeZone,
      Power: res.Power,
      BpsVoltA: res.BpsVoltA,
      BpsVoltB: res.BpsVoltB,
      BpsVoltC: res.BpsVoltC,
      InPFA: res.InPFA,
      InPFB: res.InPFB,
      InPFC: res.InPFC,
      InVoltA: res.InVoltA,
      InVoltB: res.InVoltB,
      InVoltC: res.InVoltC,
      OutPwA: res.OutPwA,
      OutPwB: res.OutPwB,
      OutPwC: res.OutPwC,
      OutPFA: res.OutPFA,
      OutPFB: res.OutPFB,
      OutPFC: res.OutPFC,
      OutVoltA: res.OutVoltA,
      OutVoltB: res.OutVoltB,
      OutVoltC: res.OutVoltC,
      BatVolt: res.BatVolt,
      BatRDate: res.BatRDate,
      GeoRegion: res.GeoRegion,
      GeoType: res.GeoType,
      ServerNum: res.ServerNum,
      Cur: res.Cur,
      CurA: res.CurA,
      CurB: res.CurB,
      CurC: res.CurC,
      PowerT: res.PowerT,
      EnergyT: res.EnergyT,
      PkCur: res.PkCur,
      PkCurA: res.PkCurA,
      PkCurB: res.PkCurB,
      PkCurC: res.PkCurC,
      PkTs: res.PkTs,
      Volt: res.Volt,
      VoltA: res.VoltA,
      VoltB: res.VoltB,
      VoltC: res.VoltC,
      SelSrc: res.SelSrc ? ePDUSourceMapping[res.SelSrc] : null,
      PreSrc: res.PreSrc ? ePDUSourceMapping[res.PreSrc] : null,
      SrcVoltA: res.SrcVoltA,
      SrcVoltB: res.SrcVoltB,
      SrcFreqA: res.SrcFreqA,
      SrcFreqB: res.SrcFreqB,
      SrcStaA: res.SrcStaA ? InStaMapping[res.SrcStaA] : null,
      SrcStaB: res.SrcStaB ? InStaMapping[res.SrcStaB] : null,
      DeviceIP: res.DeviceIP,
      subDevice: subDevice,
      BpsCurA: res.BpsCurA,
      BpsCurB: res.BpsCurB,
      BpsCurC: res.BpsCurC,
      BpsFreqA: res.BpsFreqA,
      BpsFreqB: res.BpsFreqB,
      BpsFreqC: res.BpsFreqC,
      BpsPFA: res.BpsPFA,
      BpsPFB: res.BpsPFB,
      BpsPFC: res.BpsPFC,
      InCurA: res.InCurA,
      InCurB: res.InCurB,
      InCurC: res.InCurC,
      InFreqA: res.InFreqA,
      InFreqB: res.InFreqB,
      InFreqC: res.InFreqC,
      OutCurA: res.OutCurA,
      OutCurB: res.OutCurB,
      OutCurC: res.OutCurC,
      OutFreqA: res.OutFreqA,
      OutFreqB: res.OutFreqB,
      OutFreqC: res.OutFreqC,
      OutAppA: res.OutAppA,
      OutAppB: res.OutAppB,
      OutAppC: res.OutAppC,
      OutRctA: res.OutRctA,
      OutRctB: res.OutRctB,
      OutRctC: res.OutRctC,
      BatVoltB: res.BatVoltB,
      BatCurA: res.BatCurA,
      BatCurB: res.BatCurB,
      BatTemp: res.BatTemp,
      BatNum: res.BatNum,
      ModNum: res.ModNum
    };
    return result;
  }
});
export const getSingleDeviceStatuses = (sn) => createSelector(DevicesFiltered, (statuses) => {
  const result = statuses.find(item => item.DeviceSN === sn);
  if (result) {
    return {...result, btyReplacement: null}; // Get Bty Replacement Info to details page, put null at here.
  } else {
    return null;
  }
});
export const getBatteryReplacementForDetails = (sn) => createSelector(getBatteryReplacementState, getSingleDeviceStatuses(sn),
  (data, dataStatus) => {
  if (data.isLoaded && !data.isLoading && dataStatus && data.entities.hasOwnProperty(dataStatus.dcode)) {
    // 創建新對象副本以避免修改只讀的 store 數據 (NgRx 9 immutability)
    const newEntities = {};
    for (const [key, value] of Object.entries(data.entities)) {
      const info: BatteryReplacement = value;
      const BR_Date_Format = (info.BR_Date) ? new Date(info.BR_Date * 1000) : null;
      let BR_Rc_Date = null;
      let expires = false;
      if (value.BR_Date) {
        const dt = new Date(info.BR_Date * 1000);
        dt.setMonth(dt.getMonth() + info.BR_Months);
        BR_Rc_Date = dt.getTime();
        expires = BR_Rc_Date < new Date().getTime();
      }
      // 創建新對象副本，包含新計算的屬性
      newEntities[key] = { ...value, BR_Date_Format, BR_Rc_Date, expires };
    }
    return newEntities;
  }
});

// Page - GroupDetails
export const getGroupDetails = createSelector(getSingleGroupState, DevicesFiltered, (group, device) => {
  const deviceObj = {};
  const sharedeviceObj = {};
  let result = {} as Group;
  if (group.Loaded && !group.Loading && group.entities != null) {
    result = { ...group.entities };
    result.deviceStatusCode = 3;
    result.status = statusMapping[3].status;
    result.icon = statusMapping[3].icon;
    const gId = group.entities.Id;
    let groupStatus = 0;
    if (device.length > 0) {
      device.forEach(item => {
        if (item.is_shared && item.share_group_id) {
          if (!sharedeviceObj.hasOwnProperty(item.share_group_id)) {
            sharedeviceObj[item.share_group_id] = [];
          }
          sharedeviceObj[item.share_group_id].push(item);
          if (item.share_group_id === gId && groupStatus < item.deviceStatusCode) {
            groupStatus = item.deviceStatusCode;
          }
        } else if (item.gId) {
          if (!deviceObj.hasOwnProperty(item.gId)) {
            deviceObj[item.gId] = [];
          }
          deviceObj[item.gId].push(item);
          if (item.gId === gId && groupStatus < item.deviceStatusCode) {
            groupStatus = item.deviceStatusCode;
          }
        }
      });
    }
    if (deviceObj.hasOwnProperty(gId)) {
      result.deviceStatusCode = groupStatus;
      result.status = statusMapping[groupStatus].status;
      result.icon = statusMapping[groupStatus].icon;
      if (groupStatus === 0) {
        result.desc = groupDesc;
      }
      result.devices = deviceObj[gId];
    }
    if (sharedeviceObj.hasOwnProperty(gId)) {
      result.deviceStatusCode = groupStatus;
      result.status = statusMapping[groupStatus].status;
      result.icon = statusMapping[groupStatus].icon;
      if (groupStatus === 0) {
        result.desc = groupDesc;
      }
      result.shared_devices = sharedeviceObj[gId];
    }
  }
  return {
    Id: result.Id,
    gName: (result.gName) ? result.gName : null,
    ParentGroupId: result.ParentGroupId ? result.ParentGroupId : null,
    TimeZone: result.TimeZone,
    Description: result.Description,
    Country: result.Country,
    CO2Measure: result.CO2Measure,
    CostSetting: result.CostSetting,
    CO2Emitted: result.CO2Emitted,
    devices: result.devices,
    status: (result.status) ? result.status : null,
    icon: (result.icon) ? result.icon : null,
    deviceStatusCode: (result.deviceStatusCode) ? result.deviceStatusCode : null,
    otp: (result.otp) ? result.otp : null,
    shared_devices: result.shared_devices,
    All_devices: (result.All_devices) ? result.All_devices : null,
    Load: (result.Load) ? result.Load : null,
    BatCap: (result.BatCap) ? result.BatCap : null,
    RegionId: (result.RegionId) ? result.RegionId : null,
    is_shared: result.is_shared
  };
});


// Page - Alerts / BatteryTestScheduler
export const getDevicesNameSN = createSelector(DevicesFiltered, (data) => {
  return data.map(item => {
    return {
      label: item.name,
      value: item.DeviceSN,
      isExpired: item.isExpired,
      regionId: item.regionId,
      is_Shared: item.is_shared,
      share_type: item.share_type,
      level: item.level,
      sourceType: item.SourceType,
      deviceSubType: item.DeviceSubType
    };
  });
});


// Page - Status
export const getDeviceTimeZone = createSelector(getDevicesStatusState, (device) => {
  const timeZoneMap = {};
  if (device.entities.DeviceList.length > 0) {
    device.entities.DeviceList.forEach(item => {
      timeZoneMap[item.dcode] = item.timeZone;
    });
  }
  if (device.entities.ShareDeviceList.length > 0) {
    device.entities.ShareDeviceList.forEach(item => {
      timeZoneMap[item.dcode] = item.timeZone;
    });
  }
  if (device.entities.ShareGroupDeviceList.length > 0) {
    device.entities.ShareGroupDeviceList.forEach(item => {
      timeZoneMap[item.dcode] = item.timeZone;
    });
  }
  return timeZoneMap;
});
export const getStatusLogData = createSelector(
  getStatusLogState, getDeviceTimeZone, getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState,
  (data, deviceTimeZoneMap, errorLevelMaps, errorCodeMaps) => {
  const result = [...data.entities.map(item => {
    let res = { ...item };
    const time = new Date(res.timestamp.toString().replace(/-/g, '/')).getTime();

    let hasHardwareFault = false;
    res['time'] = time;
    res['timeDate'] = new Date(time).toTimeString();
    if (deviceTimeZoneMap.hasOwnProperty(res.dcode)) {
      res['timeZone'] = deviceTimeZoneMap[res.dcode];
    } else {
      res['timeZone'] = 0;
    }

    // Hardware Fault
    if (res.ErrorCodeEvent && res.ErrorCodeEvent !== '') {
      res = hardwareStatusLogAnalysis(res, errorLevelMaps, errorCodeMaps);
      hasHardwareFault = true;
    }
    res['hasHardwareFault'] = hasHardwareFault;
    res['BpsVoltABC'] = composeData([res.BpsVoltA, res.BpsVoltB, res.BpsVoltC]);
    res['InPFABC'] = composeData([res.InPFA, res.InPFB, res.InPFC]);
    res['InVoltABC'] = composeData([res.InVoltA, res.InVoltB, res.InVoltC]);
    res['OutPwABC'] = composeData([res.OutPwA, res.OutPwB, res.OutPwC]);
    res['OutPFABC'] = composeData([res.OutPFA, res.OutPFB, res.OutPFC]);
    res['OutVoltABC'] = composeData([res.OutVoltA, res.OutVoltB, res.OutVoltC]);
    res['InFreqABC'] = composeData([res.InFreqA, res.InFreqB, res.InFreqC]);
    res['OutFreqABC'] = composeData([res.OutFreqA, res.OutFreqB, res.OutFreqC]);
    res['UPSLoadABC'] = composeData([res.LoadPctA, res.LoadPctB, res.LoadPctC]);
    res['CurABC'] = composeData([res.CurA, res.CurB, res.CurC]);
    res['PkCurABC'] = composeData([res.PkCurA, res.PkCurB, res.PkCurC]);
    res['VoltABC'] = composeData([res.VoltA, res.VoltB, res.VoltC]);
    res['SrcVoltAB'] = composeData([res.SrcVoltA, res.SrcVoltB]);
    res['SrcFreqAB'] = composeData([res.SrcFreqA, res.SrcFreqB]);
    res['BpsFreqABC'] = composeData([res.BpsFreqA, res.BpsFreqB, res.BpsFreqC]);
    res['OutActABC'] = composeData([res.OutActA, res.OutActB, res.OutActC]);
    return res;
  })].sort(function (a: any, b: any) {
    return b.time - a.time;
  });
  return result;
  // const timeZoneMap = {};
  // let timeZone = 0;
  //   device.entities.forEach(item => {
  //     timeZoneMap[item.dcode] = item.timeZone;
  // });
  //   if (data.entities.length > 0) {
  //     const dcode = data.entities[0].dcode;
  //     if (timeZoneMap.hasOwnProperty(dcode)) {
  //       timeZone = timeZoneMap[dcode];
  //     }
  //   }
    // return {
    //   Loaded: data.Loaded,
    //   Loading: data.Loading,
    //   entities: data.entities.map(res => {
    //     const time = new Date(res.timestamp).getTime();
    //     res['time'] = time;
    //     return res;
    //   }),
    //   // timeZone: timeZone
    //   };
  function composeData(array) {
    return array.map(emptyDetect).join(' / ');
  }
  function emptyDetect(value) {
    if (value === '' || typeof value === 'undefined' || value === null || isNaN(value)) {
      return '--';
    }
    return parseFloat(value).toFixed(1);
  }
});

// Page - Status Monitoring
export const getDeviceMonitoringStatuses = createSelector(
  getStatusLogState, getDeviceMonitoringState, getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState,
  (data, devices, errorLevelMaps, errorCodeMaps) => {
  let device: any;
  const result = [...data.entities.map(item => {
    let res = {...item};
    const time = new Date(res.timestamp.toString().replace(/-/g, '/')).getTime();
    let hasHardwareFault = false;
    if (!device) { // get only the first time.
      device = (devices.entities.hasOwnProperty(res.dcode)) ? devices.entities[res.dcode] : null;
    }
    res['time'] = time;
    res['timeDate'] = new Date(time).toTimeString();
    if (device) {
      res['timeZone'] = device.timeZone;
    } else {
      res['timeZone'] = 0;
    }

    // Hardware Fault
    if (res.ErrorCodeEvent && res.ErrorCodeEvent !== '') {
      res = hardwareStatusLogAnalysis(res, errorLevelMaps, errorCodeMaps);
      hasHardwareFault = true;
    }
    res['hasHardwareFault'] = hasHardwareFault;
    res['BpsVoltABC'] = composeData([res.BpsVoltA, res.BpsVoltB, res.BpsVoltC]);
    res['InPFABC'] = composeData([res.InPFA, res.InPFB, res.InPFC]);
    res['InVoltABC'] = composeData([res.InVoltA, res.InVoltB, res.InVoltC]);
    res['OutPwABC'] = composeData([res.OutPwA, res.OutPwB, res.OutPwC]);
    res['OutPFABC'] = composeData([res.OutPFA, res.OutPFB, res.OutPFC]);
    res['OutVoltABC'] = composeData([res.OutVoltA, res.OutVoltB, res.OutVoltC]);
    res['InFreqABC'] = composeData([res.InFreqA, res.InFreqB, res.InFreqC]);
    res['OutFreqABC'] = composeData([res.OutFreqA, res.OutFreqB, res.OutFreqC]);
    res['UPSLoadABC'] = composeData([res.LoadPctA, res.LoadPctB, res.LoadPctC]);
    res['CurABC'] = composeData([res.CurA, res.CurB, res.CurC]);
    res['PkCurABC'] = composeData([res.PkCurA, res.PkCurB, res.PkCurC]);
    res['VoltABC'] = composeData([res.VoltA, res.VoltB, res.VoltC]);
    res['SrcVoltAB'] = composeData([res.SrcVoltA, res.SrcVoltB]);
    res['SrcFreqAB'] = composeData([res.SrcFreqA, res.SrcFreqB]);
    res['BpsFreqABC'] = composeData([res.BpsFreqA, res.BpsFreqB, res.BpsFreqC]);
    res['OutActABC'] = composeData([res.OutActA, res.OutActB, res.OutActC]);
    return res;
  })].sort(function (a: any, b: any) {
    return b.time - a.time;
  });
  return result;
  function composeData(array) {
    return array.map(emptyDetect).join(' / ');
  }
  function emptyDetect(value) {
    if (value === '' || typeof value === 'undefined' || value === null || isNaN(value)) {
      return '--';
    }
    return parseFloat(value).toFixed(1);
  }
});
function processLogDataForCharts(data: any[]): any {
  const deviceSubType = (data && data.length > 0) ? Number(data[0].DeviceSubType) : 0;
  const chart = {
    inputVol: [],
    bpsVoltA: [],
    bpsVoltB: [],
    bpsVoltC: [],
    inputVolA: [],
    inputVolB: [],
    inputVolC: [],
    outputVol: [],
    outputVolA: [],
    outputVolB: [],
    outputVolC: [],
    inputFreq: [],
    bpsFreqA: [],
    bpsFreqB: [],
    bpsFreqC: [],
    inputFreqA: [],
    inputFreqB: [],
    inputFreqC: [],
    outputFreq: [],
    outputFreqA: [],
    outputFreqB: [],
    outputFreqC: [],
    sysTemp: [],
    envHumi: [],
    devLoad: [],
    upsLoadA: [],
    upsLoadB: [],
    upsLoadC: [],
    voltage: [],
    voltA: [],
    voltB: [],
    voltC: [],
    current: [],
    curA: [],
    curB: [],
    curC: [],
    power: [],
    energy: [],
    srcVoltA: [],
    srcVoltB: [],
    srcFreqA: [],
    srcFreqB: []
  };

  data.forEach(item => {
    const localTime = (item.timestamp != null) ? (item['time'] + (item['timeZone'] * 60 * 60 * 1000)) : '';

    if (DeviceSubType[Number(item.DeviceSubType)].name === 'UPS' || DeviceSubType[Number(item.DeviceSubType)].name === '3-Phase UPS') {
      if (DeviceSubType[Number(item.DeviceSubType)].name === 'UPS') {
        chart.inputVol.push({x: localTime, y: item.InVolt});
        chart.outputVol.push({x: localTime, y: item.OutVolt});
        chart.inputFreq.push({x: localTime, y: item.InFreq});
        chart.outputFreq.push({x: localTime, y: item.OutFreq});
        chart.sysTemp.push({x: localTime, y: item.SysTemp});
        chart.envHumi.push({x: localTime, y: item.EnvHumi});
        chart.devLoad.push({x: localTime, y: item.DevLoad});
      }
      if (DeviceSubType[Number(item.DeviceSubType)].name === '3-Phase UPS') {
        chart.inputVolA.push({x: localTime, y: item.InVoltA});
        chart.inputVolB.push({x: localTime, y: item.InVoltB});
        chart.inputVolC.push({x: localTime, y: item.InVoltC});
        chart.outputVolA.push({x: localTime, y: item.OutVoltA});
        chart.outputVolB.push({x: localTime, y: item.OutVoltB});
        chart.outputVolC.push({x: localTime, y: item.OutVoltC});
        chart.inputFreqA.push({x: localTime, y: item.InFreqA});
        chart.inputFreqB.push({x: localTime, y: item.InFreqB});
        chart.inputFreqC.push({x: localTime, y: item.InFreqC});
        chart.outputFreqA.push({x: localTime, y: item.OutFreqA});
        chart.outputFreqB.push({x: localTime, y: item.OutFreqB});
        chart.outputFreqC.push({x: localTime, y: item.OutFreqC});
        chart.upsLoadA.push({x: localTime, y: item.LoadPctA});
        chart.upsLoadB.push({x: localTime, y: item.LoadPctB});
        chart.upsLoadC.push({x: localTime, y: item.LoadPctC});
        chart.bpsVoltA.push({x: localTime, y: item.BpsVoltA});
        chart.bpsVoltB.push({x: localTime, y: item.BpsVoltB});
        chart.bpsVoltC.push({x: localTime, y: item.BpsVoltC});
        chart.bpsFreqA.push({x: localTime, y: item.BpsFreqA});
        chart.bpsFreqB.push({x: localTime, y: item.BpsFreqB});
        chart.bpsFreqC.push({x: localTime, y: item.BpsFreqC});
      }
    } else {
      chart.current.push({x: localTime, y: item.Cur});
      if (DeviceSubType[Number(item.DeviceSubType)].name === 'ATS' || DeviceSubType[Number(item.DeviceSubType)].name === 'PDU') {
        if (DeviceSubType[Number(item.DeviceSubType)].name === 'ATS') {
          chart.inputVolA.push({x: localTime, y: item.InVoltA});
          chart.inputVolB.push({x: localTime, y: item.InVoltB});
        }
        if (DeviceSubType[Number(item.DeviceSubType)].name === 'PDU') {
          chart.voltage.push({x: localTime, y: item.Volt});
        }
        chart.power.push({x: localTime, y: item.Power});
        chart.energy.push({x: localTime, y: item.Energy});
      }
      if (DeviceSubType[Number(item.DeviceSubType)].name === 'nATS' || DeviceSubType[Number(item.DeviceSubType)].name === 'nPDU') {
        chart.curA.push({x: localTime, y: item.CurA});
        chart.curB.push({x: localTime, y: item.CurB});
        chart.curC.push({x: localTime, y: item.CurC});
        chart.voltA.push({x: localTime, y: item.VoltA});
        chart.voltB.push({x: localTime, y: item.VoltB});
        chart.voltC.push({x: localTime, y: item.VoltC});
        chart.power.push({x: localTime, y: item.PowerT});
        chart.energy.push({x: localTime, y: item.EnergyT});
        chart.srcVoltA.push({x: localTime, y: item.SrcVoltA});
        chart.srcVoltB.push({x: localTime, y: item.SrcVoltB});
        chart.srcFreqA.push({x: localTime, y: item.SrcFreqA});
        chart.srcFreqB.push({x: localTime, y: item.SrcFreqB});
      }
    }
  });

  const result = {
    voltageChart: {datasets: []},
    frequencyChart: {datasets: []},
    temperatureChart: {datasets: []},
    humidityChart: {datasets: []},
    loadChart: {datasets: []},
    currentChart: {datasets: []},
    powerChart: {datasets: []},
    energyChart: {datasets: []}
  };

  const status_chart = DeviceSubType[Number(deviceSubType)].status_chart;
  if (status_chart.voltageChart) {
    status_chart.voltageChart.forEach(item => {
      result.voltageChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.frequencyChart) {
    status_chart.frequencyChart.forEach(item => {
      result.frequencyChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.temperatureChart) {
    status_chart.temperatureChart.forEach(item => {
      result.temperatureChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.humidityChart) {
    status_chart.humidityChart.forEach(item => {
      result.humidityChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.loadChart) {
    status_chart.loadChart.forEach(item => {
      result.loadChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.currentChart) {
    status_chart.currentChart.forEach(item => {
      result.currentChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.powerChart) {
    status_chart.powerChart.forEach(item => {
      result.powerChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  if (status_chart.energyChart) {
    status_chart.energyChart.forEach(item => {
      result.energyChart.datasets.push({
        label: item.label,
        data: chart[item.data],
        fill: false,
        borderColor: item.borderColor,
        backgroundColor: item.backgroundColor,
      });
    });
  }
  return result;
}
export const getMonitoringStatusChart = createSelector(
  getDeviceMonitoringStatuses,
  processLogDataForCharts
);

export const getStatusChart = createSelector(
  getStatusLogData,
  processLogDataForCharts 
);

export const getStatusPeakData = createSelector(getStatusPeakState, (data) => {
  return [...data.entities.map(i => {
    return {
      date: i.Time,
      inputVolt: composeData(i.Input_volt_max, i.Input_volt_min, i.Input_volt_avg),
      outputVolt: composeData(i.Output_volt_max, i.Output_volt_min, i.Output_volt_avg),
      // PDU的 Volt 欄位資料為 outputVolt
      Volt: composeData(i.Output_volt_max, i.Output_volt_min, i.Output_volt_avg),
      inputFreq: composeData(i.Input_freq_max, i.Input_freq_min, i.Input_freq_avg),
      outputFreq: composeData(i.Output_freq_max, i.Output_freq_min, i.Output_freq_avg),
      temp: composeData(i.Temp_max, i.Temp_min, i.Temp_avg),
      hum: composeData(i.Hum_max, i.Hum_min, i.Hum_avg),
      Cur: composeData(i.Current_max, i.Current_min, i.Current_avg),
      InVoltA: composeData(i.Input_voltA_max, i.Input_voltA_min, i.Input_voltA_avg),
      InVoltB: composeData(i.Input_voltB_max, i.Input_voltB_min, i.Input_voltB_avg),
      InVoltC: composeData(i.Input_voltC_max, i.Input_voltC_min, i.Input_voltC_avg),
      Power: composeData(i.Power_max, i.Power_min, i.Power_avg),
      Energy: composeData(i.Energy_max, i.Energy_min, i.Energy_avg),
      PowerT: composeData(i.PowerT_max, i.PowerT_min, i.PowerT_avg),
      EnergyT: composeData(i.EnergyT_max, i.EnergyT_min, i.EnergyT_avg),
      PkCur: composeData(i.PkCurrent_max, i.PkCurrent_min, i.PkCurrent_avg),
      OutVoltA: composeData(i.Output_voltA_max, i.Output_voltA_min, i.Output_voltA_avg),
      OutVoltB: composeData(i.Output_voltB_max, i.Output_voltB_min, i.Output_voltB_avg),
      OutVoltC: composeData(i.Output_voltC_max, i.Output_voltC_min, i.Output_voltC_avg),
      // ePDU的 VoltA/B/C 欄位資料為 outputVoltA/B/C
      VoltA: composeData(i.Output_voltA_max, i.Output_voltA_min, i.Output_voltA_avg),
      VoltB: composeData(i.Output_voltB_max, i.Output_voltB_min, i.Output_voltB_avg),
      VoltC: composeData(i.Output_voltC_max, i.Output_voltC_min, i.Output_voltC_avg),
      SrcVoltA: composeData(i.SrcVoltA_max, i.SrcVoltA_min, i.SrcVoltA_avg),
      SrcVoltB: composeData(i.SrcVoltB_max, i.SrcVoltB_min, i.SrcVoltB_avg),
      SrcFreqA: composeData(i.SrcFreqA_max, i.SrcFreqA_min, i.SrcFreqA_avg),
      SrcFreqB: composeData(i.SrcFreqB_max, i.SrcFreqB_min, i.SrcFreqB_avg)
    };
  })].sort(function (a: any, b: any) {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });
  function composeData(max, min, avg) {
    return emptyDetect(max) + ' / ' + emptyDetect(min) + ' / ' + emptyDetect(avg);
  }
  function emptyDetect(value) {
    if (value === '' || typeof value === 'undefined' || value === null || isNaN(value)) {
      return '--';
    }
    return parseFloat(value).toFixed(1);
  }
});
export const getStatusPageLoad = createSelector(getStatusLogState, getStatusPeakState, (log, logPeak) => {
  if (log.Loading || logPeak.Loading) {
    return { Loading: true };
  }
  return { Loading: false };
});
export const getStatusMonitoringLogData = createSelector(getStatusLogState, getDeviceInfo, (data, deviceInfos) => {
  return [...data.entities.map(item => {
    const res = { ...item };
    const time = new Date(res.timestamp.toString().replace(/-/g, '/')).getTime();
    res['time'] = time;
    if (deviceInfos.hasOwnProperty(res.dcode)) {
    } else {
      res['timeZone'] = 0;
    }
    return res;
  })].sort(function (a: any, b: any) {
    return b.time - a.time;
  });
});


// Page - Floor Map
export const getFloorMapGroupOptions = createSelector(getGroupDevices, getNoGroupDevices, (groups, devices) => {
  let options: any = [];
  groups.filter(item => !item.data.is_shared).forEach(item => {
    options.push({
      label: item.data.name,
      styleClass: 'none_active',
      draggable: true,
      children: item.children.filter(i => !IsEmptyObject(i.data)).map(res => {
        return {
          label: res.data.name,
          styleClass: 'none_active',
          draggable: true,
          data: {
            type: childDeviceStr,
            id: Number(res.data.dcode),
            groupId: Number(item.data.gId),
            name: res.data.name,
            regionId: res.data.regionId,
          }
        };
      }),
      data: {
        type: groupStr,
        id: Number(item.data.gId),
        name: item.data.name,
        regionId: item.data.regionId,
      }
    });
  });
  const deviceOpt: any = devices.filter(item => !item.is_shared).map(item => {
    return {
      label: item.name,
      styleClass: 'none_active',
      draggable: true,
      data: {
        type: deviceStr,
        id: Number(item.dcode),
        name: item.name,
        regionId: item.regionId,
      }
    };
  });
  if (deviceOpt.length > 0) {
    options = options.concat(deviceOpt);
  }
  return options;
});
export const getFloorMapNameList = createSelector(getFloorMapState, (data) => {
  if (data.Loaded && !data.Loading) {
    return Object.values(data.entities).map(item => {
      return {label: item.name, value: item.id};
    });
  }
});
export const getGroupsNameList = createSelector(getGroupState, (data) => {
  if (data.Loaded && !data.Loading) {
    const result = [...[{label: 'Select A Group', value: -1, regionId: -1}] , ...Object.values(data.entities).map(item => {
      return {label: item.gName, value: item.Id, regionId: item.RegionId};
    })];
    return result;
  }
});

export const getGroupsNameListForBatteryTestSchedule = createSelector(getGroupDevices, (data) => {
  if (!data || data.length === 0) return [];

  const result = [
    { label: 'Select A Group', value: -1, regionId: -1, disabled: false },
    ...Object.values(data).map(item => {
      let isGroupDisabled = false;

      if (item.children && item.children.length > 0) {
        const hasValidData = item.children.some(child => child.data && Object.keys(child.data).length > 0);
        isGroupDisabled = !hasValidData; 
      } else {
        isGroupDisabled = true;
      }

      return {
        label: item.data.name, 
        value: item.data.gId, 
        regionId: item.data.regionId,
        disabled: isGroupDisabled
      };
    })
  ];

  // 回傳所有沒被 disabled 的群組
  return result.filter(group => group.value === -1 || !group.disabled);
});

export const getGroupsNameListWithDeviceExpiredInfo = createSelector(getGroupDevices, (data) => {
  const result = [...[{label: 'Select A Group', value: -1, regionId: -1, allDeviceExpired: false}] , ...Object.values(data).map(item => {
    let allDeviceExpiredTemp = false;
    let expiredCounter = 0;
    if (item.children && item.children.length > 0) {
      for (let i = 0; i < item.children.length; i++) {
        if (item.children[i].data && item.children[i].data.isExpired) {
          expiredCounter++;
        }
      }
      if (expiredCounter === item.children.length) {
        allDeviceExpiredTemp = true;
      }
    }
    return {label: item.data.name, value: item.data.gId, regionId: item.data.regionId, allDeviceExpired: allDeviceExpiredTemp};
  })];
  return result;
});
export const getFloorMaps = createSelector(getFloorMapArrangeData, getFloorMapFilterState, (data, filter) => {
  if (data.Loaded && !data.Loading) {
    if (data.entities.hasOwnProperty(filter.mapOptions)) {
      let details = data.entities[filter.mapOptions].details;
      
      // Group status option
      if (filter.statusOptions !== -1) {
        details = details.filter(i => i.statusCode === filter.statusOptions);
      }
      
      // NgRx 9 不可變性: 使用 map 創建新數組而不是 forEach 修改
      details = details.map(item => ({
        ...item,
        isHighLightGroup: item.gId === filter.groupOptions
      }));
      
      const result: FloorMap = {
        ...data.entities[filter.mapOptions],
        details: details
      };
      
      return result;
    }
  }
});
export const getSingleFloorMap = createSelector(getFloorMapArrangeData, getFloorMapGroupOptions, (data, deviceGroupList, props) => {
  if (data.Loaded && !data.Loading) {
    if (data.entities.hasOwnProperty(props.mapId)) {
      const result = {...data.entities[props.mapId]};
      result.details = result.details.map(item => {
        const type = (!item.isGroup && item.gId !== null) ? childDeviceStr : item.type;
        return {
          name: item.name,
          status: 'normal',
          position: { x: item.xaxes, y: item.yaxes},
          type: type,
          ownerId: item.ownerId,
          size: {width: item.width, height: item.height},
          groupId: item.gId
        };
      });
      const detailList = [...result.details];
      const list = deviceGroupList.map(item => {
        let listItem = item;
        for (let j = 0; j < detailList.length; j++) {
          const detail = {...detailList[j]};
          if (detail.type === childDeviceStr) {
            if (listItem.hasOwnProperty('children')) {
              listItem =  {
                ...listItem, children: listItem.children.map(function (k) {
                  if (k.data.type === childDeviceStr && detail.ownerId === k.data.id && detail.groupId === k.data.groupId) {
                    return {...k, draggable: false, styleClass: 'active'};
                  }
                  return k;
                })
              };
            }
          }
          if (detail.type === item.data.type && detail.ownerId === item.data.id) {
            detailList.splice(j, 1);
            listItem = {...listItem, draggable: false, styleClass: 'active'};
          }
        }
        return listItem;
      });
      return {data: result, list: list};
    }
  }
});


// Page - Account Change Info History
export const getChangeInfo = createSelector(getChangeInfoState, (info, props) => {
  if (info.isLoaded && !info.isLoading) {
    const dcodeList = info.entities.filter(s => s.dcode === props);
    return [...dcodeList].sort(function (a: any, b: any) {
      return b.CreateTime - a.CreateTime;
    });
  }
});

// Page - Order History
export const getPurchase = createSelector(getPurchaseState, getPurchaseFilterState, (data, filter) => {
  if (data.isLoaded && !data.isLoading && data.entities.length > 0) {
    return data.entities.filter(i => {
      if (filter.ItemType >= 0) {
        return i.ItemType === filter.ItemType;
      } else {
        return i;
      }
    }).map(item => {
      let productGrade = '';
      switch (item.ItemType) {
        case 0:
          productGrade = item.PlanName;
          break;
        case 1:
          productGrade = item.Package;
          break;
        case 2:
          productGrade = item.PlanName;
          break;
        default:
      }
      return {
        OrderId: '#' + item.OrderId,
        ItemTypeStr: purchaseOrderMap.ItemType[item.ItemType], // 0: License, 1: Package, 2: Plan
        ProductGrade: productGrade,
        CreateTime: item.CreateTime,
        Period: item.Period,
        Amount: `${item.CurrencyCode} ${item.CurrencySymbol} ${item.Amount}`,
        Level: item.Level,
        ItemType: item.ItemType, // 0: License, 1: Package, 2: Plan
        PlanName: item.PlanName
      };
    });
  }
});

// Page - License Mgt List
export const getLicenseMgtData = createSelector(getLicenseMgtListState, getRegions, getLicenseMgtListExpiredDate, getDeviceInfo,
  getAccountInfo, (license, region, expiredObj, deviceInfo, accountInfo) => {
    if (license.Loaded && !license.Loading && license.data.length > 0 && region.length > 0) {
    const regionObj = region.reduce((obj, item) => (obj[item.Id] = item, obj) , {});
    const licenseInfo = license.data;
    const cryptoService = new CryptoService;
    return licenseInfo.map((item) => {
      const CompanyId = accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].CompanyId : NaN;
      const expiredDcodeList = ((item.UsingStatus === 3 || item.UsingStatus === 4) && item.LicenseType !== 2 && item.dcode) ?
      expiredObj[item.dcode] : [],
      // v1.8.5.2 - License Mgt調整為LicenseType === Plan => planName, 其他 => level
      expiredItem = expiredDcodeList !== undefined && expiredDcodeList.length > 0 ?
       expiredDcodeList.find(i => i.InfoId === item.InfoId) : null;
      // NgRx 9 不可變性: 使用擴展運算符創建新對象，而不是直接修改 item.Level
      return {...item,
        RegionId: CompanyId || item.RegionId,
        Level: item.LicenseType === 4 ? item.PlanName : item.Level,
        CompanyName: (item.LicenseType === 0 && regionObj.hasOwnProperty(item.RegionId)) ? regionObj[item.RegionId].RegionName :
          regionObj.hasOwnProperty(CompanyId) ? regionObj[CompanyId].RegionName : '',
        LicenseManagementID: (item.LicenseType === 0 && regionObj.hasOwnProperty(item.RegionId)) ?
                              regionObj[item.RegionId].RegionName + '_' + item.RegionMgtId : '',
        LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
        BindType: licenseMap.BindType[item.BindType],
        Status: licenseMap.UsingStatus[item.UsingStatus],
        ExpiredDate: (expiredItem) ? expiredItem.ExpiredDate.getTime() : null,
        CreateUser: accountInfo.hasOwnProperty(item.CreateId) ? accountInfo[item.CreateId].Account : '--',
        DeviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
        DeviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
        SerialId: item.SerialId,
        Account: accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].Account : '--',
        HashInfoId: cryptoService.aesEncrypt(item.InfoId),
        HashDcode: cryptoService.aesEncrypt(item.dcode),
        HashAcode: cryptoService.aesEncrypt(item.acode)
      };
    });
  }
  return [];
});

export const getLicenseMgtList = createSelector(getLicenseMgtData, getLicenseMgtListFilterState, (licenseInfo: any, filter) => {
  if (!!filter) {
    if (filter.RegionIdOptions !== -1) {
      licenseInfo = licenseInfo.filter(i => i.RegionId === filter.RegionIdOptions);
    }
    if (filter.RegionMgtIdOptions !== -1 && filter.RegionMgtIdOptions !== 0) {
      licenseInfo = licenseInfo.filter(i => i.MgtId === filter.RegionMgtIdOptions);
    }
    if (filter.UsingStatusOptions !== -1) {
      if (filter.UsingStatusOptions === 1) {
        licenseInfo = licenseInfo.filter(i => i.UsingStatus === 1 || i.UsingStatus === 2);
      } else {
        licenseInfo = licenseInfo.filter(i => i.UsingStatus === filter.UsingStatusOptions);
      }
    }
    if (filter.LicenseTypeOptions !== -1) {
      licenseInfo = licenseInfo.filter(i => i.LicenseType === filter.LicenseTypeOptions);
    }
    if (filter.RemainDaysOptions !== -1) {
      licenseInfo = licenseInfo.filter(i => i.RemainDay < filter.RemainDaysOptions);
    }
    // v1.8.5.2 - License Mgt調整為LicenseType === Plan => planName, 其他 => level
    // licenseInfo.map(item => {
    //   if (item.LicenseType === 4) {
    //     item.Level = item.PlanName;
    //   }
    // });
    return licenseInfo;
  }
  return [];
});


// Page - License Mgt
export const getLicenseMgt = createSelector(getLicenseState, getRegionState, getUserState, getPlanMgtState,
  (licenseMgt, regionState, user, planMgt) => {
  const allLicenses = Object.values(licenseMgt.entities);
  const allRegions = Object.values(regionState.entities);
  const regions = allRegions.map(item => item);
  const regionObj: {} = Object.assign({}, ...regions.map(item => ({[item.Id]: item})));
  // 創建新對象副本以避免修改只讀的 store 數據 (NgRx 9 immutability)
  const enrichedLicenses = allLicenses.map(i => {
    if (regionObj.hasOwnProperty(i.RegionId)) {
      return {
        ...i,
        RegionName: regionObj[i.RegionId].RegionName,
        RegionMgtName: regionObj[i.RegionId].RegionName + '_' + i.RegionMgtId
      };
    }
    return { ...i };
  });
  const licenseMgtList = (user.authority === authorityMap.SystemAdmin) ? enrichedLicenses : enrichedLicenses.filter(res => {
    return res.RegionId === user.RegionId;
  });
  return licenseMgtList;
});


// Page - License Setting
export const getLicenseSettingList = createSelector(getLicenseSettingState, getLicenseSettingListFilterState,
  getLicenseSettingListExpiredDate, getCurrentUser, (licenseSetting, filter, expiredObj, user) => {
  let allLicenses = Object.values(licenseSetting.entities);
    allLicenses = allLicenses.filter(i => i.acode === Number(user.acode));
    if (!!filter) {
    if (filter.UsingStatusOptions !== -1) {
      if (filter.UsingStatusOptions === 1) {
        allLicenses = allLicenses.filter(i => i.UsingStatus === 1 || i.UsingStatus === 2); // available & binding
      } else {
        allLicenses = allLicenses.filter(i => i.UsingStatus === filter.UsingStatusOptions);
      }
    }
    if (filter.LicenseTypeOptions !== -1) {
      allLicenses = allLicenses.filter(i => i.LicenseType === filter.LicenseTypeOptions);
    }
  }
  return allLicenses.map((item) => {
    const cryptoService = new CryptoService;
    const expiredDcodeList = ((item.UsingStatus === 3 || item.UsingStatus === 4) && item.LicenseType !== 2 && item.dcode) ?
      expiredObj[item.dcode] : [],
      expiredItem = expiredDcodeList.find(i => i.InfoId === item.InfoId);

    return {...item,
      LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
      BindType: licenseMap.BindType[item.BindType],
      Status: licenseMap.UsingStatus[item.UsingStatus],
      ExpiredDate: (expiredItem) ? expiredItem.ExpiredDate.getTime() : null,
      HashInfoId: cryptoService.aesEncrypt(item.InfoId)
    };
  });
});

// Page - License Device Detail (For License Selection List)
export const getDetailSelectLicenseList = createSelector(getLicenseSettingState, (licenseSetting) => {
    const allLicenses = Object.values(licenseSetting.entities);
    return allLicenses.map((item) => {
      return {...item,
        LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
        BindType: licenseMap.BindType[item.BindType],
        Status: licenseMap.UsingStatus[item.UsingStatus],
      };
    });
  });


// Page - License Management Filter
export const getLicenseMgtListFilterOption = createSelector(getLicenseState, getRegionState, getLicenseMgtListFilterState, getUserState,
  (license, region, filter, user) => {
  if (license.Loaded && !license.Loading && !!license.entities && !!region.entities) {
    const allRegions = Object.values(region.entities);
    const allLicenses = Object.values(license.entities);
    const result = {
      companyOption: [],
      managementIdOption: []
    };
    if (user.authority === 2) { // System Admin
      result.companyOption = allRegions.map(item => {
        return {label: item.RegionName, value: item.Id};
      });
      result.companyOption.unshift({label: 'All', value: -1});
    } else { // Region Admin
      // result.companyOption = allRegions.filter(item => user.AuthorityRegion.includes(item.Id)).map(item => {
      //   return {label: item.RegionName, value: item.Id};
      // });
      result.companyOption = allRegions.filter(item => user.AuthorityRegion.includes(item.Id)).map(item => {
        return {label: item.RegionName, value: item.Id};
      });
    }
    result.managementIdOption = allLicenses.filter(item => item.RegionId === filter.RegionIdOptions && item.IsConfirmed).map(item => {
      return {label: item.RegionMgtName, value: item.Id};
    });
    result.managementIdOption.unshift({label: 'Any Management ID', value: -1 });
    return result;
  }
  return void(0);
});


// Page - License Detail
export const getLicenseDetails = createSelector(getLicenseDetailsState, getRegionState, getDeviceInfo, getAccountInfo,
  (data, regionState, deviceInfo, accountInfo) => {
    if (data.Loaded && !data.Loading && !!data.entities && !IsEmptyObject(data.entities) && !IsEmptyObject(regionState.entities)) {
      const cryptoService = new CryptoService;
      const allRegions = Object.values(regionState.entities);
      const regions = allRegions.map(item => item);
      const regionObj: {} = Object.assign({}, ...regions.map(item => ({[item.Id]: item})));
      const user = accountInfo.hasOwnProperty(data.entities.acode) ? accountInfo[data.entities.acode] : null;
      const result = {
      Id: data.entities.Id,
      LicenseType: data.entities.LicenseType,
      LicenseTypeName: licenseMap.LicenseType[data.entities.LicenseType],
      LicenseNumber: data.entities.LicenseNumber,
      LicenseManagementID: (data.entities.LicenseType === 0) ?
      regionObj[data.entities.RegionId].RegionName + '_' + data.entities.RegionMgtId : '',
      acode: data.entities.acode,
      account: user ? user.Account : null,
      RegionId: data.entities.RegionId,
      RegionName: user ? regionObj[user.CompanyId].RegionName : '',
      Level: data.entities.Level,
      PlanName: data.entities.PlanName,
      RemainDay: data.entities.RemainDay,
      PeriodDay: data.entities.PeriodDay,
      OriginalPeriodDay: data.entities.OriginalPeriodDay,
      UsingStatus: licenseMap.UsingStatus[data.entities.UsingStatus],
      CreateId: data.entities.CreateId,
      CreateTime: data.entities.CreateTime,
      UsingDeviceData: [],
      UsedDeviceData: [],
      dcodes: [],
      ExpiredDate: null,
    };
    if (Array.isArray(data.entities.UsedDevice)) {
      result.UsingDeviceData = data.entities.UsedDevice.filter((i) => i.IsActive && (i.UsingStatus === 3 || i.UsingStatus === 4))
        .map((item) => {
        return {
          acode: item.acode,
          account: accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].Account : null,
          dcode: item.dcode,
          deviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
          deviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
          BindType: licenseMap.BindType[item.BindType],
          BindSn: item.BindSn,
          UsingStatus: licenseMap.UsingStatus[item.UsingStatus],
          LastActiveTime: item.LastActiveTime,
          IsActive: item.IsActive,
          HashDcode: cryptoService.aesEncrypt(item.dcode)
        };
      });

      result.UsedDeviceData = [...data.entities.UsedDevice.filter((i) => !i.IsActive || (i.UsingStatus !== 3 &&　i.UsingStatus !== 4))]
        .sort((i, j) => j.LastActiveTime - i.LastActiveTime)
        .map((item) => {
        return {
          acode: item.acode,
          account: accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].Account : null,
          dcode: item.dcode,
          deviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
          deviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
          BindType: licenseMap.BindType[item.BindType],
          BindSn: item.BindSn,
          UsingStatus: licenseMap.UsingStatus[item.UsingStatus],
          LastActiveTime: item.LastActiveTime,
          IsActive: item.IsActive,
          EnableActivate: item.IsActive && item.acode === data.entities.acode,
          HashDcode: cryptoService.aesEncrypt(item.dcode)
        };
      });
      result.dcodes = data.entities.UsedDevice.map((i) => i.dcode);
      result.ExpiredDate = (result.UsingDeviceData.length > 0) ? expiredDateCalculatedByLicenseDetail(result) : null;
    }
    return result;
  }
  return void (0);
});


// Page - DeviceMgtList
export const getDeviceMgtListFilter = createSelector(getDeviceMgtListFilterState, (data) => {
  return data;
});
export const getDeviceMgtList =
  createSelector(getDeviceMgtListState, getRegionState, getDeviceMgtListFilterState, getDeviceInfo, getAccountInfo,
    (data, regionState, filter, deviceInfo, accountInfo) => {
    if (data.Loaded && !data.Loading) {
      const cryptoService = new CryptoService;
      const allDevices = Object.values(data.entities);
      const allRegions = Object.values(regionState.entities);
      const regions = allRegions.map(item => item);
      const regionObj: {} = Object.assign({}, ...regions.map(item => ({[item.Id]: item})));
      //
      // allDevices.forEach((i, index) => {
      //   if (regionObj.hasOwnProperty(i.RegionId)) {
      //     i.RegionName = regionObj[i.RegionId].RegionName;
      //   }
      // });
      // if (!!filter && filter.RegionIdOption !== -1) {
      //   allDevices = allDevices.filter(i => i.RegionId === filter.RegionIdOption);
      // }
      let result = allDevices.map((item) => {
        const regionId = (accountInfo.hasOwnProperty(item.acode)) ? accountInfo[item.acode].CompanyId : null;
        return {...item,
          RegionName: regionObj.hasOwnProperty(regionId) ? regionObj[regionId].RegionName : '',
          RegionId: regionId,
          LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
          Status: licenseMap.UsingStatus[item.UsingStatus],
          deviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
          deviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
          Account: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Account : '--',
          device_sn: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceSN : '--',
          // v1.8.5.2 調整PlanName
          // Level: planChargeInfo.hasOwnProperty(`level_${item.Level}`) ? planChargeInfo[`level_${item.Level}`].name : item.Level,
          HashInfoId: cryptoService.aesEncrypt(item.InfoId),
          HashDcode: cryptoService.aesEncrypt(item.dcode),
          HashDevice_sn: deviceInfo[item.dcode] !== undefined ?
          cryptoService.aesEncrypt(deviceInfo[item.dcode].DeviceSN) : cryptoService.aesEncrypt('--')
        };
      });
      if (!!filter && filter.RegionIdOption !== -1) {
        result = result.filter(i => i.RegionId === filter.RegionIdOption);
      }
      return result;
    }
  });


// Page - Account Device Details
export const getAccountDeviceDetails = (acode) =>
  createSelector(getDeviceSettingState, getDeviceInfo, getFirmWareInfoState, getLicenseMgtListState, getDeviceMonitoringState,
  (deviceSetting, deviceInfo, firmWareInfo, license, devices) => {
  const cryptoService = new CryptoService;
  const allDevice = Object.values(deviceSetting.entities);
    // allDevice = allDevice.filter(i => i.acode === Number(user.acode));
  // let firmWare: FirmWareInfo[] = [];
    if (firmWareInfo.Loaded && !firmWareInfo.Loading && license.Loaded && !license.Loading) {
      // firmWare = firmWareInfo.entities;
      const firmWare = Object.values(firmWareInfo.entities);
      const deviceArr = allDevice.map((item) => {
        // Only not offline device could be upgrade.
        const devicesMonitoring = Object.values(devices.entities);
        const device = devicesMonitoring.find(i => Number(i.dcode) === item.dcode);
        const status = device ? device.device_status : null;
        const isNotOffline = (Number.isInteger(status) && status < 3 ) ? true : false;
        // Is the firmware have a new version. Mini card(2) without card region, Wifi card(5) definitely with card region.
        let itemFirmWare = firmWare.filter(i => i.DeviceType === item.CardType && (!i.Model || i.Model === item.CardModel) && IsNewCardVersion(i.Version, item.CardFWVersion));
        if (item.CardType === 5) {
          if (item.CardRegionCode) {
            itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode);
          } else {
            itemFirmWare = itemFirmWare.filter(i => i.Model === item.CardModel);
          }
        }
        if (itemFirmWare.length === 0) {
          itemFirmWare = firmWare.filter(i => i.DeviceType === item.CardType && i.Version === item.CardFWVersion);
          if (item.CardType === 5) {
            if (item.CardModel !== undefined && item.CardModel !== "") {
              itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode && (!i.Model || i.Model === item.CardModel));
            } else {
              itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode);
            }
          }
        }
        let displaySourceTypeStr = '';
        if (DisplaySourceType[item.DisplaySourceType] !== undefined) {
          displaySourceTypeStr = DisplaySourceType[item.DisplaySourceType].SubType;
          if (deviceInfo.hasOwnProperty(item.dcode) && deviceInfo[item.dcode].DeviceOS !== undefined && deviceInfo[item.dcode].DeviceOS !== '') {
            displaySourceTypeStr = deviceInfo[item.dcode].DeviceOS.replace(/^\S+\s/, "");
          }
        }
        return {...item,
          LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
          Status: licenseMap.UsingStatus[item.UsingStatus],
          DeviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
          DeviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
          availableUpgrade:
          (item.CardType && isNotOffline && (itemFirmWare.length > 0 && itemFirmWare[0].Version !== item.CardFWVersion)) ? true : false,
          versionInfoId: (item.CardType && itemFirmWare.length > 0) ? itemFirmWare[0].Id : null,
          HashCardDcode: cryptoService.aesEncrypt(item.CardDcode),
          HashInfoId: cryptoService.aesEncrypt(item.InfoId),
          HashDcode: cryptoService.aesEncrypt(item.dcode),
          // just show card
          DisplayCardSn: (item.CardType === 2 || item.CardType === 4 || item.CardType === 5 || item.CardType === 6) ? true : false,
          // Only card & has a different version could be upgrade.
          DisplaySourceType: item.DisplaySourceType,
          DisplaySourceTypeStr: displaySourceTypeStr
        };
      });
      const licenseList = Object.values(license.entities);
      const licenseArr = licenseList.filter((item) => item.acode === acode && item.UsingStatus !== 3).map((i) => { // UsingStatus != Using
        return {
          InfoId: i.InfoId,
          LicenseNumber: i.LicenseNumber,
          PlanName: i.PlanName,
          LicenseTypeStr: licenseMap.LicenseType[i.LicenseType],
          Status: licenseMap.UsingStatus[i.UsingStatus],
          DeviceName: '--',
          DeviceModel: '--',
          availableUpgrade: false,
          versionInfoId: null,
          HashInfoId: cryptoService.aesEncrypt(i.InfoId),
          HashDcode: cryptoService.aesEncrypt(i.dcode)
        };
      });
      return [...deviceArr, ...licenseArr];
    }
    return [];
});
// User Plan Ids For Mgt  // TODO Plan User Account Detail
export const getPlanUserInfoIds = createSelector(getPlanUserInfoState, fromPlanUserInfo.selectIds);
// User Plan Infos For Mgt
export const getPlanUserInfos = createSelector(getPlanUserInfoState, fromPlanUserInfo.selectEntities, (data) => {
  return data;
});


// Page - DeviceSetting
export const getDeviceSettingList =
  createSelector(getDeviceSettingState, getFirmWareInfoState, getCurrentUser, getDevicesStatusState, getIsMsp, getMspMemberAuthorityState,
    (deviceSetting, firmWareInfo, user, devicesStatus, isMsp, auth) => {
      let allDevice = Object.values(deviceSetting.entities);
      if (!isMsp) {
        if (user.authority <= 0) {
          allDevice = allDevice.filter(i => i.acode === Number(user.acode));
        }
      }
      // let firmWare: FirmWareInfo[] = [];

      if (firmWareInfo.Loaded && !firmWareInfo.Loading && devicesStatus.isLoaded && !devicesStatus.isLoading) {
        // firmWare = firmWareInfo.entities;
        const firmWare = Object.values(firmWareInfo.entities);
        const cryptoService = new CryptoService;
        return allDevice.map((item) => {
          // Only not offline device could be upgrade.
          const device = devicesStatus.entities.DeviceList.find(i => Number(i.dcode) === item.dcode);
          const status = device ? device.device_status : null;
          const isNotOffline = (Number.isInteger(status) && status < 3 ) ? true : false;
          const mspAuth = (auth.entities && auth.entities.length > 0) ? auth.entities.find(a => a.RegionId === item.RegionId) : null;
          // Is the firmware have a new version. Mini card(2) without card region, Wifi card(5) definitely with card region.
          // 依照Model 辨別 FW Upgrade版本
          let itemFirmWare = firmWare.filter(i => i.DeviceType === item.CardType && (!i.Model || i.Model === item.CardModel) && IsNewCardVersion(i.Version, item.CardFWVersion));
          if (item.CardType === 5) {
            if (item.CardRegionCode) {
              itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode);
            } else {
              itemFirmWare = itemFirmWare.filter(i => i.Model === item.CardModel);
            }
          }
          if (itemFirmWare.length === 0) {
            itemFirmWare = firmWare.filter(i => i.DeviceType === item.CardType && i.Version === item.CardFWVersion);
            if (item.CardType === 5) {
              if (item.CardModel !== undefined && item.CardModel !== "") {
                itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode && (!i.Model || i.Model === item.CardModel));
              } else {
                itemFirmWare = itemFirmWare.filter(i => i.RegionCode === item.CardRegionCode);
              }
            }
          }
          return {...item,
            LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
            Status: licenseMap.UsingStatus[item.UsingStatus],
            DeviceName: item.DeviceName || '--',
            DeviceModel: item.Model || '--',
            availableUpgrade:
             (item.CardType && isNotOffline && (itemFirmWare.length > 0 && itemFirmWare[0].Version !== item.CardFWVersion)) ? true : false,
            versionInfoId: (item.CardType && itemFirmWare.length > 0) ? itemFirmWare[0].Id : null,
            // Only card & has a different version could be upgrade.
            releaseNote: (item.CardType && itemFirmWare.length > 0) ? itemFirmWare[0].ReleaseNote : null,
            NewCardVersion: (item.CardType && itemFirmWare.length > 0) ? itemFirmWare[0].Version : null,
            NetworkCardID: item.CardSn,
            HashInfoId: cryptoService.aesEncrypt(item.InfoId),
            HashDcode: cryptoService.aesEncrypt(item.dcode),
            HashCardDcode: cryptoService.aesEncrypt(item.CardDcode),
            editAuth: !isMsp || (mspAuth ? mspAuth.EditDevice === 1 : false),
            deleteAuth: !isMsp || (mspAuth ? mspAuth.DeleteDevice === 1 : false),
            device_subtype: DeviceSubType[item.DeviceSubType].displayName,
          };
        });
      }
      return [];
    });


// Page - License Detail (For Device Selection List)
export const getDetailSelectDeviceList = createSelector(getDeviceSettingState, getDeviceInfo, (deviceSetting, deviceInfo) => {
    const allDevice = Object.values(deviceSetting.entities);
      return allDevice.map((item) => {
        return {...item,
          LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
          Status: licenseMap.UsingStatus[item.UsingStatus],
          DeviceName: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].DeviceName : '--',
          DeviceModel: deviceInfo.hasOwnProperty(item.dcode) ? deviceInfo[item.dcode].Model : '--',
        };
      });
  });

// Page - Device License Detail
export const getDeviceLicenseDetails = createSelector(getDeviceLicenseDetailsState, getDeviceInfo, getPlanMgtState,
   (data, deviceInfo, planMgt) => {
  if (data.Loaded && !data.Loading && data.entities) {
    const cryptoService = new CryptoService;
    const deviceData = deviceInfo.hasOwnProperty(data.entities.dcode) ? deviceInfo[data.entities.dcode] : null;
    const result = {
      deviceName: (deviceData) ? deviceData.DeviceName : '--',
      account: (deviceData) ? deviceData.Account : '--',
      deviceModel: (deviceData) ? deviceData.Model : '--',
      SN: (deviceData) ? deviceData.DeviceSN : '--',
      usingLicenseData: [],
      usedLicenseData: [],
      acode: data.entities.acode,
      dcode: data.entities.dcode,
      isCard: false,
      isTrial: false
    };
    if (Array.isArray(data.entities.UsedLicense)) {
      result.usingLicenseData = [...data.entities.UsedLicense].sort((a, b) => b.LastActiveTime - a.LastActiveTime)
        .filter((i) => i.UsingStatus === 3).map((item) => {
        result.isCard = item.LicenseType === 2;
        result.isTrial = item.LicenseType === 3;
        return {
          InfoId: item.LicenseInfo,
          License: item.LicenseNumber,
          LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
          LicenseType: item.LicenseType,
          // v1.8.5.2 - License Mgt調整為LicenseType === Plan => planName, 其他 => level
          Level: (item.LicenseType === 4) ? item.PlanName : item.Level,
          Period: item.PeriodDay,
          OriginalPeriodDay: item.OriginalPeriodDay,
          LatestActivationDate: item.LastActiveTime,
          UsingStatus: licenseMap.UsingStatus[item.UsingStatus],
          RemainingDays: item.RemainDay,
          HashInfoId: cryptoService.aesEncrypt(item.LicenseInfo),
        };
      });
      result.usedLicenseData = [...data.entities.UsedLicense.filter((i) => i.UsingStatus !== 3 && i.LicenseType !== 2)]
        .sort((i, j) => {
          if (i.UsingStatus === 4 && j.UsingStatus === 4) {
            return i.LastActiveTime - j.LastActiveTime;
          } else if (i.UsingStatus === 4) {
            return -1;
          } else if (j.UsingStatus === 4) {
            return 1;
          } else {
            return i.UsingStatus - j.UsingStatus;
          }
        })
        .map((item) => {
          return {
            InfoId: item.LicenseInfo,
            License: item.LicenseNumber,
            LicenseTypeStr: licenseMap.LicenseType[item.LicenseType],
            LicenseType: item.LicenseType,
            // v1.8.5.2 - License Mgt調整為LicenseType === Plan => planName, 其他 => level
            Level: (item.LicenseType === 4) ? item.PlanName : item.Level,
            Period: item.PeriodDay,
            OriginalPeriodDay: item.OriginalPeriodDay,
            LatestActivationDate: item.LastActiveTime,
            UsingStatus: licenseMap.UsingStatus[item.UsingStatus],
            RemainingDays: item.RemainDay,
            EnableActivate: (item.UsingStatus === 2 || item.UsingStatus === 5) ? true : false,
            isFree: item.LicenseType === 3,
            HashInfoId: cryptoService.aesEncrypt(item.LicenseInfo),
          };
        });
    }
    return result;
  }
  return void (0);
});

// Page - Device Monitoring
// TODO 改為Entity進行優化
export const getDeviceMonitoring = createSelector(getDeviceMonitoringState, getEventsMapsState, getDeviceInfo,
  getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState, getBatteryReplacement, getRegions, getDeviceSettingState,
  (data, maps, deviceInfos, faultLevelMaps, faultCodeMaps, btyReplacement, regions, deviceSetting) => {
    const cryptoService = new CryptoService;
    const allDevice = Object.values(deviceSetting.entities);
    const allDeviceDic = [];
    if (allDevice !== null && allDevice !== undefined) {
      allDevice.map((i => {
        if (allDeviceDic[i.dcode] === undefined) {
          allDeviceDic[i.dcode] = i;
        }
      }));
    }
    return Object.values(data.entities).map((item) => {
      const event = (item.event) ?
        item.event.toString().split(',').map(eventCode => {
          return (maps.entities.hasOwnProperty(eventCode)) ? maps.entities[eventCode].desc : 'None.';
        }).join(' / ') : '';
      const deviceInfo = deviceInfos.hasOwnProperty(item.dcode) ? deviceInfos[item.dcode] : null;
      const regionItem = regions.find(r => r.Id == item.regionId);
      const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ?
         item.DeviceSubType !== 2 ? DeviceSubType[item.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
      const subtypeName = (typeof DeviceSubType !== 'undefined') ? DeviceSubType[item.DeviceSubType].name : '';
      return {...item,
        status: statusMapping[item.device_status].status,
        Account: (deviceInfo) ? deviceInfo.Account : '--',
        type: deviceType[item.device_type],
        name: (deviceInfo) ? deviceInfo.DeviceName : '--',
        model: (deviceInfo) ? deviceInfo.Model : '--',
        desc: (item.device_status === 0) ? statusMapping[item.device_status].desc.replace('{DeviceType}', new_desc_deviceType) : event,
        icon: statusMapping[item.device_status].icon,
        timeZone: item.timeZone,
        image: (deviceInfo) ? imageUrl + deviceInfo.Model : null,
        hardwarefault: hardwareFaultDetailLogic(item, faultLevelMaps, faultCodeMaps),
        btyReplacement: (btyReplacement && btyReplacement.hasOwnProperty(item.dcode)) ? btyReplacement[item.dcode] : null,
        time: (btyReplacement && btyReplacement.hasOwnProperty(item.dcode)) ? btyReplacement[item.dcode].BR_Rc_Date : null,
        BatHeaSta: batHeaMapping[0],
        // #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
        BHIStatus: (deviceInfo && !(deviceInfo.Model && hideBHIModelList.includes(deviceInfo.Model.toLocaleUpperCase()))) ?
        ((deviceInfo.BHI === -1 || deviceInfo.BHI === undefined || !deviceInfo.BHI_Enable) ? null :
          ((deviceInfo.BHI >= 70) ? batHeaMapping[0] :
            ((deviceInfo.BHI >= 50) ? batHeaMapping[1] :
              ((deviceInfo.BHI >= 35) ? batHeaMapping[2] :
                ((deviceInfo.BHI >= 25) ? batHeaMapping[3] :
                  ((deviceInfo.BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))))) : null,
        BHI: (deviceInfo && !(deviceInfo.Model && hideBHIModelList.includes(deviceInfo.Model.toLocaleUpperCase()))) ? deviceInfo.BHI : 0,
        // 2025-03-06 kyrie #1286 Gateway加的UPS除了Cyberpower以外的第三方廠牌不顯示BHI
        // 2025-02-17 kyrie #1203 Gateway加的3-PH UPS不顯示BHI
        // 2024-01-22 kyrie #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
        hideBHI: (deviceInfo && deviceInfo.Model && hideBHIModelList.includes(deviceInfo.Model.toLocaleUpperCase())) ||
                  ((item.SourceType !== undefined) && (item.DeviceSubType && DeviceSubType[item.DeviceSubType]) ?
                    !DeviceSubType[item.DeviceSubType].BHIdisplay : false) ||
                  ((item.SourceType !== undefined) && (subtypeName !== undefined) &&
                   (subtypeName === 'UPS' && item.SourceType === 1 && item.Brand !== 'CyberPower')),
        HashDevice_sn: cryptoService.aesEncrypt(item.device_sn),
        RegionName: regionItem !== null && regionItem !== undefined ? regionItem.RegionName : '',
        // just show card
        DisplayCardSn: allDeviceDic.length > 0 && allDeviceDic[item.dcode] && (allDeviceDic[item.dcode].CardType === 2 || allDeviceDic[item.dcode].CardType === 4 || allDeviceDic[item.dcode].CardType === 5 || allDeviceDic[item.dcode].CardType === 6) ? true : false,
        CardSn: allDeviceDic.length > 0 && allDeviceDic[item.dcode] && allDeviceDic[item.dcode].CardSn !== '' ? allDeviceDic[item.dcode].CardSn : '',
        device_subtype: DeviceSubType[item.DeviceSubType].displayName,
        DisplaySourceType: item.DisplaySourceType
      };
    });
});

// Page - Event Monitoring
export const getEventMonitoring = createSelector(getEventMonitoringState, getEventsMapsState, getDeviceInfo,
  getHardwareFaultLevelMapsState, getHardwareFaultCodeMapsState, getRegions,
  (events, maps, deviceInfos, errorLevelMaps, errorCodeMaps, regions) => {
    if (events.Loading && !events.Loaded) {
      return;
    }
    const cryptoService = new CryptoService;
    const data = events.entities.filter(i => Object.keys(i.event).length).map(item => {
      const deviceInfo = deviceInfos.hasOwnProperty(item.dcode) ? deviceInfos[item.dcode] : null;
      const levelMaps = errorLevelMaps.entities;
      const codeMaps = errorCodeMaps.entities;
      const regionItem = regions.find(r => r.Id == item.regionId);
      // const new_desc_deviceType = (typeof DeviceSubType !== 'undefined') ? item.DeviceSubType != 2 ? DeviceSubType[item.DeviceSubType].displayName : DeviceSubType[0].displayName : '';
        return item.event.map(i => {
        const time = new Date(Number(i.ts) * 1000);
        let event: any = {...i,
          sn: item.sn,
          timezoneLabel: (item.timeZone !== null) ?
            'UTC' + ((Number(item.timeZone) >= 0) ? '+' + item.timeZone : item.timeZone) + ':00' : '',
          timeZone: item.timeZone,
          gId: item.gId,
          dcode: item.dcode,
          name: (deviceInfo) ? deviceInfo.DeviceName : '--',
          type: (deviceInfo) ? deviceType[deviceInfo.DeviceType] : '--',
          time: time.toTimeString(),
          routeLink: '/monitoring/device/detail/' + cryptoService.aesEncrypt(item.sn),
          timestamp: i.ts,
          isHardwareFault: false,
          Account: (deviceInfo) ? deviceInfo.Account : '--',
          IsMsp: item.IsMsp,
          RegionId: regionItem !== null && regionItem !== undefined ? regionItem.Id : 0,
          Region: regionItem !== null && regionItem !== undefined ? regionItem.RegionName : '',
          DeviceSubType: DeviceSubType[item.DeviceSubType] !== undefined ? DeviceSubType[item.DeviceSubType].displayName : '',
          DisplaySourceType: item.DisplaySourceType
        };
        if (typeof i.IsHardwareOccur === 'undefined') { // Common Event.
          const eventMap = (maps.entities.hasOwnProperty(i.event_number)) ? maps.entities[i.event_number] : eventMapping[i.event_number];
          // 因1.8.0新增Inveter 故回傳的event number會mapping不到,造成整個errore故做undefine的判斷
          const status = statusMapping[eventMap.status] !== undefined ? statusMapping[eventMap.status].status : '';
          event = {...event,
            status: status,
            statusCode: eventMap.status,
            desc: eventMap.desc,
            icon: eventStatusMapping[status] !== undefined ? eventStatusMapping[status].icon : '',
          };
        } else if (typeof i.ErrorCode !== 'undefined' && typeof i.LevelCode !== 'undefined' && errorLevelMaps.Loaded && errorCodeMaps.Loaded) {
          // Hardware fault occur
          if (!i.IsHardwareOccur) { // Restore hardware fault
            event = {...event,
              status: statusMapping[0].status,
              statusCode: 0,
              icon: eventStatusMapping['normal'].icon,
              desc: 'Restore：' + oldErrorCodeDesc(i, codeMaps) + (codeMaps.hasOwnProperty(i.ErrorCode) ?
              codeMaps[i.ErrorCode].Description : ''),
            };
          } else { // Hardware fault occur
            event = {...event,
              status: 'Hardware Fault',
              desc: oldErrorCodeDesc(i, codeMaps) + (codeMaps.hasOwnProperty(i.ErrorCode) ? codeMaps[i.ErrorCode].Description : ''),
              faultLevelColor: levelMaps.hasOwnProperty(i.LevelCode) ? levelMaps[i.LevelCode].ColorCode : '',
              statusCode: 4,
              isHardwareFault: true
            };
          }
        }
        return event;
      }).filter(i => !!i);
    });
    const result = [].concat(...data);
    return [...result].sort((a: any, b: any) => {
      return b.timestamp - a.timestamp;
    });
});

// Page - Device Monitoring Event
export const getEventMonitoringData = createSelector(getEventMonitoring, getEventMonitoringFilterState, getIsMsp, (data, filters, isMsp) => {
  if (data !== undefined) {
    if (isMsp) {
      return [...data].sort((a: any, b: any) => {
        return b.timestamp - a.timestamp;
      });
    } else {
      return [...data.filter(i => i.statusCode === filters.device_status)].sort((a: any, b: any) => {
        return b.timestamp - a.timestamp;
      });
    }
  }
});

// Page - Device Monitoring Event For Pro Overview
export const getProEventMonitoringData = createSelector(getEventMonitoring, getEventMonitoringFilterState, (data, filters) => {
  if (data !== undefined) {
    if (filters.device_status == null) {
      return [...data.filter(i => i.statusCode === 1 || i.statusCode === 2)].sort((a: any, b: any) => {
        return b.timestamp - a.timestamp;
      });
    } else {
      return [...data.filter(i => i.statusCode === filters.device_status)].sort((a: any, b: any) => {
        return b.timestamp - a.timestamp;
      });
    }
  }
});

// Page - Device Detail Monitoring
export const getSingleDeviceMonitoringStatuses = (sn) => createSelector(getDeviceMonitoring, (statuses) => {
  const result = statuses.find(item => item.device_sn.toLowerCase() === sn.toLowerCase());
  if (result) {
    return result;
  } else {
    return null;
  }
});

// Page - Global Map Array
export const getWorldMap = createSelector(getWorldMapState, (data) => {
  if (data.Loaded && !data.Loading) {
    return Object.values(data.entities);
  }
});
export const getWorldMapEntity = createSelector(getWorldMapState, (data) => {
  const result = {
    0: {}, // devices
    1: {}, // groups
    2: {}  // floor map
  };
  if (data.Loaded && !data.Loading) {
    for (const [key, value] of Object.entries(data.entities)) {
      if (value.Type === 0) {
        result['0'][value.OwnerId] = value;
      } else if (value.Type === 1) {
        result['1'][value.OwnerId] = value;
      } else if (value.Type === 2) {
        result['2'][value.OwnerId] = value;
      }
    }
  }
  return result;
});

// Page - Plan Mgt
export const getPlanMgtInfo = createSelector(getPlanMgtState, (data) => {
  // 創建新對象副本以避免修改只讀的 store 數據 (NgRx 9 immutability)
  const sortedEntities = [...data.entities].sort(function (a: any, b: any) { return a.Sort - b.Sort; });
  return { ...data, entities: sortedEntities };
});
export const getPlanMgtUpdateInfo = createSelector(getPlanMgtState, getAccountInfo, (data, accountInfo) => {
  if (data.Loaded && !data.Loading && data.entities.length > 0) {
    const item = data.entities[0];
    if (accountInfo.hasOwnProperty(item.UpdateId)) {
      return accountInfo[item.UpdateId];
    }
  }
});

// Page - Plan Setting
export const getPlanSetting = createSelector(getPlanSettingState, (data) => {
  return data;
});
// Page - Plan Account Info
export const getPlanAccountInfo = createSelector(getPlanSettingState, (data) => {
  const result = {
    Grade: 0,
    PlanName: ''
  };
  if (!data.Loading && data.Loaded) {
    const usingPlan = Object.values(data.entities).find((i) => i.Status === 1);  // filter out using one.
    if (usingPlan) {
      result.Grade = usingPlan.Grade;
      result.PlanName = usingPlan.PlanName;
    }
    return result;
  }
});


// Page - Plan Key Mgt
export const getPlanKeyMgt = createSelector(getPlanListState, getAccountInfo, (data, accountInfo) => {
  const result = {
    entities: [] as PlanList[],
    Loaded: data.Loaded,
    Loading: data.Loading
  };
  if (data.Loaded && !data.Loading) {
    result.entities = Object.values(data.entities).filter((i) => i.Type === 1).map((item) => {
      let mainRecipient = '';
      if (item.EmailInfo) { // get the first main recipient.
        const emailInfo = item.EmailInfo.find(i => i.ReceiverType === 0);
        mainRecipient = emailInfo.Receiver;
      }
      return {
        ...item,
        Account: accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].Account : null,
        CreateBy: accountInfo.hasOwnProperty(item.CreateId) ? accountInfo[item.CreateId].Account : null,
        Period: item.Period,
        IsFree: item.IsFree,
        mainRecipient: mainRecipient,
        ActivatedTime: (item.ActivatedTime) ? item.ActivatedTime : null
      };
    });
  }
  return result;
});

// Page - Plan List
export const getPlanList = createSelector(getPlanListState, getPlanListFilterState, getAccountInfo, (data, filter, accountInfo) => {
  const result = {
    entities: [] as PlanList[],
    Loaded: data.Loaded,
    Loading: data.Loading
  };
  if (data.Loaded && !data.Loading) {
    result.entities = Object.values(data.entities);
    if (filter.statusOptions > -1) {
      result.entities = result.entities.filter((i) => i.Status === filter.statusOptions);
    }
    if (filter.platformOptions > -1) {
      if (filter.platformOptions === 2) {
        result.entities = result.entities.filter((i) => i.Type === 1); // Plan Key
      } else {
        result.entities = result.entities.filter((i) => i.Platform === filter.platformOptions);
      }
    }
    result.entities = result.entities.map((item) => {
      return {
        ...item,
        platformStr: (item.Type === 0) ? platformTypeMap[item.Platform] : platformTypeMap[2],
        StatusStr: planStatusMap[item.Status],
        Account: accountInfo.hasOwnProperty(item.acode) ? accountInfo[item.acode].Account : null
      };
    });
  }
  return result;
});

export const getNotificationList = createSelector(getNotificationState, getDevicesInfoState, (data, deviceInfos) => {
  const result = {
    entities: [],
    Loaded: data.Loaded,
    Loading: data.Loading,
    isConfirm: false
  };
  result.isConfirm = data.isConfirm;
  if (data.Loaded && !data.Loading) {
    for (const [key, value] of Object.entries(data.entities)) {
      const MsgType = NotificationMsgType[value.type];
      if (MsgType) {

        const contentParam = value.content.split(',');
        const dcode = (value.type === 1 || value.type === 2 || value.type === 3 || value.type === 5) ? contentParam[0] : '';
        const expiredDay = (value.type === 3 || value.type === 4) ? contentParam[1] : '';
        const level = (value.type === 4) ? contentParam[0] : '';
        const deviceInfo = deviceInfos.entities.find(s => s.Id === parseInt(dcode, 10));
        const BHI = (value.type === 2 ||
          !(deviceInfo && deviceInfo.Model && hideBHIModelList.includes(deviceInfo.Model.toLocaleUpperCase()))) ?
          parseInt(contentParam[1], 10) : -1;
        const BHIStatus = (BHI === -1 || BHI === undefined) ? null :
          ((BHI >= 70) ? batHeaMapping[0] :
            ((BHI >= 50) ? batHeaMapping[1] :
              ((BHI >= 35) ? batHeaMapping[2] :
                ((BHI >= 25) ? batHeaMapping[3] :
                  ((BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5])))));
        const discoveryJobName = (value.type === 6 || value.type === 7) ? contentParam[0] : '';
        const gatewayName = (value.type === 8 || value.type === 9) ? contentParam[0] : '';
        const cryptoService = new CryptoService;
        const newItem = {
          ...value,
          title: MsgType ? MsgType.title : '',
          description: MsgType ? MsgType.description : '',
          routeLink: MsgType ? MsgType.routeLink.replace('{deviceName}', (deviceInfo ? deviceInfo.DeviceSN : '')) : '',
          deviceName: deviceInfo ? deviceInfo.DeviceName : '',
          BHI: BHI,
          BHIStatus: ((deviceInfo && deviceInfo.Model && hideBHIModelList.includes(deviceInfo.Model.toLocaleUpperCase())) ||
            BHI === -1 || BHI === undefined) ? null : ((BHI >= 70) ? batHeaMapping[0] :
              ((BHI >= 50) ? batHeaMapping[1] :
                ((BHI >= 35) ? batHeaMapping[2] :
                  ((BHI >= 25) ? batHeaMapping[3] :
                    ((BHI >= 13) ? batHeaMapping[4] : batHeaMapping[5]))))),
          level: level,
          expiredDay: expiredDay,
          icon: MsgType ? MsgType.icon : '',
          discoveryJobName: discoveryJobName,
          tab: cryptoService.aesEncrypt(discoveryJobName !== '' ? 1 : 0),
          gatewayName: gatewayName,
        };
        result.entities.push(newItem);
      }
    }
  }
  return result;
});

export const GetFirmWareInfo = createSelector(getFirmWareInfoState, getAccountbyFilter, (data, accountInfo) => {
  let FWType;
  const firmwareInfo = Object.values(data.entities).map((item) => {
    FWType = item.FWType;
    const account = accountInfo.entities.find(a => a.Acode === item.UpdateId);
    return {...item,
      Account: account ? account.Account : '--',
      latest: false
    };
  });

  const firmwareListGroup = firmwareInfo.filter(s => s.IsRelease).reduce((r, a) => {
    r[a.DeviceType.toString() + (a.RegionCode ? a.RegionCode.toString() : '')] =
     [...r[a.DeviceType.toString() + (a.RegionCode ? a.RegionCode.toString() : '')] || [], a];
    return r;
  }, {});
  (FWType === FirmwareType.RMC) ?
  deviceTypeCodeRMC.forEach(element => {
    if (firmwareListGroup.hasOwnProperty(element.DeviceType.toString())) {
      const groupKey = element.DeviceType.toString();
      const firmwareGroup = [...firmwareListGroup[groupKey]]
      .sort((a, b) => {
        const aVersionArr = a.Version.split('.');
        const bVersionArr = b.Version.split('.');
        if (parseInt(aVersionArr[0], 10) < parseInt(bVersionArr[0], 10)) { return 1; } else
        if (parseInt(aVersionArr[0], 10) > parseInt(bVersionArr[0], 10)) { return -1; } else {
          if (parseInt(aVersionArr[1], 10) < parseInt(bVersionArr[1], 10)) { return 1; } else
          if (parseInt(aVersionArr[1], 10) > parseInt(bVersionArr[1], 10)) { return -1; } else {
            if (parseInt(aVersionArr[2], 10) < parseInt(bVersionArr[2], 10)) { return 1; } else
            if (parseInt(aVersionArr[2], 10) > parseInt(bVersionArr[2], 10)) {return -1; } else { return 0; }
          }
        }
      });
      const latestItem = { ...firmwareGroup[0], latest: true };
      firmwareGroup[0] = latestItem;
      firmwareListGroup[groupKey] = firmwareGroup;
      const replaceIdx = firmwareInfo.findIndex(i => i.Id === latestItem.Id);
      if (replaceIdx >= 0) {
        firmwareInfo[replaceIdx] = latestItem;
      }
    }
  }) :
  deviceTypeCode.forEach(element => {
    if (firmwareListGroup.hasOwnProperty(element.DeviceType.toString() + (element.regionId ? element.regionId.toString() : ''))) {
      const groupKey = element.DeviceType.toString() + (element.regionId ? element.regionId.toString() : '');
      const firmwareGroup = [...firmwareListGroup[groupKey]]
      .sort((a, b) => {
        const aVersionArr = a.Version.split('.');
        const bVersionArr = b.Version.split('.');
        if (parseInt(aVersionArr[0], 10) < parseInt(bVersionArr[0], 10)) { return 1; } else
        if (parseInt(aVersionArr[0], 10) > parseInt(bVersionArr[0], 10)) { return -1; } else {
          if (parseInt(aVersionArr[1], 10) < parseInt(bVersionArr[1], 10)) { return 1; } else
          if (parseInt(aVersionArr[1], 10) > parseInt(bVersionArr[1], 10)) { return -1; } else {
            if (parseInt(aVersionArr[2], 10) < parseInt(bVersionArr[2], 10)) { return 1; } else
            if (parseInt(aVersionArr[2], 10) > parseInt(bVersionArr[2], 10)) {return -1; } else { return 0; }
          }
        }
      });
      const latestItem = { ...firmwareGroup[0], latest: true };
      firmwareGroup[0] = latestItem;
      firmwareListGroup[groupKey] = firmwareGroup;
      const replaceIdx = firmwareInfo.findIndex(i => i.Id === latestItem.Id);
      if (replaceIdx >= 0) {
        firmwareInfo[replaceIdx] = latestItem;
      }
    }
  });
  const result = firmwareInfo.map(item => {
    const DeviceType = (item.FWType === FirmwareType.RMC) ?
      deviceTypeCodeRMC.find(i => i.DeviceType === item.DeviceType) :
      deviceTypeCode.find(i =>
        i.DeviceType === item.DeviceType &&
        (!item.RegionCode || i.regionId === item.RegionCode) &&
        (!item.Model || i.label.toLowerCase().includes(item.Model.toLowerCase()))
      );
    let canRelease = false;
    if (!item.IsRelease) {
      const currentRelease =
      firmwareInfo.find(i => i.latest && i.DeviceType === item.DeviceType && (!item.RegionCode && i.RegionCode === item.RegionCode) && (!item.Model || i.Model === item.Model));
      const currentReleaseVersionArr = (currentRelease) ? currentRelease.Version.split('.') : [];
      const versionArr = item.Version.split('.');
      if (currentRelease) {
        if ((parseInt(versionArr[0], 10) >= parseInt(currentReleaseVersionArr[0], 10))) {
          if ((parseInt(versionArr[0], 10) > parseInt(currentReleaseVersionArr[0], 10))) { canRelease = true;
          } else {
            if ((parseInt(versionArr[1], 10) >= parseInt(currentReleaseVersionArr[1], 10))) {
              if ((parseInt(versionArr[1], 10) > parseInt(currentReleaseVersionArr[1], 10))) { canRelease = true;
              } else {
                if ((parseInt(versionArr[2], 10) > parseInt(currentReleaseVersionArr[2], 10))) { canRelease = true; }
              }
            }
          }
        }
      } else { canRelease = true; }
    }
    const updateTimeDate = new Date(item.UpdateTime);
    const timestamp = updateTimeDate.getTime();
    return {...item,
      type: (DeviceType) ? DeviceType.value : -1,
      typeName: (DeviceType) ? DeviceType.label : '--',
      canRelease: canRelease,
      timestamp: timestamp
    };
  });
  return [...result].sort(function (a: any, b: any) {
    return new Date(b.UpdateTime).getTime() - new Date(a.UpdateTime).getTime();
    // return parseInt(b.Version.replace(/\./g,''),10) - parseInt(a.Version.replace(/\./g,''),10);
  });
});

export const getFirmWareMgtLog =
  createSelector(getFirmWareLogState, getFirmWareInfoState, getAccountbyFilter, (data, firmwareInfo, accountInfo) => {
  const result = Object.values(data.entities);
  const mapped = [...result].sort(function (a: any, b: any) {
    return b.UpdateTime - a.UpdateTime;
    }).map((item) => {
    const info = firmwareInfo.entities.hasOwnProperty(item.FirmwareInfoId) ? firmwareInfo.entities[item.FirmwareInfoId] : null;
    const updateTimeDate = new Date(item.UpdateTime);
    const timestamp = updateTimeDate.getTime();
    const account = accountInfo.entities.find(a => a.Acode === item.UpdateId);
    return {...item,
      Account: account ? account.Account : '--',
      DeviceType: (info) ? info.DeviceType : 0,
      Version: (info) ? info.Version : '--',
      timestamp: timestamp,
      Model: (info) ? info.Model : undefined,
    };
  });
  return [...mapped].sort(function (a: any, b: any) {
    return new Date(b.UpdateTime).getTime() - new Date(a.UpdateTime).getTime();
  });
});

export const GetAzureBlobStoragesSASToken = createSelector(getAzureBlobStorageSASTokenState, (data) => {
  return data;
});

export const GetAzureBlobStoragesDownload = createSelector(getAzureBlobStoragesDownloadState, (data) => {
  return data;
});

export const GetLicenseSw = createSelector(getLicenseSwState, getAccountInfo, (data, accountInfo) => {
  const result = {
    entities: [] as LicenseSw[],
    Loaded: data.Loaded,
    Loading: data.Loading
  };
  if (data.Loaded && !data.Loading) {
    result.entities = [...Object.values(data.entities).filter(i => i.ActivateType === byKeyStr).map((item) => {
      const mainRecipient = (item.EmailInfo) ? item.EmailInfo.find(i => i.ReceiverType === 0) : null;
      return {
        ...item,
        CreateBy: accountInfo.hasOwnProperty(item.CreateId) ? accountInfo[item.CreateId].Account : null,
        Recipient: (mainRecipient) ? mainRecipient.Receiver : ''
      };
    })].sort(function (a: any, b: any) {
      return new Date(b.CreateTime).getTime() - new Date(a.CreateTime).getTime();
    });
  }
  return result;
});

export const GetLicenseSwType = createSelector(getLicenseSwTypeState, (data) => {
  return data;
});

export const GetDeviceShareToOtherList =
  createSelector(getDevicesInfoState, getDeviceSharingState, getCurrentUser, getDevicesStatusState, getIsMsp, getMspMemberAuthorityState,
     (device, shareInfo, user, statusList, isMsp, auth) => {
  if (device.isLoaded && !device.isLoading && device.entities != null) {
    let deviceList = Object.values(device.entities);
    if (isMsp) {
      const allAuthList = auth.entities;
      if (allAuthList && allAuthList.length > 0) {
        const authList = [];
        allAuthList.map(item => { if (item.ViewDevice === 1) { authList.push(item.RegionId); } });
        deviceList = deviceList.filter(i => authList && authList.includes(i.RegionId));
      }
    }
    const result = deviceList.filter(item => !item.is_shared).map(item => {
      const sharedevice = (statusList.entities.ShareDeviceList.length > 0) ?
       statusList.entities.ShareDeviceList.find(s => s.dcode == item.Id) : undefined;
      const sharegroupdevice = (statusList.entities.ShareGroupDeviceList.length > 0) ?
       statusList.entities.ShareGroupDeviceList.find(s => s.dcode == item.Id) : undefined;
      if (sharedevice === undefined && sharegroupdevice === undefined) { // 判斷device 不是 shareDevice 也不是shareGroupDevice
        const status = (statusList.entities.DeviceList.length > 0) ? statusList.entities.DeviceList.find(s => s.dcode == item.Id) : null;
        const shareDetailList = shareInfo.entities.filter(info =>  info.dcode === item.Id).map(info => {
          return {
            Id: info.Id,
            owner_acode: info.acode,
            shared_acode: info.shared_acode,
            SharedFirstName: info.SharedFirstName,
            SharedLastName: info.SharedLastName,
            status: info.status,
            statusType: shareDeviceStatusType[info.status],
            SharedAccount: info.SharedAccount
          } as ObjectSharing;
        });
        // 同email僅顯示最新資料
        const shareDetailListGroupBySharedAcode: ObjectSharing[] = [];
        shareDetailList.forEach(Item => {
          const shareDetail = (shareDetailListGroupBySharedAcode.length > 0) ?
           shareDetailListGroupBySharedAcode.find(d => d.shared_acode === Item.shared_acode) : null;
          if (shareDetail) {
            if (Item.Id > shareDetail.Id) {
              const detailbyAcodeIndex = shareDetailListGroupBySharedAcode.findIndex(d => d.shared_acode === Item.shared_acode);
              shareDetailListGroupBySharedAcode[detailbyAcodeIndex] = Item;
            }
          } else {
            shareDetailListGroupBySharedAcode.push(Item);
          }
        });
        return{
          ObjectId: item.Id,
          ObjectName: item.DeviceName,
          type: 'device',
          ObjectShareList: [...shareDetailListGroupBySharedAcode].sort(function (a: any, b: any) { return a.status - b.status; }),
          Level: status ? status.level : 0,
          isExpired: status ? status.isExpired : true,
          planActivate: status ? status.plan_activate : false,
          mspPlanActivate: status ? status.msp_plan_activate : false,
          image: (item.Model) ? imageUrl + item.Model : null,
          regionId: (status && status.RegionId !== undefined) ? status.RegionId : 0
        } as ObjectShareToOther;
      }
    }).filter(item => item);
    return result;
  }
  return [] as ObjectShareToOther[];
});

export const GetDeviceShareFromOtherList =
  createSelector(getDeviceSharingState, getCurrentUser, getDevicesInfoState, (shareInfo, user, deviceInfos) => {
  if (shareInfo.Loaded && !shareInfo.Loading && shareInfo.entities != null) {
    const result = shareInfo.entities.filter(info => info.shared_acode === user.acode && info.status !== shareDeviceStatus['Rejected'])
                                     .map(info => {

      const deviceInfo = deviceInfos.entities.find(s => s.Id === info.dcode);
      return {
        Id: info.Id,
        owner_acode: info.acode,
        FirstName: info.FirstName,
        LastName: info.LastName,
        DeviceName: deviceInfo ? deviceInfo.DeviceName : '',
        status: info.status,
        statusType: shareDeviceStatusType[info.status],
        type: 'device'
      } as ObjectSharing;
    });
    return result;
  }
  return [] as ObjectSharing[];
});

export const GetGroupShareToOtherList =
  createSelector(getGroupState, getGroupSharingState, getCurrentUser, getIsMsp, getMspMemberAuthorityState,
     (group, shareInfo, user, isMsp, auth) => {

  if (group.Loaded && !group.Loading && group.entities != null) {
    let groupList = Object.values(group.entities);
    if (isMsp) {
      const allAuthList = auth.entities;
      if (allAuthList && allAuthList.length > 0) {
        const authList = [];
        allAuthList.map(item => { if (item.ViewDevice === 1) { authList.push(item.RegionId); } });
        groupList = groupList.filter(i => authList && authList.includes(i.RegionId));
      }
    }
    const result = groupList.filter(item => !item.is_shared).map(item => {
      const shareDetailList = shareInfo.entities.filter(info =>  info.GroupId === item.Id).map(info => {
        return {
          Id: info.Id,
          owner_acode: info.acode,
          shared_acode: info.shared_acode,
          SharedFirstName: info.SharedFirstName,
          SharedLastName: info.SharedLastName,
          status: info.status,
          statusType: shareDeviceStatusType[info.status],
          SharedAccount: info.SharedAccount
        } as ObjectSharing;
      });
      // 同email僅顯示最新資料
      const shareDetailListGroupBySharedAcode: ObjectSharing[] = [];
      shareDetailList.forEach(Item => {
        const shareDetail = (shareDetailListGroupBySharedAcode.length > 0) ?
         shareDetailListGroupBySharedAcode.find(d => d.shared_acode === Item.shared_acode) : null;
        if (shareDetail) {
          if (Item.Id > shareDetail.Id) {
            const detailbyAcodeIndex = shareDetailListGroupBySharedAcode.findIndex(d => d.shared_acode === Item.shared_acode);
            shareDetailListGroupBySharedAcode[detailbyAcodeIndex] = Item;
          }
        } else {
          shareDetailListGroupBySharedAcode.push(Item);
        }
      });
      return{
        ObjectId: item.Id,
        ObjectName: item.gName,
        type: 'group',
        ObjectShareList: [...shareDetailListGroupBySharedAcode].sort(function (a: any, b: any) { return a.status - b.status; }),
        regionId: item.RegionId ? item.RegionId : null
        // image: (item.Model) ? imageUrl + item.Model : null
      } as ObjectShareToOther;
    });
    return result;
  }
  return [] as ObjectShareToOther[];
});

export const GetGroupShareFromOtherList =
  createSelector(getGroupSharingState, getCurrentUser, (shareInfo, user) => {
  if (shareInfo.Loaded && !shareInfo.Loading && shareInfo.entities != null) {
    const result = shareInfo.entities.filter(info => info.shared_acode === user.acode && info.status !== shareDeviceStatus['Rejected'])
                                     .map(info => {

      return {
        Id: info.Id,
        owner_acode: info.acode,
        FirstName: info.FirstName,
        LastName: info.LastName,
        GroupName: info.GroupName,
        status: info.status,
        statusType: shareDeviceStatusType[info.status],
        type: 'group'
      } as ObjectSharing;
    });
    return result;
  }
  return [] as ObjectSharing[];
});

export const GetObjectShareToOtherList =
  createSelector(GetDeviceShareToOtherList, GetGroupShareToOtherList, (device_shareInfo, group_shareInfo) => {
  const result: ObjectShareToOther[] = [];
  group_shareInfo.forEach(Item => {
    result.push(Item);
  });
  device_shareInfo.forEach(Item => {
    result.push(Item);
  });
  return result;
});

export const GetObjectShareFromOtherList =
  createSelector(GetDeviceShareFromOtherList, GetGroupShareFromOtherList, (device_shareInfo, group_shareInfo) => {
  const result: ObjectSharing[] = [];
  group_shareInfo.forEach(Item => {
    result.push(Item);
  });
  device_shareInfo.forEach(Item => {
    result.push(Item);
  });
  return result;
});

// Device-Reset
export const getDeviceReset = createSelector(
  getAccountState,
  getDeviceResetLogState,
  (accounts, data ) => {
    if (
      data.Loaded &&
      !data.Loading &&
      data.entities != null &&
      accounts.Loaded &&
      !accounts.Loading &&
      accounts.entities != null
    ) {
      // 判斷account是否為all
      const accountobj = Object.values(accounts.entities) ;
      if (accountobj.length > 1 ) {
        const result = [];
        [...data.entities.body].sort(function (a: any, b: any) {
          return b.Createtime - a.Createtime;
        }).forEach(d => {
          if (DeviceResetOptionType.find(f => f.value === d.Type)) {
            return result.push({
              sn: d.SN,
              type: DeviceResetOptionType.find(f => f.value === d.Type).label,
              resetdate: moment(Number(d.Createtime) * 1000).format('YYYY/MM/DD'),
              // AccountName
              resetby:
                accounts.entities[d.CreateId] !== undefined
                  ? accounts.entities[d.CreateId].Account
                  : '',
              note: d.ResetNote !== undefined ? d.ResetNote : ''
            });
          }
        });
        return result;
      }
    }
  }
);

export const GetPricelist = createSelector(getPriceState, (pricelist ) => {
  if (pricelist.Loaded && !pricelist.Loading) {
    return pricelist.entities;
  }
});

// GateWay
export const ReadGateWayList = createSelector(getGateWayListState, (data ) => {
  return data;
});

export const ReadGateWayDeviceList = createSelector(getGateWayDeviceListState, (data ) => {
  return data;
});

export const ReadGateWayAddToCloud = createSelector(getGateWayAddToCloudState, (data ) => {
  return data;
});

export const ReadMgtMibTrapList = createSelector(getGateWayMgtMibTrapListState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadMgtMibDetail = createSelector(getGateWayMgtMibDetailState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadMibTrapList = createSelector(getGateWayMibTrapListState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadMibDetail = createSelector(getGateWayMibDetailState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadMgtAttribute = createSelector(getGateWayMgtAttributeState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadMgtTrapDetail = createSelector(getGateWayMgtTrapDetailState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadTrapDetail = createSelector(getGateWayTrapDetailState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadProfileList = createSelector(getGateWayProfileListState, (data ) => {
  return data;
});

export const ReadProfileInfo = createSelector(getGateWayProfileInfoState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadDiscoveryInfoList = createSelector(getGateWayDiscoveryInfoListState, (data ) => {
  return data;
});

export const ReadDiscoveryInfo = createSelector(getGateWayDiscoveryInfoState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const getExecuteDiscoveryList = createSelector(getGateWayExecuteDiscoveryListState, (data ) => {
  if (data !== undefined && data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadDiscoveryResultList = createSelector(getGateWayDiscoveryResultListState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadDiscoveryResultForOneTimeReducer = createSelector(getGateWayDiscoveryExecutingResultForOneTimeState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ExecuteDiscovery = createSelector(getGateWayExecuteDiscoveryState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadCategoryList = createSelector(getGateWayCategoryListState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const ReadSoftwareVersionData = createSelector(getSoftwareVersionState, (data ) => {
  if (data.Loaded && !data.Loading) {
    return data.entities;
  }
});

export const GetSmartPowerReportList = createSelector(getSmartPowerReportListState, (data) => {
  
  if (data !== undefined && data.isLoaded && !data.isLoading) {
    return data.entities;
  }
});

export const GetSmartPowerReport = createSelector(getSmartPowerReportState, (data) => {
  
  if (data !== undefined && data.isLoaded && !data.isLoading) {
    return data.entities;
  }
});

export const GetSmartPowerReportData = createSelector(getSmartPowerReportDataState, (data) => {
  
  if (data !== undefined) {
    return data;
  }
});

export const GetMailModule = createSelector(getMailModuleState, (data) => {
  
  if (data !== undefined && data.isLoaded && !data.isLoading) {
    return data.entities;
  }
});


export const GetMailGroup = createSelector(getMailGroupState, (data) => {
  if (data !== undefined && data.isLoaded && !data.isLoading) {
    return data.entities;
  }
});

export const GetUserActivityReportData = createSelector(getUserActivityLogState, getAppDownloadState, GetPricelist, getPlanMgtState, 
  (logs, appdownload, pricelist, planmgtlist) => {
  const result = {
    deviceAnalysisData: [],
    monthlyIncreaseDevicesData: [],
    monthlyAPICallsData: [],
    monthlyAppDownloadData: [],
    monthlyPurchaseOrderData: [],
    monthlyOrderAmountData: [],
    monthlyOrdersOfLevelData: [],
    monthlyOrderAmountWihtYearsData: [],
    monthlyRevenueGrossProfitData: [],
    monthlyDeferredGrossProfitData: [],
    monthlyPurchaseAnalysisData: [],
    monthlyPurchaseOrderProData: [],
    ppcProUsageManagementData: [],
    monthlySubDevicesData: [],
    monthlySubAccountsData: [],
    startYear: 0,
    startMonth: 0,
    endYear: 0,
    endMonth: 0,
    alertSettings_cols: [],
    total_cols: [],
    gross_Profit_total_cols: [],
    DeviceAnalysisChart: {labels: [], datasets: []},
    DeviceChart: {labels: [], datasets: []},
    APIChart: {labels: [], datasets: []},
    AppDownloadChart: {labels: [], datasets: []},
    OrderChart: {labels: [], datasets: []},
    AmountChart: {labels: [], datasets: []},
    MonthlyOrdersAndAmountWithYearChart: {labels: [], datasets: []},
    monthlyRevenueGrossProfitChart: {labels: [], datasets: []},
    monthlyDeferredGrossProfitChart: {labels: [], datasets: []},
    monthlyPurchaseAnalysisDataChart: {labels: [], datasets: []},
    ppcProUsageManagementDataChart: {labels: [], datasets: []},
    DeviceTotal: 0,
    AppDownloadTotal: 0,
    OrderTotal: 0,
    AmountTotal: 0,
    TotalDiscount: 0,
    TotalPPCPro: 0,
    appDownloadData: [],
    reportDiscountData: [],
    AccumulatedDevices: 0,
    AccumulatedAppDownload: 0,
    AccumulatedOrder: 0,
    AccumulatedAmount: 0,
    is_AllTime: null,
  };

  if (appdownload.Loaded && !appdownload.Loading && appdownload.entities != null) {
    result.startYear = parseInt(appdownload.entities.start_date.split('/')[0], 10);
    result.startMonth = parseInt(appdownload.entities.start_date.split('/')[1], 10);
    result.endYear = parseInt(appdownload.entities.end_date.split('/')[0], 10);
    result.endMonth = parseInt(appdownload.entities.end_date.split('/')[1], 10);

    result.total_cols = [];
    for (let year = result.startYear; year <= result.endYear; year++) {
      const startMonth = (year === result.startYear) ? result.startMonth : 1;
      const endMonth = (year === result.endYear) ? result.endMonth : 12;
      for (let month = startMonth; month <= endMonth; month++) {
        const premonth = (month > 1) ? (month - 1) : 12;
        const preyear = (premonth === 12) ? (year - 1) : year;
        const cols = {
          field: (year + '/' + month),
          header: monthMap[month],
          width: '50',
          class: 'col-nowrap',
          disabled: false,
          month: month,
          year: year,
          premonth: premonth,
          preyear: preyear};
        result.total_cols.push(cols);
      }
    }
    // Edit appDownloadData
    let editiOSData = {type: reportDataField.iOS}, editAndroidData = {type: reportDataField.Android};

    const iOS = (appdownload.entities.AppDownloadNode.length > 0) ? appdownload.entities.AppDownloadNode
    .filter(item => item.Type === appDownloadType['iOS']) : [];
    const Android = (appdownload.entities.AppDownloadNode.length > 0) ? appdownload.entities.AppDownloadNode
    .filter(item => item.Type === appDownloadType['Android']) : [];
    const AccumulateiOS = iOS.reduce((init, currentValue) => {
      return init + currentValue.Value;
    }, 0);
    const AccumulateAndroid = (Android.length > 0) ? Android.reduce((init, currentValue) => {
      return init + currentValue.Value;
    }, 0) : 0;
    result.AccumulatedAppDownload += AccumulateiOS + AccumulateAndroid;


    // table data
    const iOSData = { type: reportDataField.iOS }, AndroidData = { type: reportDataField.Android },
        AppDownloadData = {type: reportDataField.iOSAndroid}, AccumulatedDownload = { type: reportDataField.AccumulatedDownload };
    const AppDownloadMOM = {type: reportDataField.MOM}, AppDownloadMOMPCT = {type: reportDataField.MOMPCT};
    let iOSTotal = 0, AndroidTotal = 0, AppDownloadTotal = 0,
     AppDownloadMOMTotal = 0, AppDownloadMOMPCTTotal = 0, AccumulatedDownloadTotal = 0;
    // Chart data
    const ChartLabel = [];
    const iOSAndroidChart = {
      label: reportDataField.iOSAndroid , data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const AppDownloadMOMPCTChart = {label: reportDataField.MOMPCT, data: [], fill: false, borderColor: '#f8a326',
     type: 'line', yAxisID: 'rightyAxisID'};


    result.total_cols.forEach(cols => {
      let iOSAndroidCount = 0, preiOSAndroidCount = 0;
      // Monthly App Download - iOS
      const iOSitem = (iOS.length > 0) ? iOS.find(data => data.Month === cols.month && data.Year === cols.year) : null;
      iOSTotal += ((iOSitem) ? iOSitem.Value : 0);
      iOSAndroidCount += ((iOSitem) ? iOSitem.Value : 0);
      iOSData[cols.year + '/' + cols.month] = ((iOSitem) ? iOSitem.Value : '-');
      editiOSData[cols.month] = ((iOSitem) ? iOSitem.Value : 0);

      // Monthly App Download - Android
      const Androiditem = (Android.length > 0) ? Android.find(data => data.Month === cols.month && data.Year === cols.year) : null;
      AndroidTotal += ((Androiditem) ? Androiditem.Value : 0);
      iOSAndroidCount += ((Androiditem) ? Androiditem.Value : 0);
      AndroidData[cols.year + '/' + cols.month] = ((Androiditem) ? Androiditem.Value : '-');
      editAndroidData[cols.month] = ((Androiditem) ? Androiditem.Value : 0);

      // Monthly App Download - iOS and Android
      AppDownloadTotal += iOSAndroidCount;
      AppDownloadData[cols.year + '/' + cols.month] = ((iOSitem && Androiditem) ? iOSAndroidCount : '-');
      iOSAndroidChart.data.push(iOSAndroidCount);
      // Monthly App Download - Accmulated Download
      AccumulatedDownloadTotal += iOSAndroidCount;
      AccumulatedDownload[cols.year + '/' + cols.month] = AccumulatedDownloadTotal;

      // Monthly App Download - App Download MOM & Devices MOM(%)
      const preiOSitem = (iOS.length > 0) ? iOS.find(data => data.Month === cols.premonth && data.Year === cols.preyear) : null;
      preiOSAndroidCount += ((preiOSitem) ? preiOSitem.Value : 0);
      const preAndroiditem = (Android.length > 0) ? Android.find(data => data.Month === cols.premonth && data.Year === cols.preyear) : null;
      preiOSAndroidCount += ((preAndroiditem) ? preAndroiditem.Value : 0);

      AppDownloadMOM[cols.year + '/' + cols.month] = ((iOSAndroidCount === 0 || preiOSAndroidCount === 0) ?
      '-' : (iOSAndroidCount - preiOSAndroidCount));
      AppDownloadMOMTotal += ((iOSAndroidCount !== 0 && preiOSAndroidCount !== 0) ?
        (iOSAndroidCount - preiOSAndroidCount) : 0);
      AppDownloadMOMPCT[cols.year + '/' + cols.month] = ((iOSAndroidCount !== 0 && preiOSAndroidCount !== 0) ?
        (Math.round(((iOSAndroidCount - preiOSAndroidCount) / preiOSAndroidCount) * 1000) / 10) : '-');
      AppDownloadMOMPCTTotal +=
        ((preiOSAndroidCount) ? (Math.round(((iOSAndroidCount - preiOSAndroidCount) / preiOSAndroidCount ) * 1000) / 10) : 0);
      AppDownloadMOMPCTChart.data.push(((iOSAndroidCount !== 0 && preiOSAndroidCount !== 0) ?
        (Math.round(((iOSAndroidCount - preiOSAndroidCount) / preiOSAndroidCount) * 1000) / 10) : null));
      ChartLabel.push(cols.header);
    });

    result.total_cols.push({field: 'total', header: 'Total', width: '100', class: 'col-nowrap text-align-right',
     disabled: false, month: '', year: ''});
    result.gross_Profit_total_cols.push({field: 'total', header: 'Total', width: '100', class: 'col-nowrap text-align-right',
      disabled: false, month: '', year: ''});
    iOSData['total'] = iOSTotal;
    AndroidData['total'] = AndroidTotal;
    AppDownloadData['total'] = AppDownloadTotal;
    // AppDownloadMOM['total'] = AppDownloadMOMTotal;
    // AppDownloadMOMPCT['total'] = parseInt((AppDownloadMOMPCTTotal * 100).toFixed(), 10) / 100;

    // Table
    result.monthlyAppDownloadData.push(iOSData, AndroidData, AppDownloadData, AppDownloadMOM, AppDownloadMOMPCT, AccumulatedDownload);
    // Chart
    result.AppDownloadChart.labels = ChartLabel;
    result.AppDownloadChart.datasets.push(iOSAndroidChart, AppDownloadMOMPCTChart);

    // Chart圖只會顯示12個月
    if (result.AppDownloadChart.labels.length > 12) {
      const removeCount = result.AppDownloadChart.labels.length - 12;
      
      result.AppDownloadChart.labels.splice(12, removeCount);
      result.AppDownloadChart.datasets.forEach(dataset => {
        if (dataset.data && dataset.data.length > 12) {
          dataset.data.splice(12, removeCount);
        }
      });
    }

    result.appDownloadData.push(editiOSData, editAndroidData);
  }


  if (logs.Loaded && !logs.Loading && logs.entities != null && logs.entities ) {
    result.is_AllTime = logs.entities.is_AllTime;

    // result.startYear = parseInt(logs.entities.start_date.split('/')[0], 10);
    // result.startMonth = parseInt(logs.entities.start_date.split('/')[1], 10);
    // result.endYear = parseInt(logs.entities.end_date.split('/')[0], 10);
    // result.endMonth = parseInt(logs.entities.end_date.split('/')[1], 10);
    // result.startYear = new Date(parseInt(logs.entities.start_date, 10) * 1000).getFullYear();
    // result.startMonth = new Date(parseInt(logs.entities.start_date, 10) * 1000).getMonth() + 1;
    // result.endYear = new Date(parseInt(logs.entities.end_date, 10) * 1000).getFullYear();
    // result.endMonth = new Date(parseInt(logs.entities.end_date, 10) * 1000).getMonth() + 1;
    const startDate = new Date(parseInt(logs.entities.start_date, 10) * 1000);
    const endDate = new Date(parseInt(logs.entities.end_date, 10) * 1000);
    result.startYear = startDate.getUTCFullYear();
    result.startMonth = startDate.getUTCMonth() + 1;
    result.endYear = endDate.getUTCFullYear();
    result.endMonth = endDate.getUTCMonth() + 1;
    result.total_cols = [];
    result.gross_Profit_total_cols = [];
    for (let year = result.startYear; year <= result.endYear; year++) {
      const startMonth = (year === result.startYear) ? result.startMonth : 1;
      const endMonth = (year === result.endYear) ? result.endMonth : 12;
      for (let month = startMonth; month <= endMonth; month++) {
        const premonth = (month > 1) ? (month - 1) : 12;
        const preyear = (premonth === 12) ? (year - 1) : year;
        const beforepremonth = (premonth > 1) ? (premonth - 1) : 12;
        const beforepreyear = (beforepremonth === 12) ? (preyear - 1) : preyear;
        const cols = {
          field: (year + '/' + month), header: monthMap[month], width: '50', class: 'col-nowrap', disabled: false,
          month: month, year: year, premonth: premonth, preyear: preyear, beforepremonth: beforepremonth, beforepreyear: beforepreyear};
        const gross_profit_cols = {
          field: (year + '/' + month), header: monthMap[month] + " '" + String(year).slice(-2), width: '50', class: 'col-nowrap', disabled: false,
          month: month, year: year, premonth: premonth, preyear: preyear, beforepremonth: beforepremonth, beforepreyear: beforepreyear};
        result.alertSettings_cols.push(cols);
        result.total_cols.push(cols);
        result.gross_Profit_total_cols.push(gross_profit_cols);
      }
    }

    const plan_dic = {};
    if (planmgtlist.entities.length > 0) {
      const planitem = Object.values(planmgtlist.entities);
      planitem.forEach((p) => {
        plan_dic[p.Id] = p; // 使用 ID 作為 key
      });
    }
    const hasPlanDic = Object.keys(plan_dic).length > 0;

    const priceitem = Object.values(pricelist);

    const Level1N_1_TitlePrice = [], Level1N_2_TitlePrice = [], Level1N_3_TitlePrice = [];
    const Level3N_1_TitlePrice = [], Level3N_2_TitlePrice = [], Level3N_3_TitlePrice = [];
    const Level10N_1_TitlePrice = [], Level10N_2_TitlePrice = [], Level10N_3_TitlePrice = [];
    const Level20N_1_TitlePrice = [], Level20N_2_TitlePrice = [], Level20N_3_TitlePrice = [];
    const Level50N_1_TitlePrice = [], Level50N_2_TitlePrice = [], Level50N_3_TitlePrice = [];
    const Level100N_1_TitlePrice = [], Level100N_2_TitlePrice = [], Level100N_3_TitlePrice = [];
    const Level3A_1_TitlePrice = [], Level3A_2_TitlePrice = [], Level3A_3_TitlePrice = [];
    const Level200N_1_TitlePrice = [], Level200N_2_TitlePrice = [], Level200N_3_TitlePrice = [];
    const Level5_1_TitlePrice = [];

    const ActiveDeviceMap = {}, LicensedDeviceMap = {}, TrialLicensedDeviceMap = {},
          ActiveDeviceLossesMap = {}, ActiveDeviceAdditionMap = {}, TrialActivationRateMap = {},
          NewConnectedMap = {}, RWCCARD100Map = {}, RCCARD100Map = {}, CloudUPSMap = {},
          CardMap = {}, SoftwareMap = {}, ActiveDevice14DaysPPCMap = {}, ActiveDevice14DaysPROMap = {},
          PowerPanelPersonalMap = {}, PowerPanelBusinessMap = {}, SoftwareOthersMap = {},
          GatewayMap = {}, GatewayUPSMap = {}, GatewayPDUMap = {}, GatewayATSMap = {}, Gateway3phaseUPSMap = {}, Gateway3rdPartysMap = {},
          InAppPurchaseMap = {}, WebPurchaseMap = {}, PPCLicenseGeneratorMap = {}, AmountAppMap = {}, AmountWebMap = {},
          AmountPPCLicenseGeneratorMap = {}, AmountPPCProMap = {}, AmountPlanDiscountMap = {},
          YearlyPlanPayPalMap = {}, YearlyPlanAppMap = {}, YearlyPlanPPCGeneratorMap = {}, PPCPROPayPalMap = {}, PPCPROGeneratorMap = {},
          YearlyPlanPayPalFeeMap = {}, YearlyPlanAppFeeMap = {}, YearlyPlanDiscountMap = {}, PPCPROPayPalFeeMap = {}, PPCPRODiscountMap = {}, ServerFeeMap = {},
          DeferredYearlyPlanPayPalMap = {}, DeferredYearlyPlanAppMap = {}, DeferredYearlyPlanPPCGeneratorMap = {}, DeferredPPCPROMap = {},
          DeferredYearlyPlanPayPalFeeMap = {}, DeferredYearlyPlanAppFeeMap = {}, DeferredYearlyPlanDiscountMap = {},
          DeferredPPCPROPayPalFeeMap = {}, DeferredPPCPRODiscountMap = {},
          PAYearlyPlanPurchaseMap = {}, PAMonthlyRenewalRateMap = {}, PATotalPlanRenewalRateMap = {}, PAPlanRenewalRate_1to3Map = {}, PAPlanRenewalRate_4to20Map = {},PAPlanRenewalRate_Over20Map = {},
          PAPlanTransferRateMap = {}, PAConversionRateMap = {};

    const Level1NMap = {}, Level3NMap = {}, Level10NMap = {}, Level20NMap = {},
          Level50NMap = {}, Level100NMap = {}, Level3AMap = {}, Level200NMap = {}, Level5Map = {};
    const Level1N_PriceMap = {}, Level3N_PriceMap = {}, Level10N_PriceMap = {}, Level20N_PriceMap = {},
          Level50N_PriceMap = {}, Level100N_PriceMap = {}, Level3A_PriceMap = {}, Level200N_PriceMap = {}, Level5_PriceMap = {};
      
    const Level1N_1Map = {}, Level1N_2Map = {}, Level1N_3Map = {},
          Level3N_1Map = {}, Level3N_2Map = {}, Level3N_3Map = {},
          Level10N_1Map = {}, Level10N_2Map = {}, Level10N_3Map = {},
          Level20N_1Map = {}, Level20N_2Map = {}, Level20N_3Map = {},
          Level50N_1Map = {}, Level50N_2Map = {}, Level50N_3Map = {},
          Level100N_1Map = {}, Level100N_2Map = {}, Level100N_3Map = {},
          Level3A_1Map = {}, Level3A_2Map = {}, Level3A_3Map = {},
          Level200N_1Map = {}, Level200N_2Map = {}, Level200N_3Map = {},
          Level5_1Map = {}; 

    const Level1N_1_PriceMap = {}, Level1N_2_PriceMap = {}, Level1N_3_PriceMap = {},
          Level3N_1_PriceMap = {}, Level3N_2_PriceMap = {}, Level3N_3_PriceMap = {},
          Level10N_1_PriceMap = {}, Level10N_2_PriceMap = {}, Level10N_3_PriceMap = {},
          Level20N_1_PriceMap = {}, Level20N_2_PriceMap = {}, Level20N_3_PriceMap = {},
          Level50N_1_PriceMap = {}, Level50N_2_PriceMap = {}, Level50N_3_PriceMap = {},
          Level100N_1_PriceMap = {}, Level100N_2_PriceMap = {}, Level100N_3_PriceMap = {},
          Level3A_1_PriceMap = {}, Level3A_2_PriceMap = {}, Level3A_3_PriceMap = {},
          Level200N_1_PriceMap = {}, Level200N_2_PriceMap = {}, Level200N_3_PriceMap = {},
          Level5_1_PriceMap = {};

    const SubDevices_Level1NMap = {}, SubDevices_Level3NMap = {}, SubDevices_Level10NMap = {},
          SubDevices_Level20NMap = {}, SubDevices_Level50NMap = {}, SubDevices_Level100NMap = {},
          SubDevices_Level3AMap = {}, SubDevices_Level200NMap = {}, SubDevices_PROMap = {}, SubDevices_TrialMap = {};
          
    const SubAccounts_Level1NMap = {}, SubAccounts_Level3NMap = {}, SubAccounts_Level10NMap = {},
          SubAccounts_Level20NMap = {}, SubAccounts_Level50NMap = {}, SubAccounts_Level100NMap = {},
          SubAccounts_Level3AMap = {}, SubAccounts_Level200NMap = {}, SubAccounts_PROMap = {}, SubAccounts_TrialMap = {};

    const PO_PPCPROAccountMap = {}, PO_TotalCompanyNumberMap = {}, PO_NPMUsageMap = {}, PO_TotalNPMRemainingMap = {}, PO_NPMPurchasedQuantityPrepaidMap = {}, PO_NPMPurchasedQuantityMonthlyMap = {},
          PO_PPCPROIncomeMap = {}, PO_PPCPRODiscountMap = {};

    const APICalls = [];

    const type_activeDevice = reportDataMonthlyType['active_device'];
    const type_licensedDevice = reportDataMonthlyType['licensed_device'];
    const type_newConnectedDevice = reportDataMonthlyType['new_connected_device'];
    const type_order = reportDataMonthlyType['order'];
    const type_revenue = reportDataMonthlyType['revenue'];
    const type_connected_device = reportDataMonthlyType['connected_device'];
    const type_apiCalls = reportDataMonthlyType['api_calls'];
    const type_proOrder = reportDataMonthlyType['pro_order'];
    const type_proRevenue = reportDataMonthlyType['pro_revenue'];
    const type_planFee = reportDataMonthlyType['plan_fee'];
    const type_proFee = reportDataMonthlyType['pro_fee'];
    const type_serverFee = reportDataMonthlyType['server_fee'];
    const type_account = reportDataMonthlyType['account'];
    const type_proCompany = reportDataMonthlyType['pro_company'];

    const subType_total = reportDataMonthlySubType['total'];
    const subType_trial = reportDataMonthlySubType['trial'];
    const subType_wifi = reportDataMonthlySubType['wifi'];
    const subType_mini = reportDataMonthlySubType['mini'];
    const subType_EmbMini = reportDataMonthlySubType['EMBMini'];
    const subType_card = reportDataMonthlySubType['card'];
    const subType_sw = reportDataMonthlySubType['sw'];
    const subType_inAppPurchase = reportDataMonthlySubType['in_app_purchase'];
    const subType_WebPurchase = reportDataMonthlySubType['web_purchase'];
    const subType_ppcLicenseGen = reportDataMonthlySubType['ppc_license_generator'];
    const subType_proIncome = reportDataMonthlySubType['pro_income'];
    const subType_planDiscount = reportDataMonthlySubType['plan_discount'];
    const subType_planMgt = reportDataMonthlySubType['plan_mgt'];
    const subType_losses = reportDataMonthlySubType['losses'];
    const subType_addition = reportDataMonthlySubType['addition'];
    const subType_gateway = reportDataMonthlySubType['gateway'];
    const subType_14daysppc = reportDataMonthlySubType['14days_ppc'];
    const subType_14dayspro = reportDataMonthlySubType['14days_pro'];
    const subType_pro_discount = reportDataMonthlySubType['pro_discount'];
    const subType_renewal_rate = reportDataMonthlySubType['renewal_rate'];
    const subType_transfer_rate = reportDataMonthlySubType['transfer_rate'];
    const subType_trial_activation_rate = reportDataMonthlySubType['trial_activation_rate'];
    const subType_conversion_rate = reportDataMonthlySubType['conversion_rate'];

    const tertType_sw = reportDataMonthlyTertiaryType['sw_type'];
    const tertType_gateway = reportDataMonthlyTertiaryType['gateway_category_type'];
    const tertType_reportCustom = reportDataMonthlyTertiaryType['report_custom_type'];
    const tertType_renewal_rate_range_type = reportDataMonthlyTertiaryType['renewal_rate_range_type'];
    const tertType_chargeType = reportDataMonthlyTertiaryType['charge_type'];
    const tertType_planMgtId = reportDataMonthlyTertiaryType['PlanMgtId'];

    const swType_ppp = reportDataMonthlySWType['PPP'];
    const swType_ppb = reportDataMonthlySWType['PPB'];
    const swType_ppl = reportDataMonthlySWType['PPL'];
    const swType_ppg = reportDataMonthlySWType['PPG'];

    const gatewayType_ups = reportDataMonthlyGatewayCategoryType['UPS'];
    const gatewayType_3phaseUps = reportDataMonthlyGatewayCategoryType['3PhaseUPS'];
    const gatewayType_ats = reportDataMonthlyGatewayCategoryType['ATS'];
    const gatewayType_pdu = reportDataMonthlyGatewayCategoryType['PDU'];
    const gatewayType_epdu2 = reportDataMonthlyGatewayCategoryType['ePDU2'];

    const reportCustomerType_3rdPartyDevices = reportDataMonthlyReportCustomType['3rdparty_devices'];
    const reportCustomerType_other = reportDataMonthlyReportCustomType['other'];
    const reportCustomerType_deferred = reportDataMonthlyReportCustomType['deferred'];
    const reportCustomerType_usage = reportDataMonthlyReportCustomType['usage'];
    const reportCustomerType_remaining = reportDataMonthlyReportCustomType['remaining'];

    const renewalRateRangeType_1To3Devices = reportDataMonthlyRenewalRateRangeType['1-3_devices'];
    const renewalRateRangeType_All = reportDataMonthlyRenewalRateRangeType['all'];
    const renewalRateRangeType_4To20Devices = reportDataMonthlyRenewalRateRangeType['4-20_devices'];
    const renewalRateRangeType_Over20Devices = reportDataMonthlyRenewalRateRangeType['over20_devices'];
    const renewalRateRangeType_Monthly = reportDataMonthlyRenewalRateRangeType['monthly'];

    const chargeType_prepaid = reportDataMonthlyChargeType['Prepaid'];
    const chargeType_monthly = reportDataMonthlyChargeType['Monthly'];

    // 預先快取常用的 PlanName (reportDataField)
    const field_Level1N = reportDataField['Level1N'];
    const field_Level3N = reportDataField['Level3N'];
    const field_Level10N = reportDataField['Level10N'];
    const field_Level20N = reportDataField['Level20N'];
    const field_Level50N = reportDataField['Level50N'];
    const field_Level100N = reportDataField['Level100N'];
    const field_Level3A = reportDataField['Level3A'];
    const field_Level200N = reportDataField['Level200N'];
    const field_Level5 = reportDataField['Level5'];
    
    // 預先快取常用的 Period
    const period_1 = reportDataPeriod[1];
    const period_2 = reportDataPeriod[2];
    const period_3 = reportDataPeriod[3];

    for (const item of priceitem) {
      const period = item.Period;
      const planName = item.PlanName;

      if (period === reportDataPeriod[1]) {
        switch (planName) {
          case reportDataField['Level1N']: Level1N_1_TitlePrice.push(item); break;
          case reportDataField['Level3N']: Level3N_1_TitlePrice.push(item); break;
          case reportDataField['Level10N']: Level10N_1_TitlePrice.push(item); break;
          case reportDataField['Level20N']: Level20N_1_TitlePrice.push(item); break;
          case reportDataField['Level50N']: Level50N_1_TitlePrice.push(item); break;
          case reportDataField['Level100N']: Level100N_1_TitlePrice.push(item); break;
          case reportDataField['Level3A']: Level3A_1_TitlePrice.push(item); break;
          case reportDataField['Level200N']: Level200N_1_TitlePrice.push(item); break;
          case reportDataField['Level5']: Level5_1_TitlePrice.push(item); break;
        }
      } else if (period === reportDataPeriod[2]) {
        switch (planName) {
          case reportDataField['Level1N']: Level1N_2_TitlePrice.push(item); break;
          case reportDataField['Level3N']: Level3N_2_TitlePrice.push(item); break;
          case reportDataField['Level10N']: Level10N_2_TitlePrice.push(item); break;
          case reportDataField['Level20N']: Level20N_2_TitlePrice.push(item); break;
          case reportDataField['Level50N']: Level50N_2_TitlePrice.push(item); break;
          case reportDataField['Level100N']: Level100N_2_TitlePrice.push(item); break;
          case reportDataField['Level3A']: Level3A_2_TitlePrice.push(item); break;
          case reportDataField['Level200N']: Level200N_2_TitlePrice.push(item); break;
        }
      } else if (period === reportDataPeriod[3]) {
        switch (planName) {
          case reportDataField['Level1N']: Level1N_3_TitlePrice.push(item); break;
          case reportDataField['Level3N']: Level3N_3_TitlePrice.push(item); break;
          case reportDataField['Level10N']: Level10N_3_TitlePrice.push(item); break;
          case reportDataField['Level20N']: Level20N_3_TitlePrice.push(item); break;
          case reportDataField['Level50N']: Level50N_3_TitlePrice.push(item); break;
          case reportDataField['Level100N']: Level100N_3_TitlePrice.push(item); break;
          case reportDataField['Level3A']: Level3A_3_TitlePrice.push(item); break;
          case reportDataField['Level200N']: Level200N_3_TitlePrice.push(item); break;
        }
      }
    }

    const sourceLogs = logs.entities.UserActivityLogNode.filter(item => item.RegionId === null || item.RegionId === 0);;
    if (sourceLogs && sourceLogs.length > 0) {
      for (const item of sourceLogs) {
        const type = item.Type;
        const subType = item.SubType;
        const tertTypeName = item.TertTypeName;
        const tertType = item.TertTypeVal;
        const period = item.period;
        const key = `${item.Year}/${item.Month}`;

        switch (type) {
          case type_activeDevice:
            switch (subType) {
              case subType_total: ActiveDeviceMap[key] = item; break;
              case subType_losses: ActiveDeviceLossesMap[key] = item; break;
              case subType_addition: ActiveDeviceAdditionMap[key] = item; break;
              case subType_14daysppc: ActiveDevice14DaysPPCMap[key] = item; break;
              case subType_14dayspro: ActiveDevice14DaysPROMap[key] = item; break;
            }
            break;
          
          case type_licensedDevice:
            switch (subType) {
              case subType_total: LicensedDeviceMap[key] = item; break;
              case subType_trial: TrialLicensedDeviceMap[key] = item; break;
            }
            break;
          
          case type_newConnectedDevice:
            switch (subType) {
              case subType_total: NewConnectedMap[key] = item; break;
              case subType_wifi: RWCCARD100Map[key] = item; break;
              case subType_mini: RCCARD100Map[key] = item; break;
              case subType_EmbMini: CloudUPSMap[key] = item; break;
              case subType_card: CardMap[key] = item; break;
              case subType_sw:
                if (tertTypeName === undefined && tertType === undefined) {
                  SoftwareMap[key] = item; break;
                }
                if (tertTypeName === tertType_sw && tertType === swType_ppp) { PowerPanelPersonalMap[key] = item; }
                else if (tertTypeName === tertType_sw && tertType === swType_ppb) { PowerPanelBusinessMap[key] = item; }
                else if (tertTypeName === tertType_sw && tertType === swType_ppg) { GatewayMap[key] = item; }
                else if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_other) { SoftwareOthersMap[key] = item; }
                break;
              case subType_gateway:
                if (tertTypeName === tertType_gateway && tertType === gatewayType_ups) { GatewayUPSMap[key] = item; }
                else if (tertTypeName === tertType_gateway && tertType === gatewayType_pdu) { GatewayPDUMap[key] = item; }
                else if (tertTypeName === tertType_gateway && tertType === gatewayType_ats) { GatewayATSMap[key] = item; }
                else if (tertTypeName === tertType_gateway && tertType === gatewayType_3phaseUps) { Gateway3phaseUPSMap[key] = item; }
                else if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_3rdPartyDevices) { Gateway3rdPartysMap[key] = item; }
                break;
            }
            break;
          
          case type_order:
            switch (subType) {
              // case subType_total:
              //   PAYearlyPlanPurchaseMap[key] = item;
              //   break;
              case subType_inAppPurchase: InAppPurchaseMap[key] = item; break;
              case subType_WebPurchase: WebPurchaseMap[key] = item; break;
              case subType_ppcLicenseGen: PPCLicenseGeneratorMap[key] = item; break;
              case subType_proIncome: AmountPPCProMap[key] = item; break;
              case subType_planMgt:
                // (B) 處理 Block 3 & 5 (plan_mgt) 的 Order 過濾
                if (!hasPlanDic || !plan_dic[item.PlanMgtId]) {
                  break; // 找不到 Plan 的資料，跳過
                }
                
                const planName = plan_dic[item.PlanMgtId].PlanName;

                if (period === undefined) {
                  // --- Block 3 (period === undefined) ---
                  switch (planName) {
                    case field_Level1N: Level1NMap[key] = item; break;
                    case field_Level3N: Level3NMap[key] = item; break;
                    case field_Level10N: Level10NMap[key] = item; break;
                    case field_Level20N: Level20NMap[key] = item; break;
                    case field_Level50N: Level50NMap[key] = item; break;
                    case field_Level100N: Level100NMap[key] = item; break;
                    case field_Level3A: Level3AMap[key] = item; break;
                    case field_Level200N: Level200NMap[key] = item; break;
                    case field_Level5: Level5Map[key] = item; break;
                  }
                } else if (period === period_1) {
                  // --- Block 5 (Order, Period 1) ---
                  switch (planName) {
                    case field_Level1N: Level1N_1Map[key] = item; break;
                    case field_Level3N: Level3N_1Map[key] = item; break;
                    case field_Level10N: Level10N_1Map[key] = item; break;
                    case field_Level20N: Level20N_1Map[key] = item; break;
                    case field_Level50N: Level50N_1Map[key] = item; break;
                    case field_Level100N: Level100N_1Map[key] = item; break;
                    case field_Level3A: Level3A_1Map[key] = item; break;
                    case field_Level200N: Level200N_1Map[key] = item; break;
                    case field_Level5: Level5_1Map[key] = item; break;
                  }
                } else if (period === period_2) {
                  // --- Block 5 (Order, Period 2) ---
                  switch (planName) {
                    case field_Level1N: Level1N_2Map[key] = item; break;
                    case field_Level3N: Level3N_2Map[key] = item; break;
                    case field_Level10N: Level10N_2Map[key] = item; break;
                    case field_Level20N: Level20N_2Map[key] = item; break;
                    case field_Level50N: Level50N_2Map[key] = item; break;
                    case field_Level100N: Level100N_2Map[key] = item; break;
                    case field_Level3A: Level3A_2Map[key] = item; break;
                    case field_Level200N: Level200N_2Map[key] = item; break;
                  }
                } else if (period === period_3) {
                  // --- Block 5 (Order, Period 3) ---
                  switch (planName) {
                    case field_Level1N: Level1N_3Map[key] = item; break;
                    case field_Level3N: Level3N_3Map[key] = item; break;
                    case field_Level10N: Level10N_3Map[key] = item; break;
                    case field_Level20N: Level20N_3Map[key] = item; break;
                    case field_Level50N: Level50N_3Map[key] = item; break;
                    case field_Level100N: Level100N_3Map[key] = item; break;
                    case field_Level3A: Level3A_3Map[key] = item; break;
                    case field_Level200N: Level200N_3Map[key] = item; break;
                  }
                }
                break;
              case subType_14dayspro:
                if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_usage) { PO_NPMUsageMap[key] = item; }
                else if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_remaining) { PO_TotalNPMRemainingMap[key] = item; }
                else if (tertTypeName === tertType_chargeType && tertType === chargeType_prepaid) { PO_NPMPurchasedQuantityPrepaidMap[key] = item; }
                else if (tertTypeName === tertType_chargeType && tertType === chargeType_monthly) { PO_NPMPurchasedQuantityMonthlyMap[key] = item; }
                break;
              case subType_renewal_rate:
                if (tertTypeName === tertType_renewal_rate_range_type && tertType === renewalRateRangeType_All) { PATotalPlanRenewalRateMap[key] = item; }
                else if (tertTypeName === tertType_renewal_rate_range_type && tertType === renewalRateRangeType_1To3Devices) { PAPlanRenewalRate_1to3Map[key] = item; }
                else if (tertTypeName === tertType_renewal_rate_range_type && tertType === renewalRateRangeType_4To20Devices) { PAPlanRenewalRate_4to20Map[key] = item; }
                else if (tertTypeName === tertType_renewal_rate_range_type && tertType === renewalRateRangeType_Over20Devices) { PAPlanRenewalRate_Over20Map[key] = item; }
                else if (tertTypeName === tertType_renewal_rate_range_type && tertType === renewalRateRangeType_Monthly) { PAMonthlyRenewalRateMap[key] = item; }
                break;
              case subType_transfer_rate: PAPlanTransferRateMap[key] = item; break;
              case subType_trial_activation_rate: TrialActivationRateMap[key] = item; break;
              case subType_conversion_rate: PAConversionRateMap[key] = item; break;
            }
            break;
          case type_revenue:
            switch (subType) {
              case subType_inAppPurchase:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanAppMap[key] = item;
                  }
                } else {
                  AmountAppMap[key] = item;
                  YearlyPlanAppMap[key] = item;
                }
                break;

              case subType_WebPurchase:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanPayPalMap[key] = item;
                  }
                } else {
                  AmountWebMap[key] = item;
                  YearlyPlanPayPalMap[key] = item;
                }
                break;

              case subType_ppcLicenseGen:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanPPCGeneratorMap[key] = item;
                  }
                } else {
                  AmountPPCLicenseGeneratorMap[key] = item;
                  YearlyPlanPPCGeneratorMap[key] = item;
                }
                break;

              case subType_planDiscount:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanDiscountMap[key] = item;
                  }
                } else {
                  AmountPlanDiscountMap[key] = item;
                  YearlyPlanDiscountMap[key] = item;
                }
                break;

              case subType_pro_discount:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredPPCPRODiscountMap[key] = item;
                    PO_PPCPRODiscountMap[key] = item;
                  }
                } else {
                  PPCPRODiscountMap[key] = item;
                }
                break;
              case subType_planMgt:
                // (C) 處理 Block 5 (plan_mgt) 的 Revenue 過濾
                if (!hasPlanDic || !plan_dic[item.PlanMgtId]) {
                  break; // 找不到 Plan 的資料，跳過
                }
                
                const planName = plan_dic[item.PlanMgtId].PlanName;

                if (period === undefined) {
                  // --- Block 3 (period === undefined) ---
                  if (tertTypeName === undefined && tertType === undefined) {
                    switch (planName) {
                      case field_Level1N: Level1N_PriceMap[key] = item; break;
                      case field_Level3N: Level3N_PriceMap[key] = item; break;
                      case field_Level10N: Level10N_PriceMap[key] = item; break;
                      case field_Level20N: Level20N_PriceMap[key] = item; break;
                      case field_Level50N: Level50N_PriceMap[key] = item; break;
                      case field_Level100N: Level100N_PriceMap[key] = item; break;
                      case field_Level3A: Level3A_PriceMap[key] = item; break;
                      case field_Level200N: Level200N_PriceMap[key] = item; break;
                      case field_Level5: Level5_PriceMap[key] = item; break;
                    }
                  }
                } else if (period === period_1) {
                  // --- Block 5 (Revenue, Period 1) ---
                  switch (planName) {
                    case field_Level1N: Level1N_1_PriceMap[key] = item; break;
                    case field_Level3N: Level3N_1_PriceMap[key] = item; break;
                    case field_Level10N: Level10N_1_PriceMap[key] = item; break;
                    case field_Level20N: Level20N_1_PriceMap[key] = item; break;
                    case field_Level50N: Level50N_1_PriceMap[key] = item; break;
                    case field_Level100N: Level100N_1_PriceMap[key] = item; break;
                    case field_Level3A: Level3A_1_PriceMap[key] = item; break;
                    case field_Level200N: Level200N_1_PriceMap[key] = item; break;
                    case field_Level5: Level5_1_PriceMap[key] = item; break;
                  }
                } else if (period === period_2) {
                  // --- Block 5 (Revenue, Period 2) ---
                  switch (planName) {
                    case field_Level1N: Level1N_2_PriceMap[key] = item; break;
                    case field_Level3N: Level3N_2_PriceMap[key] = item; break;
                    case field_Level10N: Level10N_2_PriceMap[key] = item; break;
                    case field_Level20N: Level20N_2_PriceMap[key] = item; break;
                    case field_Level50N: Level50N_2_PriceMap[key] = item; break;
                    case field_Level100N: Level100N_2_PriceMap[key] = item; break;
                    case field_Level3A: Level3A_2_PriceMap[key] = item; break;
                    case field_Level200N: Level200N_2_PriceMap[key] = item; break;
                  }
                } else if (period === period_3) {
                  // --- Block 5 (Revenue, Period 3) ---
                  switch (planName) {
                    case field_Level1N: Level1N_3_PriceMap[key] = item; break;
                    case field_Level3N: Level3N_3_PriceMap[key] = item; break;
                    case field_Level10N: Level10N_3_PriceMap[key] = item; break;
                    case field_Level20N: Level20N_3_PriceMap[key] = item; break;
                    case field_Level50N: Level50N_3_PriceMap[key] = item; break;
                    case field_Level100N: Level100N_3_PriceMap[key] = item; break;
                    case field_Level3A: Level3A_3_PriceMap[key] = item; break;
                    case field_Level200N: Level200N_3_PriceMap[key] = item; break;
                  }
                }
                break;
            }
            break;
          
          case type_connected_device:
            switch (subType) {
              case subType_total:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_planMgtId) {
                    const planName = plan_dic[tertType].PlanName;
                    switch (planName) {
                      case field_Level1N: SubDevices_Level1NMap[key] = item; break;
                      case field_Level3N: SubDevices_Level3NMap[key] = item; break;
                      case field_Level10N: SubDevices_Level10NMap[key] = item; break;
                      case field_Level20N: SubDevices_Level20NMap[key] = item; break;
                      case field_Level50N: SubDevices_Level50NMap[key] = item; break;
                      case field_Level100N: SubDevices_Level100NMap[key] = item; break;
                      case field_Level200N: SubDevices_Level200NMap[key] = item; break;
                      case field_Level3A: SubDevices_Level3AMap[key] = item; break;
                    }
                  }
                }
                break;
              case subType_trial: SubDevices_PROMap[key] = item; break;
              case subType_14dayspro: SubDevices_TrialMap[key] = item; break;
            }
            break;

          case type_apiCalls:
            APICalls.push(item);
            break;

          case type_proRevenue:
            switch (subType) {
              case subType_total: 
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredPPCPROMap[key] = item;
                    PO_PPCPROIncomeMap[key] = item;
                  }
                }
              case subType_WebPurchase:
                PPCPROPayPalMap[key] = item;
                break;
              case subType_ppcLicenseGen:
                PPCPROGeneratorMap[key] = item;
                break;
            }
            break;
          
          case type_planFee:
            switch (subType) {
              case subType_inAppPurchase:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanAppFeeMap[key] = item;
                  }
                } else {
                  YearlyPlanAppFeeMap[key] = item;
                }
                break;
              case subType_WebPurchase:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredYearlyPlanPayPalFeeMap[key] = item;
                  }
                } else {
                  YearlyPlanPayPalFeeMap[key] = item;
                }
                break;
            }
            break;
          
          case type_proFee:
            switch (subType) {
              case subType_WebPurchase:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_reportCustom && tertType === reportCustomerType_deferred) {
                    DeferredPPCPROPayPalFeeMap[key] = item;
                  }
                } else {
                  PPCPROPayPalFeeMap[key] = item;
                }
                break;
            }
            break;
          
          case type_serverFee:
            switch (subType) {
              case subType_total:
                ServerFeeMap[key] = item;
                break;
            }
            break;

          case type_account:
            switch (subType) {
              case subType_total:
                if (typeof tertTypeName === 'number' && !isNaN(tertTypeName) && typeof tertType === 'number' && !isNaN(tertType)) {
                  if (tertTypeName === tertType_planMgtId) {
                    const planName = plan_dic[tertType].PlanName;
                    switch (planName) {
                      case field_Level1N: SubAccounts_Level1NMap[key] = item; break;
                      case field_Level3N: SubAccounts_Level3NMap[key] = item; break;
                      case field_Level10N: SubAccounts_Level10NMap[key] = item; break;
                      case field_Level20N: SubAccounts_Level20NMap[key] = item; break;
                      case field_Level50N: SubAccounts_Level50NMap[key] = item; break;
                      case field_Level100N: SubAccounts_Level100NMap[key] = item; break;
                      case field_Level200N: SubAccounts_Level200NMap[key] = item; break;
                      case field_Level3A: SubAccounts_Level3AMap[key] = item; break;
                    }
                  }
                }
                break;
              case subType_trial: SubAccounts_TrialMap[key] = item; break;
              case subType_14dayspro:
                SubAccounts_PROMap[key] = item;
                PO_PPCPROAccountMap[key] = item;
                break;
            }
            break;
          case type_proCompany:
            switch (subType) {
              case subType_total:
                PO_TotalCompanyNumberMap[key] = item;
                break;
            }
            break;
        }
      }
    }
    // NgRx 9 不可變性: 雖然 APICalls 是局部創建的，但為了一致性仍使用不可變模式
    // 實際上這裡可以直接 sort，但為了最佳實踐還是創建副本
    const sortedAPICalls = [...APICalls].sort((data1, data2) => data1.SubType.localeCompare(data2.SubType));

    if (sortedAPICalls.length > 0) {
      const apiCallsTotal = {type: 'Total'},
            apiCallsAccumulated = {type: 'Accumulated Calls'},
            APIUrlArr = [],
            apiCallsPreTotal = [];
      sortedAPICalls.forEach(data => {
        if (APIUrlArr.indexOf(data.SubType) < 0) {
          APIUrlArr.push(data.SubType);
        }
      });
      const APICallsNestedMap = {};
      for (const item of sortedAPICalls) { // sortedAPICalls 是排序後的陣列
          const url = item.SubType;
          const key = `${item.Year}/${item.Month}`;
          if (!APICallsNestedMap[url]) {
              APICallsNestedMap[url] = {};
          }
          APICallsNestedMap[url][key] = item;
      }
      const APIChart = {
        label: 'API', data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
      const APIMOMPCTChart = {
        label: 'API MoM (%)', data: [], fill: false, borderColor: '#f8a326', type: 'line', yAxisID: 'rightyAxisID'};
      if (APIUrlArr.length > 0) {
        APIUrlArr.forEach(url => {
          const apiCallsData = {type: {value: url}};
          let urlTotal = 0;
          // const APIChart = {
          //   label: reportDataField.Order,
          //   data: [],
          //   fill: false,
          //   borderColor: '#af4bce',
          // };
          result.alertSettings_cols.forEach(cols => {
            const key = `${cols.year}/${cols.month}`;
            const preKey = `${cols.preyear}/${cols.premonth}`;
            const item = APICallsNestedMap[url] ? APICallsNestedMap[url][key] : null;
            const preitem = APICallsNestedMap[url] ? APICallsNestedMap[url][preKey] : null;
            apiCallsData[cols.year + '/' + cols.month] = ((item) ? {value: item.Value} : {value: '-'});
            urlTotal = urlTotal += ((item) ? item.Value : 0);

            // API Calls Total
            apiCallsTotal[cols.year + '/' + cols.month] = (apiCallsTotal[cols.year + '/' + cols.month] === undefined) ?
              ((item) ? item.Value : 0) : apiCallsTotal[cols.year + '/' + cols.month] += ((item) ? item.Value : 0);
            apiCallsTotal['total'] = (apiCallsTotal['total'] === undefined) ?
              ((item) ? item.Value : 0) : apiCallsTotal['total'] += ((item) ? item.Value : 0);
            // API Calls Accumulated
            apiCallsAccumulated[cols.year + '/' + cols.month] = (apiCallsAccumulated[cols.preyear + '/' + cols.premonth] === undefined) ?
              apiCallsTotal[cols.year + '/' + cols.month] :
              apiCallsTotal[cols.year + '/' + cols.month] + apiCallsAccumulated[cols.preyear + '/' + cols.premonth];
            apiCallsPreTotal[cols.year + '/' + cols.month] = (apiCallsPreTotal[cols.year + '/' + cols.month] === undefined) ?
              ((preitem) ? preitem.Value : 0) : apiCallsPreTotal[cols.year + '/' + cols.month] += ((preitem) ? preitem.Value : 0);

          });
          apiCallsData['total'] = {value: urlTotal};
          result.monthlyAPICallsData.push(apiCallsData);
        });
        result.alertSettings_cols.forEach(cols => {
          result.monthlyAPICallsData.forEach(data => {
            data[cols.year + '/' + cols.month].PCT = (data[cols.year + '/' + cols.month].value === '-') ?
            0 : (Math.round(((data[cols.year + '/' + cols.month].value) / apiCallsTotal[cols.year + '/' + cols.month]) * 1000) / 10);
          });
          APIChart.data.push(apiCallsTotal[cols.year + '/' + cols.month]);
          const preValue = apiCallsPreTotal[cols.year + '/' + cols.month];
          const item = apiCallsTotal[cols.year + '/' + cols.month];
          APIMOMPCTChart.data.push(((preValue && item && preValue !== 0 && item !== 0) ?
          (Math.round(((item - preValue) / preValue) * 1000) / 10) : null));
        });
      }
      result.monthlyAPICallsData.push(apiCallsTotal);
      result.monthlyAPICallsData.push(apiCallsAccumulated);
      result.APIChart.datasets.push(APIChart, APIMOMPCTChart);
    }

    // table data
    const ActiveDeviceData = {type: reportDataField.ActiveDevice},
          ActiveDeviceDataMOM = {type: reportDataField.ActiveDeviceMOM},
          ActiveDeviceLossesData = {type: reportDataField.ActiveDeviceLosses},
          ActiveDeviceAdditionData = {type: reportDataField.ActiveDeviceAddition},
          NewConnectedMoMData = {type: reportDataField.NewConnectedMoM},
          TrialActivationRateData = {type: reportDataField.TrialActivationRate},
          LicensedDeviceData = {type: reportDataField.LicensedDevice},
          LicensedDeviceDataMOM = {type: reportDataField.LicensedDeviceMOM},
          TrialLicensedDeviceData = {type: reportDataField.TrialLicensedDevice},
          TrialLicensedDeviceDataMOM = {type: reportDataField.TrialLicensedDeviceMOM},
          LicensedDevicePCTData = {type: reportDataField.LicensedDevicePCT};

    const ActiveDevice14DaysPPCData = {type: reportDataField.ActiveDevice14day_PPC},
          ActiveDevice14DaysPROData = {type: reportDataField.ActiveDevice14day_PRO},
          NewConnectedData = {type: reportDataField.NewConnected}, CardData = {type: reportDataField.Card},
          RCCARD100Data = {type: reportDataField.RCCARD100}, RWCCARD100Data = {type: reportDataField.RWCCARD100},
          CloudUPSData = {type: reportDataField.CloudUPS},
          SoftwareData = {type: reportDataField.Software}, AccumulatedDeviceData = {type: reportDataField.AccumulatedDevices},
          // NewConnectedMOM = {type: reportDataField.MOM}, NewConnectedMOMPCT = {type: reportDataField.MOMPCT},
          PowerPanelPersonalData = {type: reportDataField.PowerPanelPersonal},
          PowerPanelBusinessData = {type: reportDataField.PowerPanelBusiness},
          SoftwareOthersData = {type: reportDataField.SoftwareOthers},
          GatewayData = {type: reportDataField.Gateway},
          GatewayUPSData = {type: reportDataField.GatewayUPS},
          GatewayPDUData = {type: reportDataField.GatewayPDU},
          GatewayATSData = {type: reportDataField.GatewayATS},
          Gateway3phaseUPSData = {type: reportDataField.Gateway3phaseUPS},
          Gateway3rdPartysDevicesData = {type: reportDataField.Gateway3PartyDevices};

    const GPAMonthlySalesIncomeData = {type: reportDataField.GPAMonthlySalesIncome},
          GPAYearlyPlanPayPalData = {type: reportDataField.GPAYearlyPlanPayPal},
          GPAYearlyPlanAPPData = {type: reportDataField.GPAYearlyPlanAPP},
          GPAYearlyPlanPPCGeneratorData = {type: reportDataField.GPAYearlyPlanPPCGenerator},
          GPAPPCPROPayPalData = {type: reportDataField.GPAPPCPROPayPal},
          GPAPPCPROGeneratorData = {type: reportDataField.GPAPPCPROGenerator},
          GPAPPCPROData = {type: reportDataField.GPAPPCPRO},
          GPATotalCostData = {type: reportDataField.GPATotalCost},
          GPAYearlyPlanPayPalFeeData = {type: reportDataField.GPAYearlyPlanPayPalFee},
          GPAYearlyPlanAPPFeeData = {type: reportDataField.GPAYearlyPlanAPPFee},
          GPAYearlyPlanDiscountData = {type: reportDataField.GPAYearlyPlanDiscount},
          GPAPPCPROPayPalFeeData = {type: reportDataField.GPAPPCPROPayPalFee},
          GPARevenuePPCPRODiscountData = {type: reportDataField.GPARevenuePPCPRODiscount},
          GPAServerFeeData = {type: reportDataField.GPAServerFee},
          GPAGrossProfitData = {type: reportDataField.GPAGrossProfit},
          GPAGrossProfitMoMData = {type: reportDataField.GPAGrossProfitMoM},
          GPAGrossProfitMarginData = {type: reportDataField.GPAGrossProfitMargin},
          GPAGrossProfitMarginMoMData = {type: reportDataField.GPAGrossProfitMarginMoM};

    const GPADeferredMonthlySalesIncomeData = {type: reportDataField.GPADeferredMonthlySalesIncome},
          GPADeferredYearlyPlanPayPalData = {type: reportDataField.GPADeferredYearlyPlanPayPal},
          GPADeferredYearlyPlanAPPData = {type: reportDataField.GPADeferredYearlyPlanAPP},
          GPADeferredYearlyPlanPPCGeneratorData = {type: reportDataField.GPADeferredYearlyPlanPPCGenerator},
          GPADeferredPPCPROData = {type: reportDataField.GPADeferredPPCPRO},
          // GPADeferredPPCPROGeneratorData = {type: reportDataField.GPADeferredPPCPROGenerator},
          GPADeferredTotalCostData = {type: reportDataField.GPADeferredTotalCost},
          GPADeferredYearlyPlanPayPalFeeData = {type: reportDataField.GPADeferredYearlyPlanPayPalFee},
          GPADeferredYearlyPlanAppFeeData = {type: reportDataField.GPADeferredYearlyPlanAppFee},
          GPADeferredYearlyPlanDiscountData = {type: reportDataField.GPADeferredYearlyPlanDiscount},
          GPADeferredPPCPROPayPalFeeData = {type: reportDataField.GPADeferredPPCPROPayPalFee},
          GPADeferredPPCPRODiscountData = {type: reportDataField.GPADeferredPPCPRODiscount},
          GPADeferredGrossProfitData = {type: reportDataField.GPADeferredGrossProfit},
          GPADeferredGrossProfitMoMData = {type: reportDataField.GPADeferredGrossProfitMoM},
          GPADeferredGrossProfitMarginData = {type: reportDataField.GPADeferredGrossProfitMargin},
          GPADeferredGrossProfitMarginMoMData = {type: reportDataField.GPADeferredGrossProfitMarginMoM};

    const PAYearlyPlanPurchaseData = {type: reportDataField.PAYearlyPlanPurchase},
          PAYearlyPlanPurchaseMoMData = {type: reportDataField.PAYearlyPlanPurchaseMoM},
          PAMonthlyRenewalRateData = {type: reportDataField.MonthlyRenewalRate},
          PATotalPlanRenewalRateData = {type: reportDataField.PATotalPlanRenewalRate},
          PAPlanRenewalRate_1to3Data = {type: reportDataField.PAPlanRenewalRate_1to3},
          PAPlanRenewalRate_4to20Data = {type: reportDataField.PAPlanRenewalRate_4to20},
          PAPlanRenewalRate_Over20Data = {type: reportDataField.PAPlanRenewalRate_GT20},
          PAPlanTransferRateData = {type: reportDataField.PAPlanTransferRate},
          PAConversionRateData = {type: reportDataField.PAConversionRate};

    const PPCPROAccountData = {type: reportDataField.PPCPROAccount},
          NPMUsageData = {type: reportDataField.NPMUsage},
          TotalCompanyNumberData = {type: reportDataField.TotalCompanyNumber},
          NPMUsageMoMData = {type: reportDataField.NPMUsageMoM},
          TotalNPMRemainingData = {type: reportDataField.TotalNPMRemaining},
          NPMPurchasedQuantityPrepaidData = {type: reportDataField.NPMPurchasedQuantityPrepaid},
          NPMPurchasedQuantityMonthlyData = {type: reportDataField.NPMPurchasedQuantityMonthly},
          TotalNPMPurchasedData = {type: reportDataField.TotalNPMPurchased},
          NPMPurchaseQuantityMoMData = {type: reportDataField.NPMPurchaseQuantityMoM},
          PPCPROIncomeData = {type: reportDataField.PPCPROIncome},
          PPCPRODiscountData = {type: reportDataField.PPCPRODiscount},
          PPCPROTotalData = {type: reportDataField.PPCPROTotal};

    const SubDevices_Level1NData = {type: reportDataField.SubDevices_Level1N},
          SubDevices_Level3NData = {type: reportDataField.SubDevices_Level3N},
          SubDevices_Level10NData = {type: reportDataField.SubDevices_Level10N},
          SubDevices_Level20NData = {type: reportDataField.SubDevices_Level20N},
          SubDevices_Level50NData = {type: reportDataField.SubDevices_Level50N},
          SubDevices_Level100NData = {type: reportDataField.SubDevices_Level100N},
          SubDevices_Level200NData = {type: reportDataField.SubDevices_Level200N},
          SubDevices_Level3AData = {type: reportDataField.SubDevices_Level500N},
          SubDevices_PROData = {type: reportDataField.SubDevices_Pro},
          SubDevices_TrialData = {type: reportDataField.SubDevices_Trial},
          SubDevices_RateData = {type: reportDataField.SubDevices_Rate};

    const SubAccounts_Level1NData = {type: reportDataField.SubAccounts_Level1N},
          SubAccounts_Level3NData = {type: reportDataField.SubAccounts_Level3N},
          SubAccounts_Level10NData = {type: reportDataField.SubAccounts_Level10N},
          SubAccounts_Level20NData = {type: reportDataField.SubAccounts_Level20N},
          SubAccounts_Level50NData = {type: reportDataField.SubAccounts_Level50N},
          SubAccounts_Level100NData = {type: reportDataField.SubAccounts_Level100N},
          SubAccounts_Level200NData = {type: reportDataField.SubAccounts_Level200N},
          SubAccounts_Level3AData = {type: reportDataField.SubAccounts_Level500N},
          SubAccounts_PROData = {type: reportDataField.SubAccounts_Pro},
          SubAccounts_TrialData = {type: reportDataField.SubAccounts_Trial},
          SubAccounts_RateData = {type: reportDataField.SubAccounts_Rate};

    const OrderTotalData = {type: reportDataField.Total}, InAppPurchaseData = {type: reportDataField.InAppPurchase},
          WebPurchaseData = {type: reportDataField.WebPurchase}, PPCLicenseGeneratorData = {type: reportDataField.PPCLicenseGenerator},
          OrderMOM = {type: reportDataField.OrderMOM}, OrderMOMPCT = {type: reportDataField.OrderMOMPCT},
          AccumulatedOrderData = {type: reportDataField.AccumulatedOrder};

    const Level1NData = {type: {value: reportDataField.Level1N}},
          Level3NData = {type: {value: reportDataField.Level3N}},
          Level10NData = {type: {value: reportDataField.Level10N}},
          Level20NData = {type: {value: reportDataField.Level20N}},
          Level50NData = {type: {value: reportDataField.Level50N}},
          Level100NData = {type: {value: reportDataField.Level100N}},
          Level3AData = {type: {value: reportDataField.Level500N}},
          Level200NData = {type: {value: reportDataField.Level200N}},
          Level5Data = {type: {value: reportDataField.Level1000N}},
          LevelTotalData = {type: reportDataField.Total},
          AccumulatedOrderLevelData = {type: reportDataField.AccumulatedOrder};

    const Level1NAmountData = {type: {value: reportDataField.Level1N}},
          Level3NAmountData = {type: {value: reportDataField.Level3N}},
          Level10NAmountData = {type: {value: reportDataField.Level10N}},
          Level20NAmountData = {type: {value: reportDataField.Level20N}},
          Level50NAmountData = {type: {value: reportDataField.Level50N}},
          Level100NAmountData = {type: {value: reportDataField.Level100N}},
          Level3AAmountData = {type: {value: reportDataField.Level500N}},
          Level200NAmountData = {type: {value: reportDataField.Level200N}},
          Level5AmountData = {type: {value: reportDataField.Level1000N}},
          MonthlyOrderAmountTotalOrder = {type: reportDataField.TotalOrder},
          MonthlyOrderAmountTotalDiscount = {type: reportDataField.TotalDiscount},
          MonthlyOrderAmountPPCPro = {type: reportDataField.TotalPPCPro},
          MonthlyOrderAmountTotalData = {type: reportDataField.TotalAmount};

    const Level1N_1Data = {type: {value: reportDataField.Level1N_1, price: Level1N_1_TitlePrice[0].Amount}},
          PreLevel1N_1Data = {type: {value: reportDataField.Level1N_1}},
          Level1N_2Data = {type: {value: reportDataField.Level1N_2, price: Level1N_2_TitlePrice[0].Amount}},
          PreLevel1N_2Data = {type: {value: reportDataField.Level1N_2}},
          Level1N_3Data = {type: {value: reportDataField.Level1N_3, price: Level1N_3_TitlePrice[0].Amount}},
          PreLevel1N_3Data = {type: {value: reportDataField.Level1N_3}},
          Level3N_1Data = {type: {value: reportDataField.Level3N_1, price: Level3N_1_TitlePrice[0].Amount}},
          PreLevel3N_1Data = {type: {value: reportDataField.Level3N_1}},
          Level3N_2Data = {type: {value: reportDataField.Level3N_2, price: Level3N_2_TitlePrice[0].Amount}},
          PreLevel3N_2Data = {type: {value: reportDataField.Level3N_2}},
          Level3N_3Data = {type: {value: reportDataField.Level3N_3, price: Level3N_3_TitlePrice[0].Amount}},
          PreLevel3N_3Data = {type: {value: reportDataField.Level3N_3}},
          Level10N_1Data = {type: {value: reportDataField.Level10N_1, price: Level10N_1_TitlePrice[0].Amount}},
          PreLevel10N_1Data = {type: {value: reportDataField.Level10N_1}},
          Level10N_2Data = {type: {value: reportDataField.Level10N_2, price: Level10N_2_TitlePrice[0].Amount}},
          PreLevel10N_2Data = {type: {value: reportDataField.Level10N_2}},
          Level10N_3Data = {type: {value: reportDataField.Level10N_3, price: Level10N_3_TitlePrice[0].Amount}},
          PreLevel10N_3Data = {type: {value: reportDataField.Level10N_3}},
          Level20N_1Data = {type: {value: reportDataField.Level20N_1, price: Level20N_1_TitlePrice[0].Amount}},
          PreLevel20N_1Data = {type: {value: reportDataField.Level20N_1}},
          Level20N_2Data = {type: {value: reportDataField.Level20N_2, price: Level20N_2_TitlePrice[0].Amount}},
          PreLevel20N_2Data = {type: {value: reportDataField.Level20N_2}},
          Level20N_3Data = {type: {value: reportDataField.Level20N_3, price: Level20N_3_TitlePrice[0].Amount}},
          PreLevel20N_3Data = {type: {value: reportDataField.Level20N_3}},
          Level50N_1Data = {type: {value: reportDataField.Level50N_1, price: Level50N_1_TitlePrice[0].Amount}},
          PreLevel50N_1Data = {type: {value: reportDataField.Level50N_1}},
          Level50N_2Data = {type: {value: reportDataField.Level50N_2, price: Level50N_2_TitlePrice[0].Amount}},
          PreLevel50N_2Data = {type: {value: reportDataField.Level50N_2}},
          Level50N_3Data = {type: {value: reportDataField.Level50N_3, price: Level50N_3_TitlePrice[0].Amount}},
          PreLevel50N_3Data = {type: {value: reportDataField.Level50N_3}},
          Level100N_1Data = {type: {value: reportDataField.Level100N_1, price: Level100N_1_TitlePrice[0].Amount}},
          PreLevel100N_1Data = {type: {value: reportDataField.Level100N_1}},
          Level100N_2Data = {type: {value: reportDataField.Level100N_2, price: Level100N_2_TitlePrice[0].Amount}},
          PreLevel100N_2Data = {type: {value: reportDataField.Level100N_2}},
          Level100N_3Data = {type: {value: reportDataField.Level100N_3, price: Level100N_3_TitlePrice[0].Amount}},
          PreLevel100N_3Data = {type: {value: reportDataField.Level100N_3}},
          Level3A_1Data = {type: {value: reportDataField.Level500N_1, price: Level3A_1_TitlePrice[0].Amount}},
          PreLevel3A_1Data = {type: {value: reportDataField.Level500N_1}},
          Level3A_2Data = {type: {value: reportDataField.Level500N_2, price: Level3A_2_TitlePrice[0].Amount}},
          PreLevel3A_2Data = {type: {value: reportDataField.Level500N_2}},
          Level3A_3Data = {type: {value: reportDataField.Level500N_3, price: Level3A_3_TitlePrice[0].Amount}},
          PreLevel3A_3Data = {type: {value: reportDataField.Level500N_3}},
          Level200N_1Data = {type: {value: reportDataField.Level200N_1, price: Level200N_1_TitlePrice[0].Amount}},
          PreLevel200N_1Data = {type: {value: reportDataField.Level200N_1}},
          Level200N_2Data = {type: {value: reportDataField.Level200N_2, price: Level200N_2_TitlePrice[0].Amount}},
          PreLevel200N_2Data = {type: {value: reportDataField.Level200N_2}},
          Level200N_3Data = {type: {value: reportDataField.Level200N_3, price: Level200N_3_TitlePrice[0].Amount}},
          PreLevel200N_3Data = {type: {value: reportDataField.Level200N_3}},
          Level5_1Data = {type: {value: reportDataField.Level1000N_1, price: Level5_1_TitlePrice[0].Amount}},
          PreLevel5_1Data = {type: {value: reportDataField.Level1000N_1}},
          LevelOfYearTotalData = {type: reportDataField.TotalOrder},
          LevelOfYearTotalDiscount = {type: reportDataField.TotalDiscount},
          LevelOfYearPPCPro = {type: reportDataField.TotalPPCPro},
          AccumulatedOrderLevelOfYearData = {type: reportDataField.TotalAmount};

    const AmountData = { type: reportDataField.Amount },
      AmountofPPCGenerator = { type: reportDataField.AmountofPPCGenerator },
      AmountMOM = { type: reportDataField.AmountMOM },
      AmountMOMPCT = { type: reportDataField.AmountMOMPCT },
      AmountTot = { type: reportDataField.AmountTotal },
      AmountDiscountTot = { type: reportDataField.AmountTotalDiscount },
      AmountOfPro = { type: reportDataField.AmountOfPPCPro },
      AccumulatedAmountData = { type: reportDataField.AccumulatedAmount };
    let NewConnectedTotal = 0,
      TrialActivationRateTotal = 0,
      RCCARD100Total = 0,
      RWCCARD100Total = 0,
      CloudUPSTotal = 0,
      CardTotal = 0,
      SoftwareTotal = 0,
      Activedevice14day_PPCTotal = 0,
      Activedevice14day_PROTotal = 0,
      PowerPanelPersonalTotal = 0,
      PowerPanelBusinessTotal = 0,
      SoftwareOthersTotal = 0,
      GatewayTotal = 0,
      GatewayUPSTotal = 0,
      GatewayPDUTotal = 0,
      GatewayATSTotal = 0,
      Gateway3phaseUPSTotal = 0,
      Gateway3rdPartysDevicesTotal = 0,
      GPAMonthlySalesIncomeTotal = 0,
      GPAYearlyPlanPayPalTotal = 0,
      GPAYearlyPlanAPPTotal = 0,
      GPAYearlyPlanPPCGeneratorTotal = 0,
      GPAPPCPROPayPalTotal = 0,
      GPAPPCPROGeneratorTotal = 0,
      GPATotalCostTotal = 0,
      GPAYearlyPlanPayPalFeeTotal = 0,
      GPAYearlyPlanAPPFeeTotal = 0,
      GPAYearlyPlanDiscountTotal = 0,
      GPAPPCPROPayPalFeeTotal = 0,
      GPARevenuePPCPRODiscountTotal = 0,
      GPAServerFeeTotal = 0,
      GPAGrossProfitTotal = 0,
      GPAGrossProfitMarginTotal = 0,
      GPADeferredYearlyPlanPayPalTotal = 0,
      GPADeferredYearlyPlanAPPTotal = 0,
      GPADeferredYearlyPlanPPCGeneratorTotal = 0,
      GPADeferredPPCPROTotal = 0,
      GPADeferredMonthlySalesIncomeTotal = 0,
      GPADeferredYearlyPlanPayPalFeeTotal = 0,
      GPADeferredYearlyPlanAppFeeTotal = 0,
      GPADeferredYearlyPlanDiscountTotal = 0,
      GPADeferredPPCPROPayPalFeeTotal = 0,
      GPADeferredPPCPRODiscountTotal = 0,
      GPADeferredTotalCostTotal = 0,
      GPADeferredGrossProfitTotal = 0,
      GPADeferredGrossProfitMarginTotal = 0,
      PAYearlyPlanPurchaseTotal = 0,
      PAMonthlyRenewalRateTotal = 0,
      PATotalPlanRenewalRateTotal = 0,
      PAPlanRenewalRate_1to3Total = 0,
      PAPlanRenewalRate_4to20Total = 0,
      PAPlanRenewalRate_Over20Total = 0,
      PAPlanTransferRateTotal = 0,
      PAConversionRateTotal = 0,
      SubDevicesTotal = 0,
      SubAccountsTotal = 0,

      AccumulatedDeviceTotal = 0,
      InAppPurchaseTotal = 0,
      WebPurchaseTotal = 0,
      PPCLicenseGeneratorTotal = 0,
      OrderTotal = 0,
      OrderCount = 0,
      preOrderCount = 0,
      beforepreOrderCount = 0,
      AmountPlanDiscountCount = 0,
      AmountPPCProCount = 0,
      preAmountPlanDiscountCount = 0,
      preAmountPPCProCount = 0,
      Level1NTotal = 0,
      Level3NTotal = 0,
      Level10NTotal = 0,
      Level20NTotal = 0,
      Level50NTotal = 0,
      Level100NTotal = 0,
      Level3ATotal = 0,
      Level200NTotal = 0,
      Level5Total = 0,
      Level1NAmountTotal = 0,
      Level3NAmountTotal = 0,
      Level10NAmountTotal = 0,
      Level20NAmountTotal = 0,
      Level50NAmountTotal = 0,
      Level100NAmountTotal = 0,
      Level3AAmountTotal = 0,
      Level200NAmountTotal = 0,
      Level5AmountTotal = 0,
      Level1N_1Total = 0,
      preLevel1N_1Total = 0,
      Level1N_2Total = 0,
      preLevel1N_2Total = 0,
      Level1N_3Total = 0,
      preLevel1N_3Total = 0,
      Level3N_1Total = 0,
      preLevel3N_1Total = 0,
      Level3N_2Total = 0,
      preLevel3N_2Total = 0,
      Level3N_3Total = 0,
      preLevel3N_3Total = 0,
      Level10N_1Total = 0,
      preLevel10N_1Total = 0,
      Level10N_2Total = 0,
      preLevel10N_2Total = 0,
      Level10N_3Total = 0,
      preLevel10N_3Total = 0,
      Level20N_1Total = 0,
      preLevel20N_1Total = 0,
      Level20N_2Total = 0,
      preLevel20N_2Total = 0,
      Level20N_3Total = 0,
      preLevel20N_3Total = 0,
      Level50N_1Total = 0,
      preLevel50N_1Total = 0,
      Level50N_2Total = 0,
      preLevel50N_2Total = 0,
      Level50N_3Total = 0,
      preLevel50N_3Total = 0,
      Level100N_1Total = 0,
      preLevel100N_1Total = 0,
      Level100N_2Total = 0,
      preLevel100N_2Total = 0,
      Level100N_3Total = 0,
      preLevel100N_3Total = 0,
      Level3A_1Total = 0,
      preLevel3A_1Total = 0,
      Level3A_2Total = 0,
      preLevel3A_2Total = 0,
      Level3A_3Total = 0,
      preLevel3A_3Total = 0,
      Level200N_1Total = 0,
      preLevel200N_1Total = 0,
      Level200N_2Total = 0,
      preLevel200N_2Total = 0,
      Level200N_3Total = 0,
      preLevel200N_3Total = 0,
      Level5_1Total = 0,
      preLevel5_1Total = 0,
      LevelOfYearCount = 0,
      preLevelOfYearCount = 0,
      LevelPriceOfYearCountTotal = 0,
      LevelPriceOfYearCount = 0,
      preLevelPriceOfYearCount = 0,
      MonthlyLevelPriceCount = 0,
      preMonthlyLevelPriceCount = 0,
      MonthlyLevelPriceCountTotal = 0,
      LevelCount = 0,
      preLevelCount = 0,
      LevelTotal = 0,
      LevelOfYearTotal = {value: 0 , PCT: 0},
      preLevelOfYearTotal = {value: 0 , PCT: 0},
      LevelOfYearPriceTotal = {value: 0 , PCT: 0},
      preLevelOfYearPriceTotal = {value: 0 , PCT: 0},
      Level1N_1Price = 0,
      PreLevel1N_1Price = 0,
      Level1N_2Price = 0,
      PreLevel1N_2Price = 0,
      Level1N_3Price = 0,
      PreLevel1N_3Price = 0,
      Level3N_1Price = 0,
      PreLevel3N_1Price = 0,
      Level3N_2Price = 0,
      PreLevel3N_2Price = 0,
      Level3N_3Price = 0,
      PreLevel3N_3Price = 0,
      Level10N_1Price = 0,
      PreLevel10N_1Price = 0,
      Level10N_2Price = 0,
      PreLevel10N_2Price = 0,
      Level10N_3Price = 0,
      PreLevel10N_3Price = 0,
      Level20N_1Price = 0,
      PreLevel20N_1Price = 0,
      Level20N_2Price = 0,
      PreLevel20N_2Price = 0,
      Level20N_3Price = 0,
      PreLevel20N_3Price = 0,
      Level50N_1Price = 0,
      PreLevel50N_1Price = 0,
      Level50N_2Price = 0,
      PreLevel50N_2Price = 0,
      Level50N_3Price = 0,
      PreLevel50N_3Price = 0,
      Level100N_1Price = 0,
      PreLevel100N_1Price = 0,
      Level100N_2Price = 0,
      PreLevel100N_2Price = 0,
      Level100N_3Price = 0,
      PreLevel100N_3Price = 0,
      Level3A_1Price = 0,
      PreLevel3A_1Price = 0,
      Level3A_2Price = 0,
      PreLevel3A_2Price = 0,
      Level3A_3Price = 0,
      PreLevel3A_3Price = 0,
      Level200N_1Price = 0,
      PreLevel200N_1Price = 0,
      Level200N_2Price = 0,
      PreLevel200N_2Price = 0,
      Level200N_3Price = 0,
      PreLevel200N_3Price = 0,
      Level5_1Price = 0,
      PreLevel5_1Price = 0,
      AmountTotal = 0,
      AmountDiscountTotal = 0,
      AmountPPCProTotal = 0,
      AmountAppWebTotal = 0,
      AmountPPCTotal = 0,
      AmountCount = 0,
      preAmountCount = 0,
      ActiveDeviceCount = 0,
      preActiveDeviceCount = 0,
      beforepreActiveDeviceCount = 0,
      LicensedDeviceCount = 0,
      preLicensedDeviceCount = 0,
      beforepreLicensedDeviceCount = 0,
      TrialLicensedDeviceCount = 0,
      preTrialLicensedDeviceCount = 0,
      beforepreTrialLicensedDeviceCount = 0,
      NewConnectedCount = 0,
      preNewConnectedCount = 0,
      beforepreNewConnectedCount = 0;
    let NewConnectedMOMTotal = 0,
      NewConnectedMOMPCTTotal = 0,
      OrderMOMTotal = 0,
      OrderMOMPCTTotal = 0,
      AmountMOMTotal = 0,
      AmountMOMPCTTotal = 0;
      // ActiveDeviceMOM = 0,
      // LicensedDeviceMOM = 0,
      // TrialLicensedDeviceMOM = 0;
    // Chart data
    const ChartLabel = [];
    const ActiveDeviceChart = {
      type: 'line',
      label: reportDataField.ActiveDevice,
      data: [],
      fill: false,
      borderColor: '#007ad9',
      backgroundColor: 'rgba(0, 122, 217, 0.3)'
    };
    const ActiveDeviceMOMChart = {
      label: reportDataField.ActiveDeviceMOM,
      data: [],
      fill: false,
      borderColor: '#af4bce',
      backgroundColor: 'rgba(175, 75, 206, 0.3)'
    };
    const ActiveDeviceLossAdditionChart = {
      type: 'bar',
      label: reportDataField.ActiveDeviceLossAddition,
      data: [],
      fill: false,
      borderColor: '#af4bce',
      backgroundColor: 'rgba(175, 75, 206, 0.3)',
      yAxisID: 'rightyAxisID'
    };
    const LicensedDeviceChart = {
      label: reportDataField.LicensedDevice,
      data: [],
      fill: false,
      borderColor: '#af4bce',
    };
    const LicensedDeviceMOMChart = {
      label: reportDataField.LicensedDeviceMOM,
      data: [],
      fill: false,
      borderColor: '#af4bce',
    };
    const TrialLicensedDeviceChart = {
      label: reportDataField.TrialLicensedDevice,
      data: [],
      fill: false,
      borderColor: '#78ac37',
    };
    const TrialLicensedDeviceMOMChart = {
      label: reportDataField.TrialLicensedDeviceMOM,
      data: [],
      fill: false,
      borderColor: '#78ac37',
    };
    const LicensedDevicePCTChart = {
      label: reportDataField.LicensedDevicePCT,
      data: [],
      fill: false,
      borderColor: '#f8a326',
      yAxisID: 'rightyAxisID',
    };
    //
    const RevenueGrossProfitChart = { label: reportDataField.GPAGrossProfit, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const RevenueGrossProfitMarginChart = { label: reportDataField.GPAGrossProfitMargin, data: [], fill: false, borderColor: '#af4bce', backgroundColor: 'rgba(175, 75, 206, 0.3)', yAxisID: 'rightyAxisID'};
    const DeferredGrossProfitChart = { label: reportDataField.GPADeferredGrossProfit, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const DeferredGrossProfitMarginChart = { label: reportDataField.GPADeferredGrossProfitMargin, data: [], fill: false, borderColor: '#af4bce', backgroundColor: 'rgba(175, 75, 206, 0.3)', yAxisID: 'rightyAxisID'};
    // const PATotalPlanRenewalRateChart = { label: reportDataField.PATotalPlanRenewalRate, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    // const PAPlanRenewalRate_1to3Chart = { label: reportDataField.PAPlanRenewalRate_1to3, data: [], fill: false, borderColor: '#af4bce', backgroundColor: 'rgba(175, 75, 206, 0.3)'};
    // const PAPlanRenewalRate_4to20Chart = { label: reportDataField.PAPlanRenewalRate_4to20, data: [], fill: false, borderColor: '#f8a326', backgroundColor: 'rgba(248, 163, 38, 0.3)'};
    // const PAPlanRenewalRate_Over20Chart = { label: reportDataField.PAPlanRenewalRate_GT20, data: [], fill: false, borderColor: '#afb42b', backgroundColor: 'rgba(175, 180, 43, 0.3)'};
    // const PAPlanTransferRateChart = { label: reportDataField.PAPlanTransferRate, data: [], fill: false, borderColor: '#ff5252', backgroundColor: 'rgba(255, 82, 82, 0.3)'};
    const PAMonthlyRenewalRateChart = { label: reportDataField.MonthlyRenewalRate, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const PAConversionChart = { label: reportDataField.PAConversionRate, data: [], fill: false, borderColor: '#af4bce', backgroundColor: 'rgba(175, 75, 206, 0.3)'};

    const NPMUsageChart = { label: reportDataField.NPMUsage, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const TotalCompanyNumberChart = { label: reportDataField.TotalCompanyNumber, data: [], fill: false, borderColor: '#af4bce', backgroundColor: 'rgba(175, 75, 206, 0.3)', yAxisID: 'rightyAxisID'};

    // Monthly Orders / Amount with years Char
    const TotalOrderChart = {
      label: reportDataField.TotalOrder + '(%)', data: [], fill: false, borderColor: '#f8a326', type: 'line', borderDash: [5, 5], yAxisID : 'rightyAxisID'};
    const TotalAmountChart = {
      label: reportDataField.TotalAmount + '(%)', data: [], fill: false, borderColor: '#f8a326', type: 'line', yAxisID : 'rightyAxisID'};

    const OrderAndAmountWithYearLevel1N_1Chart = {
      label: reportDataField.Level1N_1, data: [], backgroundColor: '#afb42b', borderColor: '#afb42b', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel1N_2Chart = {
      label: reportDataField.Level1N_2, data: [], backgroundColor: '#9e9d24', borderColor: '#9e9d24', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel1N_3Chart = {
      label: reportDataField.Level1N_3, data: [], backgroundColor: '#827717', borderColor: '#827717', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3N_1Chart = {
      label: reportDataField.Level3N_1, data: [], backgroundColor: '#81c784', borderColor: '#81c784', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3N_2Chart = {
      label: reportDataField.Level3N_2, data: [], backgroundColor: '#4caf50', borderColor: '#4caf50', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3N_3Chart = {
      label: reportDataField.Level3N_3, data: [], backgroundColor: '#388e3c', borderColor: '#388e3c', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel10N_1Chart = {
      label: reportDataField.Level10N_1, data: [], backgroundColor: '#4dd0e1', borderColor: '#4dd0e1', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel10N_2Chart = {
      label: reportDataField.Level10N_2, data: [], backgroundColor: '#00bcd4', borderColor: '#00bcd4', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel10N_3Chart = {
      label: reportDataField.Level10N_3, data: [], backgroundColor: '#0097a7', borderColor: '#0097a7', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel20N_1Chart = {
      label: reportDataField.Level20N_1, data: [], backgroundColor: '#64b5f6', borderColor: '#64b5f6', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel20N_2Chart = {
      label: reportDataField.Level20N_2, data: [], backgroundColor: '#2196f3', borderColor: '#2196f3', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel20N_3Chart = {
      label: reportDataField.Level20N_3, data: [], backgroundColor: '#1976d2', borderColor: '#1976d2', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel50N_1Chart = {
      label: reportDataField.Level50N_1, data: [], backgroundColor: '#ffb300', borderColor: '#ffb300', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel50N_2Chart = {
      label: reportDataField.Level50N_2, data: [], backgroundColor: '#ff8f00', borderColor: '#ff8f00', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel50N_3Chart = {
      label: reportDataField.Level50N_3, data: [], backgroundColor: '#ff6f00', borderColor: '#ff6f00', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel100N_1Chart = {
      label: reportDataField.Level100N_1, data: [], backgroundColor: '#ff5252', borderColor: '#ff5252', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel100N_2Chart = {
      label: reportDataField.Level100N_2, data: [], backgroundColor: '#ff1744', borderColor: '#ff1744', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel100N_3Chart = {
      label: reportDataField.Level100N_3, data: [], backgroundColor: '#d50000', borderColor: '#d50000', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3A_1Chart = {
      label: reportDataField.Level500N_1, data: [], backgroundColor: '#ba68c8', borderColor: '#ba68c8', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3A_2Chart = {
      label: reportDataField.Level500N_2, data: [], backgroundColor: '#9c27b0', borderColor: '#9c27b0', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel3A_3Chart = {
      label: reportDataField.Level500N_3, data: [], backgroundColor: '#7b1fa2', borderColor: '#7b1fa2', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel200N_1Chart = {
      label: reportDataField.Level200N_1, data: [], backgroundColor: '#f06292', borderColor: '#f06292', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel200N_2Chart = {
      label: reportDataField.Level200N_2, data: [], backgroundColor: '#e91e63', borderColor: '#e91e63', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel200N_3Chart = {
      label: reportDataField.Level200N_3, data: [], backgroundColor: '#c2185b', borderColor: '#c2185b', stack: 'Stack 0'};
    const OrderAndAmountWithYearLevel5_1Chart = {
      label: reportDataField.Level1000N_1, data: [], backgroundColor: '#651fff', borderColor: '#651fff', stack: 'Stack 0'};

    const NewConnectedChart = {
      label: reportDataField.NewConnected, data: [], fill: false, borderColor: '#f8a326', backgroundColor: 'rgba(248, 163, 38, 0.3)'};
    const DeviceMOMPCTChart = {label: reportDataField.MOMPCT, data: [], fill: false, borderColor: '#f8a326', type: 'line'
    , yAxisID: 'rightyAxisID'};

    const ActiveDeviceAdditionChart = {
      type: 'bar', label: reportDataField.ActiveDeviceAddition, data: [], fill: false, borderColor: '#f8a326', backgroundColor: 'rgba(248, 163, 38, 0.3)'};

    const OrderChart = {
      label: reportDataField.Order, data: [], fill: false, borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const OrderMOMPCTChart = {
      label: reportDataField.OrderMOMPCT, data: [], fill: false,
      borderColor: '#f8a326', type: 'line', yAxisID: 'rightyAxisID'};

    const AmountChart = {
      label: reportDataField.Amount, data: [], fill: false,
      borderColor: '#007ad9', backgroundColor: 'rgba(0, 122, 217, 0.3)'};
    const AmountMOMPCTChart = {label: reportDataField.AmountMOMPCT, data: [], fill: false, borderColor: '#f8a326', type: 'line'
      , yAxisID: 'rightyAxisID' };
    result.alertSettings_cols.forEach(cols => {
      const key = cols.field;
      const preKey = `${cols.preyear}/${cols.premonth}`;
      const beforePreKey = `${cols.beforepreyear}/${cols.beforepremonth}`;
      let item, itemA, itemB;
      // Device Analysis - Active Device
      ActiveDeviceCount = 0, preActiveDeviceCount = 0, beforepreActiveDeviceCount = 0;
      item = ActiveDeviceMap[key];
      // var data = { year:cols.year,month:cols.month,monthfield:monthMap[cols.month],value:((item) ? item.Value : '') };
      ActiveDeviceData[cols.year + '/' + cols.month] = ((item) ? item.Value : '-');
      ActiveDeviceChart.data.push(((item) ? item.Value : null));
      ActiveDeviceCount += ((item) ? item.Value : 0);
      const preActiveDeviceItem = ActiveDeviceMap[preKey];
      preActiveDeviceCount += ((preActiveDeviceItem) ? preActiveDeviceItem.Value : 0);
      const beforepreActiveDeviceItem = ActiveDeviceMap[beforePreKey];
      beforepreActiveDeviceCount += ((beforepreActiveDeviceItem) ? beforepreActiveDeviceItem.Value : 0);
      const ActiveDeviceDataMOMObject = {value: null, PCT: null};
      const ActiveDeviceMOM = ActiveDeviceCount - preActiveDeviceCount;
      const preActiveDeviceMOM = preActiveDeviceCount - beforepreActiveDeviceCount;
      ActiveDeviceDataMOMObject.value = (((ActiveDeviceCount === 0) || (preActiveDeviceCount === 0)) ?
        '-' : parseInt(((ActiveDeviceMOM) * 100).toFixed(), 10) / 100);
      ActiveDeviceDataMOMObject.PCT = (((ActiveDeviceCount === 0) || (preActiveDeviceCount === 0) ||
       (beforepreActiveDeviceCount === 0)) ?
       '-' : (Math.round(((ActiveDeviceMOM - preActiveDeviceMOM) / Math.abs(preActiveDeviceMOM)) * 1000) / 10));
      ActiveDeviceMOMChart.data.push(((item && item.Value && preActiveDeviceItem && preActiveDeviceItem.Value) ? ActiveDeviceMOM : null));
      ActiveDeviceDataMOM[cols.year + '/' + cols.month] = ActiveDeviceDataMOMObject;
      itemA = ActiveDeviceLossesMap[key];
      ActiveDeviceLossesData[cols.year + '/' + cols.month] = ((itemA) ? itemA.Value : '-');
      itemB = ActiveDeviceAdditionMap[key];
      ActiveDeviceAdditionData[cols.year + '/' + cols.month] = ((itemB) ? itemB.Value : '-');
      ActiveDeviceAdditionChart.data.push(((itemB) ? item.Value : null));
      let itemLossAddition = (itemA && itemB) ? ((itemB.Value !== 0) ? (Math.round((itemA.Value / itemB.Value) * 1000) / 10) : 0) : null;
      ActiveDeviceLossAdditionChart.data.push(itemLossAddition);
      item = TrialActivationRateMap[key];
      TrialActivationRateData[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      TrialActivationRateTotal += ((item) ? item.Value : 0);

      // Device Analysis - Licensed Device
      LicensedDeviceCount = 0, preLicensedDeviceCount = 0, beforepreLicensedDeviceCount = 0;
      item = LicensedDeviceMap[key];
      LicensedDeviceData[cols.year + '/' + cols.month] = ((item) ? item.Value : '-');
      LicensedDeviceChart.data.push(((item) ? item.Value : null));
      LicensedDeviceCount += ((item) ? item.Value : 0);
      const preLicensedDeviceItem = LicensedDeviceMap[preKey];
      preLicensedDeviceCount += ((preLicensedDeviceItem) ? preLicensedDeviceItem.Value : 0);
      const beforepreLicensedDeviceItem = LicensedDeviceMap[beforePreKey];
      beforepreLicensedDeviceCount += ((beforepreLicensedDeviceItem) ? beforepreLicensedDeviceItem.Value : 0);
      const LicensedDeviceDataMOMObject = {value: null, PCT: null};
      const LicensedDeviceMOM = LicensedDeviceCount - preLicensedDeviceCount;
      const preLicensedDeviceMOM = preLicensedDeviceCount - beforepreLicensedDeviceCount;
      LicensedDeviceDataMOMObject.value = (((LicensedDeviceCount === 0) || (preLicensedDeviceCount === 0)) ?
        '-' : parseInt(((LicensedDeviceMOM) * 100).toFixed(), 10) / 100);
      LicensedDeviceDataMOMObject.PCT = (((LicensedDeviceCount === 0) || (preLicensedDeviceCount === 0) ||
       (beforepreLicensedDeviceCount === 0)) ?
       '-' : (Math.round(((LicensedDeviceMOM - preLicensedDeviceMOM) / Math.abs(preLicensedDeviceMOM)) * 1000) / 10));
      LicensedDeviceDataMOM[cols.year + '/' + cols.month] = LicensedDeviceDataMOMObject;

      // Device Analysis - Trial Licensed Device
      TrialLicensedDeviceCount = 0, preTrialLicensedDeviceCount = 0, beforepreTrialLicensedDeviceCount = 0;
      item = TrialLicensedDeviceMap[key];
      TrialLicensedDeviceData[cols.year + '/' + cols.month] = ((item) ? item.Value : '-');
      TrialLicensedDeviceChart.data.push(((item) ? item.Value : null));
      TrialLicensedDeviceCount += ((item) ? item.Value : 0);
      const preTrialLicensedDeviceItem = TrialLicensedDeviceMap[preKey];
      preTrialLicensedDeviceCount += ((preTrialLicensedDeviceItem) ? preTrialLicensedDeviceItem.Value : 0);
      const beforepreTrialLicensedDeviceItem = TrialLicensedDeviceMap[beforePreKey];
      beforepreTrialLicensedDeviceCount += ((beforepreTrialLicensedDeviceItem) ? beforepreTrialLicensedDeviceItem.Value : 0);
      const TrialLicensedDeviceMOM = TrialLicensedDeviceCount - preTrialLicensedDeviceCount;
      const preTrialLicensedDeviceMOM = preTrialLicensedDeviceCount - beforepreTrialLicensedDeviceCount;
      const TrialLicensedDeviceDataMOMObject = {MOM: null, MOMPCT: null};
      TrialLicensedDeviceDataMOMObject.MOM = (((TrialLicensedDeviceCount === 0) || (preTrialLicensedDeviceCount === 0)) ?
        '-' : parseInt(((TrialLicensedDeviceMOM) * 100).toFixed(), 10) / 100);
      TrialLicensedDeviceDataMOMObject.MOMPCT = (((TrialLicensedDeviceCount === 0) || (preTrialLicensedDeviceCount === 0) ||
       (beforepreTrialLicensedDeviceCount === 0)) ?
       '-' : (Math.round(((TrialLicensedDeviceMOM - preTrialLicensedDeviceMOM) / Math.abs(preTrialLicensedDeviceMOM)) * 1000) / 10));
      TrialLicensedDeviceDataMOM[cols.year + '/' + cols.month] = TrialLicensedDeviceDataMOMObject;

      // Device Analysis - Licensed Device (%)
      const LicensedDeviceItem = LicensedDeviceData[cols.year + '/' + cols.month];
      const ActiveDeviceItem = ActiveDeviceData[cols.year + '/' + cols.month];
      LicensedDevicePCTData[cols.year + '/' + cols.month] = (LicensedDeviceItem !== '-' && ActiveDeviceItem !== '-') ?
      (Math.round((LicensedDeviceItem / ActiveDeviceItem) * 1000) / 10) : '-';
      LicensedDevicePCTChart.data.push(
        (LicensedDevicePCTData[cols.year + '/' + cols.month] === '-') ? null : LicensedDevicePCTData[cols.year + '/' + cols.month]);

      // Device Analysis - Chart
      ChartLabel.push(cols.header);
    });

    result.total_cols.forEach(cols => {
      const key = cols.field;
      const preKey = `${cols.preyear}/${cols.premonth}`;
      const beforePreKey = `${cols.beforepreyear}/${cols.beforepremonth}`;
      let item, itemValue, preitem, preitemValue, beforepreitem, beforepreitemValue, calValue, calValueMOM;
      let itemA, itemB, preitemA, preitemB, beforepreitemA, beforepreitemB, calValueA, calpreValueA, calbeforepreValueA;

      // Monthly Sales Revenue
      let MonthlySalesIncome = 0, preMonthlySalesIncome = 0, beforepreMonthlySalesIncome = 0;
      let GPATotalCost = 0, preGPATotalCost = 0, beforepreGPATotalCost = 0;
      let GPAPPCPROCount = 0, preGPAPPCPROCount = 0;
      // Deferred Data
      let DeferredMonthlySalesIncome = 0, preDeferredMonthlySalesIncome = 0, beforepreDeferredMonthlySalesIncome = 0;
      let GPADeferredTotalCost = 0, preGPADeferredTotalCost = 0, beforepreGPADeferredTotalCost = 0;
      // Monthly Sales Revenue - Yearly Plan (Discount)
      let GPAYearlyPlanDiscountCount = 0, preGPAYearlyPlanDiscountCount = 0;
      // Deferred PPC PRO
      let GPADeferredPPCPROCount = 0, preGPADeferredPPCPROCount = 0;
      // Deferred PPC PRO (Discount)
      let GPADeferredPPCPRODiscountCount = 0, preGPADeferredPPCPRODiscountCount = 0;

      // Device Analysis - New Connected
      // Monthly Increase of Devices - New Connected
      item = NewConnectedMap[key];
      const NewConnectedValue = (item) ? item.Value : 0;
      NewConnectedTotal += NewConnectedValue;
      NewConnectedData[cols.year + '/' + cols.month] = ((item) ? item.Value : '-');
      NewConnectedChart.data.push(((item) ? item.Value : null));
      AccumulatedDeviceTotal += NewConnectedValue;
      AccumulatedDeviceData[cols.year + '/' + cols.month] = AccumulatedDeviceTotal;
      // Monthly Increase of Devices - Devices MOM & Devices MOM(%)
      preitem = NewConnectedMap[preKey];
      beforepreitem = NewConnectedMap[beforePreKey];
      itemValue = ((item) ? item.Value : 0);
      preitemValue = ((preitem) ? preitem.Value : 0);
      beforepreitemValue = ((beforepreitem) ? beforepreitem.Value : 0);
      const NewConnectedDataMOMObject = {value: null, PCT: null};
      calValueMOM = itemValue - preitemValue;
      NewConnectedDataMOMObject.value = ((itemValue !== 0 && preitemValue !== 0) ? calValueMOM : '-');
      NewConnectedMOMTotal += calValueMOM;
      NewConnectedDataMOMObject.PCT = ((preitem && item && preitem.Value !== 0 && item.Value !== 0) ?
        (Math.round(((item.Value - preitem.Value) / preitem.Value) * 1000) / 10) : '-');
      NewConnectedMOMPCTTotal += ((preitem && item && preitem.Value !== 0 && item.Value !== 0) ?
        (Math.round(((item.Value - preitem.Value) / preitem.Value) * 1000) / 10) : 0);
      NewConnectedMoMData[cols.year + '/' + cols.month] = NewConnectedDataMOMObject;

      // Monthly Increase of Devices - RCCARD100
      item = RCCARD100Map[key];
      RCCARD100Total += ((item) ? item.Value : 0);
      RCCARD100Data[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - RWCCARD100
      item = RWCCARD100Map[key];
      RWCCARD100Total += ((item) ? item.Value : 0);
      RWCCARD100Data[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - RCCARD100EMB - Cloud UPS
      item = CloudUPSMap[key];
      CloudUPSTotal += ((item) ? item.Value : 0);
      CloudUPSData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Card
      item = CardMap[key];
      CardTotal += ((item) ? item.Value : 0);
      CardData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Software
      item = SoftwareMap[key];
      SoftwareTotal += ((item) ? item.Value : 0);
      SoftwareData[cols.year + '/' + cols.month] = ((item) ? item.Value : '-');

      // Monthly Increase of Devices - Active device 14-days (PPC), Active device 14-days (PRO)
      itemA = ActiveDevice14DaysPPCMap[key];
      itemB = ActiveDevice14DaysPROMap[key];
      calValue = ((itemA) ? itemA.Value : 0) + ((itemB) ? itemB.Value : 0);
      Activedevice14day_PPCTotal += ((itemA) ? itemA.Value : 0);
      ActiveDevice14DaysPPCData[cols.year + '/' + cols.month] = { value:(itemA ? itemA.Value : '-'), PCT: (itemA ? ((calValue === 0) ? 0 : (Math.round(((itemA ? itemA.Value : 0) / calValue) * 1000) / 10)) : '-') };
      Activedevice14day_PROTotal += ((itemB) ? itemB.Value : 0);
      ActiveDevice14DaysPROData[cols.year + '/' + cols.month] = { value:(itemB ? itemB.Value : '-'), PCT: (itemA ? ((calValue === 0) ? 0 : (Math.round(((itemB ? itemB.Value : 0) / calValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - PowerPanel Personal
      item = PowerPanelPersonalMap[key];
      PowerPanelPersonalTotal += ((item) ? item.Value : 0);
      PowerPanelPersonalData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };
      
      // Monthly Increase of Devices - PowerPanel Business
      item = PowerPanelBusinessMap[key];
      PowerPanelBusinessTotal += ((item) ? item.Value : 0);
      PowerPanelBusinessData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };
      
      // Monthly Increase of Devices - Software Others
      item = SoftwareOthersMap[key];
      SoftwareOthersTotal += ((item) ? item.Value : 0);
      SoftwareOthersData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway
      item = GatewayMap[key];
      GatewayTotal += ((item) ? item.Value : 0);
      GatewayData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway UPS
      item = GatewayUPSMap[key];
      GatewayUPSTotal += ((item) ? item.Value : 0);
      GatewayUPSData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway PDU
      item = GatewayPDUMap[key];
      GatewayPDUTotal += ((item) ? item.Value : 0);
      GatewayPDUData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway ATS
      item = GatewayATSMap[key];
      GatewayATSTotal += ((item) ? item.Value : 0);
      GatewayATSData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway 3 phase UPS
      item = Gateway3phaseUPSMap[key];
      Gateway3phaseUPSTotal += ((item) ? item.Value : 0);
      Gateway3phaseUPSData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };

      // Monthly Increase of Devices - Gateway 3-Party's Devices
      item = Gateway3rdPartysMap[key];
      Gateway3rdPartysDevicesTotal += ((item) ? item.Value : 0);
      Gateway3rdPartysDevicesData[cols.year + '/' + cols.month] = { value:((item) ? item.Value : '-'), PCT: ((item) ? ((NewConnectedValue === 0) ? 0 : (Math.round(((item ? item.Value : 0) / NewConnectedValue) * 1000) / 10)) : '-') };
      
      // Monthly Sales Revenue - Yearly Plan PayPal
      item = YearlyPlanPayPalMap[key];
      preitem = YearlyPlanPayPalMap[preKey];
      beforepreitem = YearlyPlanPayPalMap[beforePreKey];
      GPAYearlyPlanPayPalData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanPayPalTotal += ((item) ? item.Value : 0);
      MonthlySalesIncome += ((item) ? item.Value : 0);
      preMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - Yearly Plan App
      item = YearlyPlanAppMap[key];
      preitem = YearlyPlanAppMap[preKey];
      beforepreitem = YearlyPlanAppMap[beforePreKey];
      GPAYearlyPlanAPPData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanAPPTotal += ((item) ? item.Value : 0);
      MonthlySalesIncome += ((item) ? item.Value : 0);
      preMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - Yearly Plan PPC Generator
      item = YearlyPlanPPCGeneratorMap[key];
      preitem = YearlyPlanPPCGeneratorMap[preKey];
      beforepreitem = YearlyPlanPPCGeneratorMap[beforePreKey];
      GPAYearlyPlanPPCGeneratorData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanPPCGeneratorTotal += ((item) ? item.Value : 0);
      MonthlySalesIncome += ((item) ? item.Value : 0);
      preMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);
      // Monthly Sales Revenue - PPC PRO (PayPal)
      itemA = PPCPROPayPalMap[key];
      preitemA = PPCPROPayPalMap[preKey];
      beforepreitem = PPCPROPayPalMap[beforePreKey];
      GPAPPCPROPayPalData[cols.year + '/' + cols.month] = ((itemA) ? formatMathroundValue(itemA.Value) : '-');
      GPAPPCPROPayPalTotal += ((itemA) ? itemA.Value : 0);
      MonthlySalesIncome += ((itemA) ? itemA.Value : 0);
      preMonthlySalesIncome += ((preitemA) ? preitemA.Value : 0);
      beforepreMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - PPC PRO (Generator)
      itemB = PPCPROGeneratorMap[key];
      preitemB = PPCPROGeneratorMap[preKey];
      beforepreitem = PPCPROGeneratorMap[beforePreKey];
      GPAPPCPROGeneratorData[cols.year + '/' + cols.month] = ((itemB) ? formatMathroundValue(itemB.Value) : '-');
      GPAPPCPROGeneratorTotal += ((itemB) ? itemB.Value : 0);
      MonthlySalesIncome += ((itemB) ? itemB.Value : 0);
      preMonthlySalesIncome += ((preitemB) ? preitemB.Value : 0);
      beforepreMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);
      GPAPPCPROData[cols.year + '/' + cols.month] = (itemA || itemB) ? formatMathroundValue((itemA ? itemA.Value : 0) + (itemB ? itemB.Value : 0)) : '-';
      calValueA = ((itemA) ? itemA.Value : 0) + ((itemB) ? itemB.Value : 0);
      calpreValueA = ((preitemA) ? preitemA.Value : 0) + ((preitemB) ? preitemB.Value : 0);
      GPAPPCPROCount += calValueA;
      preGPAPPCPROCount += calpreValueA;
      const PPCProPCT = (Math.round(((calValueA - calpreValueA) / calpreValueA) * 1000) / 10);
      MonthlyOrderAmountPPCPro[cols.year + '/' + cols.month] = {
        value: formatMathroundValue(calValueA),
        PCT: !isNaN(PPCProPCT) ? (PPCProPCT !== Infinity ? PPCProPCT : 100) : 0,
      };

      // Monthly Sales Revenue - Monthly Sales Income
      GPAMonthlySalesIncomeData[cols.year + '/' + cols.month] = formatMathroundValue(MonthlySalesIncome);
      GPAMonthlySalesIncomeTotal += MonthlySalesIncome;

      // Monthly Sales Revenue - Yearly Plan (PayPal Fee)
      item = YearlyPlanPayPalFeeMap[key];
      preitem = YearlyPlanPayPalFeeMap[preKey];
      beforepreitem = YearlyPlanPayPalFeeMap[beforePreKey];
      GPAYearlyPlanPayPalFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanPayPalFeeTotal += ((item) ? item.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - Yearly Plan (APP fee)
      item = YearlyPlanAppFeeMap[key];
      preitem = YearlyPlanAppFeeMap[preKey];
      beforepreitem = YearlyPlanAppFeeMap[beforePreKey];
      GPAYearlyPlanAPPFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanAPPFeeTotal += ((item) ? item.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - Yearly Plan (Discount)
      item = YearlyPlanDiscountMap[key];
      preitem = YearlyPlanDiscountMap[preKey];
      beforepreitem = YearlyPlanDiscountMap[beforePreKey];
      GPAYearlyPlanDiscountData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAYearlyPlanDiscountTotal += ((item) ? item.Value : 0);
      GPAYearlyPlanDiscountCount += ((item) ? item.Value : 0);
      preGPAYearlyPlanDiscountCount += ((preitem) ? preitem.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - PPC PRO (PayPal Fee)
      item = PPCPROPayPalFeeMap[key];
      preitem = PPCPROPayPalFeeMap[preKey];
      beforepreitem = PPCPROPayPalFeeMap[beforePreKey];
      GPAPPCPROPayPalFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAPPCPROPayPalFeeTotal += ((item) ? item.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - PPC PRO (Discount)
      item = PPCPRODiscountMap[key];
      preitem = PPCPRODiscountMap[preKey];
      beforepreitem = PPCPRODiscountMap[beforePreKey];
      GPARevenuePPCPRODiscountData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPARevenuePPCPRODiscountTotal += ((item) ? item.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenus - Server Fee
      item = ServerFeeMap[key];
      preitem = ServerFeeMap[preKey];
      beforepreitem = ServerFeeMap[beforePreKey];
      GPAServerFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPAServerFeeTotal += ((item) ? item.Value : 0);
      GPATotalCost += ((item) ? item.Value : 0);
      preGPATotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPATotalCost += ((beforepreitem) ? beforepreitem.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Monthly Sales Revenue - Total Cost
      GPATotalCostData[cols.year + '/' + cols.month] = formatMathroundValue(GPATotalCost);
      GPATotalCostTotal += GPATotalCost;

      // Monthly Sales Revenue - Gross Profit
      const GPAGrossProfitMoMObject = {value: null, PCT: null};
      calValue = MonthlySalesIncome - GPATotalCost;
      GPAGrossProfitData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      GPAGrossProfitTotal += calValue;
      RevenueGrossProfitChart.data.push(calValue);
      itemValue = MonthlySalesIncome - GPATotalCost;
      preitemValue = preMonthlySalesIncome - preGPATotalCost;
      beforepreitemValue = beforepreMonthlySalesIncome - beforepreGPATotalCost;
      calValue = itemValue - preitemValue;
      GPAGrossProfitMoMObject.value = formatMathroundValue(calValue);
      calValue = ((preMonthlySalesIncome - preGPATotalCost) !== 0) ? (Math.round((((MonthlySalesIncome - GPATotalCost) - (preMonthlySalesIncome - preGPATotalCost)) / (preMonthlySalesIncome - preGPATotalCost)) * 1000) / 10) : 0;
      GPAGrossProfitMoMObject.PCT = formatMathroundValue(calValue);
      GPAGrossProfitMoMData[cols.year + '/' + cols.month] = GPAGrossProfitMoMObject;

      // Monthly Sales Revenue - Gross Profit Margin
      // const GPAGrossProfitMarginMoMObject = {value: null, PCT: null};
      calValue = (MonthlySalesIncome !== 0) ? (Math.round(((MonthlySalesIncome - GPATotalCost) / MonthlySalesIncome) * 1000) / 10) : 0;
      GPAGrossProfitMarginData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      GPAGrossProfitMarginTotal += calValue;
      RevenueGrossProfitMarginChart.data.push(calValue);
      itemValue = ((MonthlySalesIncome !== 0) ? (Math.round(((MonthlySalesIncome - GPATotalCost) / MonthlySalesIncome) * 1000) / 10) : 0);
      preitemValue = ((preMonthlySalesIncome !== 0) ? (Math.round(((preMonthlySalesIncome - preGPATotalCost) / preMonthlySalesIncome) * 1000) / 10) : 0)
      // beforepreitemValue = ((beforepreMonthlySalesIncome !== 0) ? (Math.round(((beforepreMonthlySalesIncome - beforepreGPATotalCost) / beforepreMonthlySalesIncome) * 1000) / 10) : 0);
      calValue = itemValue - preitemValue;
      GPAGrossProfitMarginMoMData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      // GPAGrossProfitMarginMoMObject.value = formatMathroundValue(calValue);
      // calValue = ((preitemValue - beforepreitemValue) !== 0) ? (Math.round((((itemValue - preitemValue) - (preitemValue - beforepreitemValue)) / Math.abs(preitemValue - beforepreitemValue)) * 1000) / 10) : 0;
      // GPAGrossProfitMarginMoMObject.PCT = formatMathroundValue(calValue);
      // GPAGrossProfitMarginMoMData[cols.year + '/' + cols.month] = GPAGrossProfitMarginMoMObject;

      // Deferred Yearly Plan (PayPal)
      item = DeferredYearlyPlanPayPalMap[key];
      preitem = DeferredYearlyPlanPayPalMap[preKey];
      beforepreitem = DeferredYearlyPlanPayPalMap[beforePreKey];
      GPADeferredYearlyPlanPayPalData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanPayPalTotal += ((item) ? item.Value : 0);
      DeferredMonthlySalesIncome += ((item) ? item.Value : 0);
      preDeferredMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreDeferredMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Yearly Plan (APP)
      item = DeferredYearlyPlanAppMap[key];
      preitem = DeferredYearlyPlanAppMap[preKey];
      beforepreitem = DeferredYearlyPlanAppMap[beforePreKey];
      GPADeferredYearlyPlanAPPData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanAPPTotal += ((item) ? item.Value : 0);
      DeferredMonthlySalesIncome += ((item) ? item.Value : 0);
      preDeferredMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreDeferredMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Yearly Plan (PPC Generator)
      item = DeferredYearlyPlanPPCGeneratorMap[key];
      preitem = DeferredYearlyPlanPPCGeneratorMap[preKey];
      beforepreitem = DeferredYearlyPlanPPCGeneratorMap[beforePreKey];
      GPADeferredYearlyPlanPPCGeneratorData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanPPCGeneratorTotal += ((item) ? item.Value : 0);
      DeferredMonthlySalesIncome += ((item) ? item.Value : 0);
      preDeferredMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreDeferredMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred PPC PRO
      item = DeferredPPCPROMap[key];
      preitem = DeferredPPCPROMap[preKey];
      beforepreitem = DeferredPPCPROMap[beforePreKey];
      GPADeferredPPCPROData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredPPCPROTotal += ((item) ? item.Value : 0);
      GPADeferredPPCPROCount += ((item) ? item.Value : 0);
      preGPADeferredPPCPROCount += ((preitem) ? preitem.Value : 0);
      DeferredMonthlySalesIncome += ((item) ? item.Value : 0);
      preDeferredMonthlySalesIncome += ((preitem) ? preitem.Value : 0);
      beforepreDeferredMonthlySalesIncome += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Monthly Sales Income
      GPADeferredMonthlySalesIncomeData[cols.year + '/' + cols.month] = formatMathroundValue(DeferredMonthlySalesIncome);
      GPADeferredMonthlySalesIncomeTotal += DeferredMonthlySalesIncome;

      // Deferred Yearly Plan (PayPal Fee)
      item = DeferredYearlyPlanPayPalFeeMap[key];
      preitem = DeferredYearlyPlanPayPalFeeMap[preKey];
      beforepreitem = DeferredYearlyPlanPayPalFeeMap[beforePreKey];
      GPADeferredYearlyPlanPayPalFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanPayPalFeeTotal += ((item) ? item.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Yearly Plan (App Fee)
      item = DeferredYearlyPlanAppFeeMap[key];
      preitem = DeferredYearlyPlanAppFeeMap[preKey];
      beforepreitem = DeferredYearlyPlanAppFeeMap[beforePreKey];
      GPADeferredYearlyPlanAppFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanAppFeeTotal += ((item) ? item.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Yearly Plan (Discount)
      item = DeferredYearlyPlanDiscountMap[key];
      preitem = DeferredYearlyPlanDiscountMap[preKey];
      beforepreitem = DeferredYearlyPlanDiscountMap[beforePreKey];
      GPADeferredYearlyPlanDiscountData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredYearlyPlanDiscountTotal += ((item) ? item.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);
      
      // Deferred PPC PRO (PayPal Fee)
      item = DeferredPPCPROPayPalFeeMap[key];
      preitem = DeferredPPCPROPayPalFeeMap[preKey];
      beforepreitem = DeferredPPCPROPayPalFeeMap[beforePreKey];
      GPADeferredPPCPROPayPalFeeData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredPPCPROPayPalFeeTotal += ((item) ? item.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);
      
      // Deferred PPC PRO (Discount)
      item = DeferredPPCPRODiscountMap[key];
      preitem = DeferredPPCPRODiscountMap[preKey];
      beforepreitem = DeferredPPCPRODiscountMap[beforePreKey];
      GPADeferredPPCPRODiscountData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      GPADeferredPPCPRODiscountTotal += ((item) ? item.Value : 0);
      GPADeferredPPCPRODiscountCount += ((item) ? item.Value : 0);
      preGPADeferredPPCPRODiscountCount += ((preitem) ? preitem.Value : 0);
      GPADeferredTotalCost += ((item) ? item.Value : 0);
      preGPADeferredTotalCost += ((preitem) ? preitem.Value : 0);
      beforepreGPADeferredTotalCost += ((beforepreitem) ? beforepreitem.Value : 0);

      // Deferred Total Cost
      GPADeferredTotalCostData[cols.year + '/' + cols.month] = formatMathroundValue(GPADeferredTotalCost);
      GPADeferredTotalCostTotal += GPADeferredTotalCost;

      // Gross Profit
      const GPADeferredGrossProfitMoMObject = {value: null, PCT: null};
      calValue = DeferredMonthlySalesIncome - GPADeferredTotalCost;
      GPADeferredGrossProfitData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      GPADeferredGrossProfitTotal += calValue;
      DeferredGrossProfitChart.data.push(calValue);
      itemValue = DeferredMonthlySalesIncome - GPADeferredTotalCost;
      preitemValue = preDeferredMonthlySalesIncome - preGPADeferredTotalCost;
      beforepreitemValue = beforepreDeferredMonthlySalesIncome - beforepreGPADeferredTotalCost;
      calValue = itemValue - preitemValue;
      GPADeferredGrossProfitMoMObject.value = formatMathroundValue(calValue);
      calValue = ((preDeferredMonthlySalesIncome - preGPADeferredTotalCost) !== 0) ? (Math.round((((DeferredMonthlySalesIncome - GPADeferredTotalCost) - (preDeferredMonthlySalesIncome - preGPADeferredTotalCost)) / (preDeferredMonthlySalesIncome - preGPADeferredTotalCost)) * 1000) / 10) : 0;
      GPADeferredGrossProfitMoMObject.PCT = formatMathroundValue(calValue);
      GPADeferredGrossProfitMoMData[cols.year + '/' + cols.month] = GPADeferredGrossProfitMoMObject;

      // Gross Profit Margin
      // const GPADeferredGrossProfitMarginMoMObject = {value: null, PCT: null};
      calValue = (DeferredMonthlySalesIncome !== 0) ? (Math.round(((DeferredMonthlySalesIncome - GPADeferredTotalCost) / DeferredMonthlySalesIncome) * 1000) / 10) : 0;
      GPADeferredGrossProfitMarginData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      GPADeferredGrossProfitMarginTotal += calValue;
      DeferredGrossProfitMarginChart.data.push(calValue);
      itemValue = ((DeferredMonthlySalesIncome !== 0) ? (Math.round(((DeferredMonthlySalesIncome - GPADeferredTotalCost) / DeferredMonthlySalesIncome) * 1000) / 10) : 0);
      preitemValue = ((preDeferredMonthlySalesIncome !== 0) ? (Math.round(((preDeferredMonthlySalesIncome - preGPADeferredTotalCost) / preDeferredMonthlySalesIncome) * 1000) / 10) : 0);
      // beforepreitemValue = ((beforepreDeferredMonthlySalesIncome !== 0) ? (Math.round(((beforepreDeferredMonthlySalesIncome - beforepreGPADeferredTotalCost) / beforepreDeferredMonthlySalesIncome) * 1000) / 10) : 0);
      calValue = itemValue - preitemValue;
      GPADeferredGrossProfitMarginMoMData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);
      // GPADeferredGrossProfitMarginMoMObject.value = formatMathroundValue(calValue);
      // calValue = ((preitemValue - beforepreitemValue) !== 0) ? (Math.round((((itemValue - preitemValue) - (preitemValue - beforepreitemValue)) / Math.abs(preitemValue - beforepreitemValue)) * 1000) / 10) : 0;
      // GPADeferredGrossProfitMarginMoMObject.PCT = formatMathroundValue(calValue);

      item = PAMonthlyRenewalRateMap[key];
      PAMonthlyRenewalRateData[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAMonthlyRenewalRateTotal += ((item) ? item.Value : 0);
      PAMonthlyRenewalRateChart.data.push(((item) ? item.Value : null));

      item = PATotalPlanRenewalRateMap[key];
      PATotalPlanRenewalRateData[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PATotalPlanRenewalRateTotal += ((item) ? item.Value : 0);
      // PATotalPlanRenewalRateChart.data.push(((item) ? item.Value : null));

      item = PAPlanRenewalRate_1to3Map[key];
      PAPlanRenewalRate_1to3Data[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAPlanRenewalRate_1to3Total += ((item) ? item.Value : 0);
      // PAPlanRenewalRate_1to3Chart.data.push(((item) ? item.Value : null));

      item = PAPlanRenewalRate_4to20Map[key];
      PAPlanRenewalRate_4to20Data[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAPlanRenewalRate_4to20Total += ((item) ? item.Value : 0);
      // PAPlanRenewalRate_4to20Chart.data.push(((item) ? item.Value : null));

      item = PAPlanRenewalRate_Over20Map[key];
      PAPlanRenewalRate_Over20Data[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAPlanRenewalRate_Over20Total += ((item) ? item.Value : 0);
      // PAPlanRenewalRate_Over20Chart.data.push(((item) ? item.Value : null));

      item = PAPlanTransferRateMap[key];
      PAPlanTransferRateData[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAPlanTransferRateTotal += ((item) ? item.Value : 0);
      // PAPlanTransferRateChart.data.push(((item) ? item.Value : null));
      
      item = PAConversionRateMap[key];
      PAConversionRateData[cols.year + '/' + cols.month] = ((item) ? ((Math.round(item.Value * 10000) / 100).toFixed(2)) : '-');
      PAConversionRateTotal += ((item) ? item.Value : 0);
      PAConversionChart.data.push(((item) ? item.Value : null));

      // Subscription Devices
      SubDevicesTotal = 0;
      item = SubDevices_Level1NMap[key];
      SubDevices_Level1NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level3NMap[key];
      SubDevices_Level3NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level10NMap[key];
      SubDevices_Level10NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level20NMap[key];
      SubDevices_Level20NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level50NMap[key];
      SubDevices_Level50NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level100NMap[key];
      SubDevices_Level100NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level200NMap[key];
      SubDevices_Level200NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_Level3AMap[key];
      SubDevices_Level3AData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_PROMap[key];
      SubDevices_PROData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      item = SubDevices_TrialMap[key];
      SubDevices_TrialData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubDevicesTotal += ((item) ? item.Value : 0);
      calValue = (SubDevicesTotal !== 0) ? (Math.round(((SubDevicesTotal - ((item) ? item.Value : 0)) / SubDevicesTotal) * 1000) / 10) : 0;
      SubDevices_RateData[cols.year + '/' + cols.month] = calValue;
      
      SubDevices_Level1NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level1NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level1NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level1NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level3NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level3NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level3NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level3NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level10NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level10NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level10NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level10NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level20NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level20NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level20NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level20NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level50NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level50NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level50NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level50NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level100NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level100NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level100NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level100NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level200NData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level200NData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level200NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level200NData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_Level3AData[cols.year + '/' + cols.month].PCT =
        (SubDevices_Level3AData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_Level3AData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_Level3AData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_PROData[cols.year + '/' + cols.month].PCT =
        (SubDevices_PROData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_PROData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_PROData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);
      SubDevices_TrialData[cols.year + '/' + cols.month].PCT =
        (SubDevices_TrialData[cols.year + '/' + cols.month].PCT === '-' || SubDevices_TrialData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubDevices_TrialData[cols.year + '/' + cols.month].PCT) / SubDevicesTotal) * 1000) / 10);

      // Subscription Accounts
      SubAccountsTotal = 0;
      item = SubAccounts_Level1NMap[key];
      SubAccounts_Level1NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level3NMap[key];
      SubAccounts_Level3NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level10NMap[key];
      SubAccounts_Level10NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level20NMap[key];
      SubAccounts_Level20NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level50NMap[key];
      SubAccounts_Level50NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level100NMap[key];
      SubAccounts_Level100NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level200NMap[key];
      SubAccounts_Level200NData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_Level3AMap[key];
      SubAccounts_Level3AData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_PROMap[key];
      SubAccounts_PROData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      item = SubAccounts_TrialMap[key];
      SubAccounts_TrialData[cols.year + '/' + cols.month] = {value: ((item) ? formatMathroundValue(item.Value) : '-'), PCT: ((item) ? item.Value : '-')};
      SubAccountsTotal += ((item) ? item.Value : 0);
      calValue = (SubAccountsTotal !== 0) ? (Math.round(((SubAccountsTotal - ((item) ? item.Value : 0)) / SubAccountsTotal) * 1000) / 10) : 0;
      SubAccounts_RateData[cols.year + '/' + cols.month] = calValue;

      SubAccounts_Level1NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level1NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level1NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level1NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level3NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level3NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level3NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level3NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level10NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level10NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level10NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level10NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level20NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level20NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level20NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level20NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level50NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level50NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level50NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level50NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level100NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level100NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level100NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level100NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level200NData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level200NData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level200NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level200NData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_Level3AData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_Level3AData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_Level3AData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_Level3AData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_PROData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_PROData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_PROData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_PROData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);
      SubAccounts_TrialData[cols.year + '/' + cols.month].PCT =
        (SubAccounts_TrialData[cols.year + '/' + cols.month].PCT === '-' || SubAccounts_TrialData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((SubAccounts_TrialData[cols.year + '/' + cols.month].PCT) / SubAccountsTotal) * 1000) / 10);

      // Monthly Purchase Order - In-App Purchase
      OrderCount = 0, preOrderCount = 0, beforepreOrderCount = 0;
      item = InAppPurchaseMap[key];
      InAppPurchaseTotal += ((item) ? item.Value : 0);
      OrderCount += ((item) ? item.Value : 0);
      InAppPurchaseData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      // Monthly Purchase Order - Web Purchase
      item = WebPurchaseMap[key];
      WebPurchaseTotal += ((item) ? item.Value : 0);
      OrderCount += ((item) ? item.Value : 0);
      WebPurchaseData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      // Monthly Purchase Order - PPC License Generator
      item = PPCLicenseGeneratorMap[key];
      PPCLicenseGeneratorTotal += ((item) ? item.Value : 0);
      OrderCount += ((item) ? item.Value : 0);
      PPCLicenseGeneratorData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      // Monthly Purchase Order - Order
      OrderTotal += OrderCount;
      OrderTotalData[cols.year + '/' + cols.month] = formatMathroundValue(OrderCount);
      OrderChart.data.push(((OrderCount !== 0) ? OrderCount : null));
      // Monthly Purchase Order - Order MOM & Order MOM(%)
      preitem = InAppPurchaseMap[preKey];
      preOrderCount += ((preitem) ? preitem.Value : 0);
      preitem = WebPurchaseMap[preKey];
      preOrderCount += ((preitem) ? preitem.Value : 0);
      preitem = PPCLicenseGeneratorMap[preKey];
      preOrderCount += ((preitem) ? preitem.Value : 0);
      beforepreitem = InAppPurchaseMap[beforePreKey];
      beforepreOrderCount += ((beforepreitem) ? beforepreitem.Value : 0);
      beforepreitem = WebPurchaseMap[beforePreKey];
      beforepreOrderCount += ((beforepreitem) ? beforepreitem.Value : 0);
      beforepreitem = PPCLicenseGeneratorMap[beforePreKey];
      beforepreOrderCount += ((beforepreitem) ? beforepreitem.Value : 0);
      OrderMOM[cols.year + '/' + cols.month] = ((OrderCount !== 0 && preOrderCount !== 0) ?
        formatMathroundValue(OrderCount - preOrderCount) : '-');
      OrderMOMTotal += ((OrderCount !== 0 && preOrderCount !== 0) ? (OrderCount - preOrderCount) : 0);
      OrderMOMPCT[cols.year + '/' + cols.month] = ((preOrderCount !== 0) ?
        (Math.round(((OrderCount - preOrderCount) / preOrderCount) * 1000) / 10) : '-');
      OrderMOMPCTTotal += ((OrderCount !== 0 && preOrderCount !== 0) ?
       (Math.round(((OrderCount - preOrderCount) / preOrderCount) * 1000) / 10) : 0);
      OrderMOMPCTChart.data.push(((preOrderCount !== 0) ?
       (Math.round(((OrderCount - preOrderCount) / preOrderCount) * 1000) / 10) : null));
      // Monthly Purchase Order - Accumulated Order
      AccumulatedOrderData[cols.year + '/' + cols.month] = formatMathroundValue(OrderTotal);
      
      // Yearly Plan Purchase MoM
      PAYearlyPlanPurchaseData[cols.year + '/' + cols.month] = formatMathroundValue(OrderCount);
      PAYearlyPlanPurchaseTotal += OrderCount;
      calValue = OrderCount - preOrderCount;
      const PAYearlyPlanPurchaseMoMObject = {value: null, PCT: null};
      PAYearlyPlanPurchaseMoMObject.value = formatMathroundValue(calValue);
      calValue = ((preOrderCount !== 0) ? (Math.round(((OrderCount - preOrderCount) / preOrderCount) * 1000) / 10) : 0);
      PAYearlyPlanPurchaseMoMObject.PCT = formatMathroundValue(calValue);
      PAYearlyPlanPurchaseMoMData[cols.year + '/' + cols.month] = PAYearlyPlanPurchaseMoMObject;

      //Monthly Purchase Order - PRO
      const NPMUsageMoMObject = {value: null, PCT: null};
      const NPMPurchaseQuantityMoMObject = {value: null, PCT: null};
      item = PO_PPCPROAccountMap[key];
      PPCPROAccountData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      item = PO_TotalCompanyNumberMap[key];
      TotalCompanyNumberData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      TotalCompanyNumberChart.data.push(((item) ? item.Value : null));
      item = PO_NPMUsageMap[key];
      preitem = PO_NPMUsageMap[preKey];
      beforepreitem = PO_NPMUsageMap[beforePreKey];
      NPMUsageData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      NPMUsageChart.data.push(((item) ? item.Value : null));
      itemValue = ((item) ? item.Value : 0);
      preitemValue = ((preitem) ? preitem.Value : 0);
      beforepreitemValue = ((beforepreitem) ? beforepreitem.Value : 0);
      calValue = itemValue - preitemValue;
      NPMUsageMoMObject.value = formatMathroundValue(calValue);
      calValue = ((preitemValue !== 0) ? (Math.round(((itemValue - preitemValue) / preitemValue) * 1000) / 10) : 0);
      NPMUsageMoMObject.PCT = formatMathroundValue(calValue);
      NPMUsageMoMData[cols.year + '/' + cols.month] = NPMUsageMoMObject;
      item = PO_TotalNPMRemainingMap[key];
      TotalNPMRemainingData[cols.year + '/' + cols.month] = ((item) ? formatMathroundValue(item.Value) : '-');
      itemA = PO_NPMPurchasedQuantityPrepaidMap[key];
      preitemA = PO_NPMPurchasedQuantityPrepaidMap[preKey];
      beforepreitemA = PO_NPMPurchasedQuantityPrepaidMap[beforePreKey];
      NPMPurchasedQuantityPrepaidData[cols.year + '/' + cols.month] = ((itemA) ? formatMathroundValue(itemA.Value) : '-');
      itemB = PO_NPMPurchasedQuantityMonthlyMap[key];
      preitemB = PO_NPMPurchasedQuantityMonthlyMap[preKey];
      beforepreitemB = PO_NPMPurchasedQuantityMonthlyMap[beforePreKey];
      NPMPurchasedQuantityMonthlyData[cols.year + '/' + cols.month] = ((itemB) ? formatMathroundValue(itemB.Value) : '-');
      calValueA = ((itemA) ? itemA.Value : 0) + ((itemB) ? itemB.Value : 0);
      calpreValueA = ((preitemA) ? preitemA.Value : 0) + ((preitemB) ? preitemB.Value : 0);
      calbeforepreValueA = ((beforepreitemA) ? beforepreitemA.Value : 0) + ((beforepreitemB) ? beforepreitemB.Value : 0);
      TotalNPMPurchasedData[cols.year + '/' + cols.month] = formatMathroundValue(calValueA);
      calValue = calValueA - calpreValueA;
      NPMPurchaseQuantityMoMObject.value = formatMathroundValue(calValue);
      calValue = (calpreValueA !== 0) ? (Math.round(((calValueA - calpreValueA) / calpreValueA) * 1000) / 10) : 0;
      NPMPurchaseQuantityMoMObject.PCT = formatMathroundValue(calValue);
      NPMPurchaseQuantityMoMData[cols.year + '/' + cols.month] = NPMPurchaseQuantityMoMObject;
      itemA = PO_PPCPROIncomeMap[key];
      PPCPROIncomeData[cols.year + '/' + cols.month] = ((itemA) ? formatMathroundValue(itemA.Value) : '-');
      itemB = PO_PPCPRODiscountMap[key];
      PPCPRODiscountData[cols.year + '/' + cols.month] = ((itemB) ? formatMathroundValue(itemB.Value) : '-');
      calValue = ((itemA) ? itemA.Value : 0) - ((itemB) ? itemB.Value : 0);
      PPCPROTotalData[cols.year + '/' + cols.month] = formatMathroundValue(calValue);

      // Monthly Order Amount - Revenue
      AmountCount = 0, preAmountCount = 0;
      const itemApp = AmountAppMap[key];
      AmountTotal += ((itemApp) ? itemApp.Value : 0);
      AmountAppWebTotal += ((itemApp) ? itemApp.Value : 0);
      AmountCount += ((itemApp) ? itemApp.Value : 0);
      const itemWeb = AmountWebMap[key];
      AmountTotal += ((itemWeb) ? itemWeb.Value : 0);
      AmountAppWebTotal += ((itemWeb) ? itemWeb.Value : 0);
      AmountCount += ((itemWeb) ? itemWeb.Value : 0);
      AmountData[cols.year + '/' + cols.month] = ((AmountCount !== 0) ? formatMathroundValue(AmountCount) : '-');
      const itemPPC = AmountPPCLicenseGeneratorMap[key];
      AmountofPPCGenerator[cols.year + '/' + cols.month] = ((itemPPC) ? formatMathroundValue(itemPPC.Value) : '-');
      AmountTotal += ((itemPPC) ? itemPPC.Value : 0);
      AmountPPCTotal += ((itemPPC) ? itemPPC.Value : 0);
      AmountCount += ((itemPPC) ? itemPPC.Value : 0);

      // ProIncome
      const itemPPCPro = AmountPPCProMap[key];
      preitem = AmountPPCProMap[preKey];
      AmountOfPro[cols.year + '/' + cols.month] = ((itemPPCPro && itemPPCPro.Value !== 0) ? formatMathroundValue(itemPPCPro.Value) : '-');
      AmountTotal += ((itemPPCPro) ? itemPPCPro.Value : 0);
      preAmountPPCProCount = ((preitem) ? preitem.Value : 0);
      AmountPPCProCount = ((itemPPCPro) ? itemPPCPro.Value : 0);
      AmountPPCProTotal += ((itemPPCPro) ? itemPPCPro.Value : 0);
      AmountCount += ((itemPPCPro) ? itemPPCPro.Value : 0);

      // Plan Discount
      const itemPlanDiscount = AmountPlanDiscountMap[key];
      preitem = AmountPlanDiscountMap[preKey];
      AmountDiscountTot[cols.year + '/' + cols.month] = ((itemPlanDiscount && itemPlanDiscount.Value !== 0) ? formatMathroundValue(itemPlanDiscount.Value) : '-');
      AmountTotal -= (itemPlanDiscount) ? itemPlanDiscount.Value : 0;
      preAmountPlanDiscountCount = ((preitem) ? preitem.Value : 0);
      AmountPlanDiscountCount = ((itemPlanDiscount) ? itemPlanDiscount.Value : 0);
      AmountDiscountTotal += (itemPlanDiscount) ? itemPlanDiscount.Value : 0;
      AmountCount -= (itemPlanDiscount) ? itemPlanDiscount.Value : 0;

      AmountChart.data.push(((AmountCount !== 0) ? AmountCount : '-'));
      AmountTot[cols.year + '/' + cols.month] = ((AmountCount !== 0) ? formatMathroundValue(AmountCount) : '-');

      // Monthly Order Amount - Revenue MOM & Revenue MOM(%)
      const preitemApp = AmountAppMap[preKey];
      preAmountCount += ((preitemApp) ? preitemApp.Value : 0);
      const preitemWeb = AmountWebMap[preKey];
      preAmountCount += ((preitemWeb) ? preitemWeb.Value : 0);
      const preitemPPC = AmountPPCLicenseGeneratorMap[preKey];
      preAmountCount += ((preitemPPC) ? preitemPPC.Value : 0);
      const preitemProIncome = AmountPPCProMap[preKey];
      preAmountCount += ((preitemProIncome) ? preitemProIncome.Value : 0);
      const preitemDiscount = AmountPlanDiscountMap[preKey];
      preAmountCount -= ((preitemDiscount) ? preitemDiscount.Value : 0);
      AmountMOM[cols.year + '/' + cols.month] = (((AmountCount === 0) || (preAmountCount === 0)) ?
        '-' : parseInt(((AmountCount - preAmountCount) * 100).toFixed(), 10) / 100);
      AmountMOMTotal += ((preAmountCount !== 0 && AmountCount !== 0) ?
        parseInt(((AmountCount - preAmountCount) * 100).toFixed(), 10) / 100 : 0);
      AmountMOMPCT[cols.year + '/' + cols.month] = (((AmountCount === 0) || (preAmountCount === 0)) ?
        '-' : parseInt(((Math.round(((AmountCount - preAmountCount) / preAmountCount) * 1000) / 10) * 100).toFixed(), 10) / 100);
      AmountMOMPCTTotal += (((AmountCount === 0) || (preAmountCount === 0)) ?
        0 : parseInt(((Math.round(((AmountCount - preAmountCount) / preAmountCount) * 1000) / 10) * 100).toFixed(), 10) / 100);
      AmountMOMPCTChart.data.push((((AmountCount === 0) || (preAmountCount === 0)) ?
        null : (Math.round(((AmountCount - preAmountCount) / preAmountCount) * 1000) / 10)));
      AccumulatedAmountData[cols.year + '/' + cols.month] = formatMathroundValue(AmountTotal);

      // Monthly Orders of Level, Monthly Order Amount
      LevelCount = 0;
      preLevelCount = 0;
      MonthlyLevelPriceCount = 0;
      preMonthlyLevelPriceCount = 0;

      // Level1N
      itemA = Level1NMap[key];
      preitemA = Level1NMap[preKey];
      Level1NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level1NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level1N_PriceMap[key];
      preitemB = Level1N_PriceMap[preKey];
      Level1NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level1NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level3N
      itemA = Level3NMap[key];
      preitemA = Level3NMap[preKey];
      Level3NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level3NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level3N_PriceMap[key];
      preitemB = Level3N_PriceMap[preKey];
      Level3NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level3NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level10N
      itemA = Level10NMap[key];
      preitemA = Level10NMap[preKey];
      Level10NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level10NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level10N_PriceMap[key];
      preitemB = Level10N_PriceMap[preKey];
      Level10NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level10NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level20N
      itemA = Level20NMap[key];
      preitemA = Level20NMap[preKey];
      Level20NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level20NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level20N_PriceMap[key];
      preitemB = Level20N_PriceMap[preKey];
      Level20NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level20NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level50N
      itemA = Level50NMap[key];
      preitemA = Level50NMap[preKey];
      Level50NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level50NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level50N_PriceMap[key];
      preitemB = Level50N_PriceMap[preKey];
      Level50NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level50NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level100N
      itemA = Level100NMap[key];
      preitemA = Level100NMap[preKey];
      Level100NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level100NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level100N_PriceMap[key];
      preitemB = Level100N_PriceMap[preKey];
      Level100NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level100NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Level3A
      itemA = Level3AMap[key];
      preitemA = Level3AMap[preKey];
      Level3ATotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level3AData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level3A_PriceMap[key];
      preitemB = Level3A_PriceMap[preKey];
      Level3AAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level3AAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Leve200N
      itemA = Level200NMap[key];
      preitemA = Level200NMap[preKey];
      Level200NTotal += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level200NData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level200N_PriceMap[key];
      preitemB = Level200N_PriceMap[preKey];
      Level200NAmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level200NAmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);

      // Leve5
      itemA = Level5Map[key];
      preitemA = Level5Map[preKey];
      Level5Total += ((itemA) ? itemA.Value : 0);
      LevelCount += ((itemA) ? itemA.Value : 0);
      preLevelCount += ((preitemA) ? preitemA.Value : 0);
      Level5Data[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-')};
      itemB = Level5_PriceMap[key];
      preitemB = Level5_PriceMap[preKey];
      Level5AmountData[cols.year + '/' + cols.month] = {value: ((itemA) ? formatMathroundValue(itemA.Value) : '-'), PCT: ((itemA) ? itemA.Value : '-'), price: ((itemB) ? itemB.Value : 0)};
      Level5AmountTotal += ((itemB) ? itemB.Value : 0);
      MonthlyLevelPriceCount += ((itemB) ? itemB.Value : 0);
      preMonthlyLevelPriceCount += ((preitemB) ? preitemB.Value : 0);
      MonthlyLevelPriceCountTotal += MonthlyLevelPriceCount;

      // Total and Accumulated Order
      LevelTotalData[cols.year + '/' + cols.month] = formatMathroundValue(LevelCount);
      Level1NData[cols.year + '/' + cols.month].PCT =
        (Level1NData[cols.year + '/' + cols.month].PCT === '-' || Level1NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level1NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level3NData[cols.year + '/' + cols.month].PCT =
        (Level3NData[cols.year + '/' + cols.month].PCT === '-' || Level3NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level3NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level10NData[cols.year + '/' + cols.month].PCT =
        (Level10NData[cols.year + '/' + cols.month].PCT === '-' || Level10NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level10NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level20NData[cols.year + '/' + cols.month].PCT =
        (Level20NData[cols.year + '/' + cols.month].PCT === '-' || Level20NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level20NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level50NData[cols.year + '/' + cols.month].PCT =
        (Level50NData[cols.year + '/' + cols.month].PCT === '-' || Level50NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level50NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level100NData[cols.year + '/' + cols.month].PCT =
        (Level100NData[cols.year + '/' + cols.month].PCT === '-' || Level100NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level100NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level3AData[cols.year + '/' + cols.month].PCT =
        (Level3AData[cols.year + '/' + cols.month].PCT === '-' || Level3AData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level3AData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level200NData[cols.year + '/' + cols.month].PCT =
        (Level200NData[cols.year + '/' + cols.month].PCT === '-' || Level200NData[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level200NData[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      Level5Data[cols.year + '/' + cols.month].PCT =
        (Level5Data[cols.year + '/' + cols.month].PCT === '-' || Level5Data[cols.year + '/' + cols.month].PCT === 0) ?
        0 : (Math.round(((Level5Data[cols.year + '/' + cols.month].PCT) / LevelCount) * 1000) / 10);
      LevelTotal += LevelCount;
      AccumulatedOrderLevelData[cols.year + '/' + cols.month] = formatMathroundValue(LevelTotal);
      Level1NAmountData[cols.year + '/' + cols.month].PCT =
        (Level1NAmountData[cols.year + '/' + cols.month].price === '-' || Level1NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level1NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level3NAmountData[cols.year + '/' + cols.month].PCT =
        (Level3NAmountData[cols.year + '/' + cols.month].price === '-' || Level3NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level3NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level10NAmountData[cols.year + '/' + cols.month].PCT =
        (Level10NAmountData[cols.year + '/' + cols.month].price === '-' || Level10NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level10NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level20NAmountData[cols.year + '/' + cols.month].PCT =
        (Level20NAmountData[cols.year + '/' + cols.month].price === '-' || Level20NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level20NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level50NAmountData[cols.year + '/' + cols.month].PCT =
        (Level50NAmountData[cols.year + '/' + cols.month].price === '-' || Level50NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level50NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level100NAmountData[cols.year + '/' + cols.month].PCT =
        (Level100NAmountData[cols.year + '/' + cols.month].price === '-' || Level100NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level100NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level3AAmountData[cols.year + '/' + cols.month].PCT =
        (Level3AAmountData[cols.year + '/' + cols.month].price === '-' || Level3AAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level3AAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level200NAmountData[cols.year + '/' + cols.month].PCT =
        (Level200NAmountData[cols.year + '/' + cols.month].price === '-' || Level200NAmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level200NAmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      Level5AmountData[cols.year + '/' + cols.month].PCT =
        (Level5AmountData[cols.year + '/' + cols.month].price === '-' || Level5AmountData[cols.year + '/' + cols.month].price === 0) ?
        0 : (Math.round(((Level5AmountData[cols.year + '/' + cols.month].price) / MonthlyLevelPriceCount) * 1000) / 10);
      const MonthlyOrderAmountTotalOrderPCT = (Math.round(((LevelCount - preLevelCount) / preLevelCount) * 1000) / 10);
      MonthlyOrderAmountTotalOrder[cols.year + '/' + cols.month] = {
        value: formatMathroundValue(LevelCount),
        PCT: !isNaN(MonthlyOrderAmountTotalOrderPCT) ? (MonthlyOrderAmountTotalOrderPCT !== Infinity ? MonthlyOrderAmountTotalOrderPCT : 100) : 0,
        price: formatMathroundValue(MonthlyLevelPriceCount)
      };
      
      const TotalDiscount = GPAYearlyPlanDiscountCount + GPADeferredPPCPRODiscountCount;
      const preTotalDiscount = preGPAYearlyPlanDiscountCount + preGPADeferredPPCPRODiscountCount;
      const TotalDiscountPCT = (Math.round(((TotalDiscount - preTotalDiscount) / preTotalDiscount) * 1000) / 10);
      MonthlyOrderAmountTotalDiscount[cols.year + '/' + cols.month] = {
        value: formatMathroundValue(TotalDiscount),
        PCT: !isNaN(TotalDiscountPCT) ? (TotalDiscountPCT !== Infinity ? TotalDiscountPCT : 100) : 0,
      };
      const MonthlyOrderAmountTotalAmount = (MonthlyLevelPriceCount + GPAPPCPROCount);
      const preMonthlyOrderAmountTotalAmount = (preMonthlyLevelPriceCount + preGPAPPCPROCount);
      const MonthlyOrderAmountTotalPCT = (Math.round(((MonthlyOrderAmountTotalAmount - preMonthlyOrderAmountTotalAmount) / Math.abs(preMonthlyOrderAmountTotalAmount)) * 1000) / 10);
      const MonthlyOrderAmountTotal = {
        value: MonthlyOrderAmountTotalAmount.toFixed(1),
        PCT: !isNaN(MonthlyOrderAmountTotalPCT) ? (MonthlyOrderAmountTotalPCT === Infinity ? 100 : MonthlyOrderAmountTotalPCT === -Infinity ? -100 : MonthlyOrderAmountTotalPCT) : 0,
      };
      MonthlyOrderAmountTotalData[cols.year + '/' + cols.month] = MonthlyOrderAmountTotal;

      LevelOfYearCount = 0;
      preLevelOfYearCount = 0;
      LevelPriceOfYearCount = 0;
      preLevelPriceOfYearCount = 0;
      let preLevelitem = Level1N_1Map[preKey];
      item = Level1N_1Map[key];
      let price_item = Level1N_1_PriceMap[key];
      let prePrice_item = Level1N_1_PriceMap[preKey];
      preLevel1N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level1N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel1N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel1N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel1N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level1N-2
      preLevelitem = Level1N_2Map[preKey];
      item = Level1N_2Map[key];
      price_item = Level1N_2_PriceMap[key];
      prePrice_item = Level1N_2_PriceMap[preKey];
      preLevel1N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level1N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel1N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel1N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel1N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level1N-3
      preLevelitem = Level1N_3Map[preKey];
      item = Level1N_3Map[key];
      price_item = Level1N_3_PriceMap[key];
      prePrice_item = Level1N_3_PriceMap[preKey];
      preLevel1N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level1N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel1N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level1N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel1N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel1N_3Chart.data.push(((item) ? item.Value : 0));

      preLevelitem = Level3N_1Map[preKey];
      item = Level3N_1Map[key];
      price_item = Level3N_1_PriceMap[key];
      prePrice_item = Level3N_1_PriceMap[preKey];
      preLevel3N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel3N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level3N-2
      preLevelitem = Level3N_2Map[preKey];
      item = Level3N_2Map[key];
      price_item = Level3N_2_PriceMap[key];
      prePrice_item = Level3N_2_PriceMap[preKey];
      preLevel3N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel3N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level3N-3
      preLevelitem = Level3N_3Map[preKey];
      item = Level3N_3Map[key];
      price_item = Level3N_3_PriceMap[key];
      prePrice_item = Level3N_3_PriceMap[preKey];
      preLevel3N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel3N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level10N-1
      preLevelitem = Level10N_1Map[preKey];
      item = Level10N_1Map[key];
      price_item = Level10N_1_PriceMap[key];
      prePrice_item = Level10N_1_PriceMap[preKey];
      preLevel10N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level10N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel10N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel10N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel10N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level10N-2
      preLevelitem = Level10N_2Map[preKey];
      item = Level10N_2Map[key];
      price_item = Level10N_2_PriceMap[key];
      prePrice_item = Level10N_2_PriceMap[preKey];
      preLevel10N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level10N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel10N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel10N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel10N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level10N-3
      preLevelitem = Level10N_3Map[preKey];
      item = Level10N_3Map[key];
      price_item = Level10N_3_PriceMap[key];
      prePrice_item = Level10N_3_PriceMap[preKey];
      preLevel10N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level10N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel10N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level10N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel10N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel10N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level20N-1
      preLevelitem = Level20N_1Map[preKey];
      item = Level20N_1Map[key];
      price_item = Level20N_1_PriceMap[key];
      prePrice_item = Level20N_1_PriceMap[preKey];
      preLevel20N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level20N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel20N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel20N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel20N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level20N-2
      preLevelitem = Level20N_2Map[preKey];
      item = Level20N_2Map[key];
      price_item = Level20N_2_PriceMap[key];
      prePrice_item = Level20N_2_PriceMap[preKey];
      preLevel20N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level20N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel20N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel20N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel20N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level20N-3
      preLevelitem = Level20N_3Map[preKey];
      item = Level20N_3Map[key];
      price_item = Level20N_3_PriceMap[key];
      prePrice_item = Level20N_3_PriceMap[preKey];
      preLevel20N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level20N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel20N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level20N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel20N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel20N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level50N-1
      preLevelitem = Level50N_1Map[preKey];
      item = Level50N_1Map[key];
      price_item = Level50N_1_PriceMap[key];
      prePrice_item = Level50N_1_PriceMap[preKey];
      preLevel50N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level50N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel50N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel50N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel50N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level50N-2
      preLevelitem = Level50N_2Map[preKey];
      item = Level50N_2Map[key];
      price_item = Level50N_2_PriceMap[key];
      prePrice_item = Level50N_2_PriceMap[preKey];
      preLevel50N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level50N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel50N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel50N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel50N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level50N-3
      preLevelitem = Level50N_3Map[preKey];
      item = Level50N_3Map[key];
      price_item = Level50N_3_PriceMap[key];
      prePrice_item = Level50N_3_PriceMap[preKey];
      preLevel50N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level50N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel50N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level50N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel50N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel50N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level100N-1
      preLevelitem = Level100N_1Map[preKey];
      item = Level100N_1Map[key];
      price_item = Level100N_1_PriceMap[key];
      prePrice_item = Level100N_1_PriceMap[preKey];
      preLevel100N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level100N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel100N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel100N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel100N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level100N-2
      preLevelitem = Level100N_2Map[preKey];
      item = Level100N_2Map[key];
      price_item = Level100N_2_PriceMap[key];
      prePrice_item = Level100N_2_PriceMap[preKey];
      preLevel100N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level100N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel100N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel100N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel100N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level100N-3
      preLevelitem = Level100N_3Map[preKey];
      item = Level100N_3Map[key];
      price_item = Level100N_3_PriceMap[key];
      prePrice_item = Level100N_3_PriceMap[preKey];
      preLevel100N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level100N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel100N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level100N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel100N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel100N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level3A-1
      preLevelitem = Level3A_1Map[preKey];
      item = Level3A_1Map[key];
      price_item = Level3A_1_PriceMap[key];
      prePrice_item = Level3A_1_PriceMap[preKey];
      preLevel3A_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3A_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel3A_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3A_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3A_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level3-2A
      preLevelitem = Level3A_2Map[preKey];
      item = Level3A_2Map[key];
      price_item = Level3A_2_PriceMap[key];
      prePrice_item = Level3A_2_PriceMap[preKey];
      preLevel3A_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3A_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel3A_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3A_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3A_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level3A-3
      preLevelitem = Level3A_3Map[preKey];
      item = Level3A_3Map[key];
      price_item = Level3A_3_PriceMap[key];
      prePrice_item = Level3A_3_PriceMap[preKey];
      preLevel3A_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level3A_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel3A_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level3A_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel3A_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel3A_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level200N-1
      preLevelitem = Level200N_1Map[preKey];
      item = Level200N_1Map[key];
      price_item = Level200N_1_PriceMap[key];
      prePrice_item = Level200N_1_PriceMap[preKey];
      preLevel200N_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level200N_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel200N_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel200N_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel200N_1Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level200N-2
      preLevelitem = Level200N_2Map[preKey];
      item = Level200N_2Map[key];
      price_item = Level200N_2_PriceMap[key];
      prePrice_item = Level200N_2_PriceMap[preKey];
      preLevel200N_2Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_2Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level200N_2Price += ((price_item) ? price_item.Value : 0);
      PreLevel200N_2Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_2Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel200N_2Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel200N_2Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level200N-3
      preLevelitem = Level200N_3Map[preKey];
      item = Level200N_3Map[key];
      price_item = Level200N_3_PriceMap[key];
      prePrice_item = Level200N_3_PriceMap[preKey];
      preLevel200N_3Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_3Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      Level200N_3Price += ((price_item) ? price_item.Value : 0);
      PreLevel200N_3Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level200N_3Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel200N_3Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel200N_3Chart.data.push(((item) ? item.Value : 0));

      // Monthly Orders/Amount with years - Level5-1
      preLevelitem = Level5_1Map[preKey];
      item = Level5_1Map[key];
      price_item = Level5_1_PriceMap[key];
      prePrice_item = Level5_1_PriceMap[preKey];
      preLevel5_1Total += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelOfYearCount += ((preLevelitem) ? preLevelitem.Value : 0);
      preLevelPriceOfYearCount += ((prePrice_item) ? prePrice_item.Value : 0);
      Level5_1Total += ((item) ? item.Value : 0);
      LevelOfYearCount += ((item) ? item.Value : 0);
      LevelPriceOfYearCount += ((price_item) ? price_item.Value : 0);
      LevelPriceOfYearCountTotal += LevelPriceOfYearCount;
      Level5_1Price += ((price_item) ? price_item.Value : 0);
      PreLevel5_1Price += ((prePrice_item) ? prePrice_item.Value : 0);
      Level5_1Data[cols.year + '/' + cols.month] = {value: ((item) ? item.Value : '-'), PCT: ((item) ? item.Value : '-'),  price: ((price_item) ? price_item.Value : '0')};
      PreLevel5_1Data[cols.preyear + '/' + cols.premonth] = {value: ((preLevelitem) ? preLevelitem.Value : '-'), PCT: ((preLevelitem) ? preLevelitem.Value : '-')};
      OrderAndAmountWithYearLevel5_1Chart.data.push(((item) ? item.Value : 0));


      // Monthly Orders/Amount with years - Total and Accumulated with years

      const pct = (Math.round(((LevelOfYearCount - preLevelOfYearCount) / preLevelOfYearCount) * 1000) / 10);
      LevelOfYearTotalData[cols.year + '/' + cols.month] = {
        value: LevelOfYearCount,
        PCT: !isNaN(pct) ? (pct !== Infinity ? pct : 100) : 0,
        price: LevelPriceOfYearCount.toFixed(1)
      };

      const pctPlanDiscount = (Math.round(((AmountPlanDiscountCount - preAmountPlanDiscountCount) / preAmountPlanDiscountCount) * 1000) / 10);
      LevelOfYearTotalDiscount[cols.year + '/' + cols.month] = {
        value: AmountPlanDiscountCount,
        PCT: !isNaN(pctPlanDiscount) ? (pctPlanDiscount !== Infinity ? pctPlanDiscount : 100) : 0,
      };

      const pctPPCPro = (Math.round(((AmountPPCProCount - preAmountPPCProCount) / preAmountPPCProCount) * 1000) / 10);
      LevelOfYearPPCPro[cols.year + '/' + cols.month] = {
        value: AmountPPCProCount,
        PCT: !isNaN(pctPPCPro) ? (pctPPCPro !== Infinity ? pctPPCPro : 100) : 0,
      };
      TotalOrderChart.data.push(LevelOfYearTotalData[cols.year + '/' + cols.month].PCT);
      // TotalOrderChart.data.push(LevelOfYearTotalDiscount[cols.year + '/' + cols.month].PCT);
      // TotalOrderChart.data.push(LevelOfYearPPCPro[cols.year + '/' + cols.month].PCT);
      if (!result.MonthlyOrdersAndAmountWithYearChart.labels.includes(monthMap[cols.month])) {
        result.MonthlyOrdersAndAmountWithYearChart.labels.push(monthMap[cols.month]);
      }

      // Total and Accumulated with years - Level1N-1
      Level1N_1Data[cols.year + '/' + cols.month].PCT =
        (Level1N_1Data[cols.year + '/' + cols.month].price === '-' || Level1N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level1N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level1N-2
      Level1N_2Data[cols.year + '/' + cols.month].PCT =
        (Level1N_2Data[cols.year + '/' + cols.month].price === '-' || Level1N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level1N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level1N-3
      Level1N_3Data[cols.year + '/' + cols.month].PCT =
        (Level1N_3Data[cols.year + '/' + cols.month].price === '-' || Level1N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level1N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3N-1
      Level3N_1Data[cols.year + '/' + cols.month].PCT =
        (Level3N_1Data[cols.year + '/' + cols.month].price === '-' || Level3N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3N-2
      Level3N_2Data[cols.year + '/' + cols.month].PCT =
        (Level3N_2Data[cols.year + '/' + cols.month].price === '-' || Level3N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3N-3
      Level3N_3Data[cols.year + '/' + cols.month].PCT =
        (Level3N_3Data[cols.year + '/' + cols.month].price === '-' || Level3N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);


      // Total and Accumulated with years - Level10N-1
      Level10N_1Data[cols.year + '/' + cols.month].PCT =
        (Level10N_1Data[cols.year + '/' + cols.month].price === '-' || Level10N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level10N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level10N-2
      Level10N_2Data[cols.year + '/' + cols.month].PCT =
        (Level10N_2Data[cols.year + '/' + cols.month].price === '-' || Level10N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level10N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level10N-3
      Level10N_3Data[cols.year + '/' + cols.month].PCT =
        (Level10N_3Data[cols.year + '/' + cols.month].price === '-' || Level10N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level10N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level20N-1
      Level20N_1Data[cols.year + '/' + cols.month].PCT =
        (Level20N_1Data[cols.year + '/' + cols.month].price === '-' || Level20N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level20N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level20N-2
      Level20N_2Data[cols.year + '/' + cols.month].PCT =
        (Level20N_2Data[cols.year + '/' + cols.month].price === '-' || Level20N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level20N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level20N-3
      Level20N_3Data[cols.year + '/' + cols.month].PCT =
        (Level20N_3Data[cols.year + '/' + cols.month].price === '-' || Level20N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level20N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level50N-1
      Level50N_1Data[cols.year + '/' + cols.month].PCT =
        (Level50N_1Data[cols.year + '/' + cols.month].price === '-' || Level50N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level50N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level50N-2
      Level50N_2Data[cols.year + '/' + cols.month].PCT =
        (Level50N_2Data[cols.year + '/' + cols.month].price === '-' || Level50N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level50N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level50N-3
      Level50N_3Data[cols.year + '/' + cols.month].PCT =
        (Level50N_3Data[cols.year + '/' + cols.month].price === '-' || Level50N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level50N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level100N-1
      Level100N_1Data[cols.year + '/' + cols.month].PCT =
        (Level100N_1Data[cols.year + '/' + cols.month].price === '-' || Level100N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level100N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level100N-2
      Level100N_2Data[cols.year + '/' + cols.month].PCT =
        (Level100N_2Data[cols.year + '/' + cols.month].price === '-' || Level100N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level100N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level100N-3
      Level100N_3Data[cols.year + '/' + cols.month].PCT =
        (Level100N_3Data[cols.year + '/' + cols.month].price === '-' || Level100N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level100N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3A-1
      Level3A_1Data[cols.year + '/' + cols.month].PCT =
        (Level3A_1Data[cols.year + '/' + cols.month].price === '-' || Level3A_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3A_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3A-2
      Level3A_2Data[cols.year + '/' + cols.month].PCT =
        (Level3A_2Data[cols.year + '/' + cols.month].price === '-' || Level3A_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3A_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level3A-3
      Level3A_3Data[cols.year + '/' + cols.month].PCT =
        (Level3A_3Data[cols.year + '/' + cols.month].price === '-' || Level3A_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level3A_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level200N-1
      Level200N_1Data[cols.year + '/' + cols.month].PCT =
        (Level200N_1Data[cols.year + '/' + cols.month].price === '-' || Level200N_1Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level200N_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

      // Total and Accumulated with years - Level200N-2
      Level200N_2Data[cols.year + '/' + cols.month].PCT =
        (Level200N_2Data[cols.year + '/' + cols.month].price === '-' || Level200N_2Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level200N_2Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);


      // Total and Accumulated with years - Level200N-3
      Level200N_3Data[cols.year + '/' + cols.month].PCT =
        (Level200N_3Data[cols.year + '/' + cols.month].price === '-' || Level200N_3Data[cols.year + '/' + cols.month].price === '0') ?
        0 : (Math.round(((Level200N_3Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

        // Total and Accumulated with years - Level5-1
        Level5_1Data[cols.year + '/' + cols.month].PCT =
          (Level5_1Data[cols.year + '/' + cols.month].price === '-' || Level5_1Data[cols.year + '/' + cols.month].price === '0') ?
          0 : (Math.round(((Level5_1Data[cols.year + '/' + cols.month].price) / LevelPriceOfYearCount) * 1000) / 10);

        LevelOfYearTotal.value += LevelOfYearCount;
        // LevelOfYearTotal.PCT += (Math.round(((LevelOfYearCount + preLevelOfYearCount) / LevelOfYearCount) * 1000) / 10);
        preLevelOfYearTotal.value += preLevelOfYearCount;
        LevelOfYearPriceTotal.value += LevelPriceOfYearCount;
        preLevelOfYearPriceTotal.value += preLevelPriceOfYearCount;
        const allLevelOfYearPriceTotal = (LevelPriceOfYearCount + AmountPPCProCount - AmountPlanDiscountCount);
        const allpreLevelPriceOfYearCountTotal = (preLevelPriceOfYearCount + preAmountPPCProCount - preAmountPlanDiscountCount);
        const price = (Math.round(((allLevelOfYearPriceTotal - allpreLevelPriceOfYearCountTotal) / allpreLevelPriceOfYearCountTotal) * 1000) / 10);
        const accumulated = {
          value: allLevelOfYearPriceTotal.toFixed(1),
          PCT: !isNaN(price) ? (price !== Infinity ? price : 100) : 0,
        };
        TotalAmountChart.data.push(accumulated.PCT);
        AccumulatedOrderLevelOfYearData[cols.year + '/' + cols.month] = accumulated;

    });

    result.total_cols.push({field: 'total', header: 'Total', width: '100', class: 'col-nowrap col-total', disabled: false, month: '', year: ''});
    ActiveDeviceData['total'] = '-';
    ActiveDeviceDataMOM['total'] = '-';
    ActiveDeviceLossesData['total'] = '-';
    ActiveDeviceAdditionData['total'] = '-';
    NewConnectedData['total'] = NewConnectedTotal;
    NewConnectedMoMData['total'] = '-';
    TrialActivationRateData['total'] = ((Math.round(TrialActivationRateTotal * 10000) / 100).toFixed(2));
    RCCARD100Data['total'] = RCCARD100Total;
    RWCCARD100Data['total'] = RWCCARD100Total;
    CloudUPSData['total'] = CloudUPSTotal;
    CardData['total'] = CardTotal;
    SoftwareData['total'] = SoftwareTotal;
    OrderTotalData['total'] = OrderTotal;
    InAppPurchaseData['total'] = InAppPurchaseTotal;
    WebPurchaseData['total'] = WebPurchaseTotal;
    PPCLicenseGeneratorData['total'] = PPCLicenseGeneratorTotal;
    AmountData['total'] = parseInt((AmountAppWebTotal * 100).toFixed(), 10) / 100;
    AmountofPPCGenerator['total'] = parseInt((AmountPPCTotal * 100).toFixed(), 10) / 100;
    AmountTot['total'] = parseInt((AmountTotal * 100).toFixed(), 10) / 100;
    AmountOfPro['total'] = parseInt((AmountPPCProTotal * 100).toFixed(), 10) / 100;
    AmountDiscountTot['total'] = parseInt((AmountDiscountTotal * 100).toFixed(), 10) / 100;
    // DevicesMOM['total'] = DevicesMOMTotal;
    // DevicesMOMPCT['total'] = parseInt((DevicesMOMPCTTotal * 100).toFixed(), 10) / 100;
    // OrderMOM['total'] = OrderMOMTotal;
    // OrderMOMPCT['total'] = parseInt((OrderMOMPCTTotal * 100).toFixed(), 10) / 100;
    // AmountMOM['total'] = AmountMOMTotal;
    // AmountMOMPCT['total'] = parseInt((AmountMOMPCTTotal * 100).toFixed(), 10) / 100;
    const Activedevice14day_Total = Activedevice14day_PPCTotal + Activedevice14day_PROTotal;
    ActiveDevice14DaysPPCData['total'] = { value:Activedevice14day_PPCTotal, PCT: ((Activedevice14day_Total === 0) ? 0 : Math.round((Activedevice14day_PPCTotal / Activedevice14day_Total) * 10000) / 100) };
    ActiveDevice14DaysPROData['total'] = { value:Activedevice14day_PROTotal, PCT: ((Activedevice14day_Total === 0) ? 0 : Math.round((Activedevice14day_PROTotal / Activedevice14day_Total) * 10000) / 100) };
    PowerPanelPersonalData['total'] = PowerPanelPersonalTotal;
    PowerPanelBusinessData['total'] = PowerPanelBusinessTotal;
    SoftwareOthersData['total'] = SoftwareOthersTotal;
    GatewayData['total'] = GatewayTotal;
    GatewayUPSData['total'] = GatewayUPSTotal;
    GatewayPDUData['total'] = GatewayPDUTotal;
    GatewayATSData['total'] = GatewayATSTotal;
    Gateway3phaseUPSData['total'] = Gateway3phaseUPSTotal;
    Gateway3rdPartysDevicesData['total'] = Gateway3rdPartysDevicesTotal;
    // GPAMonthlySalesIncomeData['total'] = GPAMonthlySalesIncomeTotal;
    // GPAYearlyPlanPayPalData['total'] = GPAYearlyPlanPayPalTotal;
    // GPAYearlyPlanAPPData['total'] = GPAYearlyPlanAPPTotal;
    // GPAYearlyPlanPPCGeneratorData['total'] = GPAYearlyPlanPPCGeneratorTotal;
    // GPAPPCPROPayPalData['total'] = GPAPPCPROPayPalTotal;
    // GPAPPCPROGeneratorData['total'] = GPAPPCPROGeneratorTotal;
    // GPAPPCPROData['total'] = GPAPPCPROPayPalTotal + GPAPPCPROGeneratorTotal;
    // GPATotalCostData['total'] = GPATotalCostTotal;
    // GPAYearlyPlanPayPalFeeData['total'] = GPAYearlyPlanPayPalFeeTotal;
    // GPAYearlyPlanAPPFeeData['total'] = GPAYearlyPlanAPPFeeTotal;
    // GPAYearlyPlanDiscountData['total'] = GPAYearlyPlanDiscountTotal;
    // GPAPPCPROPayPalFeeData['total'] = GPAPPCPROPayPalFeeTotal;
    // GPARevenuePPCPRODiscountData['total'] = GPARevenuePPCPRODiscountTotal;
    // GPAServerFeeData['total'] = GPAServerFeeTotal;
    // GPAGrossProfitData['total'] = GPAGrossProfitTotal;
    // GPAGrossProfitMarginData['total'] = GPAGrossProfitMarginTotal;
    // GPADeferredMonthlySalesIncomeData['total'] = GPADeferredMonthlySalesIncomeTotal;
    // GPADeferredYearlyPlanPayPalData['total'] = GPADeferredYearlyPlanPayPalTotal;
    // GPADeferredYearlyPlanAPPData['total'] = GPADeferredYearlyPlanAPPTotal;
    // GPADeferredYearlyPlanPPCGeneratorData['total'] = GPADeferredYearlyPlanPPCGeneratorTotal;
    // GPADeferredPPCPROData['total'] = GPADeferredPPCPROTotal;
    // GPADeferredTotalCostData['total'] = GPADeferredTotalCostTotal;
    // GPADeferredYearlyPlanPayPalFeeData['total'] = GPADeferredYearlyPlanPayPalFeeTotal;
    // GPADeferredYearlyPlanAppFeeData['total'] = GPADeferredYearlyPlanAppFeeTotal;
    // GPADeferredYearlyPlanDiscountData['total'] = GPADeferredYearlyPlanDiscountTotal;
    // GPADeferredPPCPROPayPalFeeData['total'] = GPADeferredPPCPROPayPalFeeTotal;
    // GPADeferredPPCPRODiscountData['total'] = GPADeferredPPCPRODiscountTotal;
    // GPADeferredGrossProfitData['total'] = GPADeferredGrossProfitTotal;
    // GPADeferredGrossProfitMarginData['total'] = GPADeferredGrossProfitMarginTotal;
    PAYearlyPlanPurchaseData['total'] = PAYearlyPlanPurchaseTotal;
    PAYearlyPlanPurchaseMoMData['total'] = '-';
    PAMonthlyRenewalRateData['total'] = '-';
    PATotalPlanRenewalRateData['total'] = '-';
    PAPlanRenewalRate_1to3Data['total'] = '-';
    PAPlanRenewalRate_4to20Data['total'] = '-';
    PAPlanRenewalRate_Over20Data['total'] = '-';
    PAPlanTransferRateData['total'] = '-';
    PAConversionRateData['total'] = '-';

    LevelTotalData['total'] = Level1NTotal + Level3NTotal + Level10NTotal + Level20NTotal + Level50NTotal + Level100NTotal + Level3ATotal + Level200NTotal + Level5Total;
    LevelOfYearTotalData['total'] = {
      value: Level1NAmountTotal + Level3NAmountTotal + Level10NAmountTotal + Level20NAmountTotal + Level50NAmountTotal + Level100NAmountTotal + Level3AAmountTotal + Level200NAmountTotal + Level5AmountTotal,
      PCT: 0,
      price: LevelPriceOfYearCountTotal.toFixed(2),
    };
    LevelOfYearPPCPro['total'] = {
      value: AmountPPCProTotal.toFixed(2),
      PCT: 0
    };
    LevelOfYearTotalDiscount['total'] = {
      value: AmountDiscountTotal.toFixed(2),
      PCT: 0
    };
    MonthlyOrderAmountTotalOrder['total'] = {
      value: Level1NTotal + Level3NTotal + Level10NTotal + Level20NTotal + Level50NTotal + Level100NTotal + Level3ATotal + Level200NTotal + Level5Total,
      PCT: 0,
      price: (Level1NAmountTotal + Level3NAmountTotal + Level10NAmountTotal + Level20NAmountTotal + Level50NAmountTotal + Level100NAmountTotal + Level3AAmountTotal + Level200NAmountTotal + Level5AmountTotal).toFixed(1)
    };
    MonthlyOrderAmountPPCPro['total'] = {
      value: (GPAPPCPROPayPalTotal + GPAPPCPROGeneratorTotal).toFixed(2),
      PCT: 0
    };
    MonthlyOrderAmountTotalDiscount['total'] = {
      value: AmountDiscountTotal.toFixed(2),
      PCT: 0
    };
    const LevelOfYearPriceByOrder = (Level1N_1Price + Level1N_2Price + Level1N_3Price + Level3N_1Price + Level3N_2Price +
      Level3N_3Price + Level10N_1Price + Level10N_2Price + Level10N_3Price + Level20N_1Price + Level20N_2Price + Level20N_3Price +
      Level50N_1Price + Level50N_2Price + Level50N_3Price + Level100N_1Price + Level100N_2Price + Level100N_3Price + Level3A_1Price +
      Level3A_2Price + Level3A_3Price + Level200N_1Price + Level200N_2Price + Level200N_3Price + Level5_1Price);
    const LevelOfYearPrice = (LevelOfYearPriceByOrder + AmountPPCProTotal) - AmountDiscountTotal;
    AccumulatedOrderLevelOfYearData['total'] = {
      value: (LevelOfYearPrice).toFixed(1),
      PCT: 0
    };
    MonthlyOrderAmountTotalData['total'] = {
      value: (MonthlyLevelPriceCountTotal).toFixed(1),
      PCT: 0
    };
    Level1NData['total'] = {
      value: Level1NTotal,
      PCT: (LevelTotalData['total'].value === 0) ? 0 : ((Math.round(((Level1NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level3NData['total'] = {
      value: Level3NTotal,
      PCT: (LevelTotalData['total'].value === 0) ? 0 : ((Math.round(((Level3NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level10NData['total'] = {
      value: Level10NTotal,
      PCT: (LevelTotalData['total'].value === 0) ? 0 : ((Math.round(((Level10NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level20NData['total'] = {
      value: Level20NTotal,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level20NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level50NData['total'] = {
      value: Level50NTotal,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level50NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level100NData['total'] = {
      value: Level100NTotal,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level100NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level3AData['total'] = {
      value: Level3ATotal,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level3ATotal / LevelTotalData['total']) * 1000) / 10)))};
    Level200NData['total'] = {
      value: Level200NTotal,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level200NTotal / LevelTotalData['total']) * 1000) / 10)))};
    Level5Data['total'] = {
      value: Level5Total,
      PCT: (LevelTotalData['total'] === 0) ? 0 : ((Math.round(((Level5Total / LevelTotalData['total']) * 1000) / 10)))};
    Level1NAmountData['total'] = {
      value: Level1NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level1NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level1NAmountTotal)};
    Level3NAmountData['total'] = {
      value: Level3NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level3NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level3NAmountTotal)};
    Level10NAmountData['total'] = {
      value: Level10NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level10NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level10NAmountTotal)};
    Level20NAmountData['total'] = {
      value: Level20NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level20NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level20NAmountTotal)};
    Level50NAmountData['total'] = {
      value: Level50NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level50NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level50NAmountTotal)};
    Level100NAmountData['total'] = {
      value: Level100NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level100NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level100NAmountTotal)};
    Level3AAmountData['total'] = {
      value: Level3ATotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level3AAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level3AAmountTotal)};
    Level200NAmountData['total'] = {
      value: Level200NTotal,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level200NAmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level200NAmountTotal)};
    Level5AmountData['total'] = {
      value: Level5Total,
      PCT: (LevelOfYearTotalData['total'].value === 0) ? 0 : ((Math.round(((Level5AmountTotal / LevelOfYearTotalData['total'].value) * 1000) / 10))),
      price: formatMathroundValue(Level5AmountTotal)};
    Level1N_1Data['total'] = {
      value: Level1N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level1N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level1N_1Price.toFixed(2)};
    Level1N_2Data['total'] = {
      value: Level1N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level1N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level1N_2Price.toFixed(2)};
    Level1N_3Data['total'] = {
      value: Level1N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level1N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level1N_3Price.toFixed(2)};
    Level3N_1Data['total'] = {
      value: Level3N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3N_1Price.toFixed(2)};
    Level3N_2Data['total'] = {
      value: Level3N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3N_2Price.toFixed(2)};
    Level3N_3Data['total'] = {
      value: Level3N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3N_3Price.toFixed(2)};
    Level10N_1Data['total'] = {
      value: Level10N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level10N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level10N_1Price.toFixed(2)};
    Level10N_2Data['total'] = {
      value: Level10N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level10N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level10N_2Price.toFixed(2)};
    Level10N_3Data['total'] = {
      value: Level10N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level10N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level10N_3Price.toFixed(2)};
    Level20N_1Data['total'] = {
      value: Level20N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level20N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level20N_1Price.toFixed(2)};
    Level20N_2Data['total'] = {
      value: Level20N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level20N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level20N_2Price.toFixed(2)};
    Level20N_3Data['total'] = {
      value: Level20N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level20N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level20N_3Price.toFixed(2)};
    Level50N_1Data['total'] = {
      value: Level50N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level50N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level50N_1Price.toFixed(2)};
    Level50N_2Data['total'] = {
      value: Level50N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level50N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level50N_2Price.toFixed(2)};
    Level50N_3Data['total'] = {
      value: Level50N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level50N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level50N_3Price.toFixed(2)};
    Level100N_1Data['total'] = {
      value: Level100N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level100N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level100N_1Price.toFixed(2)};
    Level100N_2Data['total'] = {
      value: Level100N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level100N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level100N_2Price.toFixed(2)};
    Level100N_3Data['total'] = {
      value: Level100N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level100N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level100N_3Price.toFixed(2)};
    Level3A_1Data['total'] = {
      value: Level3A_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3A_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3A_1Price.toFixed(2)};
    Level3A_2Data['total'] = {
      value: Level3A_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3A_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3A_2Price.toFixed(2)};
    Level3A_3Data['total'] = {
      value: Level3A_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level3A_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level3A_3Price.toFixed(2)};
    Level200N_1Data['total'] = {
      value: Level200N_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level200N_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level200N_1Price.toFixed(2)};
    Level200N_2Data['total'] = {
      value: Level200N_2Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level200N_2Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level200N_2Price.toFixed(2)};
    Level200N_3Data['total'] = {
      value: Level200N_3Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level200N_3Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level200N_3Price.toFixed(2)};
    Level5_1Data['total'] = {
      value: Level5_1Total,
      PCT: (LevelOfYearPrice === 0) ? 0 : ((Math.round(((Level5_1Price / LevelOfYearPrice) * 1000)) / 10)),
      price: Level5_1Price.toFixed(2)};

    // Table
    result.deviceAnalysisData.push(ActiveDeviceData);
    result.deviceAnalysisData.push(ActiveDeviceDataMOM);
    result.deviceAnalysisData.push(ActiveDeviceLossesData);
    result.deviceAnalysisData.push(ActiveDeviceAdditionData);
    result.deviceAnalysisData.push(NewConnectedData);
    result.deviceAnalysisData.push(NewConnectedMoMData);
    result.deviceAnalysisData.push(TrialActivationRateData);
    // result.deviceAnalysisData.push(NewConnectedMOM);
    // result.deviceAnalysisData.push(NewConnectedMOMPCT);
    // result.deviceAnalysisData.push(TrialLicensedDeviceData);
    // result.deviceAnalysisData.push(TrialLicensedDeviceDataMOM);
    // result.deviceAnalysisData.push(LicensedDevicePCTData);
    result.monthlyIncreaseDevicesData.push(ActiveDevice14DaysPPCData);
    result.monthlyIncreaseDevicesData.push(ActiveDevice14DaysPROData);
    result.monthlyIncreaseDevicesData.push(NewConnectedData);
    result.monthlyIncreaseDevicesData.push(CardData);
    result.monthlyIncreaseDevicesData.push(RCCARD100Data);
    result.monthlyIncreaseDevicesData.push(RWCCARD100Data);
    result.monthlyIncreaseDevicesData.push(CloudUPSData);
    // result.monthlyIncreaseDevicesData.push(SoftwareData);
    result.monthlyIncreaseDevicesData.push(PowerPanelPersonalData);
    result.monthlyIncreaseDevicesData.push(PowerPanelBusinessData);
    result.monthlyIncreaseDevicesData.push(SoftwareOthersData);
    result.monthlyIncreaseDevicesData.push(GatewayData);
    result.monthlyIncreaseDevicesData.push(GatewayUPSData);
    result.monthlyIncreaseDevicesData.push(GatewayPDUData);
    result.monthlyIncreaseDevicesData.push(GatewayATSData);
    result.monthlyIncreaseDevicesData.push(Gateway3phaseUPSData);
    result.monthlyIncreaseDevicesData.push(Gateway3rdPartysDevicesData);
    // result.monthlyIncreaseDevicesData.push(AccumulatedDeviceData);
    result.monthlyPurchaseOrderData.push(InAppPurchaseData);
    result.monthlyPurchaseOrderData.push(WebPurchaseData);
    result.monthlyPurchaseOrderData.push(PPCLicenseGeneratorData);
    result.monthlyPurchaseOrderData.push(OrderTotalData);
    result.monthlyPurchaseOrderData.push(OrderMOM);
    result.monthlyPurchaseOrderData.push(OrderMOMPCT);
    result.monthlyPurchaseOrderData.push(AccumulatedOrderData);
    result.monthlyOrderAmountData.push(AmountData);
    result.monthlyOrderAmountData.push(AmountofPPCGenerator);
    result.monthlyOrderAmountData.push(AmountOfPro);
    result.monthlyOrderAmountData.push(AmountDiscountTot);
    result.monthlyOrderAmountData.push(AmountTot);
    result.monthlyOrderAmountData.push(AmountMOM);
    result.monthlyOrderAmountData.push(AmountMOMPCT);
    result.monthlyOrderAmountData.push(AccumulatedAmountData);
    result.monthlyOrdersOfLevelData.push(Level1NData);
    result.monthlyOrdersOfLevelData.push(Level3NData);
    result.monthlyOrdersOfLevelData.push(Level10NData);
    result.monthlyOrdersOfLevelData.push(Level20NData);
    result.monthlyOrdersOfLevelData.push(Level50NData);
    result.monthlyOrdersOfLevelData.push(Level100NData);
    result.monthlyOrdersOfLevelData.push(Level200NData);
    result.monthlyOrdersOfLevelData.push(Level3AData);
    result.monthlyOrdersOfLevelData.push(Level5Data);
    result.monthlyOrdersOfLevelData.push(LevelTotalData);
    result.monthlyOrdersOfLevelData.push(AccumulatedOrderLevelData);
    result.monthlyOrderAmountWihtYearsData.push(Level1NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level1N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level1N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level3NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level3N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level3N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level10NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level10N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level10N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level20NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level20N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level20N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level50NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level50N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level50N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level100NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level100N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level100N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level200NAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level200N_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level200N_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level3AAmountData);
    // result.monthlyOrderAmountWihtYearsData.push(Level3A_2Data);
    // result.monthlyOrderAmountWihtYearsData.push(Level3A_3Data);
    result.monthlyOrderAmountWihtYearsData.push(Level5AmountData);
    result.monthlyOrderAmountWihtYearsData.push(MonthlyOrderAmountTotalOrder);
    result.monthlyOrderAmountWihtYearsData.push(MonthlyOrderAmountPPCPro);
    // 2026/02/13 kyrie: #1152 移除Total Discount
    // result.monthlyOrderAmountWihtYearsData.push(MonthlyOrderAmountTotalDiscount);
    result.monthlyOrderAmountWihtYearsData.push(MonthlyOrderAmountTotalData);
    //
    result.monthlyRevenueGrossProfitData.push(GPAMonthlySalesIncomeData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanPayPalData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanAPPData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanPPCGeneratorData);
    result.monthlyRevenueGrossProfitData.push(GPAPPCPROPayPalData);
    result.monthlyRevenueGrossProfitData.push(GPAPPCPROGeneratorData);
    result.monthlyRevenueGrossProfitData.push(GPAPPCPROData);
    result.monthlyRevenueGrossProfitData.push(GPATotalCostData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanPayPalFeeData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanAPPFeeData);
    result.monthlyRevenueGrossProfitData.push(GPAYearlyPlanDiscountData);
    result.monthlyRevenueGrossProfitData.push(GPAPPCPROPayPalFeeData);
    result.monthlyRevenueGrossProfitData.push(GPARevenuePPCPRODiscountData);
    result.monthlyRevenueGrossProfitData.push(GPAServerFeeData);
    result.monthlyRevenueGrossProfitData.push(GPAGrossProfitData);
    result.monthlyRevenueGrossProfitData.push(GPAGrossProfitMoMData);
    result.monthlyRevenueGrossProfitData.push(GPAGrossProfitMarginData);
    result.monthlyRevenueGrossProfitData.push(GPAGrossProfitMarginMoMData);
    //
    result.monthlyDeferredGrossProfitData.push(GPADeferredMonthlySalesIncomeData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanPayPalData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanAPPData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanPPCGeneratorData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredPPCPROData);
    // result.monthlyDeferredGrossProfitData.push(GPADeferredPPCPROGeneratorData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredTotalCostData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanPayPalFeeData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanAppFeeData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredYearlyPlanDiscountData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredPPCPROPayPalFeeData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredPPCPRODiscountData);
    result.monthlyDeferredGrossProfitData.push(GPAServerFeeData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredGrossProfitData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredGrossProfitMoMData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredGrossProfitMarginData);
    result.monthlyDeferredGrossProfitData.push(GPADeferredGrossProfitMarginMoMData);
    //
    result.monthlyPurchaseAnalysisData.push(PAYearlyPlanPurchaseData);
    result.monthlyPurchaseAnalysisData.push(PAYearlyPlanPurchaseMoMData);
    result.monthlyPurchaseAnalysisData.push(PAMonthlyRenewalRateData);
    result.monthlyPurchaseAnalysisData.push(PATotalPlanRenewalRateData);
    result.monthlyPurchaseAnalysisData.push(PAPlanRenewalRate_1to3Data);
    result.monthlyPurchaseAnalysisData.push(PAPlanRenewalRate_4to20Data);
    result.monthlyPurchaseAnalysisData.push(PAPlanRenewalRate_Over20Data);
    // result.monthlyPurchaseAnalysisData.push(PAPlanTransferRateData);
    result.monthlyPurchaseAnalysisData.push(PAConversionRateData);
    //
    result.ppcProUsageManagementData.push(PPCPROAccountData);
    result.ppcProUsageManagementData.push(TotalCompanyNumberData);
    result.ppcProUsageManagementData.push(NPMUsageData);
    result.ppcProUsageManagementData.push(NPMUsageMoMData);
    result.ppcProUsageManagementData.push(TotalNPMRemainingData);
    //
    result.monthlyPurchaseOrderProData.push(NPMPurchasedQuantityPrepaidData);
    result.monthlyPurchaseOrderProData.push(NPMPurchasedQuantityMonthlyData);
    result.monthlyPurchaseOrderProData.push(TotalNPMPurchasedData);
    result.monthlyPurchaseOrderProData.push(NPMPurchaseQuantityMoMData);
    result.monthlyPurchaseOrderProData.push(PPCPROIncomeData);
    result.monthlyPurchaseOrderProData.push(PPCPRODiscountData);
    result.monthlyPurchaseOrderProData.push(PPCPROTotalData);
    //
    result.monthlySubDevicesData.push(SubDevices_Level1NData);
    result.monthlySubDevicesData.push(SubDevices_Level3NData);
    result.monthlySubDevicesData.push(SubDevices_Level10NData);
    result.monthlySubDevicesData.push(SubDevices_Level20NData);
    result.monthlySubDevicesData.push(SubDevices_Level50NData);
    result.monthlySubDevicesData.push(SubDevices_Level100NData);
    result.monthlySubDevicesData.push(SubDevices_Level200NData);
    result.monthlySubDevicesData.push(SubDevices_Level3AData);
    result.monthlySubDevicesData.push(SubDevices_PROData);
    result.monthlySubDevicesData.push(SubDevices_TrialData);
    result.monthlySubDevicesData.push(SubDevices_RateData);
    //
    result.monthlySubAccountsData.push(SubAccounts_Level1NData);
    result.monthlySubAccountsData.push(SubAccounts_Level3NData);
    result.monthlySubAccountsData.push(SubAccounts_Level10NData);
    result.monthlySubAccountsData.push(SubAccounts_Level20NData);
    result.monthlySubAccountsData.push(SubAccounts_Level50NData);
    result.monthlySubAccountsData.push(SubAccounts_Level100NData);
    result.monthlySubAccountsData.push(SubAccounts_Level200NData);
    result.monthlySubAccountsData.push(SubAccounts_Level3AData);
    result.monthlySubAccountsData.push(SubAccounts_PROData);
    result.monthlySubAccountsData.push(SubAccounts_TrialData);
    result.monthlySubAccountsData.push(SubAccounts_RateData);

    // Chart
    result.DeviceAnalysisChart.labels = ChartLabel;
    result.DeviceChart.labels = ChartLabel;
    result.AppDownloadChart.labels = ChartLabel;
    result.APIChart.labels = ChartLabel;
    result.OrderChart.labels = ChartLabel;
    result.AmountChart.labels = ChartLabel;
    result.monthlyRevenueGrossProfitChart.labels = ChartLabel;
    result.monthlyDeferredGrossProfitChart.labels = ChartLabel;
    result.monthlyPurchaseAnalysisDataChart.labels = ChartLabel;
    result.ppcProUsageManagementDataChart.labels = ChartLabel;
    result.DeviceAnalysisChart.datasets.push(ActiveDeviceChart, ActiveDeviceLossAdditionChart);
    result.DeviceChart.datasets.push(NewConnectedChart, DeviceMOMPCTChart);
    result.OrderChart.datasets.push(OrderChart, OrderMOMPCTChart);
    result.AmountChart.datasets.push(AmountChart, AmountMOMPCTChart);
    result.MonthlyOrdersAndAmountWithYearChart.datasets.push(
      TotalOrderChart,
      TotalAmountChart,
      OrderAndAmountWithYearLevel1N_1Chart,
      OrderAndAmountWithYearLevel1N_2Chart,
      OrderAndAmountWithYearLevel1N_3Chart,
      OrderAndAmountWithYearLevel3N_1Chart,
      OrderAndAmountWithYearLevel3N_2Chart,
      OrderAndAmountWithYearLevel3N_3Chart,
      OrderAndAmountWithYearLevel10N_1Chart,
      OrderAndAmountWithYearLevel10N_2Chart,
      OrderAndAmountWithYearLevel10N_3Chart,
      OrderAndAmountWithYearLevel20N_1Chart,
      OrderAndAmountWithYearLevel20N_2Chart,
      OrderAndAmountWithYearLevel20N_3Chart,
      OrderAndAmountWithYearLevel50N_1Chart,
      OrderAndAmountWithYearLevel50N_2Chart,
      OrderAndAmountWithYearLevel50N_3Chart,
      OrderAndAmountWithYearLevel100N_1Chart,
      OrderAndAmountWithYearLevel100N_2Chart,
      OrderAndAmountWithYearLevel100N_3Chart,
      OrderAndAmountWithYearLevel200N_1Chart,
      OrderAndAmountWithYearLevel200N_2Chart,
      OrderAndAmountWithYearLevel200N_3Chart,
      OrderAndAmountWithYearLevel3A_1Chart,
      OrderAndAmountWithYearLevel3A_2Chart,
      OrderAndAmountWithYearLevel3A_3Chart,
      OrderAndAmountWithYearLevel5_1Chart,
    );
    result.monthlyRevenueGrossProfitChart.datasets.push(RevenueGrossProfitChart, RevenueGrossProfitMarginChart);
    result.monthlyDeferredGrossProfitChart.datasets.push(DeferredGrossProfitChart, DeferredGrossProfitMarginChart);
    result.monthlyPurchaseAnalysisDataChart.datasets.push(PAMonthlyRenewalRateChart, PAConversionChart);
    result.ppcProUsageManagementDataChart.datasets.push(NPMUsageChart, TotalCompanyNumberChart);

    // 進圖表頁面時會抓13個月的資料(含最新月份) 但Chart最新月份不顯示資料(求"美觀") 故另外處理
    if (ChartLabel.length > 12) {
      // const removeCount = ChartLabel.length - 12;
      // ChartLabel.splice(12, removeCount);

      const allCharts = [
        result.DeviceAnalysisChart,
        result.DeviceChart,
        result.APIChart,
        result.OrderChart,
        result.AmountChart,
        result.MonthlyOrdersAndAmountWithYearChart,
        result.monthlyRevenueGrossProfitChart,
        result.monthlyDeferredGrossProfitChart,
        result.monthlyPurchaseAnalysisDataChart,
        result.ppcProUsageManagementDataChart
      ];

      allCharts.forEach(chart => {
        if (chart.datasets && chart.datasets.length > 0) {
          chart.datasets.forEach(dataset => {
            if (dataset.data && dataset.data.length > 12) {
               dataset.data[12] = null;
            }
          });
        }
      });
    }
  }
  
  return result;
  function formatMathroundValue(value: any): number {
    // 強制轉型為數字 (防禦 String, null, undefined)
    const num = Number(value) || 0;
    return Number.isInteger(num) ? num : (Math.round(num * 10) / 10);
  }
});

export const getPurchaseOtp = createSelector(getPurchaseOtpState, (data) => {
  return data;
});

export const getPayPalAgreementApprovalUrl = createSelector(getPayPalAgreementApprovalUrlState, (data) => {
  return data;
});

// export const GetProNodesBank = createSelector(GetProNodesBankState, getRegionState, (data, region) => {
//   const result = {
//     isLoading: data.isLoading,
//     isLoaded: data.isLoaded,
//     entities: [],
//     latestRegionNodeBankDic: {},
//   }
//   if (data.isLoaded && !data.isLoading && data.entities.length > 0 && !region.Loading && region.Loaded) {
    
//     const region_dic = [];
//     const allRegions = Object.values(region.entities);
//     allRegions.map((r) => {
//       region_dic[r.Id] = r;
//     });
//     result.latestRegionNodeBankDic = data.entities.reduce((acc, item) => {
//       const id = item.RegionId;
//       if (!acc[id] || item.CreateTime > acc[id].CreateTime) {
//         acc[id] = item;
//       }
//       return acc;
//     }, {});
//     result.entities = data.entities;
//     result.entities.map((item) => {
//       item['RegionName'] = (region_dic.hasOwnProperty(item.RegionId)) ? region_dic[item.RegionId].RegionName : '';
//       item['ActionTypeStr'] = (item.ActionType && ActionType.hasOwnProperty(item.ActionType)) ? ActionType[item.ActionType] : '';
//       item['Nodes'] = (item.ActionType && ActionTypeNagetiveMapping.hasOwnProperty(item.ActionType)) ? (ActionTypeNagetiveMapping[item.ActionType] * item.Nodes) : item.Nodes;
//       item['CreateTimeFormat'] = moment.utc(Number(item.CreateTime) * 1000).format('YYYY/MM/DD');
//     });
//   }
//   return result;
// });

export const GetProNodesBank = createSelector(GetProNodesBankState, getRegionState, getMspDistributorRegionPaymentState, (data, region, distributorpayment) => {
  const result = {
    isLoading: data.isLoading,
    isLoaded: data.isLoaded,
    entities: [],
    latestRegionNodeBankDic: {},
  }
  const region_dic = [];
  
  if (!distributorpayment.Loading && distributorpayment.Loaded && distributorpayment.entities && distributorpayment.entities.Customers && distributorpayment.entities.Customers.length > 0) {
    distributorpayment.entities.Customers.map(c => {
      region_dic[c.Id] = c;
    });
  }
  if (data.isLoaded && !data.isLoading && data.entities.length > 0 && !region.Loading && region.Loaded) {
    const allRegions = Object.values(region.entities);
    allRegions.map((r) => {
      region_dic[r.Id] = r;
    });
    result.latestRegionNodeBankDic = data.entities.reduce((acc, item) => {
      const id = item.RegionId;
      if (!acc[id] || item.CreateTime > acc[id].CreateTime) {
        acc[id] = { ...item };
      }
      return acc;
    }, {});
    result.entities = data.entities.map((item) => ({
      ...item,
      DisplayRegionName: (item.ActionType && item.ActionType === ActionTypeIndex_Sell) ? item.RelatedRegionName : item.RegionName,
      ActionTypeStr: (item.ActionType && ActionType.hasOwnProperty(item.ActionType)) ? ActionType[item.ActionType] : '',
      DisplayNodes: (item.ActionType && ActionTypeNagetiveMapping.hasOwnProperty(item.ActionType)) ?
        (ActionTypeNagetiveMapping[item.ActionType] * item.Nodes) : item.Nodes,
      CreateTimeFormat: moment.utc(Number(item.CreateTime) * 1000).format('YYYY/MM/DD')
    }));
  }
  return result;
});

export const GetCalculateProNodes = createSelector(GetCalculateProNodesState, (data) => {
  
  let result = 0;
  if (data.isLoaded && !data.isLoading) {
    result = data.Nodes;
  }
  return result;
});


// Region End --Frontend Viewed

// Sub functions
export const filterEmptyChildren = function (item) {
  return item.filter(i => Object.keys(i.data).length !== 0);
};
export const IsEmptyObject = function (obj) {
  return Object.keys(obj).length === 0;
};
export const addDays = function(date, days) {
  if (!date) {
    return void(0);
  }
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
export const expiredDateCalculated = function (item) {
  const activated = [...item.filter(i => // 僅使用中或Plan & Trial License會計算Expired Date
    ((i.UsingStatus === 3 || i.UsingStatus === 4) || (i.LicenseType === 3 || i.LicenseType === 4)) && i.LicenseType !== 2 && i.dcode)]
      .sort(fromLicenseMgtList.sortByLastActiveDate);
  // const lastTimeTemp = {};
  return activated.reduce((obj, cur, index, arr) => {
    // const baseTime = (lastTimeTemp.hasOwnProperty(cur.dcode)) ? lastTimeTemp[cur.dcode] : new Date(),
    const baseTime = new Date(),
      curExpiredDate = addDays(baseTime, cur.RemainDay);
    // lastTimeTemp[cur.dcode] = curExpiredDate;
    (obj[cur.dcode] = obj[cur.dcode] || []).push({...cur, ExpiredDate: new Date(curExpiredDate)});
    return Object.assign({}, obj);
  }, {});
};
export const expiredDateCalculatedByLicenseDetail = function (item) {
  // 僅使用中或Plan & Trial License會計算Expired Date
  if ((item.UsingStatus === 3 || item.UsingStatus === 4) ||
      (item.LicenseType === 3 || item.LicenseType === 4) && item.LicenseType !== 2 && (item.dcodes.length > 0)) {
    return addDays(new Date(), item.RemainDay);
  }
  return null;
};
export const hardwareFaultDetailLogic = function (device, faultLevelMaps, faultCodeMaps) {
  const hardwarefault = {
    faultLevelCode: null,
    faultLevelColor: null,
    faultCodeStr: '',
    errorCodes: null,
    isHardwareFault: false
  };
  // Hardware Fault
  if (device.hardwarefault_event && !IsEmptyObject(device.hardwarefault_event) && faultLevelMaps.entities && faultCodeMaps.entities) {
    const levelMaps = faultLevelMaps.entities;
    const codeMaps = faultCodeMaps.entities;
    hardwarefault.faultLevelCode = device.hardwarefault_event.levelcode;
    hardwarefault.faultLevelColor = levelMaps.hasOwnProperty(device.hardwarefault_event.levelcode) ?
      levelMaps[device.hardwarefault_event.levelcode].ColorCode : null;
    for (let errCodeIndex = 0; errCodeIndex <= device.hardwarefault_event.errorcodes.length - 1; errCodeIndex++) {
      if (errCodeIndex > 2) { // 3 at most.
        hardwarefault.faultCodeStr += ' ...';
        break;
      }
      hardwarefault.faultCodeStr += device.hardwarefault_event.errorcodes[errCodeIndex];
      if (device.hardwarefault_event.errorcodes.length - 1 > errCodeIndex) {
        hardwarefault.faultCodeStr += ', ';
      }
    }
    hardwarefault.errorCodes = Array.isArray(device.hardwarefault_event.errorcodes)
      ? [...device.hardwarefault_event.errorcodes]
      : [];
    if (device.hardwarefault_event.errorcodes.length > 0 && codeMaps.hasOwnProperty(device.hardwarefault_event.errorcodes[0])) {
      if (codeMaps[device.hardwarefault_event.errorcodes[0]].note !== oldErrorCode) { // Old version would not show in detail.
        hardwarefault.isHardwareFault = true;
      }
    }
  }
  return hardwarefault;
};
export const oldErrorCodeDesc = function (item, codeMaps) {
  if (codeMaps.hasOwnProperty(item.ErrorCode)) {
    const codeAttr = codeMaps[item.ErrorCode];
    if (codeAttr.note === oldErrorCode) {
      return '';
    } else {
      return item.ErrorCode + ', ';
    }
  }
  return '';
};
export const hardwareStatusLogAnalysis = function (res, errorLevelMaps, errorCodeMaps) {
  const levelMaps = errorLevelMaps.entities;
  const codeMaps = errorCodeMaps.entities;
  const errorEvents = res.ErrorCodeEvent.split(',');
  if (errorEvents.length === 0) {
    return { ...res };
  }
  const levelCodeSplit = errorEvents[0].split('.');
  const levelCode = (levelCodeSplit.length > 1) ? levelCodeSplit[1] : null;
  return {
    ...res,
    faultLevelColor: levelMaps.hasOwnProperty(levelCode) ? levelMaps[levelCode].ColorCode : '',
    faultCodeArr: errorEvents.map((item) => {
      const errorCodeSplit = item.split('.')[0];
      if (errorCodeSplit.length > 0) {
        return errorCodeSplit + ', ' + (codeMaps.hasOwnProperty(errorCodeSplit) ? codeMaps[errorCodeSplit].Description : '');
      }
      return '';
    }),
  };
};
export const IsNewCardVersion = function(itemVersion, cardVersion) {
  let IsNewVersion = false;
  if (itemVersion && cardVersion && itemVersion !== cardVersion) {
    const iVersionArr = itemVersion.split('.');
    const cardVersionArr = cardVersion.split('.');
    if ((parseInt(iVersionArr[0], 10) >= parseInt(cardVersionArr[0], 10))) {
      if ((parseInt(iVersionArr[0], 10) > parseInt(cardVersionArr[0], 10))) {
        IsNewVersion = true; } else {
        if ((parseInt(iVersionArr[1], 10) >= parseInt(cardVersionArr[1], 10))) {
          if ((parseInt(iVersionArr[1], 10) > parseInt(cardVersionArr[1], 10))) {
            IsNewVersion = true; } else {
            if ((parseInt(iVersionArr[2], 10) > parseInt(cardVersionArr[2], 10))) { IsNewVersion = true; }
          }
        }
      }
    }
  }
  return IsNewVersion;
};
export const safeRound = function(v, n) {
  if (v % 1 !== 0) {
      v = parseFloat(v.toPrecision(15));
  }
  const t = Math.pow(10, n);
  let nv = v * t;
  if (nv % 1 !== 0) {
    nv = parseFloat(nv.toPrecision(15));
}
  return Math.round(nv) / t;
};

export const convertToTreeNode = function(data, parentId, region_dic, total_data) {
  const result = {
    data_node: [],
    total_data: total_data
  };
  if (data !== undefined) {
    data.forEach(item => {
      if (item.ParentRegionId === parentId) {
        let node = {
          data: {
            // RegionId: item.RegionId,
            name: region_dic[item.RegionId] ? region_dic[item.RegionId].RegionName : '',
            // ParentRegionId: item.ParentRegionId,s
            quantity: item.DeviceUsage,
            last_quantity: item.LastDeviceUsage !== undefined ? item.LastDeviceUsage : 0,
            unitprice: total_data.unitprice,
            amount: parseFloat((item.DeviceUsage * total_data.unitprice).toFixed(2))
          },
          expanded: true,
          children: []
        };
        total_data.quantity = total_data.quantity + node.data.quantity;
        total_data.last_quantity = total_data.last_quantity + node.data.last_quantity;
        total_data.amount = parseFloat((total_data.amount + (node.data.quantity * total_data.unitprice)).toFixed(2));

        const children = convertToTreeNode(data, item.RegionId, region_dic, total_data);
        if (children.data_node.length > 0) {
          node.children = children.data_node;
        }
        result.data_node.push(node);
      }
    });
  }
  result.total_data = total_data;
  return result;
};

export const GenerateProMonthlyPeriodDate = function(DocDate, PaymentType) {
  const result = {
    Period: '',
    PeriodPDFFormat: ''
  };
  const format = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}/${m}/${day}`;
  };
  const PDFformat = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${m}/${day}/${y}`;
  };

  if (PaymentType === PaymentTypeIndex.Prepaid) {
    const docDate = new Date(DocDate);
    result.Period = `${format(docDate)}`;
    result.PeriodPDFFormat = `${PDFformat(docDate)}`;
  }
  if (PaymentType === PaymentTypeIndex.Monthly) {
    const parts = DocDate.split('-');
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);


    const startMonthIndex = month - 1;
    const daysInStartMonth = new Date(year, startMonthIndex + 1, 0).getDate();
    const startDay = Math.min(day, daysInStartMonth);
    const startDate = new Date(year, startMonthIndex, startDay);
    let nextCycleYear = year;
    let nextCycleMonth = startMonthIndex + 1;
    if (nextCycleMonth > 11) {
      nextCycleMonth = 0;
      nextCycleYear++;
    }
    const daysInNextCycleMonth = new Date(nextCycleYear, nextCycleMonth + 1, 0).getDate();
    const nextCycleStartDay = Math.min(day, daysInNextCycleMonth);
    const nextCycleStartDate = new Date(nextCycleYear, nextCycleMonth, nextCycleStartDay);
    const endDate = new Date(nextCycleStartDate);
    endDate.setDate(nextCycleStartDate.getDate() - 1);
    result.Period = `${format(startDate)} - ${format(endDate)}`;
    result.PeriodPDFFormat = `${PDFformat(startDate)} - ${PDFformat(endDate)}`;
  }
  return result;
}

const getStatusStr = (DeviceSubType, singleVal, arrayVal, mapping) => {
  if (DeviceSubType === DeviceSubTypeMapping['3-Phase UPS']) {
    if (arrayVal && arrayVal.length > 0) {
      return arrayVal.map(s => mapping[s] || s).join(', ');
    }
    return '';
  }
  return (singleVal || singleVal === 0) ? (mapping[singleVal] || '') : '';
};
